import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, Optional, NgModule, EventEmitter, Component, Input, Output, ViewChildren, Directive, ElementRef, HostListener, ViewChild, Renderer2, ChangeDetectorRef, Pipe, HostBinding, SkipSelf, Injector, ContentChildren, TemplateRef, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AuthConfig, OAuthService, OAuthModule } from 'angular-oauth2-oidc';
import { filter, map, tap, share, merge, mergeMap, catchError, retry, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Location, APP_BASE_HREF, CommonModule, DatePipe } from '@angular/common';
import { from, of, Observable, fromEvent, timer, Subject, BehaviorSubject } from 'rxjs';
import * as JWTim from 'jwt-decode';
import { HttpHeaders, HttpClient, HttpClientModule, HttpBackend } from '@angular/common/http';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { NavigationStart, Router, RouterModule, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { FormControl, Validators, FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { NativeDateAdapter, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatNativeDateModule, MatSelectModule, DateAdapter, MatButtonModule, MatTableDataSource, MatPaginator, MatSort, MatPaginatorModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatIconModule, MatDialogModule, MatCheckboxModule, MatToolbarModule, MatPaginatorIntl, MatOptionModule, MatTooltipModule, MatProgressBarModule, MatProgressSpinnerModule, PageEvent, MatTableModule as MatTableModule$1, MatSidenavModule, MatMenuModule, MatExpansionModule, MatDividerModule as MatDividerModule$1, MatTabsModule as MatTabsModule$1 } from '@angular/material';
import { __awaiter } from 'tslib';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule as MatCheckboxModule$1 } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { AvatarModule } from 'ngx-avatar';
import { MatDialogRef as MatDialogRef$1, MAT_DIALOG_DATA as MAT_DIALOG_DATA$1, MatDialogModule as MatDialogModule$1 } from '@angular/material/dialog';
import { transition, style, animate, trigger, state } from '@angular/animations';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule as MatIconModule$1 } from '@angular/material/icon';
import { MD5, mode, pad, enc, TripleDES } from 'crypto-js';
import * as moment_ from 'moment';
import { create } from 'xmlbuilder';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { service, factories } from 'powerbi-client';
import { CookieService } from 'ngx-cookie-service';
import { Directionality } from '@angular/cdk/bidi';
import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule as MatToolbarModule$1 } from '@angular/material/toolbar';
import { CKEditorModule } from 'ng2-ckeditor';
import { Overlay, OverlayModule, GlobalPositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector, TemplatePortal } from '@angular/cdk/portal';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule as MatButtonModule$1 } from '@angular/material/button';
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Define as configurações utilizadas pelo pacote angular-oauth2-oidc
 * utilizado para realizar a autenticação da aplicação.
 *
 * As configurações existentes estão disponíveis em:
 * https://manfredsteyer.github.io/angular-oauth2-oidc/docs/classes/AuthConfig.html
 * @type {?}
 */
const ISSUER_VALUE = new InjectionToken('gestaoServicos');
/** @type {?} */
const authConfig = {
    issuer: 'http://bnu-vunificado:1984/auth/realms/GOVBR',
    clientId: 'login-unificado-gestao-app',
    responseType: 'code',
    redirectUri: '/erro?tipo=discovery_not_found',
    postLogoutRedirectUri: '/',
    scope: 'openid profile email',
    timeoutFactor: 0.75,
    strictDiscoveryDocumentValidation: true,
    skipIssuerCheck: true,
    requireHttps: false,
    sessionChecksEnabled: true
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const AUTH_CONFIG_OBJ = new InjectionToken('authConfigObj');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthConfigService {
    /**
     * @param {?} authConfigObj
     */
    constructor(authConfigObj) {
        this.authConfigObj = authConfigObj;
    }
    /**
     * @return {?}
     */
    get authConfigObject() {
        return this.authConfigObj;
    }
}
AuthConfigService.decorators = [
    { type: Injectable, args: [{ providedIn: 'root' },] }
];
/** @nocollapse */
AuthConfigService.ctorParameters = () => [
    { type: AuthConfig, decorators: [{ type: Inject, args: [AUTH_CONFIG_OBJ,] }] }
];
/** @nocollapse */ AuthConfigService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthConfigService_Factory() { return new AuthConfigService(ɵɵinject(AUTH_CONFIG_OBJ)); }, token: AuthConfigService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Tenant {
    /**
     * @param {?} municipio
     * @param {?=} entidade
     */
    constructor(municipio, entidade) {
        this.municipio = municipio;
        this.entidade = entidade;
    }
    /**
     * @return {?}
     */
    toString() {
        return `Tenant [${this.municipio}, ${this.entidade}]`;
    }
}
/** @type {?} */
const MOCK_TENANT = new Tenant('teste');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LocationService {
    constructor() {
        this._defaultPath = 'default-path';
    }
    /**
     * Retorna o objeto Window
     * @return {?}
     */
    getWindow() {
        return window;
    }
    /**
     * Retorna o objeto Location
     * @return {?}
     */
    getLocation() {
        return location;
    }
    /**
     * Adiciona o parametro informado ao final da URL atual, adicionando um caracter separador, se necessário.
     * @param {...?} path caminho a ser adicionado ao final da url atual
     * @return {?}
     */
    append(...path) {
        this.getWindow().location.href = Location.joinWithSlash(this.getWindow().location.href, path.join('/'));
    }
    /**
     * Redireciona para o caminho informado por parametro
     * @param {?} path caminho que se tornará a url completa
     * @return {?}
     */
    redirect(path) {
        this.getWindow().location.href = path;
    }
    /**
     * Retorna o {\@code window.location.href} atual
     * @return {?}
     */
    getCurrentHref() {
        return this.getWindow().location.href;
    }
    /**
     * Retorna o {\@code window.location.origin} atual
     * @return {?}
     */
    getCurrentOrigin() {
        return this.getWindow().location.origin;
    }
    /**
     * Retorna o {\@code window.location.pathname} atual
     * @return {?}
     */
    getPathName() {
        /** @type {?} */
        const path = this.getWindow().location.pathname;
        return path.endsWith('/') ? path : path + '/';
    }
    /**
     * @param {?} path
     * @return {?}
     */
    saveDefaultPath(path) {
        localStorage.setItem(this._defaultPath, path);
    }
    /**
     * @return {?}
     */
    getDefaultPath() {
        return localStorage.getItem(this._defaultPath);
    }
    /**
     * @return {?}
     */
    clearDefaultPath() {
        localStorage.removeItem(this._defaultPath);
    }
}
LocationService.decorators = [
    { type: Injectable, args: [{ providedIn: 'root' },] }
];
/** @nocollapse */ LocationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LocationService_Factory() { return new LocationService(); }, token: LocationService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const TENANT_CONFIG = new InjectionToken('tenantConfig');
/** @type {?} */
const TENANT_MUNICIPIO_PLACEHOLDER = '#{tenant.municipio}';
/** @type {?} */
const TENANT_ENTIDADE_PLACEHOLDER = '#{tenant.entidade}';
class TenantService {
    /**
     * @param {?} tenantConfig
     * @param {?} locationService
     */
    constructor(tenantConfig, locationService) {
        this.tenantConfig = tenantConfig;
        this.locationService = locationService;
        if (!tenantConfig) {
            throw new Error('environment.tenant não configurado.');
        }
    }
    /**
     * @param {?=} partial
     * @return {?}
     */
    getTenant(partial = false) {
        if (!this.tenant) {
            this.tenant = this.loadTenant(partial);
        }
        return this.tenant;
    }
    /**
     * @param {?=} tenant
     * @return {?}
     */
    getBaseUri(tenant) {
        if (!this.tenantConfig.baseUri) {
            throw new Error('environment.tenant.baseUri não configurado.');
        }
        return this.formatTenant(this.tenantConfig.baseUri, tenant);
    }
    /**
     * @param {?} template
     * @param {?=} tenant
     * @return {?}
     */
    formatTenant(template, tenant = this.getTenant()) {
        return template.replace(TENANT_MUNICIPIO_PLACEHOLDER, tenant.municipio)
            .replace(TENANT_ENTIDADE_PLACEHOLDER, tenant.entidade ? tenant.entidade : '');
    }
    /**
     * @private
     * @param {?=} partial
     * @return {?}
     */
    loadTenant(partial = false) {
        if (!this.tenantConfig.uriRegex) {
            throw new Error('environment.tenant.uriRegex não configurado.');
        }
        /** @type {?} */
        const path = this.locationService.getPathName();
        /** @type {?} */
        const matches = path.match(this.tenantConfig.uriRegex);
        /** @type {?} */
        const municipio = matches[1];
        /** @type {?} */
        const entidade = matches[2];
        return new Tenant(municipio, entidade);
    }
}
TenantService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
TenantService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TENANT_CONFIG,] }] },
    { type: LocationService, decorators: [{ type: Inject, args: [LocationService,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TenantMissingError extends Error {
    /**
     * @param {?} message
     * @param {?=} part
     * @param {?=} partialTenant
     */
    constructor(message, /** Mensagem exibida ao usuário com o erro causado */ part, /** Classificação da informação não encontrada */ partialTenant /** Representa um tenant parcial, que só tem a informação de município, sem entidade */) {
        super(message);
        this.part = part;
        this.partialTenant = partialTenant;
        /*
         * Necessário a partir do typescript 2.1, conforme descrito em:
         * https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
         */
        Object.setPrototypeOf(this, TenantMissingError.prototype);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Serviço responsável pela autenticação padrão da solução GOVBR
 */
class AuthService {
    /**
     * @param {?} oauthService
     * @param {?} tenantService
     * @param {?} authConfigService
     */
    constructor(oauthService, tenantService, authConfigService) {
        this.oauthService = oauthService;
        this.tenantService = tenantService;
        this.authConfigService = authConfigService;
    }
    /**
     * Função que configura e iniciliza o servico de autenticao
     * junto ao keycloak
     * @param {?=} pageRef
     * @return {?} retorna uma promise resolvida
     */
    InicializaAutenticao(pageRef) {
        return new Promise((/**
         * @param {?} resolveFn
         * @return {?}
         */
        (resolveFn) => {
            /** @type {?} */
            const authConfigObject = this.authConfigService.authConfigObject;
            /** @type {?} */
            const config = authConfig;
            config.issuer = this.retornarUrlAuthPorTenant(authConfigObject.issuer);
            config.clientId = authConfigObject.clientId;
            config.redirectUri = authConfigObject.redirectUri + pageRef;
            config.postLogoutRedirectUri = authConfigObject.redirectUri + this.tenantService.getBaseUri(this.tenantService.getTenant());
            /** @type {?} */
            const urlPrincipal = window.location.href;
            /** @type {?} */
            const urlParams = urlPrincipal.split('?')[1] ? urlPrincipal.split('?')[1].split('&') : [];
            /** @type {?} */
            let urlFilteredParams = urlParams.filter((/**
             * @param {?} segment
             * @return {?}
             */
            segment => {
                return !segment.startsWith('state') && !segment.startsWith('session_state') && !segment.startsWith('code');
            })).join('&');
            urlFilteredParams = urlFilteredParams.length > 0 ? `?${urlFilteredParams}` : urlFilteredParams;
            authConfig.redirectUri = urlPrincipal.split('?')[0] + urlFilteredParams;
            // configuracao oauthService
            this.oauthService.configure(config);
            this.oauthService.setStorage(localStorage);
            // inscricao para eventos de tokens
            this.oauthService.events
                .pipe(filter((/**
             * @param {?} e
             * @return {?}
             */
            (e) => e.type === 'invalid_nonce_in_state')))
                .subscribe((/**
             * @param {?} _
             * @return {?}
             */
            (_) => {
                window.location.href = window.location.origin + this.tenantService.getBaseUri();
            }));
            /*  continua com inicializacao do app ou rediciona para pagina de login
             *  caso o usuario esteja deslogado   */
            this.oauthService.loadDiscoveryDocumentAndLogin().then((/**
             * @param {?} isLoggedIn
             * @return {?}
             */
            (isLoggedIn) => {
                if (isLoggedIn) {
                    this.oauthService.setupAutomaticSilentRefresh();
                    resolveFn(true);
                }
                else {
                    this.oauthService.initCodeFlow();
                }
            }));
        }));
    }
    /**
     * Encerra a sessão de um usuário logado
     * @return {?}
     */
    logout() {
        window.history.replaceState('', '', this.tenantService.getBaseUri());
        this.oauthService.loadDiscoveryDocumentAndLogin().then((/**
         * @param {?} isLoggedIn
         * @return {?}
         */
        (isLoggedIn) => {
            this.oauthService.logOut();
        }));
    }
    /**
     * Busca o tenant analisando o token de autenticação
     * de sessão do keycloak
     * @return {?}
     */
    buscarTenantPorIdOauth() {
        /** @type {?} */
        const claims = this.oauthService.getIdentityClaims();
        if (claims) {
            /** @type {?} */
            const iss = claims['iss'];
            return iss === null ? '' : iss.split('/')[5];
        }
        return '';
    }
    /**
     * Retorna a url de autenticação para o tenant corrente
     * @param {?} caminhoKeycloak url do keycloak (correspondente ao campo `issuer` de environment.authConfig)
     * @return {?}
     */
    retornarUrlAuthPorTenant(caminhoKeycloak) {
        try {
            return this.tenantService.formatTenant(caminhoKeycloak);
        }
        catch (error) {
            if (error instanceof TenantMissingError) {
                /** @type {?} */
                const municipioOAuth = this.buscarTenantPorIdOauth();
                return this.tenantService.formatTenant(caminhoKeycloak, new Tenant(municipioOAuth));
            }
            else {
                throw new Error('Falha ao obter a url de autenticação');
            }
        }
    }
}
AuthService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthService.ctorParameters = () => [
    { type: OAuthService },
    { type: TenantService, decorators: [{ type: Optional }] },
    { type: AuthConfigService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Serviço para a proteção das rotas
 */
class AuthGuardService {
    /**
     * @param {?} authService
     * @param {?} appBaseHref
     * @param {?} locationService
     */
    constructor(authService, appBaseHref, locationService) {
        this.authService = authService;
        this.appBaseHref = appBaseHref;
        this.locationService = locationService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        /** @type {?} */
        let pageRef = state.url;
        /** @type {?} */
        const productRoute = state.url.split('?')[0];
        pageRef = Boolean(this.appBaseHref) ? this.appBaseHref + productRoute : pageRef;
        return from(this.authService.InicializaAutenticao(pageRef)).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            if (route.queryParams['state']) {
                /** @type {?} */
                let queryParams = state.url.split('?')[1] ? state.url.split('?')[1].split('&') : [];
                /** @type {?} */
                let urlParams = queryParams.filter((/**
                 * @param {?} segment
                 * @return {?}
                 */
                segment => {
                    return !segment.startsWith('state') && !segment.startsWith('session_state') && !segment.startsWith('code');
                })).join('&');
                urlParams = urlParams.length > 0 ? `?${urlParams}` : urlParams;
                setTimeout((/**
                 * @return {?}
                 */
                () => this.locationService.getWindow().history.replaceState('', '', this.locationService.getWindow().location.origin + pageRef + urlParams)));
            }
            return res;
        })));
    }
}
AuthGuardService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthGuardService.ctorParameters = () => [
    { type: AuthService },
    { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }, { type: Optional }] },
    { type: LocationService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0 = authConfig;
class AuthModule {
}
AuthModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [OAuthModule.forRoot()],
                providers: [
                    AuthService,
                    AuthGuardService,
                    { provide: AuthConfig, useValue: ɵ0 },
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Usuario {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const JWT = JWTim;
class DadosUsuarioService {
    /**
     * @param {?} oauthService
     */
    constructor(oauthService) {
        this.oauthService = oauthService;
        this.sessionKey = 'govbr_dados_Usuario';
        this.dadosUsuario = undefined;
    }
    /**
     * Não possui implementação
     * @deprecated
     * @param {?} dadosUsuario dados do usuário a serem salvos
     * @return {?}
     */
    save(dadosUsuario) { }
    /**
     * @return {?}
     */
    get() {
        this.oauthService.getIdentityClaims();
        /** @type {?} */
        const claims = this.oauthService.getIdentityClaims();
        if (claims) {
            this.dadosUsuario = new Usuario();
            this.dadosUsuario.idUsuario = claims.sub;
            this.dadosUsuario.nomeUsuario = claims.preferred_username;
            this.dadosUsuario.contato = {
                email: claims.email,
                nome: claims.name,
                cpf: ''
            };
        }
        return this.dadosUsuario;
    }
    /**
     * Não possui implementação
     * Com a utilização da autenticação via Oauth não tem mais utilizadade
     * @deprecated
     * @return {?}
     */
    remove() { }
    /**
     * @return {?}
     */
    isNull() {
        return !this.get();
    }
    /**
     * Obtém as roles do usuário logado baseado no token do keycloak que é obtido através
     * do serviço OAuth.
     * @return {?}
     */
    getRolesUsuarioLogado() {
        /** @type {?} */
        let roles = [];
        /** @type {?} */
        const rawJsonString = JWT(this.oauthService.getAccessToken());
        if (rawJsonString) {
            roles = rawJsonString['client-roles'];
        }
        return roles;
    }
}
DadosUsuarioService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
DadosUsuarioService.ctorParameters = () => [
    { type: OAuthService, decorators: [{ type: Inject, args: [OAuthService,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const GESTAO_SERVICOS_URI = new InjectionToken('gestaoServicosURI');
/**
 * Classe Base Utilizada na comunicação entre serviços.
 * @author Rafael Rudinei Starke
 * @abstract
 */
class AbstractCommService {
    /**
     * @param {?} http
     * @param {?} oauthService
     * @param {?} backendSrv
     * @param {?} tenantService
     */
    constructor(http, oauthService, backendSrv, tenantService) {
        this.http = http;
        this.oauthService = oauthService;
        this.backendSrv = backendSrv;
        this.tenantService = tenantService;
    }
    /**
     * @return {?}
     */
    getTenantService() {
        return this.tenantService;
    }
    /**
     * @return {?}
     */
    getOauthService() {
        return this.oauthService;
    }
    /**
     * Metodo que adiciona as informações na header para autenticação.
     * @param {?=} params Parametros utilizados na geração dos parametros para comunicação.
     * @return {?}
     */
    requestOptionfactory(params) {
        this.requestOptions = {
            params: params || {},
        };
        /** @type {?} */
        const tenant = this.tenantService.getTenant();
        /** @type {?} */
        let headers = new HttpHeaders();
        if (this.oauthService.hasValidAccessToken()) {
            headers = headers.append('Authorization', 'Bearer ' + this.oauthService.getAccessToken());
        }
        if (tenant && tenant.municipio) {
            headers = headers.append('X-Tenant-Municipio', tenant.municipio);
        }
        if (tenant && tenant.entidade) {
            headers = headers.append('X-Tenant-Entidade', tenant.entidade);
        }
        this.requestOptions.headers = headers;
        return this.requestOptions;
    }
    /**
     * @return {?}
     */
    buscarNomeProduto() {
        return this.oauthService.clientId;
    }
    /**
     * @param {?} path
     * @param {?} body
     * @param {?=} params
     * @return {?}
     */
    post(path, body, params) {
        /** @type {?} */
        const args = this.requestOptionfactory();
        /** @type {?} */
        const argsConcat = Object.assign({}, args, params);
        return this.http.post(this.backendSrv + path, body, argsConcat);
    }
    /**
     * @template T
     * @param {?} path
     * @param {?=} params
     * @return {?}
     */
    get(path, params) {
        /** @type {?} */
        const args = this.requestOptionfactory();
        /** @type {?} */
        const argsConcat = Object.assign({}, args, params);
        return this.http.get(this.backendSrv + path, argsConcat);
    }
    /**
     * @param {?} path
     * @return {?}
     */
    head(path) {
        /** @type {?} */
        const args = this.requestOptionfactory();
        return this.http.head(this.backendSrv + path, args);
    }
    /**
     * @param {?} path
     * @return {?}
     */
    delete(path) {
        /** @type {?} */
        const args = this.requestOptionfactory();
        /*
         * TODO o backend deveria retornar o status 204 e nenhum corpo, mas por enquanto está retornando um json que pode estar inválido.
         * Quando isto for alterado no backend, a definição do responseType abaixo pode ser removida.
         */
        args.observe = 'response';
        args.responseType = 'text';
        return this.http.delete(this.backendSrv + path, args);
    }
    /**
     * @param {?} path
     * @param {?} body
     * @param {?=} params
     * @return {?}
     */
    put(path, body, params) {
        /** @type {?} */
        const args = this.requestOptionfactory();
        /** @type {?} */
        const argsConcat = Object.assign({}, args, params);
        return this.http.put(this.backendSrv + path, body, argsConcat);
    }
    /**
     * @param {?} method
     * @param {?} path
     * @return {?}
     */
    request(method, path) {
        /** @type {?} */
        const args = this.requestOptionfactory();
        return this.http.request(method, this.backendSrv + path, args);
    }
}
/** @nocollapse */
AbstractCommService.ctorParameters = () => [
    { type: HttpClient, decorators: [{ type: Inject, args: [HttpClient,] }] },
    { type: OAuthService, decorators: [{ type: Inject, args: [OAuthService,] }] },
    { type: String, decorators: [{ type: Inject, args: [GESTAO_SERVICOS_URI,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }, { type: Optional }] }
];
class BackendCommService extends AbstractCommService {
    constructor() {
        super(...arguments);
        this.contentType = 'application/json';
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    requestOptionfactory(params) {
        this.requestOptions = super.requestOptionfactory(params);
        if (this.contentType) {
            this.requestOptions.headers = this.requestOptions.headers.append('Content-Type', this.contentType);
        }
        if (this.nomeEndpoint) {
            this.requestOptions.headers = this.requestOptions.headers.append('Pronim-Service', this.nomeEndpoint);
        }
        else {
            throw new Error('Nome do Serviço inexistente');
        }
        return this.requestOptions;
    }
    /**
     * @param {?} nome
     * @return {?}
     */
    setNomeEndpoint(nome) {
        this.nomeEndpoint = nome;
        return this;
    }
    /**
     * @return {?}
     */
    getPropertyIdent() {
        return GESTAO_SERVICOS_URI.toString();
    }
    /**
     * @param {?} contentType
     * @return {?}
     */
    setContentType(contentType) {
        this.contentType = contentType;
        return this;
    }
    /**
     * @return {?}
     */
    setNoContentType() {
        this.contentType = null;
        return this;
    }
}
BackendCommService.decorators = [
    { type: Injectable }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UsuarioSSO {
    /**
     * @param {?} oid
     * @param {?} idKeycloak
     * @param {?} nome
     * @param {?} email
     * @param {?} unidades
     */
    constructor(oid, idKeycloak, nome, email, unidades) {
        this.oid = oid;
        this.idKeycloak = idKeycloak;
        this.nome = nome;
        this.email = email;
        this.unidades = unidades;
    }
    /**
     * @param {?=} chaveMunicipio
     * @param {?=} chaveEntidade
     * @return {?}
     */
    buscarUnidade(chaveMunicipio, chaveEntidade) {
        if (!this.unidades || this.unidades.length === 0) {
            return null;
        }
        return this.unidades.find((/**
         * @param {?} unidade
         * @return {?}
         */
        unidade => {
            return (chaveEntidade ? unidade.url === chaveEntidade : true) &&
                (chaveMunicipio ? unidade.municipio === chaveMunicipio : true);
        }));
    }
    /**
     * @param {?=} chaveMunicipio
     * @return {?}
     */
    buscarUnidades(chaveMunicipio) {
        if (!this.unidades) {
            return [];
        }
        return this.unidades.filter((/**
         * @param {?} unidade
         * @return {?}
         */
        unidade => unidade.municipio === chaveMunicipio));
    }
}
class Unidade {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UsuarioSsoService {
    /**
     * @param {?} backService
     * @param {?} dadosUsuario
     */
    constructor(backService, dadosUsuario) {
        this.backService = backService;
        this.dadosUsuario = dadosUsuario;
    }
    /**
     * @return {?}
     */
    getDadosUsuario() {
        if (!this.dadosUsuario.isNull()) {
            return this.dadosUsuario.get();
        }
        else {
            return null;
        }
    }
    /**
     * @return {?}
     */
    getUsuarioSSO() {
        if (!this.usuario$) {
            this.usuario$ = this.backService.setNomeEndpoint('pronim/rest/usuarioSSO/keycloak')
                .get(this.getDadosUsuario().idUsuario.toString()).pipe(map((/**
             * @param {?} res
             * @return {?}
             */
            (res) => res)), map((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                /** @type {?} */
                const usuarioSSO = new UsuarioSSO(res['oid'], res['idKeycloak'], res['nome'], res['email'], res['unidades']);
                return usuarioSSO;
            })), tap((/**
             * @param {?} usuarioSSO
             * @return {?}
             */
            usuarioSSO => this.usuario$ = of(usuarioSSO))), share());
        }
        return this.usuario$;
    }
}
UsuarioSsoService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
UsuarioSsoService.ctorParameters = () => [
    { type: BackendCommService },
    { type: DadosUsuarioService }
];
/** @nocollapse */ UsuarioSsoService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UsuarioSsoService_Factory() { return new UsuarioSsoService(ɵɵinject(BackendCommService), ɵɵinject(DadosUsuarioService)); }, token: UsuarioSsoService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const JWT$1 = JWTim;
/**
 * @param {?} oauth
 * @param {?} tenantService
 * @param {?} location
 * @param {?} appSysName
 * @param {?} authServer
 * @param {?} permissionsService
 * @param {?=} routesForRoles
 * @param {?=} url
 * @return {?}
 */
function onAppInitAuth(oauth, tenantService, location, appSysName, authServer, permissionsService, routesForRoles, url) {
    if (appSysName === undefined) {
        throw new Error('A constante APP_SYS_NAME não foi provida');
    }
    return (/**
     * @return {?}
     */
    () => {
        oauth.redirectUri = url == null
            ? window.location.href
            : window.location.origin + location.prepareExternalUrl(url);
        oauth.clientId = appSysName;
        oauth.issuer = tenantService
            ? configureTenantId(tenantService, authServer)
            : authServer;
        oauth.showDebugInformation = false;
        oauth.sessionChecksEnabled = true;
        oauth.requireHttps = false;
        oauth.tokenValidationHandler = new JwksValidationHandler();
        oauth.scope = 'openid profile email voucher';
        oauth.setStorage(localStorage);
        return oauth.loadDiscoveryDocumentAndLogin().then((/**
         * @param {?} success
         * @return {?}
         */
        success => {
            if (success) {
                return verifyUserRoles(oauth, routesForRoles, url, appSysName, permissionsService);
            }
            else {
                return Promise.reject(new UnauthorizedError());
            }
        }));
    });
}
/**
 * @param {?} tenantService
 * @param {?} uri
 * @return {?}
 */
function configureTenantId(tenantService, uri) {
    return tenantService.formatTenant(uri, tenantService.getTenant(true));
}
/**
 * @param {?} oauth
 * @param {?} routesForRoles
 * @param {?} url
 * @param {?} appSysName
 * @param {?} permissionsService
 * @return {?}
 */
function verifyUserRoles(oauth, routesForRoles, url, appSysName, permissionsService) {
    /** @type {?} */
    const rawJsonString = JWT$1(oauth.getAccessToken());
    /** @type {?} */
    let hasAllRoles = false;
    url = `/${url}`;
    return permissionsService.loadRolesFromCurrentUserAndClient().toPromise().then((/**
     * @param {?} userRoles
     * @return {?}
     */
    (userRoles) => {
        if (rawJsonString && routesForRoles && url && routesForRoles.has(url)) {
            /** @type {?} */
            const necessaryRoles = routesForRoles.get(url);
            if (!userRoles) {
                return Promise.resolve(false);
            }
            /** @type {?} */
            let keepIterating = true;
            necessaryRoles.forEach((/**
             * @param {?} roleObrigatoria
             * @return {?}
             */
            roleObrigatoria => {
                userRoles.forEach((/**
                 * @param {?} roleUsuario
                 * @return {?}
                 */
                roleUsuario => {
                    if (keepIterating) {
                        hasAllRoles = roleObrigatoria == roleUsuario;
                    }
                    if (hasAllRoles) {
                        keepIterating = false;
                    }
                }));
            }));
            return Promise.resolve(hasAllRoles);
        }
        else {
            return Promise.resolve(true);
        }
    }));
}
class UnauthorizedError extends Error {
    /**
     * @param {?=} message
     */
    constructor(message) {
        super(message);
        /*
         * Necessário a partir do typescript 2.1, conforme descrito em:
         * https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
         */
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Nome da aplicação, deve ser correspondente ao client name do front no Keycloak
 * @type {?}
 */
const APP_SYS_NAME = new InjectionToken('appSysName');
/**
 * Mapa de rota, array de permissões, serve para limitar o acesso do usuário
 * @type {?}
 */
const ROUTES_FOR_ROLES = new InjectionToken('routesForRoles');
/**
 * Recebe um objeto com todos parametros necessários para notificações
 * @type {?}
 */
const PARAMS_NOTIFICACAO = new InjectionToken('paramsNotificacao');
/**
 * Variável para definir o contexto de ambiente
 * @type {?}
 */
const AMBIENTE_PRODUCAO = new InjectionToken('ambienteProducao');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Objeto que representa um contexto com permissões, tempo de expiração das permissões e usuário logado
 */
class RoleInfo {
    /**
     * Cria um novo objeto de persistência de permissões
     * @param {?} roles permissões a serem salvas
     * @param {?} expiresAt timestamp de expiração
     * @param {?} username usuário logado
     * @param {?} municipio
     */
    constructor(roles, expiresAt, username, municipio) {
        this.roles = roles;
        this.expiresAt = expiresAt;
        this.username = username;
        this.municipio = municipio;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const Permissoes = {
    /** Permissões do usuário */
    USUARIO: 'product-user-permissions',
    /** Permissões dos produtos */
    PRODUTOS: 'all-products-permissions',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const Orientation = {
    Landscape: 0,
    Portrait: 1,
};
Orientation[Orientation.Landscape] = 'Landscape';
Orientation[Orientation.Portrait] = 'Portrait';
/** @enum {number} */
const DeviceType = {
    Phone: 0,
    Tablet: 1,
    Desktop: 2,
    LargeDesktop: 3,
};
DeviceType[DeviceType.Phone] = 'Phone';
DeviceType[DeviceType.Tablet] = 'Tablet';
DeviceType[DeviceType.Desktop] = 'Desktop';
DeviceType[DeviceType.LargeDesktop] = 'LargeDesktop';
class Device {
    /**
     * @param {?} deviceType
     * @param {?} orientation
     */
    constructor(deviceType, orientation) {
        this.deviceType = deviceType;
        this.orientation = orientation;
    }
}
class DeviceService {
    constructor() {
        // Retorna imediatamente o tipo de device
        /** @type {?} */
        const imediateDeviceType = new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        observer => {
            this.resolveTypeAndOrientation();
            observer.next(this._device);
            observer.complete();
        }));
        this.onResize = fromEvent(window, 'resize').pipe(map((/**
         * @return {?}
         */
        () => {
            this.resolveTypeAndOrientation();
            return this._device;
        })), merge(imediateDeviceType));
    }
    /**
     * Retorna o tipo de dispositivo baseado
     * no tamanho da janela
     * @return {?}
     */
    resolveType() {
        /** @type {?} */
        const maxSize = Math.max(window.innerWidth, window.innerHeight);
        if (maxSize >= 1200) {
            return DeviceType.LargeDesktop;
        }
        else if (maxSize >= 992) {
            return DeviceType.Desktop;
        }
        else if (maxSize >= 768) {
            return DeviceType.Tablet;
        }
        else {
            return DeviceType.Phone;
        }
    }
    /**
     * Retorna o tipo de orientação
     * @return {?}
     */
    resolveOrientation() {
        if (window.innerWidth >= window.innerHeight) {
            return Orientation.Landscape;
        }
        else {
            return Orientation.Portrait;
        }
    }
    /**
     * @return {?}
     */
    resolveTypeAndOrientation() {
        this._device = new Device(this.resolveType(), this.resolveOrientation());
    }
    /**
     * @return {?}
     */
    get device() {
        return this.onResize;
    }
    /**
     * @return {?}
     */
    get deviceType() {
        return this.onResize.pipe(map((/**
         * @param {?} device
         * @return {?}
         */
        (device) => { return device.deviceType; })));
    }
    /**
     * @return {?}
     */
    get deviceIsMobile() {
        return this.deviceType.pipe(map((/**
         * @param {?} device
         * @return {?}
         */
        (device) => { return this.isMobile(device); })));
    }
    /**
     * @param {?} deviceType
     * @return {?}
     */
    isMobile(deviceType) {
        return deviceType === DeviceType.Phone || deviceType === DeviceType.Tablet;
    }
    /**
     * Retorna o objeto Window
     * @return {?}
     */
    getWindow() {
        return window;
    }
}
DeviceService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DeviceService.ctorParameters = () => [];
/** @nocollapse */ DeviceService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DeviceService_Factory() { return new DeviceService(); }, token: DeviceService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TimeoutTokenHandlerService {
    /**
     * @param {?} oAuthService
     * @param {?} tenantService
     * @param {?} deviceService
     */
    constructor(oAuthService, tenantService, deviceService) {
        this.oAuthService = oAuthService;
        this.tenantService = tenantService;
        this.deviceService = deviceService;
    }
    /**
     * Ativa redirecionamento para a tela inicial após a diferença de tempo entre a
     * hora atual e o tempo limite de validade do token de autenticação, mais um tempo extra de 5
     * segundos para evitar conflito com eventos de Auth que tenham prioridade
     * @return {?}
     */
    handleTokenTimeout() {
        /** @type {?} */
        const tokenExpiration = this.oAuthService.getAccessTokenExpiration();
        /** @type {?} */
        const now = (new Date()).getTime();
        /** @type {?} */
        const timeoutFactor = 5000;
        return setTimeout((/**
         * @return {?}
         */
        () => {
            this.deviceService.getWindow().location
                .replace(window.location.origin + this.tenantService.getBaseUri(this.tenantService.getTenant()));
        }), Math.abs(tokenExpiration - now) + timeoutFactor);
    }
}
TimeoutTokenHandlerService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
TimeoutTokenHandlerService.ctorParameters = () => [
    { type: OAuthService },
    { type: TenantService },
    { type: DeviceService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const JWT$2 = JWTim;
class LoginService {
    /**
     * @param {?} backService
     * @param {?} oauthService
     * @param {?} dadosUsuario
     * @param {?} tenantService
     * @param {?} location
     * @param {?} appSysName
     * @param {?} routesForRoles
     * @param {?} authConfig
     * @param {?} ngxPermissionsService
     * @param {?} locationService
     * @param {?} router
     * @param {?} timeoutTokenHandlerService
     */
    constructor(backService, oauthService, dadosUsuario, tenantService, location, appSysName, routesForRoles, authConfig, ngxPermissionsService, locationService, router, timeoutTokenHandlerService) {
        this.backService = backService;
        this.oauthService = oauthService;
        this.dadosUsuario = dadosUsuario;
        this.tenantService = tenantService;
        this.location = location;
        this.appSysName = appSysName;
        this.routesForRoles = routesForRoles;
        this.authConfig = authConfig;
        this.ngxPermissionsService = ngxPermissionsService;
        this.locationService = locationService;
        this.router = router;
        this.timeoutTokenHandlerService = timeoutTokenHandlerService;
        this.hoursToExpire = 12;
        this.silentRefresh = '/assets/html/silent-refresh.html';
        this.discoveryDocumentLoaded = false;
        this.configAuth();
        this.oauthService.events.pipe(filter((/**
         * @param {?} e
         * @return {?}
         */
        e => e.type === 'discovery_document_loaded')))
            .subscribe((/**
         * @return {?}
         */
        () => this.discoveryDocumentLoaded = true));
        this.configurarLogoutAutomatico();
        this.permissoesUsuarioKey = this.tenantService.getTenant().municipio + '-' + Permissoes.USUARIO;
        this.permissoesProdutosKey = this.tenantService.getTenant().municipio + '-' + Permissoes.PRODUTOS;
        this.validateNavigation();
    }
    /**
     * @private
     * @param {?=} redirectRoute
     * @return {?}
     */
    configAuth(redirectRoute) {
        this.oauthService.configure({
            redirectUri: redirectRoute == null
                ? window.location.href
                : redirectRoute.indexOf('http') > -1
                    ? redirectRoute
                    : window.location.origin + this.location.prepareExternalUrl(redirectRoute),
            clientId: this.appSysName,
            issuer: this.tenantService
                ? this.retornarTenantCorreto(this.authConfig.issuer)
                : this.authConfig.issuer,
            showDebugInformation: false,
            sessionChecksEnabled: true,
            requireHttps: false,
            silentRefreshRedirectUri: window.location.origin + this.silentRefresh
        });
        this.oauthService.setStorage(localStorage);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        this.oauthService.setupAutomaticSilentRefresh();
    }
    /**
     * @private
     * @param {?} caminhoKeycloak
     * @return {?}
     */
    retornarTenantCorreto(caminhoKeycloak) {
        try {
            return this.tenantService.formatTenant(caminhoKeycloak);
        }
        catch (error) {
            if (error instanceof TenantMissingError) {
                /** @type {?} */
                const municipioOAuth = this.buscarTenantIdOauth();
                return this.tenantService.formatTenant(caminhoKeycloak, new Tenant(municipioOAuth));
            }
        }
    }
    /**
     * Busca o tenant analisando o token de autenticação
     * de sessão do keycloak
     * @return {?}
     */
    buscarTenantPorIdOauth() {
        /** @type {?} */
        const claims = this.oauthService.getIdentityClaims();
        if (claims) {
            /** @type {?} */
            const iss = claims['iss'];
            return iss === null ? '' : iss.split('/')[5];
        }
        return '';
    }
    /**
     * @return {?}
     */
    getDadosUsuario() {
        if (!this.dadosUsuario.isNull()) {
            return this.dadosUsuario.get();
        }
        else {
            return null;
        }
    }
    /**
     * @return {?}
     */
    buscarTenantIdOauth() {
        /** @type {?} */
        const claims = this.oauthService.getIdentityClaims();
        if (claims) {
            /** @type {?} */
            const iss = claims['iss'];
            return iss === null ? '' : iss.split('/')[5];
        }
        return '';
    }
    /**
     * @return {?}
     */
    buscarNomeProduto() {
        return this.oauthService.clientId;
    }
    /**
     * Envia credenciais para o servidor e guarda o token caso a resposta seja positiva
     * @param {?=} redirectRoute
     * @return {?}
     */
    login(redirectRoute) {
        this.configAuth(redirectRoute);
        this.oauthService.redirectUri = window.location.href;
        this.oauthService.initImplicitFlow();
    }
    /**
     * Encerra a sessão do usuário
     * @param {?=} redirectRoute
     * @return {?}
     */
    logout(redirectRoute) {
        this.oauthService.loadDiscoveryDocumentAndTryLogin().then((/**
         * @return {?}
         */
        () => {
            this.removeRoleInfo();
            this.ngxPermissionsService.flushPermissions();
            this.oauthService.postLogoutRedirectUri = redirectRoute ?
                redirectRoute :
                window.location.origin + this.tenantService.getBaseUri(this.tenantService.getTenant());
            this.locationService.clearDefaultPath();
            this.oauthService.logOut();
        }));
    }
    /**
     * @return {?}
     */
    isAuthenticated() {
        return this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken();
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        return onAppInitAuth.call(this, this.oauthService, this.tenantService, this.location, this.appSysName, this.authConfig.issuer, this, this.routesForRoles, route.url.join('/'))();
    }
    /**
     * @param {?} route
     * @return {?}
     */
    canLoad(route) {
        return onAppInitAuth.call(this, this.oauthService, this.tenantService, this.location, this.appSysName, this.authConfig.issuer, this)();
    }
    /**
     * Retorna uma lista com todas as roles de um usuário, de um determinado client, com base no access_token provido pelo keycloak.
     * @return {?}
     */
    getRolesFromCurrentUser() {
        /** @type {?} */
        const token = JWT$2(this.oauthService.getAccessToken());
        /** @type {?} */
        const obj = { token };
        /** @type {?} */
        const tokenInfo = obj['token'];
        return tokenInfo ? tokenInfo['client-roles'] : null;
    }
    /**
     * Carrega todas as roles de um usuário no client atual para o serviço de permissões
     * com base no access_token provido pelo keycloak.
     * @return {?}
     */
    loadRolesFromCurrentUserAndClient() {
        /** @type {?} */
        const token = JWT$2(this.oauthService.getAccessToken());
        /** @type {?} */
        const obj = { token };
        /** @type {?} */
        const username = obj['token']['preferred_username'];
        /** @type {?} */
        const userRoleInfo = this.getRoleInfo(this.permissoesUsuarioKey);
        /** @type {?} */
        const usuarioSSOResource = 'pronim/rest/usuarioSSO';
        /** @type {?} */
        const permissoesResource = 'roles/effective/' + this.dadosUsuario.get().idUsuario;
        if (this.permissoesValidas(userRoleInfo, username)) {
            this.ngxPermissionsService.loadPermissions(userRoleInfo.roles);
            return of(Object.keys(this.ngxPermissionsService.getPermissions()));
        }
        else {
            /** @type {?} */
            const rolesExpiresAt = new Date();
            return this.backService.setNomeEndpoint(usuarioSSOResource)
                .get(permissoesResource).pipe(map((/**
             * @param {?} res
             * @return {?}
             */
            (res) => {
                rolesExpiresAt.setHours(rolesExpiresAt.getHours() + this.hoursToExpire);
                this.setRoleInfo(this.permissoesUsuarioKey, res, rolesExpiresAt.getTime(), username);
                /** @type {?} */
                const permissoesDoUsuario = this.getRoleInfo(this.permissoesUsuarioKey);
                this.ngxPermissionsService.loadPermissions(permissoesDoUsuario.roles);
                return permissoesDoUsuario.roles;
            })));
        }
    }
    /**
     * Obtém todas as roles de todos os produtos do tenant e salva para conferência de permissões
     * @return {?} Observable<RoleInfo> com todas as roles de todos os produtos do tenant
     */
    verifyAllRolesFromProducts() {
        /** @type {?} */
        const productsRoleInfo = this.getRoleInfo(this.permissoesProdutosKey);
        /** @type {?} */
        const rolesAndProductsTag = 'pronim/rest/permissoes';
        /** @type {?} */
        const expiresAt = new Date();
        /** @type {?} */
        const username = ((/** @type {?} */ (this.getDadosUsuario().nomeUsuario)));
        expiresAt.setHours(expiresAt.getHours() + this.hoursToExpire);
        if (this.permissoesValidas(productsRoleInfo, username)) {
            return of(productsRoleInfo);
        }
        else {
            return this.backService.setNomeEndpoint(rolesAndProductsTag)
                .get('').pipe(map((/**
             * @param {?} rolesByProduct
             * @return {?}
             */
            rolesByProduct => {
                /** @type {?} */
                const mapRolesByProduct = {};
                rolesByProduct.forEach((/**
                 * @param {?} role
                 * @return {?}
                 */
                (role) => {
                    /** @type {?} */
                    const rolesOfProduct = mapRolesByProduct[role.produto.nome];
                    if (rolesOfProduct && rolesOfProduct.length > 0) {
                        rolesOfProduct.push(role.permissao.nomePermissao);
                        mapRolesByProduct[role.produto.nome] = rolesOfProduct;
                    }
                    else {
                        mapRolesByProduct[role.produto.nome] = [role.permissao.nomePermissao];
                    }
                }));
                this.setRoleInfo(this.permissoesProdutosKey, mapRolesByProduct, expiresAt.getTime(), username);
                return this.getRoleInfo(this.permissoesProdutosKey);
            }), (/**
             * @return {?}
             */
            () => {
                throw new Error('Falha ao se obter todas as permissões');
            })));
        }
    }
    /**
     * @return {?}
     */
    getUsuarioSSO() {
        if (!this.usuario$) {
            this.usuario$ = this.backService.setNomeEndpoint('pronim/rest/usuarioSSO/keycloak')
                .get(this.getDadosUsuario().idUsuario.toString()).pipe(
            // tslint:disable-next-line: deprecation
            map((/**
             * @param {?} res
             * @return {?}
             */
            (res) => res)), map((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                /** @type {?} */
                const usuarioSSO = new UsuarioSSO(res['oid'], res['idKeycloak'], res['nome'], res['email'], res['unidades']);
                this.setDefaultPath(usuarioSSO);
                return usuarioSSO;
            })), tap((/**
             * @param {?} usuarioSSO
             * @return {?}
             */
            usuarioSSO => this.usuario$ = of(usuarioSSO))), share());
        }
        return this.usuario$;
    }
    /**
     * Salva no localStorage a última página que o usuário acessou com sucesso.
     * @private
     * @param {?} usuarioSSO
     * @param {?=} rota Path da página para onde o usuário tenta navegar.
     * @return {?}
     */
    setDefaultPath(usuarioSSO, rota) {
        if (usuarioSSO.buscarUnidades(this.tenantService.getTenant().municipio)) {
            /** @type {?} */
            const url = `${this.locationService.getCurrentOrigin()}${this.tenantService.getBaseUri()}`;
            /** @type {?} */
            const rotaValida = rota && !rota.startsWith('erro');
            if (this.tenantService.getTenant().entidade) {
                if (usuarioSSO.unidades.find((/**
                 * @param {?} unidade
                 * @return {?}
                 */
                unidade => unidade.url === this.tenantService.getTenant().entidade))) {
                    this.locationService.saveDefaultPath(rotaValida ? url.concat(`/${rota}`) : url);
                }
            }
            else {
                this.locationService.saveDefaultPath(rotaValida ? url.concat(`/${rota}`) : url);
            }
        }
    }
    /**
     * Verifica se o usuário possui as roles da rota para qual ele quer navegar
     * para poder salvar o default-path.
     * @private
     * @return {?}
     */
    validateNavigation() {
        this.router.events.subscribe((/**
         * @param {?} routerEvent
         * @return {?}
         */
        (routerEvent) => {
            if (routerEvent instanceof NavigationStart) {
                /** @type {?} */
                const rota = routerEvent.url.split('/')[1];
                if (this.routesForRoles.has(rota)) {
                    this.loadRolesFromCurrentUserAndClient().subscribe((/**
                     * @param {?} roles
                     * @return {?}
                     */
                    roles => {
                        this.routesForRoles.get(rota).forEach((/**
                         * @param {?} role
                         * @return {?}
                         */
                        role => {
                            if (roles.find((/**
                             * @param {?} userRole
                             * @return {?}
                             */
                            userRole => userRole === role))) {
                                this.getUsuarioSSO().subscribe((/**
                                 * @param {?} usuario
                                 * @return {?}
                                 */
                                usuario => this.setDefaultPath(usuario, rota)));
                                return;
                            }
                        }));
                    }));
                }
                else {
                    this.getUsuarioSSO().subscribe((/**
                     * @param {?} usuario
                     * @return {?}
                     */
                    usuario => this.setDefaultPath(usuario, rota)));
                }
            }
        }));
    }
    /**
     * Verifica se as permissões existem no localStorage,
     * pertencem ao usuário informado e não expirou o prazo de validade
     * @private
     * @param {?} roleInfo roles obtidas do localStorage
     * @param {?} username usuário logado atualmente
     * @return {?} boolean indicando se as permissões estão válidas
     */
    permissoesValidas(roleInfo, username) {
        /** @type {?} */
        const timeNow = new Date();
        return roleInfo
            && username === roleInfo.username
            && roleInfo.expiresAt >= timeNow.getTime()
            && roleInfo.municipio === this.tenantService.getTenant().municipio;
    }
    /**
     * Obtém as permissões do localStorage
     * @private
     * @param {?} key chave que indica o tipo de permissões que se deseja recuperar
     * @return {?}
     */
    getRoleInfo(key) {
        return (/** @type {?} */ (JSON.parse(localStorage.getItem(key))));
    }
    /**
     * Salva as permissões do usuário no localStorage
     * @private
     * @param {?} key chave que indica o tipo de permissões que se deseja salvar
     * @param {?} permissions objeto com produtos e permissões do usuário
     * @param {?} expireTime tempo de expiração
     * @param {?} username usuário logado
     * @return {?}
     */
    setRoleInfo(key, permissions, expireTime, username) {
        /** @type {?} */
        const permissionsByProduct = [];
        Object.keys(permissions).forEach((/**
         * @param {?} produto
         * @return {?}
         */
        (produto) => {
            permissions[produto].forEach((/**
             * @param {?} element
             * @return {?}
             */
            (element) => {
                permissionsByProduct.push(`${produto}-${element}`);
            }));
        }));
        localStorage
            .setItem(key, JSON.stringify(new RoleInfo(permissionsByProduct, expireTime, username, this.tenantService.getTenant().municipio)));
    }
    /**
     * Apaga todas as permissões do localStorage
     * @private
     * @return {?}
     */
    removeRoleInfo() {
        localStorage.removeItem(Permissoes.USUARIO);
        localStorage.removeItem(Permissoes.PRODUTOS);
    }
    /**
     * Escuta os eventos de auth e após o último silent_refresh com sucesso/erro,
     * ou erro/fim de sessão, chama o método `timeoutTokenHandler` para fazer uma requisição
     * à página inicial da aplicação e chamar a página de login do autenticador.
     * @private
     * @return {?}
     */
    configurarLogoutAutomatico() {
        this.oauthService.events
            .pipe(filter((/**
         * @param {?} e
         * @return {?}
         */
        e => [
            'silently_refreshed', 'silent_refresh_error',
            'session_terminated', 'silent_refresh_timeout',
            'session_error'
        ].includes(e.type))))
            .subscribe((/**
         * @param {?} e
         * @return {?}
         */
        e => {
            if (this.timeoutToken) {
                clearTimeout(this.timeoutToken);
            }
            this.timeoutToken = this.timeoutTokenHandlerService.handleTokenTimeout();
        }));
    }
}
LoginService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
LoginService.ctorParameters = () => [
    { type: BackendCommService, decorators: [{ type: Inject, args: [BackendCommService,] }] },
    { type: OAuthService, decorators: [{ type: Inject, args: [OAuthService,] }] },
    { type: DadosUsuarioService, decorators: [{ type: Inject, args: [DadosUsuarioService,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }, { type: Optional }] },
    { type: Location, decorators: [{ type: Inject, args: [Location,] }] },
    { type: String, decorators: [{ type: Inject, args: [APP_SYS_NAME,] }] },
    { type: Map, decorators: [{ type: Inject, args: [ROUTES_FOR_ROLES,] }] },
    { type: AuthConfig, decorators: [{ type: Inject, args: [AUTH_CONFIG_OBJ,] }] },
    { type: NgxPermissionsService, decorators: [{ type: Inject, args: [NgxPermissionsService,] }] },
    { type: LocationService },
    { type: Router },
    { type: TimeoutTokenHandlerService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const LIC_CODIGO_SISTEMA = new InjectionToken('codigoSistema');
/** @type {?} */
const LIC = new InjectionToken('lic');
class LICService {
    /**
     * @param {?} commService
     * @param {?} codigoSistema
     * @param {?} lic
     */
    constructor(commService, codigoSistema, lic) {
        this.commService = commService;
        this.codigoSistema = codigoSistema;
        this.lic = lic;
        this.endpoint = 'pronim/rest/licenca';
    }
    /**
     * @return {?}
     */
    getInfoLicencas() {
        return this.commService.setNomeEndpoint(this.endpoint)
            .get('info').pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res['licencas'])), map((/**
         * @param {?} value
         * @return {?}
         */
        (value) => value)));
    }
    /**
     * @param {?} numeroSerie
     * @return {?}
     */
    atualizaLicenca(numeroSerie) {
        return this.commService.setNomeEndpoint(this.endpoint)
            .get(`atualiza/${numeroSerie}`).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        (res) => res['licencas'])), map((/**
         * @param {?} value
         * @return {?}
         */
        (value) => value[0])));
    }
    /**
     * @return {?}
     */
    validaLicenca() {
        if (this.codigoSistema && this.lic !== false) {
            return this.commService.setNomeEndpoint(this.endpoint)
                .get(this.codigoSistema).pipe(map((/**
             * @param {?} res
             * @return {?}
             */
            (res) => res)));
        }
        else {
            return of(true);
        }
    }
    /**
     * @return {?}
     */
    getCodigoSistema() {
        if (!this.codigoSistema) {
            throw Error('InjectionToken codigoSistema não configurado.');
        }
        return this.codigoSistema;
    }
}
LICService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LICService.ctorParameters = () => [
    { type: BackendCommService, decorators: [{ type: Inject, args: [BackendCommService,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [LIC_CODIGO_SISTEMA,] }] },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [LIC,] }] }
];
/** @nocollapse */ LICService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LICService_Factory() { return new LICService(ɵɵinject(BackendCommService), ɵɵinject(LIC_CODIGO_SISTEMA, 8), ɵɵinject(LIC, 8)); }, token: LICService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthGuard {
    /**
     * @param {?} loginService
     * @param {?} tenantService
     * @param {?} router
     * @param {?} licService
     * @param {?} locationService
     * @param {?} oauthService
     */
    constructor(loginService, tenantService, router, licService, locationService, oauthService) {
        this.loginService = loginService;
        this.tenantService = tenantService;
        this.router = router;
        this.licService = licService;
        this.locationService = locationService;
        this.oauthService = oauthService;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    canActivate(route, state) {
        if (this.tenantService) {
            return this.canActivateWithTenant(route, state);
        }
        return this.validateLoginAndLicense(route, state);
    }
    /**
     * @param {?} childRoute
     * @param {?} state
     * @return {?}
     */
    canActivateChild(childRoute, state) {
        return this.canActivate(childRoute, state);
    }
    /**
     * Valida se a rota pode ser visualizada, verificando as informações de login, tenant e licensa.
     * @private
     * @param {?} route Rota a ser validada
     * @param {?} state Representação do estado atual do router
     * @return {?}
     */
    canActivateWithTenant(route, state) {
        /** @type {?} */
        const tenantInformation = this.validateTenantDefinition();
        if (!tenantInformation.tenant) {
            return of(false);
        }
        return this.validateLogin(route, state).pipe(mergeMap((/**
         * @param {?} loginValid
         * @return {?}
         */
        loginValid => loginValid ?
            this.validateTenantAuthorization(tenantInformation.tenant) :
            of(false))), mergeMap((/**
         * @param {?} tenantValid
         * @return {?}
         */
        tenantValid => tenantValid && tenantInformation.partial ?
            this.redirectToDefaultEntity(tenantInformation.tenant) :
            of(tenantValid))), mergeMap((/**
         * @param {?} redirectValid
         * @return {?}
         */
        redirectValid => redirectValid ?
            this.validateLicense() :
            of(false))));
    }
    /**
     * Redireciona para a primeira unidade gestora do usuário logado, caso o parametro {\@code entityNotFound} for verdadeiro
     * @param {?} tenant
     * @return {?}
     */
    redirectToDefaultEntity(tenant) {
        return this.loginService.getUsuarioSSO().pipe(map((/**
         * @param {?} u
         * @return {?}
         */
        u => {
            this.locationService.append(u.buscarUnidade(tenant.municipio).url);
            return false;
        })));
    }
    /**
     * @private
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    validateLoginAndLicense(route, state) {
        return this.validateLogin(route, state).pipe(mergeMap((/**
         * @param {?} loginValid
         * @return {?}
         */
        loginValid => loginValid ? this.validateLicense() : of(false))));
    }
    /**
     * Valida a definição de um tenant. Caso a busca do tenant dê erro, e o tenant não for parcial, redireciona para
     * a tela de erro com o método {\@code this.redirectToError()}
     * @private
     * @return {?} um objeto {\@link TenantValidationResult} com o resultado da validação
     */
    validateTenantDefinition() {
        try {
            return new TenantValidationResult(this.tenantService.getTenant());
        }
        catch (error) {
            if (error instanceof TenantMissingError) {
                if (error.partialTenant) {
                    return new TenantValidationResult(error.partialTenant, true);
                }
                this.redirectToError(this.getTenantErrorType(error));
            }
            else {
                console.log('Erro inesperado ao obter o tenant: ', error);
                this.redirectToError();
            }
            return new TenantValidationResult();
        }
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    getTenantErrorType(error) {
        switch (error.part) {
            case 'tenant': return 'TENANT_INVALIDO';
            case 'municipio': return 'MUNICIPIO_NAO_ENCONTRADO';
            case 'entidade': return 'ENTIDADE_NAO_ENCONTRADA';
            default: return 'DESCONHECIDO';
        }
    }
    /**
     * @private
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    validateLogin(route, state) {
        return from(this.loginService.canActivate(route, state)).pipe(tap((/**
         * @param {?} loginValid
         * @return {?}
         */
        loginValid => this.redirectIfInvalid(loginValid, 'ACESSO_NEGADO_AUTENTICACAO'))), catchError((/**
         * @param {?} error
         * @return {?}
         */
        error => {
            if (error instanceof UnauthorizedError) {
                // Não redireciona para a tela de erro pois o serviço já está redirecionando para o login externo.
                console.error('Usuário não autenticado: ', error);
                return of(false);
            }
            // FIXME: workaround para problema de realizar reset de senha em aba anônima no Firefox e Edge
            /** @type {?} */
            const claims = this.oauthService.getIdentityClaims();
            if (!claims && error.type === 'invalid_nonce_in_state' && error.reason === null && error.params === null) {
                this.loginService.logout();
                return of(false);
            }
            this.redirectToError('ACESSO_NEGADO_AUTENTICACAO');
            console.error('Erro ao validar o login do usuário: ', error);
            return of(false);
        })));
    }
    /**
     * @private
     * @return {?}
     */
    validateLicense() {
        return this.licService.validaLicenca().pipe(tap((/**
         * @param {?} licValid
         * @return {?}
         */
        licValid => this.redirectIfInvalid(licValid, 'LICENCA_INVALIDA'))), catchError((/**
         * @param {?} error
         * @return {?}
         */
        error => {
            console.error('Erro ao validar licença: ', error);
            this.redirectToError('LICENCA_INVALIDA');
            return of(false);
        })));
    }
    /**
     * @private
     * @param {?} tenant
     * @return {?}
     */
    validateTenantAuthorization(tenant) {
        return this.loginService.getUsuarioSSO().pipe(map((/**
         * @param {?} usuarioSSO
         * @return {?}
         */
        usuarioSSO => usuarioSSO.buscarUnidade(tenant.municipio, tenant.entidade))), map(Boolean), catchError((/**
         * @param {?} error
         * @return {?}
         */
        error => {
            if (error.status === 404) {
                this.redirectToError('AMBIENTE_INDISPONIVEL');
            }
            console.error('Erro ao validar a autorização do tenant: ', error);
            return of(false);
        })), tap((/**
         * @param {?} tenantValid
         * @return {?}
         */
        tenantValid => this.redirectIfInvalid(tenantValid, 'ACESSO_NEGADO_TENANT', `Usuário não possui acesso ao ${tenant}.`))));
    }
    /**
     * @private
     * @param {?} isValid
     * @param {?} messageType
     * @param {?=} log
     * @return {?}
     */
    redirectIfInvalid(isValid, messageType, log) {
        if (!isValid) {
            this.redirectToError(messageType);
            if (log) {
                console.warn(log);
            }
        }
    }
    /**
     * @private
     * @param {?=} messageType
     * @return {?}
     */
    redirectToError(messageType) {
        this.router.navigate(['/erro'], { queryParams: { tipo: messageType } });
    }
}
AuthGuard.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AuthGuard.ctorParameters = () => [
    { type: LoginService, decorators: [{ type: Inject, args: [LoginService,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }, { type: Optional }] },
    { type: Router, decorators: [{ type: Inject, args: [Router,] }] },
    { type: LICService, decorators: [{ type: Inject, args: [LICService,] }] },
    { type: LocationService, decorators: [{ type: Inject, args: [LocationService,] }] },
    { type: OAuthService, decorators: [{ type: Inject, args: [OAuthService,] }] }
];
/**
 * Classe destinada a armazenar o resultado de validação de um {\@link Tenant}
 */
class TenantValidationResult {
    /**
     * @param {?=} tenant
     * @param {?=} partial
     */
    constructor(tenant, /** Representação do Tenant*/ partial = false /**Indica se o tenant é parcial, ou seja, só tem as informações de Municipio. */) {
        this.tenant = tenant;
        this.partial = partial;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Usuario$1 {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Produto {
    /**
     * @param {?} razaoSocial
     * @param {?} titulo
     * @param {?} usuariosLicenciados
     * @param {?} cnpj
     * @param {?} contato
     * @param {?} telefone
     * @param {?} email
     * @param {?} versao
     * @param {?} motivo
     * @param {?} numeroSerie
     * @param {?} codigoSistema
     */
    constructor(razaoSocial, titulo, usuariosLicenciados, cnpj, contato, telefone, email, versao, motivo, numeroSerie, codigoSistema) {
        this.razaoSocial = razaoSocial;
        this.titulo = titulo;
        this.usuariosLicenciados = usuariosLicenciados;
        this.cnpj = cnpj;
        this.contato = contato;
        this.telefone = telefone;
        this.email = email;
        this.motivo = motivo;
        this.numeroSerie = numeroSerie;
        this.rotate = false;
        this.versao = versao;
        this.codigoSistema = codigoSistema;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const FilterInputType = {
    TEXTO: 'TEXTO',
    SELECT: 'SELECT',
    DATA: 'DATA',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Camponentes que representa uma linha de pesquisa do filtro dinâmico
 */
class FilterLineComponent {
    constructor() {
        /**
         * Campos de pesquisa com seus respectivos critérios à serem exibidos no componente
         */
        this.searchKeys = [];
        /**
         * Array com os campos de pesquisa e seus possíveis valores (no caso de um campo SELECT)
         */
        this.criteria = [];
        /**
         * Critérios de pesquisa que podem ser aplicados ao campo
         */
        this.criteriaFilter = [];
        /**
         * Campo de pesquisa selecionado
         */
        this.keySelectedControl = new FormControl('', [Validators.required]);
        /**
         * Critério de pesquisa selecionado
         */
        this.criteriaFormControl = new FormControl('', Validators.required);
        /**
         * Valor da pesquisa do campo com o critério slecionado
         */
        this.filterValueFormControl = new FormControl('', Validators.required);
        /**
         * Valores de ação ao se clicar no botão de ações do filtro
         */
        this.filterActionFormControl = new FormControl('--', Validators.required);
        /**
         * Descritor do campo de pesquisa selecionado, contém as infromações necessários para a exibição dos critérios de pesquisa e valores
         */
        this.criteriaSelected = null;
        /**
         * Emitido quando um campo de pesquisa é selecionado
         */
        this.keySelected = new EventEmitter();
        /**
         * Emitido quando o botão 'Consultar' é selecionado
         */
        this.filterSelected = new EventEmitter();
        /**
         * Emitido quando o botão 'Remover filtro' é selecionado
         */
        this.keyRemoved = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.criteria = this.searchKeys.map((/**
         * @param {?} s
         * @return {?}
         */
        s => {
            if (s.inputType && s.inputType === FilterInputType.SELECT && !s.selectOptions)
                throw new Error('Forneça as opções do select.');
            return { key: s.key, value: s.value, inputType: s.inputType, selectOptions: s.selectOptions };
        }));
        if (this.criteria.length > 0) {
            this.keySelectedControl.setValue(this.criteria[0].key);
            this.onSelectKey({ value: this.criteria[0].key });
        }
        this.keySelectedControl.valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        value => {
            /** @type {?} */
            const criteriaSelected = this.criteria.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.key === value));
            this.criteriaSelected = criteriaSelected ? criteriaSelected : null;
        }));
    }
    /**
     * Trata a selecção de um campo de pesquisa
     * @param {?} $event
     * @return {?}
     */
    onSelectKey($event) {
        /** @type {?} */
        const criteriaSelected = $event.value;
        this.criteriaFilter = this.searchKeys
            .filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.key === criteriaSelected)).map((/**
         * @param {?} c
         * @return {?}
         */
        c => c.criteria))[0].slice();
        this.criteriaFormControl.setValue(this.criteriaFilter[0].criteriaName);
    }
    /**
     * Desabilita os selects de campo de pesquisa e ação da linha
     * @return {?}
     */
    disableLineActions() {
        this.keySelectedControl.disable();
        this.filterActionFormControl.disable();
    }
    /**
     * Habilita os selects de campo de pesquisa e ação da linha
     * @return {?}
     */
    enableLineActions() {
        this.keySelectedControl.enable();
        this.filterActionFormControl.enable();
    }
    /**
     * Trata o clique no botão de ações da linha
     * @param {?} $event
     * @return {?}
     */
    onSelectFilterAction($event) {
        if ($event === false) {
            switch (this.filterActionFormControl.value) {
                case 'filter':
                    this.filterSelected.emit('filter');
                    break;
                case 'remove':
                    this.keyRemoved.emit(this.keySelectedControl.value);
                    break;
                case 'add':
                    this.disableLineActions();
                    this.keySelected.emit(this.keySelectedControl.value);
                    break;
            }
        }
    }
}
FilterLineComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-filter-line',
                template: "<mat-form-field class=\"key govbr-form-field\" appearance=\"outline\">\n    <mat-select class=\"govbr-select\" panelClass=\"govbr-select\" [formControl]=\"keySelectedControl\" (selectionChange)=\"onSelectKey($event)\">\n        <mat-option *ngFor=\"let c of criteria\" [value]=\"c.key\">\n            {{c.value}}\n        </mat-option>\n    </mat-select>\n</mat-form-field>\n<mat-form-field class=\"criteria govbr-form-field\" appearance=\"outline\">\n    <mat-select class=\"govbr-select\" panelClass=\"govbr-select\" [formControl]=\"criteriaFormControl\">\n        <mat-option *ngFor=\"let f of criteriaFilter\" [value]=\"f.criteriaName\">\n            {{f.criteriaValue}}\n        </mat-option>\n    </mat-select>\n</mat-form-field>\n<ng-container *ngIf=\"criteriaSelected\" [ngSwitch]=\"criteriaSelected.inputType\">\n    <ng-container *ngSwitchCase=\"'TEXTO'\">\n        <mat-form-field class=\"value govbr-form-field\" appearance=\"outline\">\n            <input matInput [formControl]=\"filterValueFormControl\">\n        </mat-form-field>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'DATA'\">\n        <mat-form-field class=\"value govbr-form-field\" appearance=\"outline\">\n            <input matInput [matDatepicker]=\"myDatepicker\" [formControl]=\"filterValueFormControl\">\n            <mat-datepicker-toggle matSuffix [for]=\"myDatepicker\"></mat-datepicker-toggle>\n            <mat-datepicker #myDatepicker></mat-datepicker>\n        </mat-form-field>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'SELECT'\">\n        <mat-form-field class=\"value govbr-form-field\" appearance=\"outline\">\n            <mat-select class=\"govbr-select\" panelClass=\"govbr-select\" [formControl]=\"filterValueFormControl\">\n                <mat-option *ngFor=\"let c of criteriaSelected.selectOptions\" [value]=\"c.value\">\n                    {{c.label}}\n                </mat-option>\n            </mat-select>\n        </mat-form-field>\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n        <mat-form-field class=\"value govbr-form-field\" appearance=\"outline\">\n            <input matInput [formControl]=\"filterValueFormControl\">\n        </mat-form-field>\n    </ng-container>\n</ng-container>\n<ng-container *ngIf=\"!criteriaSelected\">\n    <mat-form-field class=\"value govbr-form-field\" appearance=\"outline\">\n        <input matInput [formControl]=\"filterValueFormControl\">\n    </mat-form-field>\n</ng-container>\n<mat-form-field appearance=\"outline\" class=\"actions govbr-form-field\">\n    <mat-select [formControl]=\"filterActionFormControl\" (openedChange)=\"onSelectFilterAction($event)\"\n        class=\"govbr-select\" panelClass=\"govbr-select\">\n        <mat-option value=\"--\">Selecionar a\u00E7\u00E3o</mat-option>\n        <mat-option *ngIf=\"criteria.length > 1\" value=\"add\">Adicionar filtro</mat-option>\n        <mat-option value=\"remove\">Remover filtro</mat-option>\n        <mat-option value=\"filter\">Consultar</mat-option>\n    </mat-select>\n</mat-form-field>",
                styles: [".value{width:424px}"]
            }] }
];
FilterLineComponent.propDecorators = {
    searchKeys: [{ type: Input }],
    keySelected: [{ type: Output }],
    filterSelected: [{ type: Output }],
    keyRemoved: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente de filtro. Recebe os parâmetros de critérios de filtro via input ou com
 * mat-form-field, sempre utilizar com com FormControl e FormGroup
 * Exemplo:
 * ```html
 * <gov-filter [criteria]="criteria" [filterFormGroup]="filterForm" (filterSelected)="onFilterSelected($event)">
 * <mat-form-field appearance="outline">
 * <mat-label>Nome</mat-label>
 * <input matInput placeholder="Nome" [formControl]="filterForm.get('nome')">
 * </mat-form-field>
 * </gov-filter>
 * ```
 */
class FilterComponent {
    constructor() {
        /**
         * Critérios de filtro utilizados para gerar os filtros dinâmicos
         */
        this.criteria = [];
        /**
         * Array utilizado para manipulação da estrutura de dados do componente
         */
        this.criteriaCopy = [];
        /**
         * Representa os critérios que já foram selecionados no filtro dinâmico
         */
        this.filterCriteriaSelected = [];
        /**
         * Array de controle, seu tamanho representa a quantidade de filtros dinâmicos exibida na tela
         */
        this.filterCriteriaVisible = [];
        /**
         * Emitido quando o botão 'Consultar' do filtro dinâmico é selecionado, emite todos os campos do filtro
         */
        this.filterSelected = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.criteriaCopy = this.criteria.slice();
        this.filterCriteriaVisible = [''];
    }
    /**
     * Captura a seleção de um campo de pesquisa para filtro na linha de filtro dinâmico
     * @param {?} $event
     * @return {?}
     */
    onKeySelected($event) {
        this.filterCriteriaVisible.push('');
        this.filterCriteriaSelected.push($event);
        /** @type {?} */
        const criteriaToRemove = this.criteriaCopy.find((/**
         * @param {?} c
         * @return {?}
         */
        c => c.key === $event));
        /** @type {?} */
        const criteriaToRemoveIndex = this.criteriaCopy.indexOf(criteriaToRemove);
        this.criteriaCopy.splice(criteriaToRemoveIndex, 1);
    }
    /**
     * Captura a remoção de uma linha de critério de filtragem do filtro dinâmico
     * @param {?} $event
     * @return {?}
     */
    onKeyRemoved($event) {
        if (this.filterCriteriaVisible.length > 1) {
            this.filterCriteriaVisible.pop();
            /** @type {?} */
            const criteriaSelectedToRemove = this.filterCriteriaSelected.indexOf($event);
            this.filterCriteriaSelected.splice(criteriaSelectedToRemove, 1);
            /** @type {?} */
            const criteriaToAdd = this.criteria.find((/**
             * @param {?} c
             * @return {?}
             */
            c => c.key === $event));
            this.criteriaCopy.push(criteriaToAdd);
        }
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.inputs.last.enableLineActions();
            this.inputs.last.filterActionFormControl.setValue('--');
        }));
    }
    /**
     * Captura todos os campos deste filtro ao se clicar no botão 'Consultar' e os emite
     * @param {?} $event
     * @return {?}
     */
    onFilterSelected($event) {
        /** @type {?} */
        const result = {};
        /** @type {?} */
        const filterFormResult = this.filterFormGroup ? this.filterFormGroup.value : {};
        Object.keys(this.filterFormGroup.value).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            result[key] = filterFormResult[key];
        }));
        this.inputs.forEach((/**
         * @param {?} filter
         * @return {?}
         */
        filter => {
            result[filter.keySelectedControl.value] = [filter.criteriaFormControl.value, filter.filterValueFormControl.value];
        }));
        this.filterSelected.emit(result);
    }
}
FilterComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-filter',
                template: "<div class=\"filter-form-container\">\n    <ng-content></ng-content>\n</div>\n<div class=\"filter-lines-container\">\n    <gov-filter-line *ngFor=\"let c of filterCriteriaVisible; let i = index\" class=\"filter-line-{{i}}\"\n        [searchKeys]=\"criteriaCopy\" (keySelected)=\"onKeySelected($event)\" (keyRemoved)=\"onKeyRemoved($event)\"\n        (filterSelected)=\"onFilterSelected($event)\"></gov-filter-line>\n</div>\n",
                styles: [".filter-lines-container{display:flex;flex-wrap:nowrap;flex-direction:column}"]
            }] }
];
FilterComponent.propDecorators = {
    filterFormGroup: [{ type: Input }],
    criteria: [{ type: Input }],
    filterSelected: [{ type: Output }],
    inputs: [{ type: ViewChildren, args: [FilterLineComponent,] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DatepickerAdapter extends NativeDateAdapter {
    /**
     * @param {?} value
     * @return {?}
     */
    parse(value) {
        /** @type {?} */
        const dateString = value.split('/');
        if (dateString.length === 3) {
            return new Date(+dateString[2], +dateString[1] - 1, +dateString[0], 12);
        }
    }
}
DatepickerAdapter.decorators = [
    { type: Injectable }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FilterModule {
}
FilterModule.decorators = [
    { type: NgModule, args: [{
                declarations: [FilterComponent, FilterLineComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    MatDatepickerModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatNativeDateModule,
                    MatSelectModule,
                    ReactiveFormsModule,
                ],
                exports: [FilterComponent, FilterLineComponent],
                providers: [
                    { provide: DateAdapter, useClass: DatepickerAdapter },
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const TipoDado = {
    texto: 'TEXTO',
    /** Indica que o campo se refere à outra entidade */
    entidade: 'ENTIDADE',
    oculto: 'OCULTO',
    numerico: 'NUMERICO',
    select: 'SELECT',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe responsável por montar um formulário reativo com base nas
 * configurações de metadados fornecidas
 */
class FormBuilderService {
    /**
     * @param {?} formBuilder
     */
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        /**
         * Coleção gerada para renderizar o form de forma linear, sem forms aninhados,
         * para que a estilização do form seja facilitada
         */
        this.arrayEntidades = [];
    }
    /**
     * Coleção gerada para renderizar o form de forma linear, sem forms aninhados,
     * para que a estilização do form seja facilitada
     * @return {?}
     */
    get arrayEntidadesForm() {
        return this.arrayEntidades;
    }
    /**
     * @param {?} entidade
     * @return {?}
     */
    buildForm(entidade) {
        /** @type {?} */
        const formGroup = this.formBuilder.group(this.generateFormObject(entidade));
        this.generateArrayEntidadesForm(entidade, formGroup);
        return formGroup;
    }
    /**
     * @private
     * @param {?} entidade
     * @return {?}
     */
    generateFormObject(entidade) {
        /** @type {?} */
        const formObject = {};
        entidade.campos.forEach((/**
         * @param {?} campo
         * @return {?}
         */
        campo => {
            if (campo.tipoDado !== TipoDado.entidade) {
                formObject[campo.nome] = [null, this.generateFormControlConfig(campo)];
            }
            else {
                formObject[campo.nome] = this.formBuilder.group(this.generateFormObject(campo));
                campo.formGroup = formObject[campo.nome];
            }
        }));
        return formObject;
    }
    /**
     * Retorna todos os campos do formulário como um array para facilitar a mainuplação dos campos
     * @private
     * @param {?} entidade entidade do formulário
     * @param {?} formGroup `FormGroup` responsável pela entidade do formulário
     * @return {?}
     */
    generateArrayEntidadesForm(entidade, formGroup) {
        entidade.campos.forEach((/**
         * @param {?} campo
         * @return {?}
         */
        campo => {
            if (campo.tipoDado !== TipoDado.entidade) {
                campo.formGroup = formGroup;
                this.arrayEntidades.push(campo);
            }
            else {
                this.generateArrayEntidadesForm(campo, campo.formGroup);
            }
        }));
    }
    /**
     * @private
     * @param {?} campo
     * @return {?}
     */
    generateFormControlConfig(campo) {
        /** @type {?} */
        const config = { validators: campo.validators, asyncValidators: campo.asyncValidators, updateOn: 'blur' };
        if (!config.asyncValidators || config.asyncValidators.length === 0) {
            delete config.updateOn;
        }
        return config;
    }
}
FormBuilderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
FormBuilderService.ctorParameters = () => [
    { type: FormBuilder }
];
/** @nocollapse */ FormBuilderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FormBuilderService_Factory() { return new FormBuilderService(ɵɵinject(FormBuilder)); }, token: FormBuilderService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente que recebe uma `EntidadeGenerica`
 * como entrada e monta um formulário de modo automático.
 * Emite os eventos `submitForm` e `deleteItem`,
 * que tratam respectivamente da submissão de dados do formulário
 * e da exclusão do registro sendo exibido no mesmo.
 */
class GenericFormComponent {
    /**
     * @param {?} formBuilderService
     */
    constructor(formBuilderService) {
        this.formBuilderService = formBuilderService;
        /**
         * Evento emitodo ao se submeter um item pelo formulário
         */
        this.submitForm = new EventEmitter();
        /**
         * Evento emitodo ao se excluir um item pelo formulário
         */
        this.deleteItem = new EventEmitter();
        /**
         * Indica se o objeto no formulário está sendo utilizado para edição ou nova submissão
         */
        this.mode = 'new';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.enitityForm = this.formBuilderService.buildForm(this.entidade);
        this.campos = [...this.formBuilderService.arrayEntidadesForm];
    }
    /**
     * @return {?}
     */
    get camposEntidade() {
        return this.campos;
    }
    /**
     * Emite o valor preenchido no formulário
     * @return {?}
     */
    onSubmit() {
        this.submitForm.emit(this.enitityForm.value);
    }
    /**
     * Limpa os dados do formulário
     * @return {?}
     */
    cleanForm() {
        this.mode = 'new';
        this.enitityForm.reset();
    }
    /**
     * Indica que a entidade preenchida no formulário deve ser excluída
     * @return {?}
     */
    delete() {
        this.deleteItem.emit(this.enitityForm.value);
    }
}
GenericFormComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-generic-form',
                template: "<form [formGroup]=\"enitityForm\" (ngSubmit)=\"onSubmit()\">\n\n    <gov-generic-form-renderer [campos]=\"camposEntidade\"></gov-generic-form-renderer>\n\n    <div>\n        <button class=\"govbr-button\" mat-raised-button [disabled]=\"!enitityForm.valid\"\n            [color]=\"enitityForm.valid ? 'primary' : ''\">Salvar</button>\n        <button class=\"govbr-button\" type=\"button\" mat-raised-button (click)=\"cleanForm()\" *ngIf=\"mode === 'edit'\">Cancelar</button>\n        <button class=\"govbr-button\" type=\"button\" mat-raised-button (click)=\"cleanForm()\" *ngIf=\"mode === 'new'\">Limpar</button>\n        <button class=\"govbr-button\" type=\"button\" mat-raised-button (click)=\"delete()\" *ngIf=\"mode === 'edit'\">Excluir</button>\n    </div>\n</form>",
                providers: [FormBuilderService],
                styles: ["div,form,gov-generic-form-renderer{display:flex;align-items:center}form{flex-direction:column;justify-content:center;padding:0 20px}gov-generic-form-renderer{width:100%;justify-content:flex-start;height:calc(100% - 50px);flex-direction:row;flex-wrap:wrap}div{justify-content:center}button{margin:0 8px 16px}"]
            }] }
];
/** @nocollapse */
GenericFormComponent.ctorParameters = () => [
    { type: FormBuilderService }
];
GenericFormComponent.propDecorators = {
    entidade: [{ type: Input }],
    submitForm: [{ type: Output }],
    deleteItem: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente responsável por renderizar um input
 * apropriado para cada campo da entidade, exemplo:
 *
 * Rua, Número: irá renderizar um input texto para rua e tipo numérico para
 * Número
 */
class GenericFormRendererComponent {
    constructor() {
        /**
         * Campos da entidade à serem renderizados
         */
        this.campos = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
GenericFormRendererComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-generic-form-renderer',
                template: "<ng-container *ngFor=\"let cmp of campos\" [ngSwitch]=\"cmp.tipoDado\">\n    <ng-container *ngSwitchCase=\"'TEXTO'\">\n        <gov-input-text [campo]=\"cmp\" [formGroup]=\"cmp.formGroup\"></gov-input-text>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'OCULTO'\">\n        <gov-input-hidden [campo]=\"cmp\" [formGroup]=\"cmp.formGroup\"></gov-input-hidden>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'NUMERICO'\">\n        <gov-input-number [campo]=\"cmp\" [formGroup]=\"cmp.formGroup\"></gov-input-number>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'SELECT'\">\n        <gov-select [campo]=\"cmp\" [formGroup]=\"cmp.formGroup\" [options]=\"cmp.opcoes\"></gov-select>\n    </ng-container>\n</ng-container>",
                styles: ["gov-input-number,gov-input-text,gov-select{max-width:33.3%;width:33.3%;padding:0 10px}"]
            }] }
];
/** @nocollapse */
GenericFormRendererComponent.ctorParameters = () => [];
GenericFormRendererComponent.propDecorators = {
    campos: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe responsável pela configuração da texto de mensagem
 * de erro dos validadores. Extenda essa classe para configurar
 * mensagens de erro customizáveis, aproveitando as que já estão
 * definidas aqui ou crie uma classe que implemente a interface `MensagemErros`
 * para definir as suas próprias mensagens para todos os validadores
 */
class MensagensErroBase {
    constructor() {
        this.required = 'Campo obrigatório';
        this.forbiddenName = 'Nome proibido';
    }
    /**
     * Retorna os campos que indicam o tipo de erro
     * @return {?}
     */
    criteriosDeErros() {
        return Object.keys(new MensagensErroBase());
    }
    /**
     * Retorna com base no tipo de erro, as mensagem correspondente
     * @param {?} criterio tipo de erro
     * @return {?}
     */
    getMensagemErro(criterio) {
        return new MensagensErroBase()[criterio];
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Representa um campo no formulário
 */
class DescritorCampo {
    constructor() {
        /**
         * Opções de preenchimento do campo. Para campos com o valor do atributo tipoDado = SELECT
         */
        this.opcoes = [];
        this.validators = [];
        this.asyncValidators = [];
        /**
         * Quando o campo representa uma entidade (tipoDado = ENTIDADE)
         */
        this.campos = null;
        this.formGroup = null;
        /**
         * Classe de mensagem de erro utilizada para validar o campo
         */
        this.errorConfig = new MensagensErroBase();
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe responsável por obter a mensagem de erro correta com base nas configurações
 * de validação do formulário
 */
class ErrorService {
    constructor() { }
    /**
     * Obtém mensagem de validação com basse em erro levantado no formulário
     * @param {?} campo campo da entidade a ser validado
     * @return {?}
     */
    hasError(campo) {
        /** @type {?} */
        const err = campo.errorConfig.criteriosDeErros().filter((/**
         * @param {?} criterio
         * @return {?}
         */
        criterio => {
            return campo.formGroup.get(campo.nome).hasError(criterio);
        }));
        return err.length > 0 ? campo.errorConfig.getMensagemErro(err[0]) : null;
    }
}
ErrorService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ErrorService.ctorParameters = () => [];
/** @nocollapse */ ErrorService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ErrorService_Factory() { return new ErrorService(); }, token: ErrorService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputTextComponent {
    /**
     * @param {?} errorService
     */
    constructor(errorService) {
        this.errorService = errorService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} group
     * @return {?}
     */
    set formGroup(group) {
        this.fGroup = group;
        this.formControl = (/** @type {?} */ (this.fGroup.get(this.campo.nome)));
    }
    /**
     * @return {?}
     */
    get formGroup() {
        return this.fGroup;
    }
}
InputTextComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-input-text',
                template: "<div [formGroup]=\"formGroup\">\n    <mat-form-field class=\"govbr-form-field\" appearance=\"outline\">\n        <mat-label>{{campo.placeholder}}</mat-label>\n        <input matInput [placeholder]=\"campo.placeholder\" [formControlName]=\"campo.nome\">\n        <mat-error *ngIf=\"errorService.hasError(campo)\">\n            {{errorService.hasError(campo)}}\n        </mat-error>\n    </mat-form-field>\n</div>",
                styles: [""]
            }] }
];
/** @nocollapse */
InputTextComponent.ctorParameters = () => [
    { type: ErrorService }
];
InputTextComponent.propDecorators = {
    campo: [{ type: Input }],
    formGroup: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputHiddenComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} group
     * @return {?}
     */
    set formGroup(group) {
        this.fGroup = group;
        this.formControl = (/** @type {?} */ (this.fGroup.get(this.campo.nome)));
    }
    /**
     * @return {?}
     */
    get formGroup() {
        return this.fGroup;
    }
}
InputHiddenComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-input-hidden',
                template: "<div [formGroup]=\"formGroup\">\n    <input type=\"hidden\" [formControlName]=\"campo.nome\">\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
InputHiddenComponent.ctorParameters = () => [];
InputHiddenComponent.propDecorators = {
    campo: [{ type: Input }],
    formGroup: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputNumberComponent {
    /**
     * @param {?} errorService
     */
    constructor(errorService) {
        this.errorService = errorService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} group
     * @return {?}
     */
    set formGroup(group) {
        this.fGroup = group;
        this.formControl = (/** @type {?} */ (this.fGroup.get(this.campo.nome)));
    }
    /**
     * @return {?}
     */
    get formGroup() {
        return this.fGroup;
    }
}
InputNumberComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-input-number',
                template: "<div [formGroup]=\"formGroup\">\n    <mat-form-field class=\"govbr-form-field\" appearance=\"outline\">\n        <mat-label>{{campo.placeholder}}</mat-label>\n        <input type=\"number\" matInput inputNumber [placeholder]=\"campo.placeholder\" [formControlName]=\"campo.nome\">\n        <mat-error *ngIf=\"errorService.hasError(campo)\">\n            {{errorService.hasError(campo)}}\n        </mat-error>\n    </mat-form-field>\n</div>",
                styles: ["input::-webkit-inner-spin-button,input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}"]
            }] }
];
/** @nocollapse */
InputNumberComponent.ctorParameters = () => [
    { type: ErrorService }
];
InputNumberComponent.propDecorators = {
    campo: [{ type: Input }],
    formGroup: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelectComponent {
    /**
     * @param {?} errorService
     */
    constructor(errorService) {
        this.errorService = errorService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} group
     * @return {?}
     */
    set formGroup(group) {
        this.fGroup = group;
        this.formControl = (/** @type {?} */ (this.fGroup.get(this.campo.nome)));
    }
    /**
     * @return {?}
     */
    get formGroup() {
        return this.fGroup;
    }
    /**
     * Opções disponíveis para o select
     * @param {?} options
     * @return {?}
     */
    set options(options) {
        this.opts = options;
    }
    /**
     * Opções disponíveis para o select
     * @return {?}
     */
    get options() {
        return this.opts;
    }
}
SelectComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-select',
                template: "<div [formGroup]=\"formGroup\">\n    <mat-form-field class=\"govbr-form-field\" appearance=\"outline\">\n        <mat-label>{{campo.placeholder}}</mat-label>\n        <mat-select [formControlName]=\"campo.nome\" class=\"govbr-select\" panelClass=\"govbr-select\">\n            <mat-option *ngFor=\"let option of options\" [value]=\"option.value\">\n                {{option.key}}\n            </mat-option>\n        </mat-select>\n        <mat-error *ngIf=\"errorService.hasError(campo)\">\n            {{errorService.hasError(campo)}}\n        </mat-error>\n    </mat-form-field>\n</div>",
                styles: [""]
            }] }
];
/** @nocollapse */
SelectComponent.ctorParameters = () => [
    { type: ErrorService }
];
SelectComponent.propDecorators = {
    campo: [{ type: Input }],
    formGroup: [{ type: Input }],
    options: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputNumberDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onInputChange(event) {
        event.preventDefault();
        /** @type {?} */
        const match = this.el.nativeElement.value.match(/\d+/g);
        if (match) {
            this.el.nativeElement.value = match.join('');
        }
        else {
            this.el.nativeElement.value = '';
        }
        event.stopPropagation();
    }
}
InputNumberDirective.decorators = [
    { type: Directive, args: [{
                selector: '[inputNumber]'
            },] }
];
/** @nocollapse */
InputNumberDirective.ctorParameters = () => [
    { type: ElementRef }
];
InputNumberDirective.propDecorators = {
    onInputChange: [{ type: HostListener, args: ['input', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputsModule {
}
InputsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [InputNumberDirective],
                imports: [
                    CommonModule
                ],
                exports: [
                    InputNumberDirective
                ],
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GenericFormsModule {
}
GenericFormsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    GenericFormComponent, InputTextComponent,
                    GenericFormRendererComponent, InputHiddenComponent,
                    InputNumberComponent,
                    SelectComponent
                ],
                imports: [
                    CommonModule,
                    InputsModule,
                    MatButtonModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatSelectModule,
                    ReactiveFormsModule
                ],
                exports: [GenericFormComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AsyncValidatorsConfig {
    constructor() {
        this.forbiddenName = (/**
         * @param {?=} time
         * @return {?}
         */
        (time = 2000) => {
            return (/**
             * @param {?} control
             * @return {?}
             */
            (control) => {
                return timer(time).pipe(map((/**
                 * @param {?} res
                 * @return {?}
                 */
                res => {
                    return control.value === 'proibido' ? { forbiddenName: {} } : null;
                })));
            });
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ValidatorsConfig {
    constructor() {
        this.required = (/**
         * @return {?}
         */
        () => {
            return Validators.required;
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Representa uma classe a ser preenchida no formulário genérico
 */
class EntidadeBase {
    /**
     * @param {?} campos
     * @param {?=} errorConfig
     */
    constructor(campos, errorConfig = new MensagensErroBase()) {
        this.errorConfig = new MensagensErroBase();
        this.campos = [];
        this.campos = campos;
        this.errorConfig = errorConfig;
        this.campos.forEach((/**
         * @param {?} campo
         * @return {?}
         */
        campo => campo.errorConfig = this.errorConfig));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EntidadesMetadadosService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * @param {?} nome
     * @return {?}
     */
    getEntidadePorNomeQualificado(nome) {
        return __awaiter(this, void 0, void 0, /** @this {!EntidadesMetadadosService} */ function* () {
            return this.httpClient.get(`assets/entidades-metadados/${nome}.json`)
                .pipe(map((/**
             * @param {?} entidade
             * @return {?}
             */
            entidade => (/** @type {?} */ (entidade))))).toPromise();
        });
    }
}
EntidadesMetadadosService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
EntidadesMetadadosService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ EntidadesMetadadosService.ngInjectableDef = ɵɵdefineInjectable({ factory: function EntidadesMetadadosService_Factory() { return new EntidadesMetadadosService(ɵɵinject(HttpClient)); }, token: EntidadesMetadadosService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe responsável pela configuração do texto de mensagem
 * de erro dos validadores com valores customizados.
 */
class MensagensErroCustomizadas {
    /**
     * @param {?} mensagemErrosConfig
     */
    constructor(mensagemErrosConfig) {
        /** @type {?} */
        const mensagemErrosBase = new MensagensErroBase();
        Object.keys(mensagemErrosBase).forEach((/**
         * @param {?} chave
         * @return {?}
         */
        chave => {
            this[chave] = mensagemErrosBase[chave];
        }));
        Object.keys(mensagemErrosConfig).forEach((/**
         * @param {?} chave
         * @return {?}
         */
        chave => {
            this[chave] = mensagemErrosConfig[chave];
        }));
    }
    /**
     * @return {?}
     */
    criteriosDeErros() {
        return Object.keys(this);
    }
    /**
     * @param {?} criterio
     * @return {?}
     */
    getMensagemErro(criterio) {
        return this[criterio];
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe responsável por construir um objeto de metadados para configurar o formulário genérico
 */
class EntidadeBuilderService {
    /**
     * @param {?} entidadesMetadadosService
     */
    constructor(entidadesMetadadosService) {
        this.entidadesMetadadosService = entidadesMetadadosService;
    }
    /**
     * Constrói o objeto de configuração do formulário de metadados
     * @param {?} entidade nome da entidade a ser construida
     * @param {?=} validatorsConfig objeto com configuração de métodos `ValidatorFn`
     * @param {?=} asyncValidatorsConfig objeto com configuração de métodos `AsyncValidatorFn`
     * @return {?}
     */
    buildEntidadeMetadados(entidade, validatorsConfig = null, asyncValidatorsConfig = null) {
        return from(this.buildEntidade(entidade, validatorsConfig, asyncValidatorsConfig))
            .pipe(filter((/**
         * @param {?} enti
         * @return {?}
         */
        enti => Boolean(enti))));
    }
    /**
     * Constrói o objeto de configuração do formulário de metadados
     * @private
     * @param {?} entidade nome da entidade a ser construida
     * @param {?=} validatorsConfig objeto com configuração de métodos `ValidatorFn`
     * @param {?=} asyncValidatorsConfig objeto com configuração de métodos `AsyncValidatorFn`
     * @return {?}
     */
    buildEntidade(entidade, validatorsConfig = null, asyncValidatorsConfig = null) {
        return __awaiter(this, void 0, void 0, /** @this {!EntidadeBuilderService} */ function* () {
            /** @type {?} */
            let entidadeCarregada = false;
            /** @type {?} */
            const json = yield this.entidadesMetadadosService.getEntidadePorNomeQualificado(entidade);
            /** @type {?} */
            const errorConfig = json.mensagensErro ? new MensagensErroCustomizadas(json.mensagensErro) : new MensagensErroBase();
            /** @type {?} */
            const campos = [];
            /** @type {?} */
            const validatorsCfg = validatorsConfig !== null ? validatorsConfig : new ValidatorsConfig();
            /** @type {?} */
            const asyncValidatorsCfg = asyncValidatorsConfig !== null ? asyncValidatorsConfig : new AsyncValidatorsConfig();
            /** @type {?} */
            const allValidatorsNames = [];
            json.campos.filter((/**
             * @param {?} c
             * @return {?}
             */
            c => c.tipoDado !== TipoDado.entidade)).forEach((/**
             * @param {?} campo
             * @return {?}
             */
            campo => {
                /** @type {?} */
                const c = new DescritorCampo();
                Object.keys(campo).forEach((/**
                 * @param {?} atributo
                 * @return {?}
                 */
                atributo => {
                    switch (atributo) {
                        case 'validators':
                            c[atributo] = this.getValidators(campo[atributo], validatorsCfg);
                            this.setEntityValidators(campo[atributo], allValidatorsNames);
                            break;
                        case 'asyncValidators':
                            c[atributo] = this.getAsyncValidators(campo[atributo], asyncValidatorsCfg);
                            this.setEntityValidators(campo[atributo], allValidatorsNames);
                            break;
                        default:
                            c[atributo] = campo[atributo];
                            break;
                    }
                }));
                campos.push(c);
            }));
            this.verificarMensagensErro(errorConfig, allValidatorsNames);
            /** @type {?} */
            const subCampos = json.campos.filter((/**
             * @param {?} c
             * @return {?}
             */
            c => c.tipoDado === TipoDado.entidade));
            if (subCampos.length === 0) {
                entidadeCarregada = true;
            }
            else {
                for (const cm of subCampos) {
                    yield this.contruirSubEntidade(cm, campos, validatorsCfg, asyncValidatorsCfg);
                    entidadeCarregada = true;
                }
            }
            return entidadeCarregada ? new EntidadeBase(campos, errorConfig) : null;
        });
    }
    /**
     * Constrói um campo do tipo 'ENTIDADE'
     * @private
     * @param {?} campo campo a ser construído
     * @param {?} campos campos da sub-entidade
     * @param {?=} validatorsConfig
     * @param {?=} asyncValidatorsConfig
     * @return {?}
     */
    contruirSubEntidade(campo, campos, validatorsConfig = null, asyncValidatorsConfig = null) {
        return __awaiter(this, void 0, void 0, /** @this {!EntidadeBuilderService} */ function* () {
            /** @type {?} */
            const c = new DescritorCampo();
            c.tipoDado = campo.tipoDado;
            c.nome = campo.nome;
            c.placeholder = campo.placeholder;
            /** @type {?} */
            const subEntidade = yield this.getEntidade(campo.nomeQualificado, validatorsConfig, asyncValidatorsConfig);
            c.campos = subEntidade.campos;
            campos.push(c);
        });
    }
    /**
     * Constrói o objeto de configuração do formulário de metadados,
     * esse método é chamado pelo método `contruirSubEntidade`, para
     * construir a entidade de modo recursivo
     * @private
     * @param {?} entidade nome da entidade a ser construida
     * @param {?=} validatorsConfig objeto com configuração de métodos `ValidatorFn`
     * @param {?=} asyncValidatorsConfig objeto com configuração de métodos `AsyncValidatorFn`
     * @return {?}
     */
    getEntidade(entidade, validatorsConfig = null, asyncValidatorsConfig = null) {
        return __awaiter(this, void 0, void 0, /** @this {!EntidadeBuilderService} */ function* () {
            /** @type {?} */
            const jsonEntidade = yield this.buildEntidade(entidade, validatorsConfig, asyncValidatorsConfig);
            return jsonEntidade;
        });
    }
    /**
     * Obtém os validators dos campos com base na classe de configuração
     * fornecida em ´validatorsConfig´
     * @private
     * @param {?} campos campos da entidade
     * @param {?} validatorsConfig configuração de validações
     * @return {?}
     */
    getValidators(campos, validatorsConfig) {
        /** @type {?} */
        const validators = [];
        campos.forEach((/**
         * @param {?} campo
         * @return {?}
         */
        campo => {
            /** @type {?} */
            const validator = validatorsConfig[campo];
            if (validator) {
                validators.push(validator());
            }
            else {
                throw new Error('validator não encontrado: ' + campo);
            }
        }));
        return validators;
    }
    /**
     * Obtém os async validators dos campos com base na classe de configuração
     * fornecida em ´asyncValidatorsConfig´
     * @private
     * @param {?} campos campos da entidade
     * @param {?} asyncValidatorsConfig configuração de validações
     * @return {?}
     */
    getAsyncValidators(campos, asyncValidatorsConfig) {
        /** @type {?} */
        const asyncValidators = [];
        campos.forEach((/**
         * @param {?} campo
         * @return {?}
         */
        campo => {
            /** @type {?} */
            const asyncValidator = asyncValidatorsConfig[campo];
            if (asyncValidator) {
                asyncValidators.push(asyncValidator());
            }
            else {
                throw new Error('asyncValidator não encontrado: ' + campo);
            }
        }));
        return asyncValidators;
    }
    /**
     * Verifica se para cada função de validação há uma mensagem de erro associada
     * @private
     * @param {?} errorConfig objeto de configuração de mensagens de erro
     * @param {?} allValidatorsNames validadores utilizados na entidade
     * @return {?}
     */
    verificarMensagensErro(errorConfig, allValidatorsNames) {
        /** @type {?} */
        const entityErrorMessages = Object.keys(errorConfig);
        /** @type {?} */
        const defaultErrorMessages = Object.keys(new MensagensErroBase());
        allValidatorsNames.forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            if (!entityErrorMessages.find((/**
             * @param {?} msg
             * @return {?}
             */
            msg => msg === val))
                && !defaultErrorMessages.find((/**
                 * @param {?} msg
                 * @return {?}
                 */
                msg => msg === val))) {
                throw new Error(`Mensagem de erro não definida: ${val}`);
            }
        }));
    }
    /**
     * Obtém uma lista com elementos únicos contendo todos os validadores utilizados na entidade sendo construída
     * @private
     * @param {?} validators validadores do campo da entidade
     * @param {?} allValidators validadores sendo utilizados na entidade
     * @return {?}
     */
    setEntityValidators(validators, allValidators) {
        validators.forEach((/**
         * @param {?} val
         * @return {?}
         */
        val => {
            if (allValidators.indexOf(val) === -1) {
                allValidators.push(val);
            }
        }));
    }
}
EntidadeBuilderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
EntidadeBuilderService.ctorParameters = () => [
    { type: EntidadesMetadadosService }
];
/** @nocollapse */ EntidadeBuilderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function EntidadeBuilderService_Factory() { return new EntidadeBuilderService(ɵɵinject(EntidadesMetadadosService)); }, token: EntidadeBuilderService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GenericTableComponent {
    constructor() {
        this.dados = [];
        this.clickItem = new EventEmitter();
        this.colunasNome = [];
        this.colunasValor = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.entidade.campos
            .filter((/**
         * @param {?} campo
         * @return {?}
         */
        campo => (campo.tipoDado !== TipoDado.entidade && campo.tipoDado !== TipoDado.oculto)))
            .forEach((/**
         * @param {?} campo
         * @return {?}
         */
        campo => {
            this.colunasNome.push(campo.placeholder);
            this.colunasValor.push(campo.nome);
        }));
        this.dataSource = new MatTableDataSource(this.dados);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        this.clickItem.emit($event);
    }
    /**
     * @param {?} elements
     * @return {?}
     */
    update(elements) {
        this.dataSource.data = elements;
    }
}
GenericTableComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-generic-table',
                template: "<div>\n    <table #tableMat mat-table [dataSource]=\"dataSource\" matSort>\n\n        <ng-container *ngFor=\"let coluna of colunasValor; let i = index\">\n            <ng-container [matColumnDef]=\"coluna\">\n                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{colunasNome[i]}}</th>\n                <td mat-cell *matCellDef=\"let row\">{{row[coluna]}}</td>\n            </ng-container>    \n        </ng-container>\n\n        <tr mat-header-row *matHeaderRowDef=\"colunasValor\"></tr>\n        <tr mat-row (click)=\"onClick(row)\" *matRowDef=\"let row; columns: colunasValor;\">\n        </tr>\n    </table>\n\n    <mat-paginator [pageSizeOptions]=\"[5, 10, 25, 100]\"></mat-paginator>\n</div>",
                styles: ["table{width:100%}.mat-form-field{font-size:14px;width:100%}td,th{width:25%}div{padding:0 20px}"]
            }] }
];
/** @nocollapse */
GenericTableComponent.ctorParameters = () => [];
GenericTableComponent.propDecorators = {
    paginator: [{ type: ViewChild, args: [MatPaginator, { static: true },] }],
    sort: [{ type: ViewChild, args: [MatSort, { static: true },] }],
    tableMat: [{ type: ViewChild, args: ['tableMat', { static: true },] }],
    entidade: [{ type: Input }],
    dados: [{ type: Input }],
    clickItem: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GenericTableModule {
}
GenericTableModule.decorators = [
    { type: NgModule, args: [{
                declarations: [GenericTableComponent],
                imports: [
                    CommonModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatPaginatorModule,
                    MatTableModule
                ],
                exports: [GenericTableComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GovColDirective {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     */
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.colConfig.join(' ');
        this.colConfig.forEach((/**
         * @param {?} column
         * @return {?}
         */
        column => this.renderer.addClass(this.elementRef.nativeElement, `colunas-${column}`)));
    }
}
GovColDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govbrColumn]',
            },] }
];
/** @nocollapse */
GovColDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
GovColDirective.propDecorators = {
    colConfig: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GovRowDirective {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     */
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.elementRef.nativeElement.classList.add("govbrRow");
        this.rowConfig.join(' ');
        this.rowConfig.forEach((/**
         * @param {?} row
         * @return {?}
         */
        row => {
            this.renderer.addClass(this.elementRef.nativeElement, `${row}`);
        }));
    }
}
GovRowDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govbrRow]'
            },] }
];
/** @nocollapse */
GovRowDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
GovRowDirective.propDecorators = {
    rowConfig: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GovContainerDirective {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     */
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.containerConfig = [];
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.containerConfig.length) {
            this.containerConfig.forEach((/**
             * @param {?} container
             * @return {?}
             */
            container => {
                this.renderer.addClass(this.elementRef.nativeElement, `container-${container}`);
            }));
        }
        else {
            this.renderer.addClass(this.elementRef.nativeElement, 'container');
        }
    }
}
GovContainerDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govbrContainer]'
            },] }
];
/** @nocollapse */
GovContainerDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
GovContainerDirective.propDecorators = {
    containerConfig: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GridModule {
}
GridModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    GovRowDirective,
                    GovColDirective,
                    GovContainerDirective
                ],
                imports: [],
                exports: [
                    GovRowDirective,
                    GovColDirective,
                    GovContainerDirective
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe que representa um item de perfil do usuário vindo do backend.
 */
class ItemPerfilUsuario {
    /**
     * @param {?} uid
     * @param {?} nomePerfilUsuario
     * @param {?} urlPerfilImagem
     */
    constructor(uid, nomePerfilUsuario, urlPerfilImagem) {
        this.uid = uid;
        this.nomePerfilUsuario = nomePerfilUsuario;
        this.urlPerfilImagem = urlPerfilImagem;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe que representa um item de favoritos vindo do backend
 */
class ItemFavoritos {
    /**
     * @param {?} uid
     * @param {?} titulo
     * @param {?=} url
     * @param {?=} rota
     * @param {?=} tituloProduto
     * @param {?=} breadcrumb
     */
    constructor(uid, titulo, url, rota, tituloProduto, breadcrumb) {
        this.uid = uid;
        this.titulo = titulo;
        this.url = url;
        this.rota = rota;
        this.tituloProduto = tituloProduto;
        this.breadcrumb = breadcrumb;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TelaMenuGrpService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.cliqueMenuGrp = new Subject();
        this.cliqueHomeGrp = new Subject();
    }
    /**
     * @param {?} url
     * @param {?} idUsuario
     * @return {?}
     */
    getMenuGrpIdUsuario(url, idUsuario) {
        return this.httpClient.get(`${url}/${idUsuario}`);
    }
    /**
     * @param {?} url
     * @param {?} idUsuario
     * @param {?} idCliente
     * @return {?}
     */
    getMenuGrpIdUsuarioEIdCliente(url, idUsuario, idCliente) {
        return this.httpClient.get(`${url}/${idUsuario}/${idCliente}`);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setCliqueMenuGrp(event) {
        this.cliqueMenuGrp.next(event);
    }
    /**
     * @return {?}
     */
    getCliqueMenuGrp() {
        return this.cliqueMenuGrp;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setCliqueHome(event) {
        return this.cliqueHomeGrp.next(event);
    }
}
TelaMenuGrpService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
TelaMenuGrpService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ TelaMenuGrpService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TelaMenuGrpService_Factory() { return new TelaMenuGrpService(ɵɵinject(HttpClient)); }, token: TelaMenuGrpService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente de implementação do cabeçalho
 */
class CabecalhoComponent {
    /**
     * @param {?} telaMenuGrpService
     */
    constructor(telaMenuGrpService) {
        this.telaMenuGrpService = telaMenuGrpService;
        this.exibeAlterarSenha = true;
        this.exibeBotaoHamburguer = true;
        this.exibeModalLGPD = true;
        this.exibeBtnHome = false;
        this.menu = new EventEmitter();
        this.itemMenuGrp = new EventEmitter();
        this.cliqueFavoritos = new EventEmitter();
        this.cliqueNotificacao = new EventEmitter();
        this.botaoSair = new EventEmitter();
        this.botaoItem = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    openMenu() {
        this.menu.emit(true);
    }
    /**
     * Método para detectar o clique no item do menu GRP.
     * @param {?} event
     * @return {?}
     */
    capturaCliqueMenuGrp(event) {
        this.itemMenuGrp.emit(event);
    }
    /**
     * Método para detectar o clique no produto de favoritos.
     * @param {?} item
     * @return {?}
     */
    capturaCliqueFavoritos(item) {
        this.cliqueFavoritos.emit(item);
    }
    /**
     * Método para detectar o clique no botão de sair do perfil de usuário.
     * @param {?} event
     * @return {?}
     */
    capturaCliqueBotaoSair(event) {
        this.botaoSair.emit(event);
    }
    /**
     * Método para detectar o clique no produto de notificações.
     * @param {?} event
     * @return {?}
     */
    capturaCliqueNotificacoes(event) {
        this.cliqueNotificacao.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    capturaCliqueItem(event) {
        this.botaoItem.emit(event);
    }
    /**
     * @return {?}
     */
    paraHome() {
        this.telaMenuGrpService.cliqueHomeGrp.next(true);
    }
}
CabecalhoComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-cabecalho',
                template: "<section class=\"cabecalho flex\">\n  <button *ngIf=\"exibeBotaoHamburguer\" class=\"menu-hamburguer\" (click)=\"openMenu()\">\n    <div>\n      <mat-icon [inline]=\"true\">menu</mat-icon>\n    </div>\n  </button>\n  <div class=\"cabecalho-itens flex-column\">\n    <div class=\"nav-top navegacao flex bg-branco\">\n      <h1 class=\"navegacao-titulo\">{{ dadoCabecalho?.nomeProduto }}</h1>\n      <gov-navegacao\n        [exibePesquisa]=\"exibePesquisa\"\n        [exibeMenuGRP]=\"exibeMenuGRP\"\n        [exibeFavoritos]=\"exibeFavoritos\"\n        [exibeNotificacao]=\"exibeNotificacao\"\n        [exibePerfil]=\"exibePerfil\"\n        [exibeAlterarSenha]=\"exibeAlterarSenha\"\n        [url]=\"url\"\n        [menuGrp]=\"menuGrp\"\n        [favoritos]=\"favoritos\"\n        [perfilusuario]=\"perfilUsuario\"\n        [rotaNotificacoes]=\"rotaNotificacoes\"\n        (itemMenuGrp)=\"capturaCliqueMenuGrp($event)\"\n        (cliqueFavoritos)=\"capturaCliqueFavoritos($event)\"\n        (botaoSair)=\"capturaCliqueBotaoSair($event)\"\n        (botaoItem)=\"capturaCliqueItem($event)\"\n        class=\"navegacao-itens flex\"\n      ></gov-navegacao>\n    </div>\n    <div class=\"nav-bottom navegacao bg-azul-claro\">\n      <h2 (click)=\"paraHome()\" class=\"navegacao-subtitulo\">\n        <mat-icon>home</mat-icon>\n        {{ dadoCabecalho?.nomePrefeitura }}\n      </h2>\n      <div class=\"flex\">\n        <p *ngFor=\"let item of dadoCabecalho?.itens\">\n          <a [routerLink]=\"item.url\">{{ item.nome }}</a>\n        </p>\n      </div>\n    </div>\n  </div>\n  <govbr-modal-lgpd [isPerfilUsuarioLgpd]=\"false\" [exibeModalLGPD]=\"exibeModalLGPD\"></govbr-modal-lgpd>\n</section>\n",
                styles: [".cabecalho{height:80px}.cabecalho-itens{height:80px;width:100%}.menu-hamburguer{border:none;width:80px;height:80px;cursor:pointer;display:flex;justify-content:center;align-items:center}.menu-hamburguer .mat-icon{font-size:35px}.navegacao{display:flex;justify-content:space-between;align-items:center}.nav-top{height:80px}.nav-top .navegacao-titulo{font-style:normal;font-weight:200;font-size:28px;font-size:calc(.5em + 1vw);margin-left:25px}.nav-bottom{height:28px;padding:5px 0}.nav-bottom .navegacao-subtitulo{font-style:normal;font-weight:400;font-size:14px;line-height:19px;text-transform:uppercase;margin-left:25px;display:flex;align-items:center;justify-content:center;margin-bottom:-1px;cursor:pointer}.nav-bottom .navegacao-subtitulo mat-icon{margin-top:-1px;margin-right:10px}.nav-bottom div p{margin-right:25px;font-size:13px;font-weight:400}.avatar{width:36px;height:36px;margin-right:16px;background-color:red;border-radius:50%}.notificacoes{width:15px;height:15px;background-color:red;position:absolute;border-radius:50%;top:-2px;right:8px}@media screen and (max-width:600px){.nav-bottom .navegacao-subtitulo{font-size:12px}.nav-bottom div p{font-size:11px;margin-right:15px}}.mat-toolbar-row,.mat-toolbar-single-row{height:100%}.flex{display:flex;align-items:center}.flex p a{text-decoration:none}.flex-column{display:flex;flex-direction:column}"]
            }] }
];
/** @nocollapse */
CabecalhoComponent.ctorParameters = () => [
    { type: TelaMenuGrpService }
];
CabecalhoComponent.propDecorators = {
    dadoCabecalho: [{ type: Input }],
    exibePesquisa: [{ type: Input }],
    menuGrp: [{ type: Input }],
    url: [{ type: Input }],
    exibeMenuGRP: [{ type: Input }],
    exibePerfil: [{ type: Input }],
    exibeAlterarSenha: [{ type: Input }],
    exibeFavoritos: [{ type: Input }],
    exibeNotificacao: [{ type: Input }],
    perfilUsuario: [{ type: Input }],
    favoritos: [{ type: Input }],
    exibeBotaoHamburguer: [{ type: Input }],
    exibeModalLGPD: [{ type: Input }],
    rotaNotificacoes: [{ type: Input }],
    exibeBtnHome: [{ type: Input }],
    menu: [{ type: Output }],
    itemMenuGrp: [{ type: Output }],
    cliqueFavoritos: [{ type: Output }],
    cliqueNotificacao: [{ type: Output }],
    botaoSair: [{ type: Output }],
    botaoItem: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe que representa um item de menu vindo do backend
 */
class ItemMenuGrp {
    /**
     * @param {?} uid
     * @param {?} titulo
     * @param {?=} icone
     * @param {?=} url
     * @param {?=} submenu
     * @param {?=} statusProduto
     */
    constructor(uid, titulo, icone, url, submenu, statusProduto) {
        this.uid = uid;
        this.titulo = titulo;
        this.icone = icone;
        this.url = url;
        this.submenu = submenu;
        this.statusProduto = statusProduto;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NavegacaoComponent {
    constructor() {
        this.exibeAlterarSenha = true;
        this.itemMenuGrp = new EventEmitter();
        this.cliqueFavoritos = new EventEmitter();
        this.botaoSair = new EventEmitter();
        this.botaoItem = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * Método para detectar o clique no item do menu GRP.
     * @param {?} event
     * @return {?}
     */
    capturaCliqueMenuGrp(event) {
        this.itemMenuGrp.emit(event);
    }
    /**
     * Método para detectar o clique no produto de favoritos.
     * @param {?} item
     * @return {?}
     */
    capturaCliqueFavoritos(item) {
        this.cliqueFavoritos.emit(item);
    }
    /**
     * Método para detectar o clique no botão de sair do perfil de usuário.
     * @param {?} event
     * @return {?}
     */
    capturaCliqueBotaoSair(event) {
        this.botaoSair.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    capturaCliqueItem(event) {
        this.botaoItem.emit(event);
    }
}
NavegacaoComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-navegacao',
                template: "<div class=\"navegacao-itens\">\n  <gov-pesquisa *ngIf=\"exibePesquisa\" [url]=\"url\"></gov-pesquisa>\n  <gov-botao-menu-grp *ngIf=\"exibeMenuGRP\" [menuGrp]=\"menuGrp\" (itemMenuGrp)=\"capturaCliqueMenuGrp($event)\"></gov-botao-menu-grp>\n  <gov-notificacoes *ngIf=\"exibeNotificacao\" [rotaNotificacoes]=\"rotaNotificacoes\"></gov-notificacoes>\n  <gov-favoritos *ngIf=\"exibeFavoritos\" [favoritos]=\"favoritos\" (cliqueFavoritos)=\"capturaCliqueFavoritos($event)\"></gov-favoritos>\n  <gov-perfil-usuario \n    *ngIf=\"exibePerfil\" \n    [exibeModalLGPD]=\"exibeModalLGPD\" \n    [exibeAlterarSenha]=\"exibeAlterarSenha\" \n    [perfilUsuario]=\"perfilusuario\" \n    (botaoSair)=\"capturaCliqueBotaoSair($event)\"\n    (botaoItem)=\"capturaCliqueItem($event)\">\n  </gov-perfil-usuario>\n</div>\n",
                styles: [".navegacao-itens{display:flex;align-items:center;margin:0 10px;list-style:none}.nav-top{padding:8px 0 6px 11px}.nav-top .navegacao-titulo{font-style:normal;font-weight:200;font-size:28px;line-height:38px;margin-left:10px}.nav-bottom{padding:8px 0 5px 11px;height:28px}.avatar{width:36px;height:36px;margin-right:17px;background-color:red;border-radius:50%}.navegacao-itens li{padding:0 8px;position:relative}.notificacoes{width:16px;height:16px;background-color:red;position:absolute;border-radius:50%;top:3px;right:5px}.notificacoes p{font-size:10px;text-align:center;margin-top:1px}.notificacao-create{width:16px;height:16px;background-color:red;position:absolute;border-radius:50%;top:-2px;right:6px}.notificacao-create p{font-size:10px;text-align:center;margin-top:1px;color:#fff}.simbolo-govbr{background:url(../../../assets/icons/simbolo.svg) center no-repeat;width:30px;height:30px}.simbolo-create{background:url(../../../assets/icons/create.svg) center no-repeat;width:25px;height:25px}.simbolo-estrela,.simbolo-sino,.simbolo-update{margin-top:5px}@media screen and (max-width:768px){.navegacao-itens li{padding:0 5px}}"]
            }] }
];
/** @nocollapse */
NavegacaoComponent.ctorParameters = () => [];
NavegacaoComponent.propDecorators = {
    menuGrp: [{ type: Input }],
    favoritos: [{ type: Input }],
    exibeMenuGRP: [{ type: Input }],
    url: [{ type: Input }],
    exibePesquisa: [{ type: Input }],
    exibeFavoritos: [{ type: Input }],
    exibePerfil: [{ type: Input }],
    exibeAlterarSenha: [{ type: Input }],
    perfilusuario: [{ type: Input }],
    exibeNotificacao: [{ type: Input }],
    exibeModalLGPD: [{ type: Input }],
    rotaNotificacoes: [{ type: Input }],
    itemMenuGrp: [{ type: Output }],
    cliqueFavoritos: [{ type: Output }],
    botaoSair: [{ type: Output }],
    botaoItem: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuGrpService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.cliqueMenuGrp = new Subject();
    }
    /**
     * @param {?} url
     * @param {?} idUsuario
     * @return {?}
     */
    getMenuGrpIdUsuario(url, idUsuario) {
        return this.httpClient.get(`${url}/${idUsuario}`);
    }
    /**
     * @param {?} url
     * @param {?} idUsuario
     * @param {?} idCliente
     * @return {?}
     */
    getMenuGrpIdUsuarioEIdCliente(url, idUsuario, idCliente) {
        return this.httpClient.get(`${url}/${idUsuario}/${idCliente}`);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setCliqueMenuGrp(event) {
        this.cliqueMenuGrp.next(event);
    }
    /**
     * @return {?}
     */
    getCliqueMenuGrp() {
        return this.cliqueMenuGrp;
    }
}
MenuGrpService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MenuGrpService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ MenuGrpService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MenuGrpService_Factory() { return new MenuGrpService(ɵɵinject(HttpClient)); }, token: MenuGrpService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogProdutosGrpComponent {
    /**
     * @param {?} dialogRef
     * @param {?} produto
     * @param {?} menuGrpService
     */
    constructor(dialogRef, produto, menuGrpService) {
        this.dialogRef = dialogRef;
        this.produto = produto;
        this.menuGrpService = menuGrpService;
        this.produtosGrp = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Ordenação dos produtos por ordem alfabética.
        if (this.produto) {
            this.produtosGrp = this.produto.submenu.slice();
        }
        this.produtosGrp.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        (a, b) => a.titulo.localeCompare(b.titulo)));
    }
    /**
     *  Emite o evento de clique no status do produto correspondente.
     * @param {?} item
     * @return {?}
     */
    cliqueStatusProduto(item) {
        this.menuGrpService.setCliqueMenuGrp(item);
    }
    /**
     * Fecha o dialog que exibe os produtos.
     * @return {?}
     */
    fecharProdutos() {
        this.dialogRef.close();
    }
}
DialogProdutosGrpComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-dialog-produtos-grp',
                template: "<div class=\"produtos-menu-grp\">\n  <div class=\"titulo\">\n    <img\n      src=\"assets/icons/icone-x-fechar.svg\"\n      class=\"icone-fechar\"\n      (click)=\"fecharProdutos()\"\n    />\n    <div class=\"subtitulo\">\n      <p>Produtos</p>\n      <mat-icon>{{ produto.icone }}</mat-icon>\n    </div>\n    <img src=\"assets/icons/linha.svg\" class=\"linha\" />\n  </div>\n\n  <div class=\"produtos\">\n    <ul class=\"lista-produtos\">\n      <li *ngFor=\"let row of produto.submenu; let idx = index\">\n        <div class=\"title_product\">\n          <p>{{ row.titulo | slice:0:30 }}</p>\n        </div>\n        <govbr-menu-grp-button\n          [corBotao]=\"row.corBotao\"\n          [textoBotao] = \"row.statusProduto?.titulo\"\n          (cliqueStatusProduto)=\"cliqueStatusProduto(row)\">\n        >\n        </govbr-menu-grp-button>\n      </li>\n    </ul>\n  </div>\n</div>\n",
                styles: [".produtos{width:calc(100% - 50px);padding-bottom:32px}.produtos .lista-produtos{display:flex;justify-content:flex-start;flex-wrap:wrap;width:100%;margin-left:31px}.produtos .lista-produtos li{display:flex;align-items:center;flex-direction:column;height:95px;width:calc(25% - 15px);margin-top:24px;border-radius:5px;z-index:1;margin-right:15px;min-width:110px;padding:3px}.produtos .lista-produtos li .title_product{height:45px;overflow:hidden}.produtos .lista-produtos li .title_product p{margin-top:10px;height:33px;word-wrap:break-word;font-family:Nunito Sans;font-style:normal;font-weight:600;font-size:12px;line-height:18px;text-align:center}.produtos .lista-produtos .status a{cursor:pointer;display:flex;justify-content:center;align-items:center;height:30px;min-width:94px;margin-top:10px;padding-top:4px;padding-left:8px;padding-right:8px;border-radius:5px;z-index:1}.produtos .lista-produtos .status a mat-icon{font-size:12px;height:18px;width:18px}.produtos .lista-produtos .status a p{font-family:Nunito Sans;font-style:normal;font-weight:400;font-size:13px;line-height:18px;text-align:center}.titulo{display:flex;flex-flow:column}.titulo .subtitulo{display:flex;width:calc(100% - 90px);margin-left:25px}.titulo .subtitulo p{font-family:Nunito Sans;font-style:normal;font-weight:600;font-size:16px;line-height:18px}.titulo .subtitulo mat-icon{font-size:16px;height:16px;width:16px;margin-top:3px;margin-left:calc(100% - 40px)}.titulo img.icone-fechar{cursor:pointer;margin-top:10px;margin-left:calc(100% - 20px);margin-bottom:11px;height:12px;width:12px}.titulo img.linha{max-height:2px;min-height:2px;margin-left:25px;width:calc(100% - 50px)}"]
            }] }
];
/** @nocollapse */
DialogProdutosGrpComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: ItemMenuGrp, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
    { type: MenuGrpService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DataMenuGrpModal {
    /**
     * @param {?} menuGrp
     */
    constructor(menuGrp) {
        this.menuGrp = menuGrp;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuGrpComponent {
    /**
     * @param {?} dialogRef
     * @param {?} data
     * @param {?} dialog
     */
    constructor(dialogRef, data, dialog) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.menuGrp = [];
        this.itemMenuGrp = new EventEmitter();
        this.showMenu = false;
        this.inside = false;
        this.isClickedWithSubMenu = false;
        this.isBgBlue = [];
        this.areaAberta = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.data) {
            this.menuGrp = this.data.menuGrp;
            this.data.menuGrp.map((/**
             * @param {?} menu
             * @return {?}
             */
            menu => {
                this.isBgBlue.push({ uid: menu.uid, hasBgBlue: false });
            }));
        }
    }
    /**
     * gera a config para que saber quando intejar a classe hasBgBlue
     * quando clicado no array isBgBlue
     * @param {?} event
     * @param {?} row
     * @return {?}
     */
    isShowSubMenu(event, row) {
        event.stopPropagation();
        this.isBgBlue = [];
        if (row.submenu) {
            /** @type {?} */
            const genBgBlueTrue = this.data.menuGrp.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => row === item && item.submenu));
            genBgBlueTrue.map((/**
             * @param {?} config
             * @return {?}
             */
            config => this.isBgBlue.push({ uid: config.uid, hasBgBlue: true })));
        }
        if (row.submenu === undefined) {
            /** @type {?} */
            const genBgBlueNonSub = this.data.menuGrp.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => row === item));
            genBgBlueNonSub.map((/**
             * @param {?} config
             * @return {?}
             */
            config => this.isBgBlue.push({ uid: config.uid, hasBgBlue: false })));
        }
        /** @type {?} */
        const genBgBlueFalse = this.data.menuGrp.filter((/**
         * @param {?} item
         * @return {?}
         */
        item => row !== item));
        genBgBlueFalse.map((/**
         * @param {?} config
         * @return {?}
         */
        config => this.isBgBlue.push({ uid: config.uid, hasBgBlue: false })));
        this.isBgBlue.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        (a, b) => {
            return (a.uid - b.uid);
        }));
        this.areaAberta = true;
        this.dialog.open(DialogProdutosGrpComponent, {
            backdropClass: 'gov-produtos-menu-grp-background',
            panelClass: 'gov-produtos-menu-grp-panel',
            data: row,
            maxHeight: '100vh'
        }).afterClosed().subscribe((/**
         * @param {?} _
         * @return {?}
         */
        _ => {
            this.areaAberta = false;
        }));
    }
    /**
     * Método para detectar click outside
     * @param {?} ev
     * @return {?}
     */
    capturaClickFora(ev) {
        this.isBgBlue.map((/**
         * @param {?} config
         * @return {?}
         */
        config => config.hasBgBlue = false));
    }
    /**
     * Método para detectar o clique no item do menu GRP
     * e enviar o produto clicado.
     * @param {?} event
     * @param {?} prod
     * @return {?}
     */
    capturaCliqueMenuGrp(event, prod) {
        /* if (prod.submenu) {
          this.itemMenuGrp.emit(prod);
        } */
    }
    /**
     * Método exibe/recolhe menu grp  clicando na bandeira
     * @return {?}
     */
    show() {
        this.inside = true;
    }
    /**
     * Método recolhe menu grp clicando em qualquer lugar da tela fora do box menu
     * @return {?}
     */
    clickedOut() {
        if (!this.inside && !this.areaAberta) {
            this.isBgBlue.map((/**
             * @param {?} config
             * @return {?}
             */
            config => config.hasBgBlue = false));
        }
        this.showMenu = this.inside
            ? true
            : false;
        this.inside = false;
    }
}
MenuGrpComponent.decorators = [
    { type: Component, args: [{
                selector: "gov-menu-grp",
                template: "<div class=\"menu-grp\" (click)=\"capturaClickFora($event)\">\n  <div class=\"row\">\n    <ul class=\"menu\">\n      <!-- Controle de limitacao dos itens do menu atraves do slice -->\n      <li *ngFor=\"let row of menuGrp | slice:0:18; let indx = index\">\n          <a\n            (mouseenter)=\"uidHover = row.uid\"\n            (mouseleave)=\"uidHover = null\"\n            (click)=\"isShowSubMenu($event, row)\"\n            [ngClass]=\"{'hasntProduct': !row?.submenu,\n                        'hasProduct': row?.submenu,\n                        'bg-blue': isBgBlue[indx].hasBgBlue}\" >\n            <mat-icon *ngIf=\"row.icone !== null && row?.icone\">{{ row.icone }}</mat-icon>\n            <!-- Controle de limitacao dos caracteres do item do menu atraves do slice -->\n            <p>{{ row.titulo | slice:0:60 }}</p>\n          </a>\n        <span *ngIf=\"!menuGrp[indx]?.submenu && uidHover === row.uid\">Conhe\u00E7a a solu\u00E7\u00E3o</span>\n      </li>\n    </ul>\n  </div>\n</div>\n",
                styles: ["@charset \"UTF-8\";:host{height:calc(100vh - 447px);width:978px;max-width:978px}*{box-sizing:border-box}.menu-grp{transform:translate(-50%,-50%);border:1px solid #9fdfff;height:calc(100vh - 250px);width:calc(100vw - 200px);position:absolute;border-radius:5px;min-height:300px;min-width:200px;overflow:auto;left:50%;top:50%}.row:after{content:\"\";display:table;clear:both}.menu,.submenu{display:flex;flex-flow:row wrap;width:100%;height:100%;padding:40px;row-gap:0;-moz-column-gap:30px;column-gap:30px}.menu li{display:flex;flex-direction:column;list-style:none;padding-bottom:47px}.menu li .hasntProduct{opacity:.5}.menu li .hasntProduct mat-icon,.menu li .hasntProduct p{cursor:default}.menu li .hasntProduct:hover{opacity:1}.menu li a{width:104px;height:104px;display:flex;flex-flow:column;align-items:center;justify-content:center;text-align:center}.menu li a p{width:97px;max-height:55px;overflow:hidden;font-size:.813rem;padding:0 .313rem;display:-webkit-box;word-wrap:break-word;-webkit-box-orient:vertical}.menu li span{width:104px;font-size:.75rem;margin-top:4px}.menu li .hasProduct{cursor:pointer}.menu li:nth-child(6n) a{margin-right:0}.menu li:hover{padding-bottom:27px}.menu li a mat-icon{font-size:1.8rem;vertical-align:middle;width:26px;height:26px;margin-bottom:7px}.is-father:hover .bg-blue{height:auto;border-radius:5px 5px 0 0}.is-father .submenu{border-radius:0 0 5px 5px}.is-father:hover .submenu{display:block}.submenu li{margin:0;padding:0;width:100%;height:auto;list-style:none}.submenu li a{padding:4px 10px 6px;height:auto;font-size:.813rem}.submenu{display:none;width:calc(25% - 30px);z-index:1}.last-child:hover{border-radius:0 0 5px 5px}@media only screen and (max-height:640px){:host{height:calc(100vh - 417px)}}@media only screen and (min-height:1200px){:host{height:calc(100vh - 1130px)}}"]
            }] }
];
/** @nocollapse */
MenuGrpComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: DataMenuGrpModal, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
    { type: MatDialog }
];
MenuGrpComponent.propDecorators = {
    menuGrp: [{ type: Input }],
    itemMenuGrp: [{ type: Output }],
    show: [{ type: HostListener, args: ['click',] }],
    clickedOut: [{ type: HostListener, args: ['document:click',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProdutosMenuGrpComponent {
    /**
     * @param {?} dialog
     */
    constructor(dialog) {
        this.dialog = dialog;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /*
       * Método que exibe os produtos ao clicar na área de négocio.
       */
    /**
     * @return {?}
     */
    exibeProdutos() {
        this.dialog.open(DialogProdutosGrpComponent, {
            backdropClass: 'gov-produtos-menu-grp-background',
            panelClass: 'gov-produtos-menu-grp-panel'
        });
    }
}
ProdutosMenuGrpComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-produtos-menu-grp',
                template: "<div class=\"botao-area-negocio\" (click)=\"exibeProdutos()\"></div>\n",
                styles: [".botao-area-negocio{background:url(../../../assets/icons/marca-GOVBR.svg) center no-repeat;width:100px;height:100px;cursor:pointer;margin-left:16px}"]
            }] }
];
/** @nocollapse */
ProdutosMenuGrpComponent.ctorParameters = () => [
    { type: MatDialog }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuGrpButtonComponent {
    constructor() {
        this.cliqueStatusProduto = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} produto
     * @return {?}
     */
    emiteCliqueItemMenuGrp(produto) {
        this.cliqueStatusProduto.emit(produto);
    }
}
MenuGrpButtonComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-menu-grp-button',
                template: "<button\n    mat-raised-button\n    class=\"govbr-button-menu-grp {{corBotao}}\"\n    (click)=\"emiteCliqueItemMenuGrp($event)\"\n    type=\"button\">\n    {{textoBotao}}\n</button>\n\n",
                styles: [""]
            }] }
];
/** @nocollapse */
MenuGrpButtonComponent.ctorParameters = () => [];
MenuGrpButtonComponent.propDecorators = {
    corBotao: [{ type: Input }],
    textoBotao: [{ type: Input }],
    cliqueStatusProduto: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ProdutosMenuGrpModule {
}
ProdutosMenuGrpModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ProdutosMenuGrpComponent,
                    DialogProdutosGrpComponent,
                    MenuGrpButtonComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatDialogModule
                ],
                exports: [
                    ProdutosMenuGrpComponent,
                    DialogProdutosGrpComponent,
                    MenuGrpButtonComponent
                ],
                entryComponents: [
                    DialogProdutosGrpComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BotaoMenuGrpComponent {
    /**
     * @param {?} dialog
     */
    constructor(dialog) {
        this.dialog = dialog;
        this.menuGrp = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    openMenu() {
        this.dialog.open(MenuGrpComponent, {
            data: { menuGrp: this.menuGrp },
            backdropClass: 'new-background',
            panelClass: 'menu-grp-panel',
            maxWidth: '100vw'
        });
    }
}
BotaoMenuGrpComponent.decorators = [
    { type: Component, args: [{
                selector: "gov-botao-menu-grp",
                template: "<div class=\"simbolo-govbr\" (click)=\"openMenu()\">\n    <img alt=\"Bot\u00E3o GRP\" src=\"assets/icons/simbolo.svg\">\n</div>\n",
                styles: [".simbolo-govbr{width:30px;height:30px;cursor:pointer;margin-left:16px;display:flex;align-items:center;justify-content:center}"]
            }] }
];
/** @nocollapse */
BotaoMenuGrpComponent.ctorParameters = () => [
    { type: MatDialog }
];
BotaoMenuGrpComponent.propDecorators = {
    menuGrp: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuGrpModule {
}
MenuGrpModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    BotaoMenuGrpComponent,
                    MenuGrpComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    HttpClientModule,
                    RouterModule,
                    ProdutosMenuGrpModule,
                    MatDialogModule
                ],
                exports: [
                    BotaoMenuGrpComponent,
                    MenuGrpComponent
                ],
                entryComponents: [
                    MenuGrpComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AbreModalLgpdService {
    /**
     * @param {?} backService
     * @param {?} usuarioSsoService
     */
    constructor(backService, usuarioSsoService) {
        this.backService = backService;
        this.usuarioSsoService = usuarioSsoService;
    }
    /**
     * @return {?}
     */
    aceiteModalLgpd() {
        return __awaiter(this, void 0, void 0, /** @this {!AbreModalLgpdService} */ function* () {
            /** @type {?} */
            const user = yield this.usuarioSsoService.getUsuarioSSO().toPromise();
            this.user = user;
            return this.backService.setNomeEndpoint('pronim/aceiteTermoLgpd').post(`pronim-framework/${this.user.oid}/v1`, {});
        });
    }
    /**
     * @return {?}
     */
    showDialogLgpd() {
        return __awaiter(this, void 0, void 0, /** @this {!AbreModalLgpdService} */ function* () {
            /** @type {?} */
            const user = yield this.usuarioSsoService.getUsuarioSSO().toPromise();
            this.user = user;
            return this.backService.setNomeEndpoint('pronim/aceiteTermoLgpd').get(`pronim-framework/${this.user.oid}/v1`);
        });
    }
    /**
     * @return {?}
     */
    getUsuarioSSO() {
        this.usuarioSsoService.getUsuarioSSO().subscribe((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            console.log(user);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        err => console.log(err)));
    }
    /**
     * @return {?}
     */
    getTextoLGPD() {
        return [
            { title: '',
                body: `Estes Termos de Uso (“Termos de Uso”) estabelecem os termos e condições de acesso e uso dos produtos produzidos e mantidos pela GOVERNANÇABRASIL S/A TECNOLOGIA E GESTAO EM SERVIÇOS (“GOVBR”), sociedade inscrita no CNPJ/MF nº 00.165.960/0001-01 com sede na Rua João Pessoa, n.º 1183, bairro Velha em Blumenau/SC, CEP 89036-001.` },
            { title: '1.	Introdução',
                body: `A presente Política de Privacidade e Tratamento de Dados foi criada para reafirmar o compromisso em relação a modernização da gestão pública, que a GOVERNANÇA BRASIL S/A (“GOVBR”) tem em relação a privacidade e a proteção dos dados pessoais dos seus clientes e parceiros no uso das funcionalidades da plataforma TRANSPARÊNCIA BRASIL (“Portal TB”).
        O TRANSPARÊNCIA BRASIL é um Portal informativo que tem por escopo a modernização da gestão pública, com foco no resultado, demonstrando o compromisso da GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS, pessoa jurídica de direito privado, inscrita no CNPJ/ME sob o n.º 00.165.960/0001-01, estabelecida na Rua João Pessoa, nº 1.183, Velha, Blumenau/SC, CEP: 89.036-001, na prevalência da privacidade e da Proteção de Dados Pessoais, em obediência às Leis Nacionais e demais regulamentos atinentes sobre o tema, sejam federais, estaduais e/ou municipais, principalmente as Leis nº 13.709/2018 (LGPD), 12.527/2011 (Lei de Acesso à Informação) e a Lei nº 101/2000 (Lei de Responsabilidade Fiscal).
        Ao se utilizar dos Serviços, você declara que fez a leitura completa e atenta da presente Política, estando plenamente ciente dos termos e condições vigentes aqui presentes e conferindo a sua livre e expressa concordância para o tratamento dos Dados de acordo com as condições abaixo especificadas.`
            },
            { title: '2.	Termos e Definições',
                body: `Para dar mais clareza, transparência, e para que você entenda com maior exatidão sobre o que está sendo informado nesta Política, é importante que você saiba o significado destas terminologias:
      (i)	  Anonimização: utilização de meios técnicos razoáveis e disponíveis no momento da realização do Tratamento, por meio dos quais um dado perde a possibilidade de associação, direta ou indireta, a uma pessoa física.
      (ii)	Cloud Computing: refere-se a um conceito tecnológico e um modelo de negócio que reúne ideias diversas. Entre as principais, podemos destacar soluções como as voltadas para o armazenamento de informações, comunicações entre computadores, prestação de serviços ou metodologias de desenvolvimento de aplicações. Tudo isso baseado na nuvem.
      (iii)	Cookies: são pequenos arquivos salvos nos seus dispositivos, que armazenam as preferências e poucas outras informações, com a finalidade de personalizar sua navegação de acordo com o seu perfil.
      (iv)	Dados: quaisquer informações inseridas, tratadas ou transmitidas através dos Nossos Ambientes.
      (v)	Dados Pessoais: dados que se relacionam a pessoa natural identificada ou identificável.
      (vi)	Dados Pessoais Sensíveis: dados pessoais sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dados referentes à saúde ou à vida sexual, dados genéticos ou biométricos, quando vinculados a uma pessoa natural.
      (vii)	Decisões unicamente automatizadas: caracterizada como um ato decisório realizado por meio de mapeamento de perfis, mediante qualquer forma de tratamento automatizado de dados pessoais, para avaliar aspectos pessoais relativos a uma pessoa singular.
      (viii)	Encarregado (Data Protection Officer -DPO): pessoa indicada pela GOVBR para atuar como canal de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD).
      (ix)	ID de Sessão: identificação da sessão de usuários quando é efetuado o acesso aos ambientes da GOVBR.
      (x)	IP: do inglês "Internet Protocol" (protocolo de rede) que consiste em um conjunto de regras que regem o formato de dados enviados pela Internet ou por uma rede local.
      (xi) 	Link: terminologia para endereço de internet. Componente de sites que ligam alguns conteúdos em evidência, pequenos textos, imagens, aos seus documentos associados.
      (xii) 	Logs: registros de atividades de quaisquer usuários que utilizem o Portal.
      (xiii)	Software: conjunto de programas executáveis por computador e suas respectivas documentações técnicas que acompanham o produto.
      (xiv)	Tratamento: toda operação realizada com Dados Pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.
      ` },
            { title: '3.	Informações relevantes',
                body: `A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS não tem ingerência sobre os controles de segurança utilizados pelos seus clientes, mas está conforme em relação à sua Plataforma, estando aderente em relação aos seus controles técnicos e organizacionais e disponibiliza, através de seu sistema, a segurança necessária para fins de utilização de seu produto. No entanto, não é responsável pelas informações inseridas dentro da Plataforma, visto que estas são imputadas pelos seus próprios clientes, pessoas jurídicas, diretamente, através do acesso ao sistema por seus funcionários, cadastrados por meio de login e senha específicos.
      ` },
            { title: '4.	Informações sobre os Dados Pessoais que constam no Portal',
                body: `Para a realização dos Serviços, os Dados, incluindo Dados Pessoais e Dados Pessoais sensíveis, poderão ser coletados quando você (ou outro usuário habilitado no sistema) os submete ou quando você (usuário habilitado ou outro usuário habilitado e com acesso ao sistema) interage no Portal, seja para acrescentar informações, seja para consultá-los. 
      A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS realiza o tratamento de dados cadastrais e de dados pessoais relativos a contrato de servidores e de pessoas terceirizadas em nome do controlador.
      
      Ressalta-se que a grande maioria destas informações, consideradas como básicas, são compartilhadas com outros órgãos do Poder Público em obediência a leis, normas e demais legislações e regulamentações aplicáveis (Integração com o E-social, o FGTS, Receita Federal, dentre outros). 
      
      O cadastro do cidadão normalmente é feito quando ele ingressa no serviço público. Finalizado o cadastro, o Portal faz a divulgação necessária por lei das informações para garantir a Transparência.
      
      O Portal GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS não compartilhamento dados pessoais com outros órgãos ou entidades de maneira direta. Este compartilhamento é realizado pelo próprio controlador dos dados pessoais, ou seja, pessoas jurídicas de direito público como municípios ou estados, órgãos da Administração direta e indireta os quais são aqueles que contratam os serviços da GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS e quem define as hipóteses legais para o tratamento de dados pessoais compartilhados neste Portal. 
      
      Há o registro de pagamento de terceiros que prestam serviços e vinculados à Área de Gestão de Pessoal devido a consolidação do recolhimento dos encargos, como a retenção do INSS e a Prestação de contas para a CFIP, pois alguns terceiros são registrados dentro da própria Plataforma, devido a sua rotina estar ali integrada.
      
      Poderão ser coletados Dados Pessoais no atendimento a você, usuário cadastrado, para fins de suporte. Esses Dados Pessoais serão encaminhados à GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS via e-mail juntamente com o número de protocolo de atendimento.
      
      Você, usuário habilitado pelo Controlador, é quem alimenta a Plataforma GOVBR através do seu Login e senha, executando suas funções diante da utilização da Plataforma e que com ela interage possuindo o correspondente acesso, é o único responsável pela precisão, veracidade ou falta dela em relação aos Dados que você fornece, consulta, compartilha ou pela sua desatualização. Fique atento, pois é de sua responsabilidade garantir a sua exatidão ou mantê-los atualizados.
      
      ` },
            { title: '5.	Armazenamento dos seus Dados Pessoais e o registro de atividades',
                body: `Os dados pessoais ficarão armazenados para fins operacionais e obedecerão a padrões rígidos de confidencialidade e segurança, por um prazo mínimo que segue a tabela abaixo:
      
      PRAZO DE ARMAZENAMENTO -
      Enquanto perdurar o período de contratação entre a GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS e os Estados, Prefeituras, Municípios e demais órgãos do Poder Público.
      
      FUNDAMENTO LEGAL -
      Art. 7º, inciso III, da Lei Geral de Proteção de Dados Pessoais.
      
      Para fins de auditoria, segurança e controle de fraudes, a GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS poderá permanecer com o histórico de registro de seus Dados por prazo maior nas hipóteses que a lei ou norma regulatória assim estabelecer ou para preservação de direitos.
      
      Os Dados coletados são armazenados em servidores dos próprios clientes GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS (estados, prefeituras e municípios) localizados no Brasil, não comprometendo-se a GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS em adotar as medidas necessárias para assegurar que as transferências de Dados estejam adequadamente protegidas, de acordo com a legislação de proteção de Dados Pessoais aplicável, tendo em vista que tais sistemas não estão sob o controle da Operadora GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS, e sim dos seus clientes, Controladores (órgãos da Administração direta e indireta, estados e municípios), cabendo a eles a definição sobre a finalidade e as hipóteses legais cabíveis na coleta de cada um dos dados pessoais que solicita, quando requer a abertura de mais campos para inserção de informações adicionais no Portal TRANSPARÊNCIA BRASIL. 
      Os Dados podem ser armazenados em ambiente de uso de recursos ou servidores na nuvem (cloud computing).
      
      ` },
            { title: '6.	Como seus Dados são protegidos e de que forma você também poderá protegê-los',
                body: ` Internamente, os Dados Pessoais são acessados somente por profissionais devidamente autorizados, servidores e funcionários com direito de acesso de cada um dos clientes GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS da Administração Pública direta e indireta, estados e municípios, respeitando os princípios da finalidade, adequação, necessidade e demais princípios inerentes ao tratamento de dados pessoais, além do compromisso de confidencialidade e preservação da privacidade nos termos desta Política.
      
      Você também é responsável pelo sigilo dos seus Dados Pessoais e deve ter sempre ciência de que o compartilhamento de senhas e informações de acesso viola esta Política, podendo comprometer a segurança dos seus Dados e do Portal.
      
      Também é muito importante que você saiba que não serão enviadas, no âmbito do uso do Portal, mensagens eletrônicas solicitando confirmação de dados ou com anexos que possam ser executados (extensões: .exe, .com, entre outros).
      
      No caso de tratamento de Dados realizados por clientes GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS, cuja atuação se limita à sua contratação, cada uma dentro de uma interface própria do seu estado, prefeitura ou município, estes deverão respeitar as condições aqui estipuladas e as normas de segurança da informação, obrigatoriamente.
      
      ` },
            { title: '7.	Quais são os seus direitos e como exercê-los',
                body: `Qualquer pessoa física, titular de Dados Pessoais poderá, a qualquer tempo, solicitar a confirmação da existência de tratamento de Dados Pessoais utilizados no Portal, além da exibição ou retificação de seus Dados Pessoais, por meio dos Canais de Atendimento.
      
      As informações inseridas neste Portal são de responsabilidade exclusiva do controlador dos dados pessoais, não tendo, a GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS quaisquer responsabilidades relacionadas a atualização, revisão, exclusão, inclusão, bloqueio e/ou demais direitos, os quais deverão ser repassados, imediatamente, aos controladores dos dados pessoais, sendo eles órgãos da Administração Pública direta e indireta, estados e municípios.
      
      No entanto, caso necessite entrar em contato diretamente e pelos Canais de Atendimento, você também tem o direito de requerer:
      
      (i)	A limitação de uso dos seus Dados Pessoais;
      
      (ii)	Manifestação de sua oposição quanto ao uso de seus Dados Pessoais; ou
      
      (iii)	Solicitação da exclusão de seus Dados Pessoais que tenham sido coletados no âmbito dos serviços realizados.
      
      Todas estas manifestações deverão ser entregues imediatamente aos controladores dos dados pessoais responsáveis pelas informações inseridas no Portal.
      Ademais, você está ciente que qualquer solicitação em relação aos Dados inerentes à prestação dos Serviços poderá causar limitações de uso das funcionalidades, além de que a correção de Dados Pessoais também deverá observar as normas legais e regulamentares específicas da certificação digital.
      
      ` },
            { title: '8.	Disposições Gerais',
                body: `Sujeito a constante melhoria e aprimoramento, o teor desta Política poderá ser alterado a qualquer momento, conforme a finalidade ou necessidade, tal qual para adequação e conformidade legal de disposição de lei ou norma que tenha força jurídica equivalente, cabendo a Você, usuário, verificá-la sempre que efetuar o acesso ao Portal.
      
      Caso haja alguma dúvida sobre as condições estabelecidas nesta Política, você poderá entrar em contato diretamente com o Encarregado de Proteção de Dados Pessoais VANESSA BITTENCOURT, disponível através do e-mail lgpd@govbr.com.br, e endereço na Rua João Pessoa, nº 1.183, Velha, Blumenau/SC, CEP: 89.036-001, cujo horário de funcionamento é de (dias da semana/ e ou finais de semana), das 08:00 às 17:00hs, exceto feriados nacionais.
      
      Ao requerer seus direitos como Titulares de Dados Pessoais, é importante que você tenha conhecimento de que as informações que constam no Portal são inseridas pelos órgãos da Administração Pública, direta e indireta, os quais são considerados controladores dos dados pessoais neste contexto. A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS é operadora dos dados pessoais, razão pela qual encaminhará as solicitações, com a máxima urgência aos controladores correspondentes. 
      
      Caso alguma disposição desta Política seja considerada ilegal ou ilegítima pela Autoridade Nacional de Proteção de Dados, órgão administrativo ou judicial, as demais condições permanecerão em pleno vigor e efeito.
      
      Você reconhece que toda comunicação realizada por e-mail (aos endereços informados no seu cadastro), SMS, aplicativos de comunicação instantânea ou qualquer outra forma digital, virtual e digital também são válidas como prova documental, sendo eficazes e suficientes para a divulgação de qualquer assunto que se refira aos Serviços, aos seus Dados, bem como às condições de sua prestação ou a qualquer assunto aqui abordado, ressalvadas as disposições expressamente diversas previstas nesta Política.
      
      
      ` },
            { title: '9.	Lei Aplicável e Jurisdição',
                body: `Esta Política e a relação decorrente das ações aqui compreendidas, assim como qualquer disputa que surja em virtude disto será regulada exclusivamente pela legislação brasileira.
      
      Fica eleito o foro de Blumenau – SC, para dirimir qualquer questão envolvendo o presente documento, salvo ressalva específica de competência pessoal, territorial ou funcional pela legislação aplicável.
      ` },
            { title: 'Termos e condições de uso do Portal Transparência Brasil',
                body: `
      
      Este Termo de Uso apresenta as “Condições Gerais” e demais regras inerentes a utilização deste Portal o qual o usuário, autorizado pelo órgão público contratante dá sua plena ciência ao utilizar esta ferramenta e as funcionalidades nela contidas, declarando, ter realizado a leitura de seu conteúdo e dando pleno acordo sobre as considerações aqui levantadas.
      
      Ao utilizar os serviços prestados pela GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS, através do seu Portal Transparência Brasil, o usuário e seu representante legal igualmente se declaram cientes de todas as políticas dos princípios que regem o Presente Termo. 
      
      Este Termo e Condições de Uso, em conjunto com a Política de Privacidade do Portal Transparência Brasil estão em plena consonância com toda a legislação nacional e internacional atinente aos serviços prestados, tais como o Código de Defesa do Consumidor (Lei nº 8.078/1990), Decreto 7.962/2013, Código Civil e Lei Geral de Proteção de Dados Pessoais (Lei nº 13.70 9/2018).
      
      GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS, pessoa jurídica de direito privado, inscrita no CNPJ/ME sob o n.º 00.165.960/0001-01, estabelecida na Rua João Pessoa, nº 1.183, Velha, Blumenau/SC, CEP: 89.036-001.
      ` },
            { title: '1. Informações que são úteis para o usuário do produto',
                body: `É muito importante que a utilização deste Portal traga a você melhores funcionalidades principalmente no que diz respeito ao tratamento dos dados pessoais de todos os Titulares. Mais informações, o usuário encontra na nossa Política de Privacidade. 
      
      O Portal Transparência Brasil deverá ser acessado através do site da entidade contratante. não podendo ter acesso por outro meio não autorizado.
      
      Ao utilizar a área administrativa do Portal, será pedido ao usuário, previamente cadastrado pela entidade pública adquirente do produto, que preencha seu login e senha de acesso: Tudo isso é para proporcionar uma melhor experiência em relação aos serviços dos produtos GOVERNANÇABRASIL S/A e o que de melhor pode lhe ser oferecido.
      
      Verifique se está no ambiente disponibilizado pelo Portal Transparência Brasil. Caso não identifique, entre em contato, imediatamente, com a GOVERNANÇABRASIL S/A por meio dos canais de atendimento.
      
      O conteúdo deste produto é voltado para o Poder Público (estados, prefeituras e municípios).
      
      O Portal Transparência Brasil preserva sua funcionalidade com esforços razoáveis, utilizando layout que respeita a usabilidade e navegabilidade sempre que possível, além de atuar com transparência e clareza, demonstrando suas funcionalidades de maneira clara, completa, precisa e suficiente.
      
      Ao acessar o sistema, o usuário declara ciência sobre a sua total responsabilidade em relação a operacionalização da ferramenta, mesmo se sua utilização for de uso indevido. Não será realizado tratamento de dados pessoais com qualquer fim ilícito, ilegal ou imoral.
      
      O Portal Transparência Brasil foi criado para facilitar a consulta de profissionais e servidores da administração no cumprimento das Leis de Acesso, como a LAI e de transparência públicas e para viabilizar o acompanhamento efetivo. Os dados pessoais ficam disponibilizados até o final da contratação.
      
      Não é permitido que o usuário realize qualquer ato que comprometa a integridade do Portal. É terminantemente proibido o acesso de qualquer área do produto que se relacione a programação, assim como também é vedada alteração de códigos-fonte, sua cópia, modificação, engenharia reversa reprodução, locação, divulgação, publicação, transmissão, empréstimo, cópia, sublicenciação ou qualquer outro tipo de ação que exponha a risco ao Portal Transparência Brasil e sua funcionalidade.
      
      O usuário do sistema declara sua ciência de que havendo incidência de danos à GOVERNANÇABRASIL S/A por descumprimento do presente Termo, deverá arcar com as devidas indenizações cabíveis e correspondentes, sejam elas administrativas ou judiciais. O usuário autorizado para a utilização do Portal, assim como o contratante estão cientes de que deverão se comprometer a assumir o polo passivo das demandas, isentando a empresa de qualquer condenação ou despesas relacionadas.
      
      O usuário legitimado ao acesso do produto, assim como a entidade contratante estão igualmente cientes de que devem se comprometer com as obrigações relativas à Lei Geral de Proteção de Dados Pessoais e demais legislações cabíveis e auxiliar a GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS no que for necessário no que disser respeito aos Direitos dos Titulares de Dados Pessoais. Sendo constatado ou havendo suspeita de qualquer violação, deverão comunicar o ocorrido a GOVERNANÇABRASIL S/A imediatamente.
      
      É terminantemente proibida a utilização de softwares data mining ou análogos por qualquer tipo de ferramenta técnica, estatística, de algoritmos para fins de coleta de informações, tendências de consumo e demais atividades.
      `
            },
            { title: ' 2. Atualizações necessárias e responsabilidades pelo uso',
                body: ` Nós procuramos manter todas as informações e conteúdos atualizados periodicamente e sem qualquer aviso prévio, assim como podemos alterar os critérios de elegibilidade de acesso e utilização do Portal a qualquer momento e ao nosso critério. Nosso conteúdo poderá sofrer modificações rotineiras visando viabilizar um acesso facilitado aos usuários e clientes. No entanto, não nos responsabilizamos sobre como são utilizados os dados e as informações que disponibilizamos, nem sobre seu conteúdo ou operação, quando usados em desconformidade. Orientamos aos usuários e as entidades públicas por eles representadas que sempre se mantenham atualizados a respeito de todas as nossas atualizações, principalmente àquelas relacionadas aos serviços que prestamos através deste produto `
            },
            { title: '3. Descrição da atividade',
                body: `O Portal Transparência Brasil foi criado para facilitar a consulta de profissionais e servidores da administração no cumprimento das Leis de Acesso, como a LAI e de transparência públicas e para viabilizar o acompanhamento efetivo `
            },
            { title: '4. Isenção de Responsabilidade e limitações de uso',
                body: `Através do acesso a este produto a entidade contratante declara  ciência de que o Portal Transparência Brasil tem o escopo de apresentar, de maneira Transparente, os dados dos agentes Públicos em atendimento às exigências legais e que as disponibilizações do Portal podem ser encerradas quando sua relação entre clientes termina e quando a contratação é encerrada, seja por meio de rescisão unilateral, bilateral, ou pelo término da contratação por meio de instrumento contratual. Sendo assim, as partes firmam contratos públicos.

O Portal Transparência Brasil está sujeito a qualquer indisponibilidade temporária em razão de manutenção ou por motivos de força maior. Nesta situação, não haverá qualquer dano efetivamente gerado ou indenização a ser devida, devendo a GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS enveredar todos os seus esforços para restabelecer a continuidade dos seus serviços.

A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS não terá qualquer responsabilidade sobre ato de terceiros (hackers), falhas de servidor, conexão, bugs, indisponibilidade de funcionamento ou pela utilização de softwares que possam causar algum tipo de dano ao Portal e aos seus sistemas que a ele dão acesso. `
            },
            { title: '5. Possibilidade de interrupção dos serviços',
                body: `Os serviços oferecidos pelo Portal Transparência Brasil poderão ser interrompidos no caso de existirem circunstâncias não previstas ou que estejam fora do controle, além de motivação legal e jurídica. Caso a interrupção dos serviços do produto ocorra por determinação da própria GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS, seus cientes, parceiros e usuários cadastrados no sistema deverão ser devidamente notificados, em tempo razoável.`
            },
            { title: ' 6. Declaração de direitos autorais e propriedade intelectual',
                body: ` O usuário e a entidade contratante do produto dão sua ciência e concordância de que a empresa GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS é titular exclusiva de todos os direitos autorais e de propriedade intelectual relacionados ao Portal Transparência Brasil, assim como a seu conteúdo, e que estes direitos estão abrangidos e protegidos pela Lei nº 9.609/1998 e demais normas e regulamentos

É vedada qualquer alteração, remoção, bloqueio, suspensão de conteúdo, mudança ou tentativa de modificação de qualquer tipo de funcionalidade do Portal Transparência Brasil que não seja realizada por ele próprio. 

Qualquer intenção de acesso ao conteúdo do Portal que tenha o objetivo de construir, realizar ou elaborar qualquer produto ou serviço concorrente poderá configurar violação de direito autoral, nos termos da Lei 9.610/98 e caracterizar conduta criminosa, conforme artigo 184, §1º a 3º, do Código Penal. A identidade visual assim como qualquer serviço que esteja associado às marcas aqui consideradas não gera aos usuários qualquer tipo de direito.
`
            },
            { title: ' 7. Proteção dos Dados Pessoais e Segurança da Informação',
                body: ` A GOVERNANÇABRASIL S/A se obriga a cumprir toda a legislação aplicável sobre privacidade e proteção de dados, inclusive e, sempre que aplicáveis, a Constituição Federal, o Código de Defesa do Consumidor, o Código Civil, o Marco Civil da Internet (Lei Federal n° 12.965/14), Lei Geral de Proteção de Dados — Lei Federal n° 13.709/2018, e demais normas setoriais ou gerais sobre o tema, reconhecendo que todos os dados pessoais devem ser tratados como Informações Confidenciais.`
            },
            { title: '8. O papel da GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS ',
                body: `A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS responsabiliza-se por todos os serviços por ela prestados, bem como pelos deveres oriundos da relação de consumo entre ela e seus, declarando que possui capacidade legal para o(s) segmento(s) em que atua, assumindo aqui o compromisso com a idoneidade moral e o respeito irrevogável à legislação vigente.

A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS se compromete a exercer suas atividades comerciais com qualidade e transparência, e executando os serviços de forma idêntica à anunciada e dentro do prazo, esclarecendo dúvidas dos produtos e serviços comercializados.

São de exclusiva responsabilidade do cliente os atos e/ou omissões praticados por seus empregados/prepostos, bem como pelos danos de qualquer natureza que os mesmos venham a sofrer ou causar aos seus clientes ou terceiros em geral em decorrência das obrigações assumidas neste Termo.

É também de exclusiva responsabilidade do cliente o cumprimento de todas as determinações impostas pelas autoridades públicas competentes, relativas aos serviços prestados, bem como o pagamento de todos os tributos federais, estaduais e municipais que incidam ou venham a incidir sobre os mesmos.`
            },
            { title: '9. O papel dos usuários cadastrados no Portal',
                body: `O usuário, o qual representa o órgão ou a entidade pública, se obriga a não utilizar o Portal Transparência Brasil para fins ilícitos.

É proibida a utilização do Portal da Transparência para fins que são sejam os propostos, sobretudo que possam atingir a moral, os bons costumes e/ ou a ordem pública.

Os dados dos usuários cadastrados serão utilizados somente para acesso à área administrativa para permitir ao administrador parametrizar as consultas que serão exibidas na área pública. 

É terminantemente proibida a violação da privacidade dos usuários cadastrados no Portal Transparência Brasil.

É proibida a violação dos direitos autorais de terceiros.`
            },
            { title: ' 10. Obrigações da GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS',
                body: ` Manter as informações em seus servidores, incluindo, mas não se limitando, àquelas relacionadas ao cadastro, mas também relativos a pedidos, produtos, serviços, transações financeiras e clientes.`
            },
            { title: ' 11. Disposições Finais',
                body: `A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS se reserva no direito de não omitir informações aos seus clientes ou instituições que porventura solicitarem tais dados pautados em argumentações consistentes de desrespeito as cláusulas deste Termo e relacionadas a qualquer tipo de inadimplência

O desrespeito a este Termo e a Política de Privacidade ou indícios de irregularidades, seja de natureza fática, jurídica ou fiscal implicará na suspensão dos serviços oferecidos pela GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS e, consequentemente, na devolução dos valores retidos aos pagadores, cabendo ao cliente os encargos oriundos das devoluções.

A GOVERNANÇABRASIL S/A TECNOLOGIA E GESTÃO EM SERVIÇOS se reserva o direito de alterar os termos e condições de uso do produto a qualquer tempo dando ciência aos usuários por meio de seus endereços eletrônicos cadastrados, sendo certo que a continuidade no uso implicará aceitação das eventuais alterações.

Para dirimir qualquer questão oriunda da interpretação deste Termo ou da relação contratual firmada, fica eleito o Foro da Comarca de Blumenau-SC, por mais privilegiado que outro seja.
`
            }
        ];
    }
}
AbreModalLgpdService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AbreModalLgpdService.ctorParameters = () => [
    { type: BackendCommService },
    { type: UsuarioSsoService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogLgpdComponent {
    /**
     * @param {?} dialogRef
     * @param {?} abreModalLgpdService
     * @param {?} data
     */
    constructor(dialogRef, abreModalLgpdService, data) {
        this.dialogRef = dialogRef;
        this.abreModalLgpdService = abreModalLgpdService;
        this.data = data;
        this.isDisabled = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.lgpdText = this.abreModalLgpdService.getTextoLGPD();
        this.isAlreadyAcepted();
    }
    /**
     * @return {?}
     */
    changeAceiteLgpd() {
        this.isDisabled = true;
        this.abreModalLgpdService.aceiteModalLgpd().then((/**
         * @param {?} s
         * @return {?}
         */
        s => s.subscribe((/**
         * @param {?} _
         * @return {?}
         */
        _ => { }), (/**
         * @param {?} _
         * @return {?}
         */
        _ => { this.isDisabled = false; }))));
    }
    /**
     * @return {?}
     */
    isAlreadyAcepted() {
        this.abreModalLgpdService.showDialogLgpd().then((/**
         * @param {?} s
         * @return {?}
         */
        s => s.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            if (res === null) {
                this.isDisabled = true;
            }
        }))));
    }
}
DialogLgpdComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-dialog-lgpd',
                template: "<div  mat-dialog-title>\n  <h1> Termos de uso </h1>\n  <img src=\"assets/icons/close-modal.svg\" (click)=\"dialogRef.close()\"/>\n</div>\n<div mat-dialog-content>\n  <div class=\"lgpd-text\" *ngFor=\"let text of lgpdText\">\n    <h4>{{text.title}}</h4>\n    <p>{{text.body}}</p>\n  </div>\n  <mat-checkbox \n    class=\"govbr-checkbox\" \n    [checked]= \"isDisabled\"\n    [disabled]=\"isDisabled\"\n    (change)=\"changeAceiteLgpd()\"><span>\"Li e concordo com os termos de uso.\"</span></mat-checkbox>\n</div>\n",
                styles: [".mat-dialog-content{margin-right:.063rem;font-size:.875rem;padding-left:38px;height:42vh}.mat-dialog-content .lgpd-text p{margin-bottom:10px;font-size:.75rem}.mat-dialog-content .lgpd-text:not(:last-child){margin-bottom:0}.mat-dialog-title{display:flex;justify-content:space-between;margin-bottom:.563rem;padding-right:12px;padding-left:12px;padding-top:12px}.mat-dialog-title h1{font-weight:700;font-size:.875rem}.mat-dialog-title img{cursor:pointer}"]
            }] }
];
/** @nocollapse */
DialogLgpdComponent.ctorParameters = () => [
    { type: MatDialogRef$1 },
    { type: AbreModalLgpdService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA$1,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlteracaoSenha {
    /**
     * @param {?=} nomeUsuario
     * @param {?=} senhaVelha
     * @param {?=} senhaNova
     * @param {?=} confirmarSenha
     */
    constructor(nomeUsuario, senhaVelha, senhaNova, confirmarSenha) {
        this.nomeUsuario = nomeUsuario;
        this.senhaVelha = senhaVelha;
        this.senhaNova = senhaNova;
        this.confirmarSenha = confirmarSenha;
        this.nomeUsuario = nomeUsuario;
        this.senhaVelha = senhaVelha;
        this.senhaNova = senhaNova;
        this.confirmarSenha = confirmarSenha;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastData {
}
// default configuration of toast message
/** @type {?} */
const defaultToastConfig = {};
/** @type {?} */
const TOAST_CONFIG_TOKEN = new InjectionToken('toast-config');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AlterarSenhaService {
    constructor() {
        this.newGroup = new AlteracaoSenha();
        this.newToast = new ToastData();
        this.groupListSource = new BehaviorSubject(this.newGroup);
        this.toastListSource = new BehaviorSubject(this.newToast);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    groupItems(data) {
        this.groupListSource.next(data);
    }
    /**
     * @return {?}
     */
    get groupList() {
        return this.groupListSource;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    setToast(data) {
        this.toastListSource.next(data);
    }
    /**
     * @return {?}
     */
    get toastList() {
        return this.toastListSource.value;
    }
}
AlterarSenhaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
AlterarSenhaService.ctorParameters = () => [];
/** @nocollapse */ AlterarSenhaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AlterarSenhaService_Factory() { return new AlterarSenhaService(); }, token: AlterarSenhaService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EventoBotaoNovaSenhaService {
    constructor() {
        this.messageSource = new BehaviorSubject(null);
        this.currentMessage = this.messageSource.asObservable();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    botaoEnviarNovaSenha(value) {
        this.messageSource.next(value);
    }
}
EventoBotaoNovaSenhaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
EventoBotaoNovaSenhaService.ctorParameters = () => [];
/** @nocollapse */ EventoBotaoNovaSenhaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function EventoBotaoNovaSenhaService_Factory() { return new EventoBotaoNovaSenhaService(); }, token: EventoBotaoNovaSenhaService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormValidations {
    /**
     * @param {?} oldPwd
     * @param {?} newPwd
     * @param {?} confirmPwd
     * @return {?}
     */
    static equalsTo(oldPwd, newPwd, confirmPwd) {
        /** @type {?} */
        const validator = (/**
         * @param {?} formControl
         * @return {?}
         */
        (formControl) => {
            /** @type {?} */
            const oldField = ((/** @type {?} */ (formControl.root))).get(oldPwd);
            /** @type {?} */
            const newField = ((/** @type {?} */ (formControl.root))).get(newPwd);
            /** @type {?} */
            const confirmField = ((/** @type {?} */ (formControl.root))).get(confirmPwd);
            if (oldField.value === newField.value) {
                return { errorOnNewPwd: true };
            }
            if (newField.value !== confirmField.value) {
                return { errorOnConfirmPwd: true };
            }
            return false;
        });
        return validator;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogAlteracaoSenhaComponent {
    /**
     * @param {?} fb
     * @param {?} changePwdService
     * @param {?} eventoBotaoNovaSenhaService
     */
    constructor(fb, changePwdService, eventoBotaoNovaSenhaService) {
        this.fb = fb;
        this.changePwdService = changePwdService;
        this.eventoBotaoNovaSenhaService = eventoBotaoNovaSenhaService;
        this.errOnConfirm = false;
        this.errOnNewPwd = false;
        this.botaoSairClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.formulario = this.fb.group({
            senhaVelha: ['', Validators.required],
            senhaNova: ['', Validators.required],
            confirmarSenha: ['', Validators.required]
        }, { validators: FormValidations.equalsTo('senhaVelha', 'senhaNova', 'confirmarSenha') });
        this.changePwdService.groupList.subscribe((/**
         * @param {?} dados
         * @return {?}
         */
        (dados) => {
            this.nomeUsuario = dados.nomeUsuario;
        }));
        this.formulario.valueChanges.subscribe((/**
         * @return {?}
         */
        () => {
            if (this.errorsForm) {
                this.errOnNewPwd = this.errorsForm.errorOnNewPwd;
                this.errOnConfirm = this.errorsForm.errorOnConfirmPwd;
            }
            else {
                this.errOnNewPwd = false;
                this.errOnConfirm = false;
            }
        }));
    }
    /**
     * @return {?}
     */
    get errorsForm() {
        return this.formulario.errors;
    }
    /**
     * @return {?}
     */
    onSubmit() {
        this.usuarioAlterado = new AlteracaoSenha(this.nomeUsuario, this.formulario.value.senhaVelha, this.formulario.value.senhaNova, this.formulario.value.confirmarSenha);
        this.changePwdService.groupItems(this.usuarioAlterado);
        this.buttonSubmitHasClicked();
    }
    /**
     * @return {?}
     */
    get color() {
        return this.formulario.invalid ? null : 'primary';
    }
    /**
     * @return {?}
     */
    buttonSubmitHasClicked() {
        this.eventoBotaoNovaSenhaService.botaoEnviarNovaSenha(true);
    }
}
DialogAlteracaoSenhaComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-dialog-alteracao-senha',
                template: "<mat-toolbar class=\"dialog-header\">\n  <span id=\"dialog-titulo\">Altera\u00E7\u00E3o de senha</span>\n  <span id=\"icon-close\" mat-button mat-dialog-close>\n    <mat-icon>close</mat-icon>\n  </span>\n</mat-toolbar>\n<div id=\"dialog-container\">\n  <p id=\"id_usuario\">\n    {{ nomeUsuario }}\n  </p>\n  <div mat-dialog-content>\n    <form [formGroup]=\"formulario\">\n      <mat-form-field class=\"my-field-password govbr-form-field\" appearance=\"outline\">\n        <mat-label class=\"asterix--before\">Senha atual</mat-label>\n        <input matInput placeholder=\"Senha atual\" [type]=\"oldPwdToggle.type\" formControlName=\"senhaVelha\" autocomplete=\"off\" />\n        <button class=\"gov-botao-olhinho\" mat-icon-button matSuffix govPasswordToggle #oldPwdToggle=\"govPasswordToggle\">\n          <mat-icon class=\"gov-icone-olhinho\">{{ oldPwdToggle.icon }}</mat-icon>\n        </button>\n      </mat-form-field>\n      <small *ngIf=\"formulario.get('senhaVelha').hasError('required') && formulario.get('senhaVelha').touched\" class=\"show-err\">Campo obrigat\u00F3rio</small>\n      <mat-form-field class=\"my-field-password govbr-form-field\" appearance=\"outline\">\n        <mat-label class=\"asterix--before\">Nova senha</mat-label>\n        <input matInput placeholder=\"Nova senha\" [type]=\"newPwdToggle.type\" formControlName=\"senhaNova\" autocomplete=\"off\" />\n        <button class=\"gov-botao-olhinho\" mat-icon-button matSuffix govPasswordToggle #newPwdToggle=\"govPasswordToggle\">\n          <mat-icon class=\"gov-icone-olhinho\">{{ newPwdToggle.icon }}</mat-icon>\n        </button>\n      </mat-form-field>\n      <small *ngIf=\"formulario.get('senhaNova').hasError('required') && formulario.get('senhaNova').touched\" class=\"show-err\">Campo obrigat\u00F3rio</small>\n      <small *ngIf=\"errOnNewPwd\" class=\"show-err\">A nova senha n\u00E3o pode ser igual a senha atual.</small>\n      <mat-form-field class=\"my-field-password govbr-form-field\" appearance=\"outline\">\n        <mat-label class=\"asterix--before\">Repita a nova senha</mat-label>\n        <input matInput placeholder=\"Repita a nova senha\" [type]=\"confirmPwdToggle.type\" formControlName=\"confirmarSenha\" autocomplete=\"off\" />\n        <button class=\"gov-botao-olhinho\" mat-icon-button matSuffix govPasswordToggle #confirmPwdToggle=\"govPasswordToggle\">\n          <mat-icon class=\"gov-icone-olhinho\">{{ confirmPwdToggle.icon }}</mat-icon>\n        </button>\n      </mat-form-field>\n      <small *ngIf=\"formulario.get('confirmarSenha').hasError('required') && formulario.get('confirmarSenha').touched\" class=\"show-err\">Campo obrigat\u00F3rio</small>\n      <small *ngIf=\"errOnConfirm\" class=\"show-err\">Por favor, digite o mesmo valor do campo \"Nova senha\".</small>\n    </form>\n  </div>\n  <div mat-dialog-actions>\n    <button class=\"govbr-button\" mat-button mat-dialog-close>Cancelar</button>\n    <button class=\"alterar-senha govbr-button\" (click)=\"onSubmit()\" [color]=\"color\" mat-raised-button [disabled]=\"formulario.invalid\">Salvar</button>\n  </div>\n</div>",
                styles: [".dialog-header .mat-toolbar-row,.mat-toolbar-single-row{height:16.5%;padding:0 20px}#dialog-titulo{width:66.7%;font-family:Nunito Sans;font-style:normal;font-weight:400;font-size:18px;line-height:1.563rem;padding-left:4px}#icon-close{width:33.3%;cursor:pointer;display:flex;justify-content:flex-end;position:relative;left:6px}#dialog-container{display:block;width:100%;height:84%;padding:24px}.gov-botao-olhinho{position:relative;top:-8px;left:7px}.gov-icone-olhinho{font-size:18px;height:16px;width:16px}#id_usuario{font-family:\"Nunito Sans\";font-style:normal;font-weight:600;font-size:17px;line-height:23px;padding-bottom:10px}.asterix--before::after{content:\"*\";font-size:1rem;position:relative;left:2px;top:3px}.asterix--before{position:relative}.show-err{height:.938rem;color:#f53c56;font-size:11px;display:inherit}"]
            }] }
];
/** @nocollapse */
DialogAlteracaoSenhaComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: AlterarSenhaService },
    { type: EventoBotaoNovaSenhaService }
];
DialogAlteracaoSenhaComponent.propDecorators = {
    botaoSairClick: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente de implementação do botão de perfil do usuário
 */
class PerfilUsuarioComponent {
    /**
     * @param {?} dialog
     */
    constructor(dialog) {
        this.dialog = dialog;
        this.exibeAlterarSenha = true;
        this.exibeModalLGPD = true;
        this.botaoSair = new EventEmitter();
        this.botaoItem = new EventEmitter();
        this.itensMenu = [];
        this.showPerfil = false;
        this.inside = false;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.perfilUsuario) {
            this.getFullName();
        }
    }
    /**
     * Método exibe/recolhe perfil usuário clicando na imagem do cabecalho
     * @return {?}
     */
    clicked() {
        this.inside = true;
    }
    /**
     * Método recolhe perfil usuário clicando em qualquer lugar da tela
     * @return {?}
     */
    clickedOut() {
        this.showPerfil = this.inside
            ? true
            : false;
        this.inside = false;
    }
    /**
     * Método para detectar o clique no botão de sair do perfil de usuário.
     * @return {?}
     */
    capturaCliqueBotaoSair() {
        this.botaoSair.emit(true);
    }
    /**
     * @param {?} itemNome
     * @return {?}
     */
    capturaCliqueItem(itemNome) {
        this.botaoItem.emit(itemNome);
    }
    /**
     * @return {?}
     */
    openModalLgpd() {
        this.dialog.open(DialogLgpdComponent, {
            width: '650px',
            maxHeight: '650px',
            autoFocus: false,
            backdropClass: 'govbr-modal-lgpd-background',
            panelClass: 'govbr-modal-lgpd-panel'
        });
    }
    /**
     * @return {?}
     */
    openDialog() {
        this.dialog.open(DialogAlteracaoSenhaComponent, {
            backdropClass: 'cdk-backdropBackground',
            panelClass: 'alterar-senha',
            hasBackdrop: true,
        });
    }
    /**
     * @return {?}
     */
    getFullName() {
        this.firstName = this.perfilUsuario.nomePerfilUsuario.split(' ');
        this.lastName = this.perfilUsuario.nomePerfilUsuario.split(' ').slice(-1).join(' ');
        this.fullName = `${this.firstName} ${this.lastName}`;
        return this.fullName;
    }
}
PerfilUsuarioComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-perfil-usuario',
                template: "<ng-container *ngIf=\"perfilUsuario\">\n  <div class=\"main-image\" (click)=\"clicked()\">\n    <div *ngIf=\"perfilUsuario?.urlPerfilImagem; else avatar\" class=\"profile-image\">\n      <img src=\"{{ perfilUsuario?.urlPerfilImagem }}\" alt=\"Imagem do perfil do usu\u00E1rio\">\n    </div>\n    <ng-template #avatar>\n      <ngx-avatar *ngIf=\"firstName.length === 1\" bgColor=\"#0395df\" initialsSize=\"1\" [name]=\"fullName\" size=\"36\">\n      </ngx-avatar>\n      <ngx-avatar *ngIf=\"firstName.length > 1\" bgColor=\"#0395df\" initialsSize=\" 2\" [name]=\"fullName\" size=\"36\">\n      </ngx-avatar>\n    </ng-template>\n  </div>\n\n  <div *ngIf=\"showPerfil\" class=\"card\">\n    <div *ngIf=\"perfilUsuario?.urlPerfilImagem; else avatar\" class=\"profile-image\">\n      <img src=\"{{ perfilUsuario?.urlPerfilImagem }}\" alt=\"Imagem do perfil do usu\u00E1rio\">\n    </div>\n    <ng-template #avatar>\n      <ngx-avatar *ngIf=\"firstName.length === 1\" bgColor=\"#0395df\" initialsSize=\"1\" [name]=\"fullName\" size=\"36\">\n      </ngx-avatar>\n      <ngx-avatar *ngIf=\"firstName.length > 1\" bgColor=\"#0395df\" initialsSize=\" 2\" [name]=\"fullName\" size=\"36\">\n      </ngx-avatar>\n    </ng-template>\n    <div class=\"profile-content\">\n      <div class=\"title\">\n        <p>{{ perfilUsuario?.nomePerfilUsuario }}</p>\n      </div>\n      <ng-container *ngIf=\"itensMenu\">\n        <div class=\"itens-dinamicos\" *ngFor=\"let item of itensMenu\">\n          <a (click)=\"capturaCliqueItem(item.nome)\">\n            {{item.nome}}\n          </a>\n        </div>\n      </ng-container>\n      <div class=\"itens-perfil\" *ngIf=\"exibeAlterarSenha\">\n        <a (click)=\"openDialog()\">Alterar senha</a>\n      </div>\n      <div class=\"itens-perfil\" *ngIf=\"exibeModalLGPD\">\n        <a (click)=\"openModalLgpd()\">Termos de uso</a>\n        <govbr-modal-lgpd [isPerfilUsuarioLgpd]=\"true\"></govbr-modal-lgpd>\n      </div>\n      <div class=\"itens-perfil\">\n        <a (click)=\"capturaCliqueBotaoSair()\">Sair</a>\n      </div>\n    </div>\n  </div>\n</ng-container>",
                styles: [".main-image{cursor:pointer;margin-left:16px;margin-right:10px}.main-image .profile-image img{border-radius:100%;width:36px;height:36px}.card{position:absolute;top:50px;right:20px;display:flex;padding:16px;width:245px;height:auto;border-radius:5px;z-index:1}.card .profile-image img{width:70px;height:70px;border-radius:100%}.profile-content{width:100%;margin-left:15px}.title p{width:125px;padding-bottom:10px;font-family:\"Nunito Sans\";font-size:1.125rem;line-height:1.25rem;font-weight:700}.itens-dinamicos,.itens-perfil{margin-top:9px;line-height:16px}.itens-dinamicos a,.itens-perfil a{text-decoration:none;cursor:pointer;font-size:.8rem;line-height:.875rem}"]
            }] }
];
/** @nocollapse */
PerfilUsuarioComponent.ctorParameters = () => [
    { type: MatDialog }
];
PerfilUsuarioComponent.propDecorators = {
    perfilUsuario: [{ type: Input }],
    exibeAlterarSenha: [{ type: Input }],
    exibeModalLGPD: [{ type: Input }],
    botaoSair: [{ type: Output }],
    botaoItem: [{ type: Output }],
    itensMenu: [{ type: Input }],
    clicked: [{ type: HostListener, args: ['click',] }],
    clickedOut: [{ type: HostListener, args: ['document:click',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Exemplo de uso da diretiva
 *  <mat-form-field>
 * <input matInput [type]="pwToggle.type" placeholder="Password" value="p\@$$Word" />
 * <button mat-icon-button matSuffix appPasswordToggle #pwToggle="appPasswordToggle">
 * <mat-icon>{{ pwToggle.icon }}</mat-icon>
 * </button>
 * </mat-form-field>
 */
class PasswordToggleDirective {
    constructor() {
        this.show = false;
    }
    /**
     * @return {?}
     */
    get type() {
        return this.show ? 'text' : 'password';
    }
    /**
     * @return {?}
     */
    get icon() {
        return this.show ? 'visibility_off' : 'visibility';
    }
    /**
     * @return {?}
     */
    onClick() {
        this.show = !this.show;
    }
}
PasswordToggleDirective.decorators = [
    { type: Directive, args: [{
                selector: 'button[govPasswordToggle]',
                exportAs: 'govPasswordToggle'
            },] }
];
PasswordToggleDirective.propDecorators = {
    onClick: [{ type: HostListener, args: ['click',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalLgpdComponent {
    /**
     * @param {?} dialog
     * @param {?} abreModalLgpdService
     */
    constructor(dialog, abreModalLgpdService) {
        this.dialog = dialog;
        this.abreModalLgpdService = abreModalLgpdService;
        this.isPerfilUsuarioLgpd = false;
        this.exibeModalLGPD = true;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.isPerfilUsuarioLgpd && this.exibeModalLGPD) {
            this.shoudOpenModalOnInit();
        }
    }
    /**
     * @return {?}
     */
    openDialogLgpd() {
        this.dialog.open(DialogLgpdComponent, {
            width: '650px',
            maxHeight: '621px',
            autoFocus: false,
            backdropClass: 'govbr-modal-lgpd-background',
            panelClass: 'govbr-modal-lgpd-panel'
        });
    }
    /**
     * @return {?}
     */
    shoudOpenModalOnInit() {
        this.abreModalLgpdService.showDialogLgpd()
            .then((/**
         * @param {?} s
         * @return {?}
         */
        s => {
            s.subscribe((/**
             * @param {?} _
             * @return {?}
             */
            _ => { }), (/**
             * @param {?} err
             * @return {?}
             */
            err => {
                if (err.status === 404) {
                    this.openDialogLgpd();
                }
            }));
        }));
    }
}
ModalLgpdComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-modal-lgpd',
                template: "",
                styles: [""]
            }] }
];
/** @nocollapse */
ModalLgpdComponent.ctorParameters = () => [
    { type: MatDialog },
    { type: AbreModalLgpdService }
];
ModalLgpdComponent.propDecorators = {
    isPerfilUsuarioLgpd: [{ type: Input }],
    exibeModalLGPD: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModalLgpdModule {
}
ModalLgpdModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ModalLgpdComponent,
                    DialogLgpdComponent,
                ],
                imports: [
                    CommonModule,
                    MatDialogModule,
                    MatCheckboxModule,
                    MatFormFieldModule
                ],
                entryComponents: [
                    DialogLgpdComponent
                ],
                exports: [
                    ModalLgpdComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PerfilUsuarioModule {
}
PerfilUsuarioModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    PerfilUsuarioComponent,
                    DialogAlteracaoSenhaComponent,
                    PasswordToggleDirective
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    AvatarModule,
                    MatInputModule,
                    MatDialogModule,
                    MatButtonModule,
                    MatToolbarModule,
                    ReactiveFormsModule,
                    FormsModule,
                    MatFormFieldModule,
                    ModalLgpdModule
                ],
                entryComponents: [
                    DialogLgpdComponent,
                    DialogAlteracaoSenhaComponent,
                ],
                exports: [
                    PerfilUsuarioComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PesquisaService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} url
     * @param {?} pesquisa
     * @return {?}
     */
    pesquisarFuncionalidades(url, pesquisa) {
        return this.http.get(`${url}?nome_like=${pesquisa}`).pipe(retry(10), map((/**
         * @param {?} resposta
         * @return {?}
         */
        (resposta) => resposta)));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    setCliquePesquisa(event) {
        this.cliquePesquisa = of(event);
    }
    /**
     * @return {?}
     */
    getCliquePesquisa() {
        return this.cliquePesquisa;
    }
}
PesquisaService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PesquisaService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ PesquisaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PesquisaService_Factory() { return new PesquisaService(ɵɵinject(HttpClient)); }, token: PesquisaService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogPesquisaComponent {
    /**
     * @param {?} data
     */
    constructor(data) {
        this.data = data;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    confirmar() {
        window.location.href = this.data.url;
    }
}
DialogPesquisaComponent.decorators = [
    { type: Component, args: [{
                selector: "gov-dialog-pesquisa",
                template: "<mat-toolbar class=\"dialog-header\">\n  <span id=\"dialog-titulo\">Aten\u00E7\u00E3o!</span>\n  <span id=\"icon-close\" mat-button mat-dialog-close>\n    <mat-icon>close</mat-icon>\n  </span>\n</mat-toolbar>\n<div id=\"dialog-container\">\n  <div mat-dialog-content>\n    <p id=\"subtitulo-1\">Deseja seguir com essa a\u00E7\u00E3o? Dados em m\u00E9moria seram perdidos.</p>\n    <p id=\"subtitulo-2\">Esta a\u00E7\u00E3o n\u00E3o poder\u00E1 ser desfeita.</p>\n  </div>\n  <div mat-dialog-actions>\n    <button mat-button mat-dialog-close>Retornar</button>\n    <button mat-raised-button color=\"primary\" (click)=\"confirmar()\">Avan\u00E7ar</button>\n  </div>\n</div>\n\n",
                styles: [".dialog-header .mat-toolbar-row,.mat-toolbar-single-row{height:36px;padding:0 20px}#dialog-titulo{width:66.7%;font-family:Nunito Sans;font-style:normal;font-weight:400;font-size:1rem;line-height:1.563rem;padding-left:4px}#icon-close{width:33.3%;cursor:pointer;display:flex;justify-content:flex-end}#dialog-container{display:block;width:100%;height:152px;min-height:152px;padding:22px 81px 66px 24px}.mat-dialog-content{margin:0;padding:0;height:64px;min-height:64px;width:234px;min-width:234px;overflow-y:hidden}.mat-dialog-actions{display:flex;align-items:flex-end;justify-content:flex-start;padding:0;margin:0}#subtitulo-1{font-family:\"Nunito Sans\";font-size:12px;text-align:Left}#subtitulo-2{font-family:\"Nunito Sans\";font-size:12px;font-weight:700;line-height:45px;text-align:Left}"]
            }] }
];
/** @nocollapse */
DialogPesquisaComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const enterTransition = transition(':enter', [
    style({
        opacity: 0
    }),
    animate('1.2s linear', style({
        opacity: 1
    }))
]);
/** @type {?} */
const fadeIn = trigger('fadeIn', [
    enterTransition
]);
class PesquisaComponent {
    /**
     * @param {?} pesquisaService
     * @param {?} dialog
     */
    constructor(pesquisaService, dialog) {
        this.pesquisaService = pesquisaService;
        this.dialog = dialog;
        this.showPesquisa = false;
        this.inside = false;
        this.subjectPesquisa = new Subject();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.resultados = this.subjectPesquisa
            .pipe(debounceTime(300), // executa a ação do switchMap após um 1s
        distinctUntilChanged(), // para fazer pesquisas distintas,
        switchMap((/**
         * @param {?} termo
         * @return {?}
         */
        (termo) => {
            if (termo.trim() === '') {
                /**
                 * retorna um observable de um array vazio
                 */
                return of([]);
            }
            return this.pesquisaService.pesquisarFuncionalidades(this.url, termo);
        })));
    }
    /**
     * @return {?}
     */
    clicked() {
        this.inside = true;
    }
    /**
     * @return {?}
     */
    clickedOut() {
        this.showPesquisa = this.inside
            ? true
            : false;
        this.inside = false;
    }
    /**
     * @param {?} termoDaBusca
     * @return {?}
     */
    pesquisa(termoDaBusca) {
        this.valorDigitado = this.showPesquisa === true ? termoDaBusca : '';
        this.subjectPesquisa.next(this.valorDigitado);
    }
    /**
     * @param {?} url
     * @return {?}
     */
    capturaCliquePesquisa(url) {
        this.openDialog(url);
        this.link.nativeElement.href = url;
        this.pesquisaService.setCliquePesquisa(this.link);
    }
    /**
     * @param {?} url
     * @return {?}
     */
    openDialog(url) {
        this.dialog.open(DialogPesquisaComponent, {
            panelClass: 'salvar-consulta',
            data: {
                url
            }
        });
    }
}
PesquisaComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-pesquisa',
                template: "<div id=\"simbolo-search\" *ngIf=\"!showPesquisa\" @fadeIn>\n  <mat-icon class=\"gov-icon\" (click)=\"clicked()\" class=\"icone-search\">search</mat-icon>\n</div>\n<div *ngIf=\"showPesquisa\" @fadeIn>\n  <mat-form-field class=\"my-form-field govbr-form-field\" appearance=\"outline\">\n    <div id=\"alinhar-pesquisa\">\n      <input id=\"barra-pesquisa\" matInput placeholder=\"Localizar Funcionalidade\"\n      #termoDaPesquisa (keyup)=\"pesquisa(termoDaPesquisa.value)\">\n      <mat-icon class=\"icone-search posicao-icone\" matSuffix>search</mat-icon>\n    </div>\n  </mat-form-field>\n  <div *ngIf=\"valorDigitado !== ''\" class=\"search-component-container\">\n    <div class=\"search-result\">\n      <div class=\"search-ps\">\n        <div *ngFor=\"let resultado of resultados | async\">\n          <p class=\"titulo-produto\">\n            {{resultado.nome}}\n          </p>\n          <ul *ngFor=\"let subItem of resultado.subItens\" id=\"group-result\">\n             <li id=\"link-pesquisa\">\n               <a #mylink (click)=\"capturaCliquePesquisa(subItem.url)\" id=\"link\">{{subItem.nome}}</a><br>\n               <span id=\"caminho-pesquisa\" *ngFor=\"let item of subItem.subItens; let i = index\">\n                <span> {{item}} <span *ngIf=\"i < subItem.subItens.length - 1\"> > </span> </span>\n              </span>\n              </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                animations: [
                    fadeIn
                ],
                styles: ["@charset \"UTF-8\";.posicao-icone{position:relative;top:7px;left:35px;font-size:20px}#simbolo-search{display:flex;margin-left:16px}.icone-search{cursor:pointer}.my-form-field{display:flex;align-items:center}#alinhar-pesquisa{display:flex;justify-content:flex-end;align-items:center;height:30px}.search-component-container{position:relative;max-width:448px;min-width:200px;z-index:1}div#alinhar-pesquisa>input{margin-top:11px}.search-result{position:absolute;margin-top:0;width:446px;padding:10px 15px 20px 10px;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.search-ps{width:auto;height:auto;overflow-y:auto;max-height:320px;min-height:100px}.titulo-produto{font-family:Nunito Sans;font-style:normal;font-weight:600;font-size:14px;padding-top:5px}#caminho-pesquisa{font-family:Nunito Sans;font-style:italic;font-weight:400;font-size:12px;text-align:justify;white-space:pre-line}#link-pesquisa{font-family:Nunito Sans;font-style:normal;font-weight:400;font-size:12px;margin-bottom:4px;margin-top:4px}#link{cursor:pointer}#link-pesquisa a{text-decoration:none}#group-result{margin-left:20px;display:-ms-grid;display:grid;list-style:none}#link-pesquisa::before{content:\"\u2022 \";display:inline-block;width:1em;margin-left:-1em}@media screen and (max-width:600px){.search-result{width:202px}}"]
            }] }
];
/** @nocollapse */
PesquisaComponent.ctorParameters = () => [
    { type: PesquisaService },
    { type: MatDialog }
];
PesquisaComponent.propDecorators = {
    link: [{ type: ViewChild, args: ['mylink', { static: false },] }],
    exibePesquisa: [{ type: Input }],
    url: [{ type: Input }],
    clicked: [{ type: HostListener, args: ['click',] }],
    clickedOut: [{ type: HostListener, args: ['document:click',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PesquisaModule {
}
PesquisaModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    PesquisaComponent,
                    DialogPesquisaComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatInputModule,
                    MatDialogModule,
                    MatButtonModule,
                    MatToolbarModule
                ],
                entryComponents: [
                    DialogPesquisaComponent
                ],
                exports: [
                    PesquisaComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FavoritosComponent {
    constructor() {
        this.cliqueFavoritos = new EventEmitter();
        this.showFavoritos = false;
        this.inside = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * Método para detectar o clique no produto de favoritos e validação da rota.
     * @param {?} item
     * @param {?} rota
     * @return {?}
     */
    capturaCliqueFavoritos(item, rota) {
        if (rota === '' || rota === undefined) {
            this.cliqueFavoritos.emit(item);
        }
    }
    /**
     * Método exibe/recolhe favoritos clicando no icone da estrela
     * @return {?}
     */
    show() {
        this.inside = true;
    }
    /**
     * Método recolhe favoritos clicando em qualquer lugar da tela
     * @return {?}
     */
    clickedOut() {
        this.showFavoritos = this.inside
            ? true
            : false;
        this.inside = false;
    }
}
FavoritosComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-favoritos',
                template: "<div class=\"favoritos-icone\" (click)=\"show()\"><mat-icon>star_outline</mat-icon></div>\n\n<div *ngIf=\"showFavoritos\" class=\"card-container\">\n  <div class=\"card\">\n    <div class=\"title\">\n        <p>Meus Favoritos</p>\n    </div>\n    <div class=\"content\">\n        <ul class=\"list\" *ngFor=\"let row of favoritos\">\n            <li>{{ row.titulo }}\n              <ul class=\"child-list\" *ngFor=\"let rowTituloProduto of row.tituloProduto\">\n                  <li><a [routerLink]=\"rowTituloProduto.rota ? rowTituloProduto.rota : ''\" (click)=\"capturaCliqueFavoritos(rowTituloProduto, rowTituloProduto.rota)\">{{ rowTituloProduto.titulo}}</a>\n                    <ul class=\"breadcrumb\">\n                        <li *ngFor=\"let rowBreadcrumb of rowTituloProduto.breadcrumb\">\n                          {{ rowBreadcrumb.titulo }}\n                        </li>\n                    </ul>\n                  </li>\n              </ul>\n            </li>\n        </ul>\n    </div>\n  </div>\n</div>\n",
                styles: ["@charset \"UTF-8\";::-webkit-scrollbar{width:10px}::-webkit-scrollbar-track{border-radius:50px}::-webkit-scrollbar-thumb{border-radius:50px}.favoritos-icone mat-icon{display:flex;margin-left:16px;cursor:pointer}.card-container{position:relative;display:flex;justify-content:flex-end}.card{position:absolute;top:10px;padding:10px 15px 15px;width:300px;border-radius:5px}div.title p{cursor:auto;margin:0;padding-bottom:2px;font-family:\"Nunito Sans\",sans-serif;font-size:14px;font-weight:700}.content{margin-top:10px;overflow-y:scroll;height:248px}ul.list{margin:0 0 10px;padding:0;list-style:none}ul.list>li{font-family:\"Nunito Sans\",sans-serif;font-size:14px;text-decoration:none}ul.child-list{margin-top:5px;padding:0 20px}ul.child-list>li::marker{content:\"\u2022\"}ul.child-list>li>a{cursor:pointer;padding-left:5px;font-family:\"Nunito Sans\",sans-serif;font-size:12px;text-decoration:none}ul.breadcrumb{margin-top:-5px;padding:0 5px;font-family:\"Nunito Sans\",sans-serif;font-style:italic;list-style:none}ul.breadcrumb li{display:inline;font-size:12px;text-decoration:none}ul.breadcrumb li+li:before{padding:5px;content:\">\"}"]
            }] }
];
/** @nocollapse */
FavoritosComponent.ctorParameters = () => [];
FavoritosComponent.propDecorators = {
    favoritos: [{ type: Input }],
    cliqueFavoritos: [{ type: Output }],
    show: [{ type: HostListener, args: ['click',] }],
    clickedOut: [{ type: HostListener, args: ['document:click',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FavoritosModule {
}
FavoritosModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    FavoritosComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    RouterModule
                ],
                exports: [
                    FavoritosComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const TipoMensagem = {
    Aviso: 'aviso',
    Educativa: 'educativa',
    Versao: 'nova_versao',
    getNomeExibicao: 'getNomeExibicao',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const JWT$3 = JWTim;
class NotificacoesService {
    /**
     * @param {?} http
     * @param {?} tenantService
     * @param {?} appSysName
     * @param {?} params_notificacao
     */
    constructor(http, tenantService, appSysName, params_notificacao) {
        this.http = http;
        this.tenantService = tenantService;
        this.appSysName = appSysName;
        this.params_notificacao = params_notificacao;
        this.hash_key = 'QMxxqYKfkwCyuxSr4rPT1E1zj9paP9Qc9yk5qCQD0wG9ZwMGqjUk1O310Fr3oTJn';
        this.idKeycloak = this.getIdKeyCloak();
    }
    /**
     * @param {?} url
     * @param {?} tiposMensagem
     * @param {?} permissoes
     * @return {?}
     */
    getBadge(url, tiposMensagem, permissoes) {
        /** @type {?} */
        const headers = this.appendHeaders();
        /** @type {?} */
        const body = JSON.stringify({ tiposMensagem, permissoes });
        return this.http.post(`${url}/notificacao/badge/idUsuario/${this.idKeycloak}`, body, { headers });
    }
    /**
     * @param {?} url
     * @param {?} page
     * @param {?} tiposMensagem
     * @param {?} permissoes
     * @return {?}
     */
    getNotificacoesPaginacao(url, page, tiposMensagem, permissoes) {
        /** @type {?} */
        const headers = this.appendHeaders();
        /** @type {?} */
        const params = Object.assign({}, page, { permissoes, tiposMensagem });
        /** @type {?} */
        const body = JSON.stringify(params);
        return this.http.post(`${url}/notificacao/buscarComPaginacao/idUsuario/${this.idKeycloak}`, body, { headers });
    }
    /**
     * @param {?} url
     * @param {?} tiposMensagem
     * @param {?} qtd
     * @param {?} permissoes
     * @return {?}
     */
    getNotificacaoPorQtd(url, tiposMensagem, qtd, permissoes) {
        /** @type {?} */
        const headers = this.appendHeaders();
        /** @type {?} */
        const body = JSON.stringify({ tiposMensagem, permissoes });
        return this.http.post(`${url}/notificacao/buscar/idUsuario/${this.idKeycloak}/quantidade/${qtd}`, body, { headers });
    }
    /**
     * @private
     * @return {?}
     */
    getIdKeyCloak() {
        try {
            const { sub } = JWT$3(localStorage.getItem('access_token'));
            return sub;
        }
        catch (error) {
            return error;
        }
    }
    /**
     * @return {?}
     */
    getRolesFromUser() {
        try {
            /** @type {?} */
            const municipio = this.tenantService.getTenant().municipio;
            const { roles } = JSON.parse(localStorage.getItem(`${municipio}-product-user-permissions`));
            return roles;
        }
        catch (error) {
            return null;
        }
    }
    /**
     * Metodo que adiciona as informações no header para os requests
     * @private
     * @return {?}
     */
    appendHeaders() {
        /** @type {?} */
        const tenant = this.tenantService.getTenant();
        /** @type {?} */
        let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        if (this.hash_key) {
            headers = headers.append('X-Api-Key', this.hash_key);
        }
        if (tenant && tenant.municipio) {
            headers = headers.append('X-Tenant-Municipio', tenant.municipio);
        }
        if (tenant && tenant.entidade) {
            headers = headers.append('X-Tenant-Entidade', tenant.entidade);
        }
        headers = headers.append('X-Product-Key', //
        (this.params_notificacao.nomeProduto ? this.params_notificacao.nomeProduto : this.appSysName));
        return headers;
    }
    /**
     * @param {?} tipoMensagemString
     * @return {?}
     */
    getNomeExibicaoTipoMensagem(tipoMensagemString) {
        switch (tipoMensagemString) {
            case TipoMensagem.Aviso.toString(): return 'Aviso';
            case TipoMensagem.Educativa.toString(): return 'Educativa';
            case TipoMensagem.Versao.toString(): return 'Nova Versão';
        }
    }
}
NotificacoesService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
NotificacoesService.ctorParameters = () => [
    { type: HttpClient, decorators: [{ type: Inject, args: [HttpClient,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }, { type: Optional }] },
    { type: String, decorators: [{ type: Inject, args: [APP_SYS_NAME,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [PARAMS_NOTIFICACAO,] }] }
];
/** @nocollapse */ NotificacoesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NotificacoesService_Factory() { return new NotificacoesService(ɵɵinject(HttpClient), ɵɵinject(TenantService, 8), ɵɵinject(APP_SYS_NAME), ɵɵinject(PARAMS_NOTIFICACAO)); }, token: NotificacoesService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AnalyticsUtils {
    constructor() {
        this.pronimKey = 'PronimCentral';
        this.moment = moment_;
    }
    /**
     * @return {?}
     */
    encryptRequestToken() {
        /** @type {?} */
        const text = this.formatData();
        /** @type {?} */
        let key = this.pronimKey;
        /*
          O TripleDES utiliza um chave de 24 bytes, onde k = k1 + k2 + k3.
          Quando k3 = 0, o algoritmo do .net completa k3 com k1 (k3 = k1)
          porém o javascript não o faz (k3 = 0)
        */
        key = MD5(key).toString();
        /** @type {?} */
        const k1 = key.substring(0, 16);
        key = key + k1;
        /** @type {?} */
        const options = {
            mode: mode.ECB,
            padding: pad.Pkcs7
        };
        /** @type {?} */
        const textWordArray = enc.Utf8.parse(text);
        /** @type {?} */
        const keyHex = enc.Hex.parse(key);
        /** @type {?} */
        const encrypted = TripleDES.encrypt(textWordArray, keyHex, options);
        /** @type {?} */
        const base64String = encrypted.toString();
        return base64String;
    }
    // Retorna a data de acordo com o formato requerido pelo serviço PronimCentral  
    /**
     * @return {?}
     */
    formatData() {
        /** @type {?} */
        const data = new Date();
        /** @type {?} */
        const now = this.moment.utc(data.toISOString());
        return now.format('DD/MM/YYYY HH:mm:ss').toString();
    }
    // Retorna a data de acordo com o formato requerido pelo SQL Server 
    /**
     * @return {?}
     */
    formatSqlData() {
        this.moment.locale('pt-BR');
        /** @type {?} */
        const now = this.moment().format('YYYY-MM-DD HH:mm:ss').toString();
        return now;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class XmlBase {
    /**
     * @param {?} xmlBaseBuilder
     */
    constructor(xmlBaseBuilder) {
        this.numeroSerie = xmlBaseBuilder.numeroSerie;
        this.siglaSistema = xmlBaseBuilder.siglaSistema;
        this.data = xmlBaseBuilder.data;
        this.codigoXml = xmlBaseBuilder.codigoXml;
        this.nomeUsuario = xmlBaseBuilder.nomeUsuario;
        this.tenant = xmlBaseBuilder.tenant;
        this.dados = xmlBaseBuilder.dados;
    }
    /**
     * @return {?}
     */
    buildXml() {
        /** @type {?} */
        const root = create('Log', { headless: true })
            .ele('Lic', this.numeroSerie).up()
            .ele('Sis', this.siglaSistema).up()
            .ele('Data', this.data).up()
            .ele('Opcao', this.codigoXml).up()
            .ele('Login', this.nomeUsuario).up();
        /** @type {?} */
        const dados = root.ele('Dados')
            .ele('Dado');
        if (this.dados) {
            dados.ele('Tenant', this.tenant.municipio).up();
            dados.ele('Entidade', this.tenant.entidade).up();
            this.dados.forEach((/**
             * @param {?} key
             * @param {?} value
             * @return {?}
             */
            (key, value) => {
                dados.ele(value, key).up();
            }));
        }
        return root.end({ pretty: true }).toString();
    }
}
class XMLBaseBuilder {
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} numeroSerie
     * @return {THIS}
     */
    setNumeroSerie(numeroSerie) {
        (/** @type {?} */ (this))._numeroSerie = numeroSerie;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} siglaSistema
     * @return {THIS}
     */
    setSiglaSistema(siglaSistema) {
        (/** @type {?} */ (this))._siglaSistema = siglaSistema;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} data
     * @return {THIS}
     */
    setData(data) {
        (/** @type {?} */ (this))._data = data;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} codigoXML
     * @return {THIS}
     */
    setCodigoXml(codigoXML) {
        (/** @type {?} */ (this))._codigoXml = codigoXML;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} nomeUsuario
     * @return {THIS}
     */
    setNomeUsuario(nomeUsuario) {
        (/** @type {?} */ (this))._nomeUsuario = nomeUsuario;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} tenant
     * @return {THIS}
     */
    setTenant(tenant) {
        (/** @type {?} */ (this))._tenant = tenant;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} dados
     * @return {THIS}
     */
    setDados(dados) {
        (/** @type {?} */ (this))._dados = dados;
        return (/** @type {?} */ (this));
    }
    /**
     * @return {?}
     */
    get numeroSerie() {
        return this._numeroSerie;
    }
    /**
     * @return {?}
     */
    get siglaSistema() {
        return this._siglaSistema;
    }
    /**
     * @return {?}
     */
    get codigoXml() {
        return this._codigoXml;
    }
    /**
     * @return {?}
     */
    get nomeUsuario() {
        return this._nomeUsuario;
    }
    /**
     * @return {?}
     */
    get tenant() {
        return this._tenant;
    }
    /**
     * @return {?}
     */
    get data() {
        return this._data;
    }
    /**
     * @return {?}
     */
    get dados() {
        return this._dados;
    }
    /**
     * @return {?}
     */
    build() {
        return new XmlBase(this);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const SIGLA_SISTEMA = new InjectionToken('siglaSistema');
/** @type {?} */
const ANALYTICS_PRODUTO_FRAMEWORK = new InjectionToken('produtoFramework');
class LogAnalyticsService {
    /**
     * @param {?} dadosUsuarioService
     * @param {?} licService
     * @param {?} ambienteProducao
     * @param {?} siglaSistemaToken
     * @param {?} produtoFrameworkToken
     * @param {?} tenantService
     * @param {?=} http
     */
    constructor(dadosUsuarioService, licService, ambienteProducao, siglaSistemaToken, produtoFrameworkToken, tenantService, http) {
        this.dadosUsuarioService = dadosUsuarioService;
        this.licService = licService;
        this.ambienteProducao = ambienteProducao;
        this.siglaSistemaToken = siglaSistemaToken;
        this.produtoFrameworkToken = produtoFrameworkToken;
        this.tenantService = tenantService;
        this.http = http;
        this.endpointPronimCentral = `http://central.govbr.com.br/Pronim.Central.Web/LoggerGovBr/Log/Post`;
        this.utils = new AnalyticsUtils();
    }
    /*
      *  Método que envia xml com a intenção de uso do usuário com o código da funcionalidade registrado no PRONIM Analytics.
      *  @param intencao intencao de uso do usuario
      *  @param chaveAnalytics código da funcionalidade cadastrada no EA / LOGOS
      */
    /**
     * @param {?} intencao
     * @param {?} chaveAnalytics
     * @return {?}
     */
    SU_INF_0004(intencao, chaveAnalytics) {
        /** @type {?} */
        const dados = new Map();
        dados.set('Chave', chaveAnalytics);
        dados.set('Opcao', intencao);
        this.log('SU_INF_0004', dados);
    }
    /**
     * @param {?} codigoXml
     * @param {?} dados
     * @return {?}
     */
    log(codigoXml, dados) {
        if (this.produtoFrameworkToken == null || this.produtoFrameworkToken === false)
            this.codigoSistema = this.licService.getCodigoSistema();
        this.verificaInjectionTokens();
        /** @type {?} */
        const nomeUsuario = this.dadosUsuarioService.get().nomeUsuario.toString();
        /** @type {?} */
        const tenant = this.tenantService.getTenant();
        if (this.ambienteProducao === true) {
            if (this.produtoFrameworkToken === true) {
                /** @type {?} */
                const xml = this.buildXmlBase(null, codigoXml, nomeUsuario, tenant, dados);
                this.http.post(this.endpointPronimCentral, xml, { headers: this.getHeaders(), responseType: 'text' }).subscribe();
            }
            else {
                this.licService.getInfoLicencas().subscribe((/**
                 * @param {?} res
                 * @return {?}
                 */
                res => {
                    /** @type {?} */
                    const prod = res.find((/**
                     * @param {?} x
                     * @return {?}
                     */
                    x => x.codigoSistema === this.codigoSistema));
                    if (prod) {
                        /** @type {?} */
                        const xml = this.buildXmlBase(prod.numeroSerie.toString(), codigoXml, nomeUsuario, tenant, dados);
                        this.http.post(this.endpointPronimCentral, xml, { headers: this.getHeaders(), responseType: 'text' }).subscribe();
                    }
                    else {
                        throw new Error('Tenant não possui licença válida para este produto');
                    }
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                err => {
                    throw new Error('Ocorreu um erro ao obter as licenças deste Tenant');
                }));
            }
        }
    }
    /**
     * @return {?}
     */
    verificaInjectionTokens() {
        if (this.siglaSistemaToken === undefined) {
            throw new Error('InjectionToken SIGLA_SISTEMA não configurado');
        }
        if (this.ambienteProducao === undefined) {
            throw new Error('InjectionToken AMBIENTE_PRODUCAO não configurado');
        }
    }
    /**
     * @return {?}
     */
    getHeaders() {
        return new HttpHeaders({
            'Content-Type': 'text/plain',
            'Request-Token': this.utils.encryptRequestToken()
        });
    }
    /**
     * @private
     * @param {?} numeroSerie
     * @param {?} codigoXml
     * @param {?} nomeUsuario
     * @param {?} tenant
     * @param {?} dados
     * @return {?}
     */
    buildXmlBase(numeroSerie, codigoXml, nomeUsuario, tenant, dados) {
        return new XMLBaseBuilder()
            .setNumeroSerie(numeroSerie).setSiglaSistema(this.siglaSistemaToken)
            .setData(this.utils.formatSqlData()).setCodigoXml(codigoXml)
            .setNomeUsuario(nomeUsuario).setDados(dados)
            .setTenant(tenant)
            .build().buildXml();
    }
}
LogAnalyticsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LogAnalyticsService.ctorParameters = () => [
    { type: DadosUsuarioService, decorators: [{ type: Inject, args: [DadosUsuarioService,] }] },
    { type: LICService, decorators: [{ type: Inject, args: [LICService,] }] },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [AMBIENTE_PRODUCAO,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [SIGLA_SISTEMA,] }] },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [ANALYTICS_PRODUTO_FRAMEWORK,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }] },
    { type: HttpClient, decorators: [{ type: Inject, args: [HttpClient,] }] }
];
/** @nocollapse */ LogAnalyticsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LogAnalyticsService_Factory() { return new LogAnalyticsService(ɵɵinject(DadosUsuarioService), ɵɵinject(LICService), ɵɵinject(AMBIENTE_PRODUCAO, 8), ɵɵinject(SIGLA_SISTEMA, 8), ɵɵinject(ANALYTICS_PRODUTO_FRAMEWORK, 8), ɵɵinject(TenantService), ɵɵinject(HttpClient)); }, token: LogAnalyticsService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogMensagemEccoComponent {
    /**
     * @param {?} analyticsService
     * @param {?} dialogRef
     * @param {?} data
     * @param {?} router
     */
    constructor(analyticsService, dialogRef, data, router) {
        this.analyticsService = analyticsService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.router = router;
        this.index = 1;
        this.config = {
            allowTouchMove: false,
            pagination: {
                el: '#cpage',
                clickable: false,
                hideOnClick: false
            }
        };
        this.pagination = {
            el: '#cpage',
            clickable: false,
            hideOnClick: false
        };
        this.analyticsService.produtoFrameworkToken = true;
        this.analyticsService.siglaSistemaToken = 'GRP';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.criaYoutubePlayer();
        this.notificacoes = this.data;
        this.config.pagination = this.pagination;
        this.definirNotificacaoLida(this.notificacoes[0]);
    }
    /**
     * @return {?}
     */
    criaYoutubePlayer() {
        /** @type {?} */
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(tag);
    }
    /**
     * @param {?} notificacao
     * @return {?}
     */
    redirectLink(notificacao) {
        /** @type {?} */
        const link = notificacao.linkInterno ? notificacao.linkInterno : notificacao.linkExterno;
        this.chamadaAnalyticsRedirecionamento(link);
        if (notificacao.linkInterno) {
            this.router.navigate([link]);
            this.dialogRef.close();
        }
    }
    /**
     * @return {?}
     */
    nextSlide() {
        this.componentRef.directiveRef.nextSlide();
        this.definirNotificacaoLida(this.notificacoes[this.index]);
        this.index++;
    }
    /**
     * @return {?}
     */
    prevSlide() {
        this.componentRef.directiveRef.prevSlide();
        this.index--;
    }
    /**
     * @param {?} notificacao
     * @return {?}
     */
    definirNotificacaoLida(notificacao) {
        /** @type {?} */
        const popupStorageKey = 'id-popups-ecco';
        /** @type {?} */
        let storage;
        if (localStorage.getItem(popupStorageKey)) {
            storage = localStorage.getItem(popupStorageKey).toString();
        }
        /** @type {?} */
        const notificacoesArmazenadas = storage ? storage.split(',') : [];
        if (!notificacoesArmazenadas.includes(notificacao.oid)) {
            notificacoesArmazenadas.push(notificacao.oid);
        }
        localStorage.setItem(popupStorageKey, notificacoesArmazenadas.toString());
    }
    /**
     * @return {?}
     */
    get isAtFirst() {
        return this.componentRef.isAtFirst;
    }
    /**
     * @return {?}
     */
    get isAtLast() {
        return this.componentRef.isAtLast;
    }
    /**
     * @private
     * @param {?} link
     * @return {?}
     */
    chamadaAnalyticsRedirecionamento(link) {
        /** @type {?} */
        const dados = new Map();
        dados.set('Chave', 'FRA0001');
        dados.set('Opcao', 'Redirecionamento Pop-up');
        dados.set('SubOpcao', link);
        this.analyticsService.log('SU_INF_0004', dados);
    }
}
DialogMensagemEccoComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-dialog-mensagem-ecco',
                template: "<div mat-dialog-title>\n    <img alt=\"fechar\" class=\"btn-close-modal\" src=\"assets/icons/close-modal.svg\" (click)=\"dialogRef.close()\" />\n</div>\n\n<div mat-dialog-content>\n    <swiper #swiper class=\"swiper-container\" [config]=\"config\">\n        <div class=\"swiper-slide\" *ngFor=\"let notificacao of notificacoes\"\n            style=\"overflow-y: scroll; max-height: 430px;\">\n            <div class=\"rotulo-tipo-mensagem\" govbrRotuloTipoMensagem [tipoMensagem]=\"notificacao?.tipoMensagem\">\n                <div class=\"span-tipo-mensagem\"> {{ notificacao?.tipoMensagem?.toUpperCase() }} </div>\n            </div>\n            <a id=\"link\" target=\"_blank\" [attr.href]=\"notificacao.linkExterno ? notificacao.linkExterno : null\"\n                (click)=\"redirectLink(notificacao)\">\n                <p class=\"titulo\">{{ notificacao.titulo }} </p>\n                \n                <ng-container *ngIf=\"notificacao.tipoMidia === 'video'; else elseTemplate\">\n                    <youtube-player \n                        videoId=\"notificacao.urlMidia\" \n                        suggestedQuality=\"highres\" \n                        [height]=\"300\" \n                        [width]=\"555\">\n                    </youtube-player>\n                </ng-container>\n                <ng-template #elseTemplate>\n                    <img alt=\"midia notificacao\" [src]=\"notificacao.urlMidia\" />\n                </ng-template>\n\n                <span id=\"data-notificacao\"> {{ notificacao?.dataCriacao | date: 'dd/MM/yyyy' }} </span>\n\n                <h3>{{notificacao?.titulo}}</h3>\n            </a>\n            <div id=\"conteudo-mensagem\" [innerHtml]=\"notificacao?.mensagem\"></div>\n        </div>\n    </swiper>\n</div>\n\n<span id=\"cpage\"></span>\n<button mat-raised-button [disabled]=\"isAtFirst\" (click)=\"prevSlide();\"\n    class=\"govbr-button\">Anterior</button>\n<button mat-raised-button [disabled]=\"isAtLast\" (click)=\"nextSlide();\"\n    class=\"govbr-button button-next\">Pr\u00F3ximo</button>",
                providers: [LogAnalyticsService],
                styles: [".govbr-ecco-modal-background{background-color:transparent}.btn-close-modal{float:right;cursor:pointer}.rotulo-tipo-mensagem{background-color:#4fc219;display:inline-block;border-radius:3px;text-align:center;padding:0 5px;vertical-align:top;height:100%;margin-bottom:20px}.rotulo-tipo-mensagem .span-tipo-mensagem{color:#fff;font-family:\"Nunito Sans\";font-size:12px;height:100%;line-height:normal}#cpage{width:100%;border-radius:3px;display:flex;justify-content:center;align-items:center;margin-top:10px}.swiper-pagination{position:absolute;bottom:-25px}.button-next{margin-left:69%;margin-top:10px}.mat-dialog-title{height:18px}.mat-dialog-content,.mat-dialog-title{font-family:\"Nunito Sans\";max-height:430px;padding-right:10px}h3{color:#0395df}.mat-dialog-content{line-height:19px}.mat-dialog-content p{color:#707070}.mat-dialog-content img{display:block;max-width:550px;width:100%;border-radius:10px}#data-notificacao{font-family:\"Nunito Sans\";font-size:10px}"]
            }] }
];
/** @nocollapse */
DialogMensagemEccoComponent.ctorParameters = () => [
    { type: LogAnalyticsService, decorators: [{ type: Inject, args: [LogAnalyticsService,] }] },
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
    { type: Router }
];
DialogMensagemEccoComponent.propDecorators = {
    componentRef: [{ type: ViewChild, args: ['swiper', { static: true },] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificacoesComponent {
    /**
     * @param {?} analyticsService
     * @param {?} notificacaoService
     * @param {?} params_notificacao
     * @param {?} router
     * @param {?} dialog
     */
    constructor(analyticsService, notificacaoService, params_notificacao, router, dialog) {
        this.analyticsService = analyticsService;
        this.notificacaoService = notificacaoService;
        this.params_notificacao = params_notificacao;
        this.router = router;
        this.dialog = dialog;
        this.rotaNotificacoes = 'notificacoes';
        /**
         * Notificação selecionada a ser expandida para interação do usuário.
         */
        this.notificacoes = [];
        /**
         * Flag que exibe o componente
         */
        this.showNotificacao = false;
        this.inside = false;
        /**
         * Chamada do dialog
         */
        this.dialogAtivo = false;
        /**
         * Objeto padrão de paginação
         */
        this.page = {
            pageRequest: {
                page: 0,
                size: 5
            }
        };
        /**
         * Variável de controle para impedir que múltiplos cliques gerem múltiplos requests
         */
        this.podeObterNotificacoes = true;
        const { urlBase, intervalPeriod, minutes, tiposMensagem } = params_notificacao;
        this.urlNotificacoes = urlBase;
        this.intervalPeriod = intervalPeriod;
        this.minutes = minutes;
        this.tiposMensagem = tiposMensagem;
        this.analyticsService.produtoFrameworkToken = true;
        this.analyticsService.siglaSistemaToken = 'GRP';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.streamBadge(this.urlNotificacoes, this.intervalPeriod, this.minutes, this.tiposMensagem);
        this.streamNotificacoes(this.urlNotificacoes, this.intervalPeriod, this.minutes, this.tiposMensagem);
    }
    /**
     * @return {?}
     */
    clicked() {
        this.analyticsService.SU_INF_0004('Visualizar Últimas Notificações', 'FRA0004');
        this.inside = true;
    }
    /**
     * Método recolhe perfil usuário clicando em qualquer lugar da tela
     * @return {?}
     */
    clickedOut() {
        this.showNotificacao = this.inside
            ? true
            : false;
        this.inside = false;
    }
    /**
     * Fica fazendo requests em tempo determinado a fim de estabelecer uma sensação de real-time
     * @param {?} url
     * @param {?} intervalPeriod
     * @param {?} minutes
     * @param {?} tiposMensagem
     * @return {?} número da badge no momento
     */
    streamBadge(url, intervalPeriod, minutes, tiposMensagem) {
        this.subscription = timer(intervalPeriod, minutes)
            .pipe(switchMap((/**
         * @return {?}
         */
        () => {
            return this.notificacaoService.getBadge(url, tiposMensagem, this.getRoles());
        })))
            .subscribe((/**
         * @param {?} badge
         * @return {?}
         */
        (badge) => {
            this.badgeCount = badge;
        }));
    }
    /**
     * Fica fazendo requests em tempo determinado a fim de estabelecer uma sensação de real-time
     * @param {?} url
     * @param {?} intervalPeriod
     * @param {?} minutes
     * @param {?} tiposMensagem
     * @return {?} Retorna um Array de Notificações
     */
    streamNotificacoes(url, intervalPeriod, minutes, tiposMensagem) {
        this.subscription = timer(intervalPeriod, minutes)
            .pipe(switchMap((/**
         * @return {?}
         */
        () => {
            return this.notificacaoService.getNotificacaoPorQtd(url, tiposMensagem, 5, this.getRoles());
        })))
            .subscribe((/**
         * @param {?} notificacoes
         * @return {?}
         */
        (notificacoes) => {
            this.notificacoes = notificacoes;
            if (!this.dialogAtivo) {
                this.deveAbrirDialogNotificacoes();
            }
        }));
    }
    /**
     * chama as notificacoes paginadas apatir de um click
     * @return {?} notificacoes paginadas
     */
    verTodasNotificaoes() {
        if (this.podeObterNotificacoes) {
            this.podeObterNotificacoes = false;
            this.notificacaoService.getNotificacoesPaginacao(this.urlNotificacoes, this.page, this.tiposMensagem, this.getRoles())
                .subscribe((/**
             * @param {?} notificacoes
             * @return {?}
             */
            (notificacoes) => {
                notificacoes.content.forEach((/**
                 * @param {?} notificacao
                 * @return {?}
                 */
                (notificacao) => {
                    this.cleared = notificacao.visualizado;
                }));
                this.notificacoes = notificacoes.content;
                this.showNotificacao = false;
                this.podeObterNotificacoes = true;
            }));
        }
        this.showNotificacao = false;
        this.analyticsService.SU_INF_0004('Visualizar Todas Notificações', 'FRA0003');
        this.router.navigate([this.rotaNotificacoes]);
    }
    /**
     * @param {?} linkInterno
     * @return {?}
     */
    redirectLinkInterno(linkInterno) {
        this.router.navigate([linkInterno]);
    }
    /**
     * Retorna número da badge ou nada caso não existam notificações
     * @return {?}
     */
    get retornaBadge() {
        return this.badgeCount !== 0 ? this.badgeCount : null;
    }
    /**
     * @return {?}
     */
    getRoles() {
        return this.notificacaoService.getRolesFromUser() ? this.notificacaoService.getRolesFromUser() : [];
    }
    /**
     * @return {?}
     */
    deveAbrirDialogNotificacoes() {
        /** @type {?} */
        const notificacoesAExibir = [];
        /** @type {?} */
        const notificacoes = this.notificacoes
            .sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        (a, b) => new Date(b.dataCriacao).getTime() - new Date(a.dataCriacao).getTime()));
        /** @type {?} */
        const notificacoesPopup = notificacoes.filter((/**
         * @param {?} notificacao
         * @return {?}
         */
        notificacao => notificacao.popup === true //
            && notificacao.visualizado === false));
        if ((notificacoesPopup.length > 0)) {
            notificacoesPopup.forEach((/**
             * @param {?} notificacaoPopup
             * @return {?}
             */
            notificacaoPopup => {
                if (notificacaoPopup.dataFimPopup) {
                    /** @type {?} */
                    const dataFimMaior = new Date(notificacaoPopup.dataFimPopup).getTime() > Date.now();
                    if (dataFimMaior) {
                        notificacoesAExibir.push(notificacaoPopup);
                    }
                }
                else {
                    notificacoesAExibir.push(notificacaoPopup);
                }
            }));
            this.exibirPopupsEcco(notificacoesAExibir);
        }
    }
    /**
     * @param {?} notificacoesPopup
     * @return {?}
     */
    exibirPopupsEcco(notificacoesPopup) {
        /** @type {?} */
        const popupStorageKey = 'id-popups-ecco';
        /** @type {?} */
        const notificacoesExibir = [];
        localStorage.setItem(popupStorageKey, localStorage.getItem(popupStorageKey) ? localStorage.getItem(popupStorageKey) : '');
        /** @type {?} */
        const notificacoesArmazenadas = localStorage.getItem(popupStorageKey).split(',');
        if (notificacoesPopup.length > 0) {
            if (notificacoesArmazenadas.length > 0) {
                /** @type {?} */
                const idNotificacoesFiltradas = notificacoesPopup
                    .filter((/**
                 * @param {?} notificacao
                 * @return {?}
                 */
                notificacao => notificacoesArmazenadas.includes(notificacao.oid)))
                    .map((/**
                 * @param {?} notificacao
                 * @return {?}
                 */
                notificacao => notificacao.oid));
                localStorage.setItem(popupStorageKey, idNotificacoesFiltradas.toString());
            }
            notificacoesPopup.forEach((/**
             * @param {?} notificacaoPopup
             * @return {?}
             */
            notificacaoPopup => {
                if (!notificacoesArmazenadas.includes(notificacaoPopup.oid)) {
                    notificacoesExibir.push(notificacaoPopup);
                }
            }));
            if (notificacoesExibir.length > 0) {
                this.analyticsService.SU_INF_0004('Abertura Pop-up', 'FRA0002');
                this.openDialogs(notificacoesExibir);
            }
        }
    }
    /**
     * @private
     * @param {?} notificacoesPopup
     * @return {?}
     */
    openDialogs(notificacoesPopup) {
        this.dialog.open(DialogMensagemEccoComponent, {
            width: '600px',
            maxHeight: '800px',
            autoFocus: false,
            data: notificacoesPopup,
            backdropClass: 'govbr-ecco-modal-background',
            panelClass: 'govbr-ecco-modal-panel'
        });
        this.dialogAtivo = true;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
NotificacoesComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-notificacoes',
                template: "<div class=\"container-sininho\" (click)=\"clicked()\">\n  <mat-icon [matBadge]=\"retornaBadge\" matBadgeSize=\"small\" matBadgeColor=\"warn\" class=\"icone-sininho\">notifications_none\n  </mat-icon>\n</div>\n<div *ngIf=\"showNotificacao\" class=\"card-container\">\n  <div class=\"card\">\n    <h4 id=\"card-titulo\">Notifica\u00E7\u00F5es</h4>\n    <hr id=\"linha-divisoria\">\n    <div class=\"card-ps\">\n      <div class=\"notificacoes\" *ngFor=\"let notificacao of notificacoes, let i = index\">\n        <div *ngIf=\"notificacao.visualizado !== true\">\n          <hr class=\"linha-tipo-aviso\" govbrRotuloTipoMensagem [tipoMensagem]=\"notificacao.tipoMensagem\">\n          <p id=\"data-notificacao\">{{ notificacao.dataCriacao | date: 'dd/MM/yyyy' }}</p>\n          <div class=\"tipo-container\">\n            <span class=\"tipo-mensagem\" govbrRotuloTipoMensagem [tipoMensagem]=\"notificacao.tipoMensagem\">\n              {{ notificacaoService.getNomeExibicaoTipoMensagem(notificacao.tipoMensagem).toUpperCase() }}</span>\n          </div>\n          <p id=\"titulo-notificacao\">{{ notificacao.titulo }}</p>\n          <p id=\"descricao-notificacao\" [innerHtml]=\"notificacao.mensagem | ellipsis:50\">\n            <a *ngIf=\"notificacao.linkInterno\" (click)=\"redirectLinkInterno(notificacao.linkInterno)\"\n              id=\"link-notificacao\">Saiba mais</a>\n            <a *ngIf=\"notificacao.linkExterno\" href=\"//{{notificacao.linkExterno}}\" id=\"link-notificacao\">Saiba mais</a>\n          </p>\n        </div>\n\n      </div>\n      <hr *ngIf=\"cleared\" class=\"separador fixo\">\n\n      <hr class=\"linha-ver-todas\">\n      <a (click)=\"verTodasNotificaoes()\" id=\"link-notificacoes\">Ver todas as notifica\u00E7\u00F5es</a>\n\n    </div>\n  </div>",
                providers: [LogAnalyticsService],
                styles: [".container-sininho{margin-left:16px;display:flex;align-items:center}.icone-sininho{cursor:pointer}.card-container{position:relative;display:flex;justify-content:flex-end}.card{position:absolute;top:10px;padding:10px 15px;width:300px;height:322px;border-radius:5px}.card-ps{width:auto;height:auto;overflow-y:auto;max-height:231px;min-height:40px}#card-titulo{font-family:\"Nunito Sans\";font-weight:700;font-style:normal;font-size:14px}#linha-divisoria{display:block;height:1px;padding:0;margin-top:-4px;margin-bottom:12px}.notificacoes{width:248px}#link-notificacao{font-family:\"Nunito Sans\";font-size:12px;text-decoration:none;cursor:pointer}#link-notificacoes{position:absolute;left:5%;right:12.33%;top:89%;bottom:55%;font-family:\"Nunito Sans\";font-size:12px;text-decoration:none;cursor:pointer;line-height:3}#ver-todas{position:absolute;left:5%;right:12.33%;top:81%;bottom:55%;font-size:12px}#data-notificacao{font-family:\"Nunito Sans\";font-size:10px;position:relative;top:-5px}#titulo-notificacao{font-family:\"Nunito Sans\";font-size:14px;line-height:18px;margin-top:3px;margin-bottom:5px}#descricao-notificacao{font-family:\"Nunito Sans\";font-size:12px;padding-bottom:5px}.separador{display:block;margin-top:9px;margin-bottom:9px;padding:0}.separador.fixo{width:248px;margin-top:0}.tipo-container{align-items:center;display:flex;justify-content:right;margin-top:-23px;flex-grow:0}.tipo-mensagem{font-family:\"Nunito Sans\";text-align:center;font-size:11px;border-radius:0 0 3px 3px;padding:1px 4px 0}.linha-tipo-aviso{margin-top:2px;margin-bottom:7px}.linha-ver-todas{position:absolute;left:5%;right:12.33%;top:83.6%}"]
            }] }
];
/** @nocollapse */
NotificacoesComponent.ctorParameters = () => [
    { type: LogAnalyticsService, decorators: [{ type: Inject, args: [LogAnalyticsService,] }] },
    { type: NotificacoesService, decorators: [{ type: Inject, args: [NotificacoesService,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [PARAMS_NOTIFICACAO,] }] },
    { type: Router },
    { type: MatDialog }
];
NotificacoesComponent.propDecorators = {
    rotaNotificacoes: [{ type: Input }],
    clickedOut: [{ type: HostListener, args: ['document:click',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConteudoNotificacoesComponent {
    /**
     * @param {?} notificacaoService
     * @param {?} params_notificacao
     * @param {?} changeDetectorRef
     * @param {?} router
     */
    constructor(notificacaoService, params_notificacao, changeDetectorRef, router) {
        this.notificacaoService = notificacaoService;
        this.params_notificacao = params_notificacao;
        this.changeDetectorRef = changeDetectorRef;
        this.router = router;
        this.dataSource = new MatTableDataSource();
        this.minutes = 10;
        /**
         * Notificação selecionada a ser expandida para interação do usuário.
         */
        this.notificacoes = [];
        this.pageSize = 5;
        this.pageSizeOptions = [5, 10, 25, 100];
        const { urlBase, intervalPeriod, minutes, tiposMensagem } = params_notificacao;
        this.urlNotificacoes = urlBase;
        this.intervalPeriod = intervalPeriod;
        this.minutes = minutes;
        this.tiposMensagem = tiposMensagem;
        this.page = {
            pageRequest: {
                page: 0,
                size: 5
            }
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.streamNotificacoes(this.urlNotificacoes, this.page, this.tiposMensagem, this.intervalPeriod, this.minutes);
        this.dataSource.data = this.notificacoes;
        this.changeDetectorRef.detectChanges();
        this.dataSource.paginator = this.paginator;
    }
    /**
     * Fica fazendo requests em tempo determinado a fim de estabelecer uma sensação de real-time
     * @param {?} url
     * @param {?} page
     * @param {?} tiposMensagem
     * @param {?} intervalPeriod
     * @param {?} minutes
     * @return {?} Retorna um Array de Notificações
     */
    streamNotificacoes(url, page, tiposMensagem, intervalPeriod, minutes) {
        this.subscription = timer(intervalPeriod, minutes)
            .pipe(switchMap((/**
         * @return {?}
         */
        () => {
            return this.notificacaoService.getNotificacoesPaginacao(url, page, tiposMensagem, this.getRoles());
        })))
            .subscribe((/**
         * @param {?} notificacoes
         * @return {?}
         */
        (notificacoes) => {
            this.notificacoes = notificacoes.content;
            this.length = notificacoes.totalCount;
        }));
    }
    /**
     * @param {?} linkInterno
     * @return {?}
     */
    redirectLinkInterno(linkInterno) {
        if (linkInterno && linkInterno.length > 0) {
            this.router.navigate([linkInterno]);
        }
    }
    /**
     * @param {?} setPageSizeOptionsInput
     * @return {?}
     */
    setPageSizeOptions(setPageSizeOptionsInput) {
        this.pageSizeOptions = setPageSizeOptionsInput.split(',').map((/**
         * @param {?} str
         * @return {?}
         */
        str => +str));
    }
    /**
     * @param {?} page
     * @return {?}
     */
    onPageChanged(page) {
        this.page.pageRequest.page = page.pageIndex;
        this.page.pageRequest.size = page.pageSize;
        this.notificacaoService.getNotificacoesPaginacao(this.urlNotificacoes, this.page, this.tiposMensagem, this.getRoles())
            .subscribe((/**
         * @param {?} notificacoes
         * @return {?}
         */
        (notificacoes) => {
            this.notificacoes = notificacoes.content;
            this.length = notificacoes.totalCount;
        }));
    }
    /**
     * @return {?}
     */
    getRoles() {
        return this.notificacaoService.getRolesFromUser() ? this.notificacaoService.getRolesFromUser() : [];
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
ConteudoNotificacoesComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-conteudo-notificacoes',
                template: "<div *ngIf=\"length > 0\" class=\"container-notificacoes\">\n  <h4 id=\"titulo-principal\">Notifica\u00E7\u00F5es</h4>\n\n  <hr id=\"linha-divisoria\">\n\n  <div class=\"notificacoes\" *ngFor=\"let notificacao of notificacoes\">\n    <hr class=\"linha-tipo-aviso\" govbrRotuloTipoMensagem [tipoMensagem]=\"notificacao.tipoMensagem\">\n\n    <div class=\"tipo-container\">\n      <p id=\"data-notificacao\">{{ notificacao.dataCriacao | date: 'dd/MM/yyyy' }}</p>\n      <span class=\"tipo-mensagem\" govbrRotuloTipoMensagem [tipoMensagem]=\"notificacao.tipoMensagem\">\n        {{ notificacaoService.getNomeExibicaoTipoMensagem(notificacao.tipoMensagem).toUpperCase() }}</span>\n    </div>\n\n    <a id=\"titulo-notificacao\" [attr.href]=\"notificacao.linkExterno ? notificacao.linkExterno : null\"\n      (click)=redirectLinkInterno(notificacao.linkInterno)>\n      <p class=\"link\">{{ notificacao.titulo }} </p>\n    </a>\n\n    <div id=\"descricao-notificacao\" [innerHTML]=\"notificacao.mensagem\"></div>\n\n    <hr id=\"separador\">\n  </div>\n\n  <gov-paginator *ngIf=\"length > 0\" #paginator [length]=\"length\" [pageSize]=\"pageSize\"\n    [pageSizeOptions]=\"pageSizeOptions\" (page)=\"onPageChanged($event)\">\n  </gov-paginator>\n</div>",
                styles: [".container-notificacoes{width:auto;height:auto;padding:50px 26px 105px;overflow-y:auto;overflow-x:auto;top:80px;bottom:47px;position:fixed}#titulo-principal{font-family:\"Nunito Sans\";font-weight:700;font-size:24px;line-height:32.74px;height:33px;width:132px}#linha-divisoria{display:block;height:1px;padding:0;margin-bottom:3rem}.notificacoes{display:flex;flex-direction:column}#titulo-notificacao{font-family:\"Nunito Sans\";font-size:15px;font-weight:700;line-height:20.46px;text-decoration:none;margin-bottom:6px;cursor:pointer}#titulo-notificacao a{cursor:pointer}#data-notificacao{border-radius:4px;font-family:\"Nunito Sans\";font-style:SemiBold;font-size:11px;line-height:15px;padding-bottom:2px}#separador{display:block;margin-top:15px;margin-bottom:15px;padding:0}#descricao-notificacao{font-family:\"Nunito Sans\";font-size:13px;font-style:normal;line-height:17.73px}.tipo-container{align-items:center;display:flex;justify-content:space-between;margin-top:-1rem}.tipo-mensagem{text-align:center;font-size:9px;width:100px;border-radius:3px;margin-top:-5px}.linha-tipo-aviso{margin-top:-15px;width:103rem}@media screen and (min-width:320px){.linha-tipo-aviso{width:100%}}"]
            }] }
];
/** @nocollapse */
ConteudoNotificacoesComponent.ctorParameters = () => [
    { type: NotificacoesService, decorators: [{ type: Inject, args: [NotificacoesService,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [PARAMS_NOTIFICACAO,] }] },
    { type: ChangeDetectorRef },
    { type: Router }
];
ConteudoNotificacoesComponent.propDecorators = {
    paginator: [{ type: ViewChild, args: [MatPaginator, { static: false },] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@description
 * Pipe que corta uma string no final da útlima palavra antes do limite máximo de caracteres
 * e substitui o final por elipse (...).
 *
 * ### Exemplo
 *
 * string = 'Uma string muito muito longa"
 *
 * <p>{{ string | ellipsis:20 }}</p>
 *
 * saída: Uma string muito...
 */
class EllipsisPipe {
    /**
     * @param {?} text
     * @param {?} max
     * @return {?}
     */
    transform(text, max) {
        if (!text)
            return '';
        if (text.length <= max) {
            return text;
        }
        /**
         * String truncada no tamanho máximo, em qualquer caractere
         * @type {?}
         */
        let truncada = text.substr(0, max);
        // Se o caractere no tamanho máximo da string já é um espaço ou pontuação, retorna string truncada nesse ponto
        if (text.charAt(max).match(/[,\.\s\/\'\"]/g)) {
            return truncada + '...';
        }
        /** @type {?} */
        const maxLength = max - 1;
        /** @type {?} */
        let i = maxLength;
        // Calcula o index do último espaço ou pontuação da string
        while (!truncada.charAt(i).match(/[,\.\s\/\'\"]/g) && i > 0) {
            i--;
        }
        truncada = truncada.substr(0, i);
        return truncada + '...';
    }
}
EllipsisPipe.decorators = [
    { type: Pipe, args: [{
                name: 'ellipsis'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HighlightSearchPipe {
    /**
     * @param {?} value
     * @param {?} search
     * @return {?}
     */
    transform(value, search) {
        /** @type {?} */
        const valueStr = value + '';
        return valueStr.replace(new RegExp('(?![^&;]+;)(?!<[^<>]*)(' + search + ')(?![^<>]*>)(?![^&;]+;)', 'gi'), '<div class="destaque-buscado">$1</div>');
    }
}
HighlightSearchPipe.decorators = [
    { type: Pipe, args: [{
                name: 'highlightSearch'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PipesModule {
}
PipesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [EllipsisPipe, HighlightSearchPipe],
                exports: [EllipsisPipe, HighlightSearchPipe]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente de paginação, possui um MatPaginator em sua estrutura interna para
 * facilitar a manipulação do fluxo de eventos de paginação.
 *
 * Exemplo de utilização:
 * ```html
 * <gov-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
 * (page)="pageEvent = $event">
 * </gov-paginator>
 * ```
 * Referência ao MatPaginator: https://v8.material.angular.io/components/paginator/overview
 *
 * Recomendado que o atributo width do componente seja sempre igual ao da tabela associada
 */
class PaginatorComponent {
    constructor() {
        /**
         * Evento emitido ao se realizar uma ação de paginação
         */
        this.page = new EventEmitter();
        /**
         * Quantidade de registros paginados
         */
        this.length = 100;
        /**
         * Quantidade de itens por página
         */
        this.pageSize = 10;
        /**
         * Opções disponíveis de valores para itens por página
         */
        this.pageSizeOptions = [5, 10, 25, 100];
        /**
         * Opção de mostrar, ou não, ultima e primeira pagina
         */
        this.showFirstLastButtons = true;
    }
    /**
     * Trata o evento de paginação emitido pelo MatPaginator
     * @param {?} $event
     * @return {?}
     */
    onPage($event) {
        this.page.emit($event);
    }
}
PaginatorComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-paginator',
                template: "<div class=\"paginator-container\">\n    <mat-paginator  #paginator \n                    [length]=\"length\" \n                    [pageSize]=\"pageSize\" \n                    [pageSizeOptions]=\"pageSizeOptions\"\n                    [showFirstLastButtons]=\"showFirstLastButtons\"\n            \t    (page)=\"onPage($event)\" >\n    </mat-paginator>\n</div>\n",
                styles: [".paginator-container{display:flex;align-items:center;justify-content:flex-end}.paginator-container mat-paginator{display:flex;position:relative;background:0 0;width:calc(100% - 123px)}.paginator-container .total-registers{font-size:12px;font-style:normal;font-weight:400;line-height:16px}"]
            }] }
];
/** @nocollapse */
PaginatorComponent.ctorParameters = () => [];
PaginatorComponent.propDecorators = {
    paginatorComponent: [{ type: ViewChild, args: ['paginator', { static: true },] }],
    paginator: [{ type: ViewChild, args: ['paginator', { static: false, read: ElementRef },] }],
    page: [{ type: Output }],
    length: [{ type: Input }],
    pageSize: [{ type: Input }],
    pageSizeOptions: [{ type: Input }],
    showFirstLastButtons: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Componente Paginator utilizado pela Comunicação Social */
class PaginatorCsComponent {
    constructor() {
        /**
         * Opções disponíveis de valores para itens por página
         */
        this.valores = [10, 25, 50, 100];
        /**
         * Envia os dados repaginados e atualiza a tabela
         */
        this.dadosRepaginados = new EventEmitter();
        this.currentPage = 1;
        this.isReadOnly = false;
        this.validatorCurrentPage = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.calculaNumTotalPages();
    }
    /**
     * @return {?}
     */
    calculaNumTotalPages() {
        this.length = this.data.filteredData.length;
        this.totalPages = Math.ceil(this.length / this.pageSize);
        this.currentPage = 1;
        this.validatorCurrentPage = false;
        this.totalPages === 1 ? this.isReadOnly = true : this.isReadOnly = false;
        /** @type {?} */
        const filteredDataSource = this.data.filteredData.slice(0, this.pageSize);
        this.dadosRepaginados.emit(filteredDataSource);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    detectSelectChange(event) {
        this.calculaNumTotalPages();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    validatorNewCurrentPage(event) {
        if (this.totalPages >= event.target.value && event.target.value !== '0') {
            this.currentPage = event.target.value;
            if (event.target.value === '') {
                this.currentPage = 1;
            }
            this.validatorCurrentPage = false;
            /** @type {?} */
            const startItem = (this.currentPage - 1) * this.pageSize;
            /** @type {?} */
            const endItem = this.currentPage * this.pageSize;
            /** @type {?} */
            const filteredDataSource = this.data.filteredData.slice(startItem, endItem);
            this.dadosRepaginados.emit(filteredDataSource);
        }
        else {
            this.validatorCurrentPage = true;
        }
    }
    /**
     * @return {?}
     */
    nextPage() {
        if (this.currentPage <= this.totalPages) {
            this.currentPage++;
            this.validatorCurrentPage = false;
            /** @type {?} */
            const startItem = (this.currentPage - 1) * this.pageSize;
            /** @type {?} */
            const endItem = this.currentPage * this.pageSize;
            /** @type {?} */
            const filteredDataSource = this.data.filteredData.slice(startItem, endItem);
            this.dadosRepaginados.emit(filteredDataSource);
        }
        else {
            this.validatorCurrentPage = true;
        }
    }
    /**
     * @return {?}
     */
    previousPage() {
        if ((this.currentPage - 1) >= 1) {
            this.currentPage--;
            this.validatorCurrentPage = false;
            /** @type {?} */
            const startItem = (this.currentPage - 1) * this.pageSize;
            /** @type {?} */
            const endItem = this.currentPage * this.pageSize;
            /** @type {?} */
            const filteredDataSource = this.data.filteredData.slice(startItem, endItem);
            this.dadosRepaginados.emit(filteredDataSource);
        }
        else {
            this.validatorCurrentPage = true;
        }
    }
}
PaginatorCsComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-paginator-cs',
                template: "<div class=\"row-paginator\">\n    <div class=\"current-page-input\">\n        <label for=\"currentPage\">P\u00E1gina </label>\n        <button (click)=\"previousPage()\" class=\"cursor-pointer\" *ngIf=\"currentPage > 1\">\n          <mat-icon class=\"previous-page\" role=\"img\" aria-hidden=\"true\">arrow_forward_ios</mat-icon>\n        </button>\n        <input type=\"text\" id=\"currentPage\" name=\"currentPage\"\n          [(ngModel)]=\"currentPage\"\n          (change)=\"validatorNewCurrentPage($event)\"\n          [ngClass]=\"validatorCurrentPage ? 'border-red' : 'border-grey'\"\n          [readonly]=\"isReadOnly\">\n        <p> de {{ totalPages }}</p>\n         <button (click)=\"nextPage()\" class=\"cursor-pointer\" *ngIf=\"currentPage < totalPages\">\n            <mat-icon role=\"img\" aria-hidden=\"true\">arrow_forward_ios</mat-icon>\n        </button>\n\n    </div>\n\n    <div class=\"div-select-page-size\">\n      <mat-label for=\"registros-pagina\">Registros por p\u00E1gina:</mat-label>\n      <mat-select class=\"select-page-size\"\n        [(value)]=\"pageSize\"\n        (change)=\"detectSelectChange($event)\">\n        <mat-option *ngFor=\"let valor of valores\" [value]=\"valor\" >\n          {{ valor }}\n        </mat-option>\n      </mat-select>\n      <p>Total de registros: {{ length }}</p>\n    </div>\n</div>\n<div class=\"row-validator\">\n  <p class=\"validator-current-page\" \n    *ngIf=\"validatorCurrentPage  && totalPages !== 1\">\n      Digite um n\u00FAmero de 1 a {{totalPages}}\n  </p>\n</div>\n",
                styles: [".row-paginator{display:flex;justify-content:space-between;margin-top:30px}div{display:inherit}.current-page-input{font-size:14px;width:300px}input#currentPage{width:13%;margin-left:10px;margin-right:10px;text-align:center;height:30px;border-radius:8px;margin-top:-7px}.select-page-size{width:67px;margin-left:10px;margin-right:10px;margin-top:-6px;height:30px;padding-top:5px;padding-right:10px;padding-left:10px;font-size:14px;border-radius:5px;font-weight:500}mat-icon{width:32px;font-size:16px;font-weight:700;height:16px}.previous-page{rotate:180deg;margin-right:-6px}button{border:none;margin-top:-1.5px}.cursor-pointer{cursor:pointer}.row-validator{padding:0 5% 0 0}.validator-current-page{font-size:13px}"]
            }] }
];
/** @nocollapse */
PaginatorCsComponent.ctorParameters = () => [];
PaginatorCsComponent.propDecorators = {
    pageSize: [{ type: Input }],
    valores: [{ type: Input }],
    data: [{ type: Input }],
    dadosRepaginados: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Serviço responsável pela tradução dos labels de paginação
 */
class PaginatorService extends MatPaginatorIntl {
    constructor() {
        super(...arguments);
        /**
         * Texto padrão de itens por página
         */
        this.itemsPerPageLabel = 'Itens por página';
        this.firstPageLabel = 'Primeira página';
        this.previousPageLabel = 'Página anterior';
        this.nextPageLabel = 'Próxima página';
        this.lastPageLabel = 'Última página';
        this.getRangeLabel = (/**
         * @param {?} page
         * @param {?} pageSize
         * @param {?} length
         * @return {?}
         */
        function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return '1 de ' + length;
            }
            length = Math.max(length, 0);
            /** @type {?} */
            const startIndex = page + 1;
            return (startIndex) + ' - ' + pageSize + ' de ' + length;
        });
    }
}
PaginatorService.decorators = [
    { type: Injectable }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TimeoutService {
    /**
     * @param {?} time
     * @param {?} callback
     * @return {?}
     */
    setTimeout(time, callback) {
        this.timeout = setTimeout(callback, time);
    }
    /**
     * @return {?}
     */
    clearTimeout() {
        clearTimeout(this.timeout);
    }
}
TimeoutService.decorators = [
    { type: Injectable }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PaginationModule {
}
PaginationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    PaginatorComponent,
                    PaginatorCsComponent
                ],
                imports: [
                    CommonModule,
                    MatPaginatorModule,
                    MatIconModule,
                    MatOptionModule,
                    MatSelectModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [
                    PaginatorComponent,
                    PaginatorCsComponent
                ],
                providers: [
                    TimeoutService,
                    { provide: MatPaginatorIntl, useClass: PaginatorService }
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificacoesDirective {
    constructor() {
        // tslint:disable-next-line:no-input-rename
        this.tipoMensagem = '';
        this.background = '';
        this.color = 'white';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        switch (this.tipoMensagem) {
            case TipoMensagem.Aviso:
                this.background = '#F49300';
                break;
            case TipoMensagem.Educativa:
                this.background = '#4FC219';
                break;
            case TipoMensagem.Versao:
                this.background = '#E17AEA';
                break;
        }
    }
}
NotificacoesDirective.decorators = [
    { type: Directive, args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[govbrRotuloTipoMensagem]'
            },] }
];
/** @nocollapse */
NotificacoesDirective.ctorParameters = () => [];
NotificacoesDirective.propDecorators = {
    tipoMensagem: [{ type: Input }],
    background: [{ type: HostBinding, args: ['style.backgroundColor',] }],
    color: [{ type: HostBinding, args: ['style.color',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NotificacoesModule {
}
NotificacoesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [NotificacoesComponent, ConteudoNotificacoesComponent, NotificacoesDirective, DialogMensagemEccoComponent],
                imports: [
                    CommonModule,
                    RouterModule,
                    MatBadgeModule,
                    MatButtonModule,
                    MatIconModule$1,
                    GridModule,
                    MatDialogModule,
                    PaginationModule,
                    SwiperModule,
                    PipesModule,
                    YouTubePlayerModule
                ],
                exports: [NotificacoesComponent, ConteudoNotificacoesComponent],
                entryComponents: [
                    DialogMensagemEccoComponent
                ],
                providers: [
                    DadosUsuarioService
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CabecalhoModule {
}
CabecalhoModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    CabecalhoComponent,
                    NavegacaoComponent,
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    RouterModule,
                    PesquisaModule,
                    MenuGrpModule,
                    RouterModule,
                    PerfilUsuarioModule,
                    FavoritosModule,
                    NotificacoesModule,
                    ModalLgpdModule
                ],
                exports: [
                    CabecalhoComponent,
                    NavegacaoComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DadoRodape {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente de implementação do rodapé
 */
class RodapeComponent {
    constructor() {
        this.ano = new Date().getFullYear();
        this.isShown = false;
        this.showLinks = false;
        this.showManual = false;
        this.dadoRodape = {
            urlImg: 'assets/icons/GOVBR.svg',
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    toggleShow() {
        this.isShown = !this.isShown;
    }
    /**
     * @param {?} tipo
     * @return {?}
     */
    abrirPagina(tipo) {
        /** @type {?} */
        let urlArray = window.location.href.split("/");
        /** @type {?} */
        let qtdmaximobarramento = 6;
        /** @type {?} */
        let link = "";
        for (let i = 0; i < qtdmaximobarramento; i++) {
            if (i == 0)
                link = urlArray[i];
            else
                link = link + "/" + urlArray[i];
        }
        switch (tipo) {
            case "usaradm":
                window.open(link + "/usaradm", '_blank');
                break;
            case "glossario":
                window.open(link + "/glossario", '_blank');
                break;
            case "perguntas":
                window.open(link + "/perguntas", '_blank');
                break;
            case "manual":
                window.open(link + "/manual", '_blank');
                break;
            case "termouso":
                window.open(link + "/termouso", '_blank');
                break;
            case "privacidade":
                window.open(link + "/privacidade", '_blank');
                break;
        }
    }
}
RodapeComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-rodape',
                template: "<section class=\"rodape\">\n  <div class=\"rodape-itens flex\">\n    <div class=\"rodape-item\">\n      <div class=\"rodape-texto\">\n        <mat-icon>copyright</mat-icon>\n        <p>{{ano}} - Copyright GOVERNAN\u00C7ABRASIL S/A</p>\n      </div>\n      <div [ngClass]=\"{'links': dadoRodape.showChat === true, 'sem-chat': dadoRodape.showChat === false}\">\n        <p *ngIf=\"dadoRodape?.versaoGovbr || dadoRodape?.versaoLib\"\n        #tooltip=\"matTooltip\"\n        matTooltip=\"Vers\u00E3o: {{dadoRodape?.versaoGovbr}} | SULibary {{dadoRodape?.versaoLib}}\"\n        matTooltipPosition=\"above\"\n        matTooltipClass=\"versao-govbr-tooltip\">\n        <mat-icon class=\"material-icons-outlined\">info</mat-icon>\n      </p>\n      <div *ngIf=\"showLinks\" class=\"links\" >\n        <p>\n          <a (click)=\"abrirPagina('termouso')\" target=\"_blank\">Termos de uso</a>\n          <a (click)=\"toggleShow()\" >Ajuda</a>\n        </p>\n        <div *ngIf=\"isShown\" >\n          <ul class=\"menu-drop-rodape\">\n              <li class=\"a1 first\" *ngIf=\"showManual\"><a download=\"manual-de-ajuda\" target=\"_blank\" [href]=\"linkManual\">Manual de ajuda</a></li> \n              <li class=\"a2\"><a (click)=\"abrirPagina('perguntas')\" target=\"_blank\">Perguntas Frequentes</a></li>\n              <li class=\"a3\"><a (click)=\"abrirPagina('usaradm')\" target=\"_blank\">Como Usar o Adm</a></li>\n              <li class=\"a4\"><a (click)=\"abrirPagina('glossario')\" target=\"_blank\">Gloss&aacute;rio</a></li>\n            </ul>\n          </div>\n          \n        </div>\n      </div>\n    </div>\n    <div class=\"rodape-formas\">\n      <button mat-icon-button *ngIf=\"dadoRodape.showChat\" class=\"rodape-chat\">\n        <mat-icon id=\"icone-rodape\">chat</mat-icon>\n      </button>\n      <div class=\"rodape-logo\">\n        <img [src]=\"dadoRodape?.urlImg\" alt=\"GOVBR-522 Logo\">\n      </div>\n    </div>\n  </div>\n</section>\n",
                styles: ["@charset \"UTF-8\";a{text-decoration:none;cursor:pointer;color:#28aef2}.menu-drop-rodape{list-style:none;display:inline-block;margin:0;padding:0;position:absolute;top:-222px}.menu-drop-rodape li{border-bottom:1px solid #ccc;border-right:1px solid #ccc;border-left:1px solid #ccc;padding:16px 22px 16px 40px;display:block;background-repeat:no-repeat;background-size:20px;background-position:10px center}.menu-drop-rodape li a{color:#2cbed5;text-decoration:none;font-size:verdana}.menu-drop-rodape li.first{border-top:1px solid #ccc}.menu-drop-rodape li.a1{background-image:url(https://upload.wikimedia.org/wikipedia/commons/7/7d/Simpleicons_Business_note.svg)}.menu-drop-rodape li.a2{background-image:url(https://upload.wikimedia.org/wikipedia/commons/2/29/Comment_alt_font_awesome.svg)}.menu-drop-rodape li.a3{background-image:url(https://upload.wikimedia.org/wikipedia/commons/0/0e/Feather-core-file-plus.svg)}.menu-drop-rodape li.a4{background-image:url(https://upload.wikimedia.org/wikipedia/commons/b/b3/Book_font_awesome.svg)}.flex{display:flex;align-items:center}.rodape{width:100%;height:39px}.rodape-item{margin-top:12px;margin-bottom:11px;align-items:center;display:flex;width:100%}.rodape-texto{display:flex;font-weight:400;margin-left:27px;justify-content:flex-start;width:100%}mat-icon{font-size:16px;vertical-align:middle}div.rodape-chat mat-icon{font-size:24px}.rodape-texto p{-ms-grid-row-align:auto;align-self:auto;font-size:10px;padding-top:2px;white-space:pre}.links p{font-size:12px;min-width:24px;white-space:pre;margin-bottom:10px}.sem-chat p{font-size:12px;min-width:24px;white-space:pre}.links p a{text-decoration:none;margin-left:30px}.sem-chat p a{text-decoration:none}.links p mat-icon{margin-right:-10px}.rodape-itens{justify-content:space-between;position:relative}.links{display:flex;font-weight:400;justify-content:flex-end;margin-right:270px;cursor:pointer}.sem-chat{display:flex;font-weight:400;justify-content:flex-end;margin-right:200px;cursor:pointer}.links p+p,.sem-chat p+p{margin-left:30px}.rodape-formas{position:relative}.rodape-chat{position:absolute;width:67px;right:170px;top:-23px;z-index:1;height:40px}.rodape-chat mat-icon{position:relative;top:5px;left:2px;font-size:20px;transform:skew(-134deg);cursor:pointer}.rodape-logo{border-left:97px solid transparent;border-right:0 solid transparent;height:0;width:236px;transform:translate(-99.9%,-35%);position:absolute;z-index:999}.rodape-logo img{width:110px;position:absolute;top:17px;right:24px}::ng-deep div.versao-govbr-tooltip{width:auto;text-align:center;border-radius:initial;font-size:11px;overflow:visible;font-family:\"Nunito Sans\";font-weight:400;left:calc(50% - 24px);padding:2px 6px;top:2px;position:relative;margin:16px 24px}::ng-deep div.versao-govbr-tooltip:after{content:\" \";position:absolute;bottom:-9px;z-index:999;width:0;height:0;left:0;border-style:solid;border-width:13px 13px 0 0;border-color:#28aef2 transparent transparent}"]
            }] }
];
/** @nocollapse */
RodapeComponent.ctorParameters = () => [];
RodapeComponent.propDecorators = {
    showLinks: [{ type: Input }],
    showManual: [{ type: Input }],
    dadoRodape: [{ type: Input }],
    linkManual: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 */
class Chat {
    /**
     * @param {?=} session
     */
    constructor(session) {
        this.conversation = [];
    }
    /**
     * @param {?} message
     * @return {?}
     */
    addMessageToConversation(message) {
        this.conversation.push(message);
    }
    /**
     * @param {?} message
     * @param {?} visualConfig
     * @return {?}
     */
    addVisualToConversation(message, visualConfig) {
        message.visualConfig = visualConfig;
        this.conversation.push(message);
    }
    /**
     * @param {?} conversation
     * @return {?}
     */
    setConversation(conversation) {
        this.conversation = conversation;
    }
    /**
     * @return {?}
     */
    getConversation() {
        return this.conversation;
    }
    /**
     * @param {?} id
     * @return {?}
     */
    getMessageById(id) {
        return this.conversation.find((/**
         * @param {?} message
         * @return {?}
         */
        (message) => message.id === id));
    }
    /**
     * @return {?}
     */
    getLastMessage() {
        return this.conversation[this.conversation.length - 1];
    }
    /**
     * @param {?} session
     * @return {?}
     */
    setSession(session) {
        this.session = session;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const MessageType = {
    text: 0,
    pbie: 1,
    option: 2,
    feedbackOptionList: 3,
};
MessageType[MessageType.text] = 'text';
MessageType[MessageType.pbie] = 'pbie';
MessageType[MessageType.option] = 'option';
MessageType[MessageType.feedbackOptionList] = 'feedbackOptionList';
class Message {
    /**
     * @param {?} messageBuilder
     */
    constructor(messageBuilder) {
        this.id = this.idGenerator();
        this.type = MessageType[messageBuilder.type];
        this.body = messageBuilder.body === Object ? '' : messageBuilder.body;
        this.datetime = Date();
        this.isBot = messageBuilder.isBot;
        this.cssClass = messageBuilder.cssClass;
        this.feedbackOptionsList = messageBuilder.feedbackOptionsList;
        this.optionsList = messageBuilder.optionsList;
        this.visualConfig = messageBuilder.visualConfig;
    }
    /**
     * @param {?} visualConfig
     * @return {?}
     */
    setVisualConfig(visualConfig) {
        this.visualConfig = visualConfig;
    }
    /**
     * @private
     * @return {?}
     */
    idGenerator() {
        /** @type {?} */
        let date = new Date().getTime();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (/**
         * @param {?} c
         * @return {?}
         */
        function (c) {
            /** @type {?} */
            const r = (date + Math.random() * 16) % 16 | 0;
            date = Math.floor(date / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }));
    }
    /**
     * @return {?}
     */
    updateStatusMessage() {
    }
}
class MessageBuilder {
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} id
     * @return {THIS}
     */
    setId(id) {
        (/** @type {?} */ (this))._id = id;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} type
     * @return {THIS}
     */
    setType(type) {
        (/** @type {?} */ (this))._type = type;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} body
     * @return {THIS}
     */
    setBody(body) {
        (/** @type {?} */ (this))._body = body;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} datetime
     * @return {THIS}
     */
    setDatetime(datetime) {
        (/** @type {?} */ (this))._datetime = datetime;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} isBot
     * @return {THIS}
     */
    setIsBot(isBot) {
        (/** @type {?} */ (this))._isBot = isBot;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} cssClass
     * @return {THIS}
     */
    setCssClass(cssClass) {
        (/** @type {?} */ (this))._cssClass = cssClass;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} visualConfig
     * @return {THIS}
     */
    setVisualConfig(visualConfig) {
        (/** @type {?} */ (this))._visualConfig = visualConfig;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} feedbackOptionsList
     * @return {THIS}
     */
    setFeedbackOptionsList(feedbackOptionsList) {
        (/** @type {?} */ (this))._feedbackOptionsList = feedbackOptionsList;
        return (/** @type {?} */ (this));
    }
    /**
     * @template THIS
     * @this {THIS}
     * @param {?} optionsList
     * @return {THIS}
     */
    setOptionsList(optionsList) {
        (/** @type {?} */ (this))._optionsList = optionsList;
        return (/** @type {?} */ (this));
    }
    /**
     * @return {?}
     */
    get id() {
        return this._id;
    }
    /**
     * @return {?}
     */
    get type() {
        return this._type;
    }
    /**
     * @return {?}
     */
    get body() {
        return this._body;
    }
    /**
     * @return {?}
     */
    get datetime() {
        return this._datetime;
    }
    /**
     * @return {?}
     */
    get isBot() {
        return this._isBot;
    }
    /**
     * @return {?}
     */
    get cssClass() {
        return this._cssClass;
    }
    /**
     * @return {?}
     */
    get visualConfig() {
        return this._visualConfig;
    }
    /**
     * @return {?}
     */
    get feedbackOptionsList() {
        return this._feedbackOptionsList;
    }
    /**
     * @return {?}
     */
    get optionsList() {
        return this._optionsList;
    }
    /**
     * @return {?}
     */
    build() {
        return new Message(this);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Serviço do Chat é responsável por:
 *  - Validar o usuário, afim de saber quais perguntas ele pode fazer.
 *  - Criar um novo Chat com uma variável de sessão do Watson.
 * @type {?}
 */
const CHATBOT_CONFIG = new InjectionToken('ChatBot');
class ChatBotService {
    /**
     * @param {?} chatBot
     * @param {?} http
     * @param {?} oauthService
     * @param {?} tenantService
     * @param {?} usuarioService
     */
    constructor(chatBot, http, oauthService, tenantService, usuarioService) {
        this.chatBot = chatBot;
        this.http = http;
        this.oauthService = oauthService;
        this.tenantService = tenantService;
        this.usuarioService = usuarioService;
        this.usuarioService.get();
        this.dialog = {
            messageText: '',
            userName: this.usuarioService.dadosUsuario.nomeUsuario.toString(),
        };
    }
    /**
     * @return {?}
     */
    createNewChat() {
        if (!this.chat) {
            this.chat = new Chat();
            this
                .post('start', this.dialog).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                response.messages.forEach((/**
                 * @param {?} element
                 * @return {?}
                 */
                element => {
                    /** @type {?} */
                    const welcomeMessage = new MessageBuilder().setBody(element.textMessage.text)
                        .setType('text')
                        .setCssClass('bot')
                        .setIsBot(true).build();
                    this.chat.addMessageToConversation(welcomeMessage);
                }));
            }));
        }
        return this.chat.getConversation();
    }
    /**
     * @param {?} body
     * @param {?} type
     * @param {?=} isBot
     * @return {?}
     */
    addMessageToConversation(body, type, isBot = true) {
        /** @type {?} */
        const message = new MessageBuilder().setBody(body).setType(type).setIsBot(isBot)
            .setCssClass(isBot ? 'bot' : 'usuario')
            .build();
        this.chat.addMessageToConversation(message);
        return this.getConversation();
    }
    /**
     * @param {?} optionList
     * @param {?} type
     * @return {?}
     */
    addOptionListToConversation(optionList, type) {
        /** @type {?} */
        const message = new MessageBuilder().setType(type).setOptionsList(optionList).setIsBot(true)
            .setCssClass('optionList')
            .build();
        this.chat.addMessageToConversation(message);
        return this.getConversation();
    }
    /**
     * @param {?} visual
     * @param {?} type
     * @return {?}
     */
    addVisualToConversation(visual, type) {
        /** @type {?} */
        const message = new MessageBuilder().setBody('').setType(type).setIsBot(true).setCssClass('bot').build();
        this.chat.addVisualToConversation(message, visual);
        return this.getConversation();
    }
    /**
     * @return {?}
     */
    getLastMessage() {
        return this.chat.getLastMessage();
    }
    /**
     * @return {?}
     */
    getConversation() {
        return this.chat.getConversation();
    }
    /**
     * @param {?} text
     * @param {?=} exercicio
     * @return {?}
     */
    getDialog(text, exercicio = true) {
        this.dialog.messageText = text;
        return this.post('', this.dialog);
    }
    /**
     * @return {?}
     */
    askSimpleFeedback() {
        /** @type {?} */
        const message1 = new MessageBuilder().setBody('Consegui te ajudar ?').setType('text').setIsBot(true)
            .setCssClass('botFeedback').build();
        this.chat.addMessageToConversation(message1);
        /** @type {?} */
        const messageOptions = [
            {
                answerString: 'sim',
                icon: 'thumb_up_alt'
            },
            {
                answerString: 'não',
                icon: 'thumb_down_alt'
            }
        ];
        /** @type {?} */
        const optionsList = new MessageBuilder().setType('feedbackOptionList')
            .setFeedbackOptionsList(messageOptions)
            .setIsBot(true).setCssClass('botFeedback').build();
        this.chat.addMessageToConversation(optionsList);
    }
    /**
     * @return {?}
     */
    toggleChat() {
        this.chatIsOpen = !this.chatIsOpen;
    }
    /**
     * @param {?=} params
     * @return {?}
     */
    requestOptionfactory(params) {
        this.requestOptions = {
            params: params || {},
        };
        /** @type {?} */
        const tenant = this.tenantService.getTenant();
        /** @type {?} */
        let headers = new HttpHeaders();
        headers = headers.append('X-Request-ApplicationKey', this.chatBot.key);
        if (this.oauthService.hasValidAccessToken()) {
            headers = headers.append('Authorization', 'Basic ' + btoa('administrador:PRO2010nim'));
        }
        if (tenant && tenant.municipio) {
            headers = headers.append('X-Tenant-Municipio', tenant.municipio);
        }
        if (tenant && tenant.entidade) {
            headers = headers.append('X-Tenant-Entidade', tenant.entidade);
        }
        this.requestOptions.headers = headers;
        return this.requestOptions;
    }
    /**
     * @param {?} path
     * @param {?} body
     * @param {?=} params
     * @return {?}
     */
    post(path, body, params) {
        /** @type {?} */
        const args = this.requestOptionfactory();
        /** @type {?} */
        const argsConcat = Object.assign({}, args, params);
        return this.http.post(this.chatBot.url + path, body, argsConcat);
    }
}
ChatBotService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ChatBotService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [CHATBOT_CONFIG,] }] },
    { type: HttpClient, decorators: [{ type: Inject, args: [HttpClient,] }] },
    { type: OAuthService, decorators: [{ type: Inject, args: [OAuthService,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }] },
    { type: DadosUsuarioService, decorators: [{ type: Inject, args: [DadosUsuarioService,] }] }
];
/** @nocollapse */ ChatBotService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ChatBotService_Factory() { return new ChatBotService(ɵɵinject(CHATBOT_CONFIG), ɵɵinject(HttpClient), ɵɵinject(OAuthService), ɵɵinject(TenantService), ɵɵinject(DadosUsuarioService)); }, token: ChatBotService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChatBotComponent {
    /**
     * @param {?} botService
     */
    constructor(botService) {
        this.botService = botService;
        this.buttons = [];
        this.buttons.push('chat_bubble_outline', 'close');
        this.chatIsOpen = this.botService.chatIsOpen;
        this.iconButton = this.chatIsOpen ? this.buttons[1] : this.buttons[0];
        this.isTyping = false;
        this.powerBiService = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.conversation = this.botService.createNewChat();
    }
    /**
     * Método chamado ao usuário fazer input no chat.
     * @param {?} input
     * @return {?}
     */
    enviarMensagem(input) {
        if (input.value === 'limpar') {
            this.botService.chat.setConversation(new Array());
            this.sendMessageToWatson(input);
        }
        else if (input.value !== '') {
            this.botService.addMessageToConversation(input.value, 'text', false);
            this.sendMessageToWatson(input);
        }
    }
    /**
     * @param {?} input
     * @return {?}
     */
    sendMessageToWatson(input) {
        this.botService.getDialog(input.value)
            .subscribe((/**
         * @param {?} messagesArray
         * @return {?}
         */
        (messagesArray) => {
            if (messagesArray.messages) {
                messagesArray.messages.forEach((/**
                 * @param {?} message
                 * @return {?}
                 */
                (message) => {
                    switch (message.type) {
                        case 'text':
                            this.botService.addMessageToConversation(message.textMessage.text, message.type);
                            break;
                        case 'pbie':
                            this.botService.addVisualToConversation(message.visualConfig, message.type);
                            break;
                        case 'option':
                            this.botService.addOptionListToConversation(message.option, message.type);
                            break;
                    }
                }));
            }
            else {
                this.botService.addMessageToConversation('Desculpe, não encontramos resposta para essa pergunta.', 'text');
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            this.botService.addMessageToConversation('Desculpe, não encontramos resposta para essa pergunta.', 'text');
        }));
        this.conversation = this.botService.getConversation();
        /** Limpa o campo do input */
        input.value = null;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onOptionSelected(event) {
        this.enviarMensagem(event);
    }
    /**
     * Método de animação do Bot digitando.
     * @return {?}
     */
    typingAnimation() {
        this.isTyping = !this.isTyping;
    }
    /**
     * @return {?}
     */
    toggleChat() {
        this.chatIsOpen = !this.chatIsOpen;
        this.botService.toggleChat();
        this.iconButton = this.chatIsOpen ? this.buttons[1] : this.buttons[0];
    }
}
ChatBotComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-chat-bot',
                template: "<div class=\"chat-area\" *ngIf=\"chatIsOpen\">\n  <div class=\"chat\">\n    <div class=\"contact bar\">\n      <div class=\"pic bot\"><img src=\"../../assets/avatar3.svg\" alt=\"\"></div>\n      <div class=\"name\">\n        GOVbot\n      </div>\n      <div class=\"seen\">\n        Dispon\u00EDvel\n      </div>\n      <div class=\"closeButton\">\n        <button mat-icon-button color=\"warn\" (click)=\"toggleChat()\" align=\"end\">\n          <mat-icon class=\"notranslate\">{{iconButton}}</mat-icon>\n        </button>\n      </div>\n    </div>\n    <div class=\"messages\" id=\"chat\" #scrollMe [scrollTop]=\"scrollMe.scrollHeight\">\n      <div class=\"message\" *ngFor=\"let message of conversation\"\n        [ngClass]=\"message.cssClass\">\n        <div govChatBotDirective (optionSelected)=\"onOptionSelected($event);\" [message]=\"message\" id={{message.id}}>{{message.body}}</div>\n      </div>\n    </div>\n    <div class=\"input\">\n      <input #mensagem placeholder=\"Qual \u00E9 a sua d\u00FAvida?\" (keydown.enter)=\"enviarMensagem(mensagem)\" type=\"text\"/>\n      <button mat-icon-button (click)=\"enviarMensagem(mensagem)\">\n        <mat-icon class=\"notranslate\">send</mat-icon>\n      </button>\n    </div>\n  </div>\n</div>\n<button mat-fab color=\"primary\" class=\"buttonBottom\" style=\"z-index: 2;\" (click)=\"toggleChat()\" *ngIf=\"!chatIsOpen\">\n  <mat-icon class=\"buttonIcon\">{{iconButton}}</mat-icon>\n</button>\n",
                styles: ["@charset \"UTF-8\";@import url(https://fonts.googleapis.com/css?family=Red+Hat+Display:400,500,900&display=swap);.buttonBottom{position:fixed;bottom:35px;right:0;margin:0 10px 10px 0;width:40px;height:40px;cursor:pointer;transform-origin:center center;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-font-smoothing:antialiased;border-radius:50%;overflow:hidden}.closeButtonButton{color:#333}.buttonIcon{padding:8px 0;line-height:4px}:host ::ng-deep .mat-button-wrapper{padding:0}.closeButton{position:absolute;right:0;cursor:pointer}.chat-area{font-family:Red hat Display,sans-serif;font-weight:400;line-height:1.25em;letter-spacing:.025em;color:#333;z-index:2147483002;position:absolute;right:0;bottom:0}.contact{position:relative;margin-bottom:1rem;padding-left:5rem;height:4.5rem;display:flex;flex-direction:column;justify-content:center}.contact .pic{position:absolute;left:0}.contact .name{font-weight:500;margin-bottom:.125rem}.pic{width:3rem;height:3rem;background-size:cover;background-position:center;border-radius:50%}.chat{position:relative;display:flex;flex-direction:column;justify-content:space-between;width:24rem;height:38rem;z-index:2;box-sizing:border-box;border-radius:1rem 0 0;background:#fff;box-shadow:0 0 8rem 0 rgba(0,0,0,.1),0 2rem 4rem -3rem rgba(0,0,0,.5)}.chat .contact.bar{flex-basis:3.5rem;flex-shrink:0;margin:1rem;box-sizing:border-box}.chat .messages{height:100vh;padding:1rem;background:#f7f7f7;flex-shrink:2;overflow-y:auto;overflow-wrap:break-word;box-shadow:inset 0 2rem 2rem -2rem rgba(0,0,0,.05),inset 0 -2rem 2rem -2rem rgba(0,0,0,.05)}.chat .messages .time{font-size:.8rem;background:#eee;padding:.25rem 1rem;border-radius:2rem;color:#999;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin:0 auto}.chat .messages .message{box-sizing:border-box;padding:.5rem 1rem;margin:1rem;background:#fff;border-radius:1.125rem 1.125rem 1.125rem 0;min-height:2.25rem;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;max-width:85%;box-shadow:0 0 2rem rgba(0,0,0,.075),0 1rem 1rem -1rem rgba(0,0,0,.1);white-space:pre-wrap}.chat .messages .message.usuario{margin:1rem 1rem 1rem auto;border-radius:1.125rem 1.125rem 0;background:#333;color:#fff}.chat .messages .message .botFeedback{margin:1rem 1rem 1rem auto;border-radius:1.125rem 1.125rem 0;background:#0277bd;color:#fff}.chat .messages .message .typing{display:inline-block;width:.8rem;height:.8rem;margin-right:0;box-sizing:border-box;background:#ccc;border-radius:50%}.chat .messages .message .typing.typing-1{-webkit-animation:3s infinite typing;animation:3s infinite typing}.chat .messages .message .typing.typing-2{-webkit-animation:3s 250ms infinite typing;animation:3s 250ms infinite typing}.chat .messages .message .typing.typing-3{-webkit-animation:3s .5s infinite typing;animation:3s .5s infinite typing}.chat .input{box-sizing:border-box;flex-basis:4rem;flex-shrink:0;display:flex;align-items:center;padding:0 .5rem 0 1.5rem}.chat .input i{font-size:1.5rem;margin-right:1rem;color:#666;cursor:pointer;transition:color .2s}.chat .input i:hover{color:#333}.chat .input input{border:none;background-image:none;background-color:#fff;padding:.5rem 1rem;margin-right:1rem;border-radius:1.125rem;flex-grow:2;box-shadow:0 0 1rem rgba(0,0,0,.1),0 1rem 1rem -1rem rgba(0,0,0,.2);font-family:Red hat Display,sans-serif;font-weight:400;letter-spacing:.025em}.chat .input input:placeholder{color:#999}.feedbackButton{min-height:36px;background:#0277bd;color:#fff;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);display:inline-block;text-decoration:none;vertical-align:baseline;text-align:center;margin:5px;min-width:88px;line-height:20px;padding:5px 16px;border-radius:15px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;width:60px;word-break:break-word;white-space:normal;font-family:Red hat Display,sans-serif;font-weight:400;letter-spacing:.025em;font-size:14px}.optionButton{min-height:36px;background:#0277bd;color:#fff;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);display:inline-block;text-decoration:none;vertical-align:baseline;text-align:center;margin:5px;min-width:88px;line-height:20px;padding:5px 16px;border-radius:15px;overflow:visible;transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;width:100%;word-break:break-word;white-space:normal;font-family:Red hat Display,sans-serif;font-weight:400;letter-spacing:.025em;font-size:14px}@-webkit-keyframes typing{0%,100%,75%{transform:translate(0,.25rem) scale(.9);opacity:.5}25%{transform:translate(0,-.25rem) scale(1);opacity:1}}@keyframes typing{0%,100%,75%{transform:translate(0,.25rem) scale(.9);opacity:.5}25%{transform:translate(0,-.25rem) scale(1);opacity:1}}.pic.bot{background-image:url(../../assets/avatar3.svg)}@media (max-width:767px){.buttonBottom[_ngcontent-c27]{position:fixed;bottom:6%;right:10%}.chat[_ngcontent-c27]{position:relative;width:100%;height:100%;border-radius:inherit}.chat-area[_ngcontent-c27]{position:absolute;display:block;height:100%;width:100%;right:0;bottom:0}}"]
            }] }
];
/** @nocollapse */
ChatBotComponent.ctorParameters = () => [
    { type: ChatBotService, decorators: [{ type: Inject, args: [ChatBotService,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChatBotDirective {
    /**
     * @param {?} elementeRef
     * @param {?} renderer
     * @param {?} botService
     * @param {?} cookieService
     */
    constructor(elementeRef, renderer, botService, cookieService) {
        this.elementeRef = elementeRef;
        this.renderer = renderer;
        this.botService = botService;
        this.cookieService = cookieService;
        this.feedbackAsked = false;
        this.optionSelected = new EventEmitter();
        this.powerBiService = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        switch (this.message.type) {
            case MessageType.feedbackOptionList:
                this.caseMessageTypeIsFeedbackOptionList();
                break;
            case MessageType.pbie:
                this.caseMessageTypeIsPbie();
                break;
            case MessageType.option:
                this.caseMessageTypeIsOptionList();
        }
    }
    /**
     * @return {?}
     */
    caseMessageTypeIsPbie() {
        /** @type {?} */
        const awaitTime = 1000;
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const messageDivElement = document.getElementById(this.message.id);
            /** @type {?} */
            const visual = (/** @type {?} */ (this.powerBiService.embed(messageDivElement, this.message.visualConfig)));
            this.setPbiCookies(this.message.visualConfig);
            visual.on('loaded', (/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                // busca os slicers que conflitam com os filtros aplicados
                // e atualiza o slicer com o filtro aplicado no visual
                visual.page(this.message.visualConfig.pageName).getVisuals().then((/**
                 * @param {?} v
                 * @return {?}
                 */
                v => {
                    v.filter((/**
                     * @param {?} i
                     * @return {?}
                     */
                    i => i.type === 'slicer')).forEach((/**
                     * @param {?} slicer
                     * @return {?}
                     */
                    slicer => {
                        slicer.getSlicerState().then((/**
                         * @param {?} state
                         * @return {?}
                         */
                        state => {
                            if (state.filters.length > 0) {
                                this.message.visualConfig.filters.forEach((/**
                                 * @param {?} filter
                                 * @return {?}
                                 */
                                filter => {
                                    if (state.targets.findIndex((/**
                                     * @param {?} t
                                     * @return {?}
                                     */
                                    t => t.table === filter.target.table && t['column'] === filter.target.column)) >= 0) {
                                        slicer.setSlicerState({ filters: [filter] });
                                    }
                                }));
                            }
                        }));
                    }));
                }));
            }));
            visual.on('rendered', (/**
             * @param {?} event
             * @return {?}
             */
            (event) => {
                if (!this.cookieService.check(this.message.id + '-feedbackAsked')) {
                    /** @type {?} */
                    const pr = Math.floor(Math.random() * 100) + 1;
                    if (pr <= 40) {
                        this.removeMessagesByClass('botFeedback');
                        this.botService.askSimpleFeedback();
                    }
                    this.cookieService.set(this.message.id + '-feedbackAsked', 'true');
                    this.feedbackAsked = true;
                }
            }));
        }), awaitTime);
    }
    /**
     * @return {?}
     */
    caseMessageTypeIsFeedbackOptionList() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const messageDivElement = document.getElementById(this.message.id);
            /** @type {?} */
            const optionsList = this.message.feedbackOptionsList;
            optionsList.forEach((/**
             * @param {?} opt
             * @return {?}
             */
            opt => {
                /** @type {?} */
                const buttonElement = (/** @type {?} */ (this.renderer.createElement('button')));
                buttonElement.id = opt.answerString;
                buttonElement.className = 'feedbackButton';
                /** @type {?} */
                const iconElement = (/** @type {?} */ (this.renderer.createElement('i')));
                iconElement.className = 'material-icons notranslate';
                iconElement.innerHTML = opt.icon;
                this.renderer.appendChild(buttonElement, iconElement);
                this.renderer.appendChild(messageDivElement, buttonElement);
                this.renderer.listen(buttonElement, 'click', (/**
                 * @param {?} event
                 * @return {?}
                 */
                (event) => {
                    this.removeMessagesByClass('botFeedback');
                    this.callAnalyticsService(buttonElement.id);
                    this.botService.addMessageToConversation('Obrigado pelo seu feedback !', 'text', true);
                }));
            }));
        }), 1000);
    }
    /**
     * @return {?}
     */
    caseMessageTypeIsOptionList() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const messageDivElement = document.getElementById(this.message.id);
            /** @type {?} */
            const optionsList = this.message.optionsList;
            optionsList.forEach((/**
             * @param {?} opt
             * @return {?}
             */
            opt => {
                /** @type {?} */
                const buttonElement = (/** @type {?} */ (this.renderer.createElement('button')));
                buttonElement.id = opt.label;
                buttonElement.className = 'optionButton';
                buttonElement.innerHTML = opt.label;
                this.renderer.appendChild(messageDivElement, buttonElement);
                this.renderer.listen(buttonElement, 'click', (/**
                 * @param {?} event
                 * @return {?}
                 */
                (event) => {
                    this.optionSelected.emit({ value: opt.value });
                    this.removeMessagesByClass('optionList');
                }));
            }));
        }), 1000);
    }
    /**
     * @param {?} cssClass
     * @return {?}
     */
    removeMessagesByClass(cssClass) {
        /** @type {?} */
        const chatMessages = this.botService.getConversation();
        for (let i = chatMessages.length - 1; i >= 0; --i) {
            if (chatMessages[i].cssClass === cssClass) {
                chatMessages.splice(i, 1);
            }
        }
    }
    /**
     * @param {?} visualConfig
     * @return {?}
     */
    setPbiCookies(visualConfig) {
        /** @type {?} */
        const visualPageName = visualConfig.pageName;
        /** @type {?} */
        const visualName = visualConfig.visualName;
        /** @type {?} */
        const visualEmbedUrl = visualConfig.embedUrl;
        this.cookieService.set('currentVisualName', visualName);
        this.cookieService.set('currentVisualEmbedUrl', visualEmbedUrl);
        this.cookieService.set('currentVisualPageName', visualPageName);
    }
    /**
     * @param {?} feedback
     * @return {?}
     */
    callAnalyticsService(feedback) {
        /** @type {?} */
        const visualName = this.cookieService.get('currentVisualName');
        /** @type {?} */
        const visualEmbedUrl = this.cookieService.get('currentVisualEmbedUrl');
        /** @type {?} */
        const visualPageName = this.cookieService.get('currentVisualPageName');
    }
}
ChatBotDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govChatBotDirective]'
            },] }
];
/** @nocollapse */
ChatBotDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChatBotService, decorators: [{ type: Optional }, { type: Inject, args: [ChatBotService,] }] },
    { type: CookieService, decorators: [{ type: Optional }, { type: Inject, args: [CookieService,] }] }
];
ChatBotDirective.propDecorators = {
    optionSelected: [{ type: Output }],
    message: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ChatBotModule {
}
ChatBotModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatButtonModule,
                    FormsModule
                ],
                declarations: [ChatBotComponent, ChatBotDirective],
                exports: [ChatBotComponent],
                providers: [ChatBotService, DadosUsuarioService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RodapeModule {
}
RodapeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    RodapeComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatTooltipModule,
                    RouterModule,
                    ChatBotModule
                ],
                exports: [
                    RodapeComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuItem {
    /**
     * @param {?} uid
     * @param {?} nome
     * @param {?=} rota
     * @param {?=} showIcon
     * @param {?=} nivel
     * @param {?=} iconeGuia
     * @param {?=} children
     * @param {?=} parameters
     */
    constructor(uid, nome, rota, showIcon, nivel, iconeGuia, children, parameters) {
        this.showIcon = true;
        this.iconeGuia = true;
        this.uid = uid;
        this.nome = nome;
        this.rota = rota;
        this.showIcon = showIcon;
        this.nivel = nivel;
        this.iconeGuia = iconeGuia;
        this.children = children;
        this.parameters = parameters;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuItemComponent {
    /**
     * @param {?} router
     */
    constructor(router) {
        this.router = router;
        this.funcionalidade = new EventEmitter();
        this.funcionalidadeAbrirOutraAba = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} children
     * @param {?} nivel
     * @return {?}
     */
    openCurrentSubmenu(children, nivel) {
        if (children.length === undefined) {
            return;
        }
        if (nivel > 3) {
            throw new Error('Submenu não pode ter mais de quatro níveis.');
        }
    }
    /**
     * @return {?}
     */
    get rotaSelecionada() {
        return this.rota ? this.rota : '';
    }
    /**
     * @param {?} item
     * @return {?}
     */
    onClickMenuItem(item) {
        if (this.rota || this.rota === '') {
            if (item.parameters) {
                this.router.navigate([this.rota], { queryParams: item.parameters });
            }
            else {
                this.router.navigate([this.rota]);
            }
            this.funcionalidade.emit(item);
        }
    }
    /**
     * Emite o evento de clique do item de menu correspodende
     * @param {?} item
     * @return {?}
     */
    cliqueFuncionalidade(item) {
        if (this.rotaSelecionada === '') {
            this.funcionalidade.emit(item);
        }
    }
    /**
     * Emite o evento de clique do item de menu correspodende
     * @param {?} event
     * @param {?} item
     * @return {?}
     */
    cliqueFuncionalidadeAbrirOutraAba(event, item) {
        event.stopPropagation();
        if (this.url) {
            this.funcionalidadeAbrirOutraAba.emit(item);
        }
    }
}
MenuItemComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-menu-item',
                template: "<a mat-list-item class=\"nav-item\">\n    <mat-icon *ngIf=\"icone\">segment</mat-icon>\n    <p [ngClass]=\"{'sem-icone': icone == false}\" (click)=\"onClickMenuItem(item)\">{{nome}}</p>\n    <mat-icon *ngIf=\"iconeGuia === false\" class=\"arrow-hovered\">chevron_right</mat-icon>\n    <mat-icon class=\"guia-icon\" *ngIf=\"iconeGuia\" (click)=\"cliqueFuncionalidadeAbrirOutraAba($event, item)\">open_in_new\n    </mat-icon>\n</a>",
                styles: [".nav-item{position:relative;display:flex;align-items:center;width:100%;font-size:.8rem;font-weight:400;cursor:pointer;height:30px;text-decoration:none;padding:0 10px 0 20px}.nav-item p{flex:1 1 210px}.nav-item mat-icon{width:24px;height:15px;font-size:15px;margin-right:7px;vertical-align:middle}.nav-item mat-icon.arrow-hovered{visibility:hidden}.nav-item:hover{font-weight:600;z-index:5}.nav-item:hover mat-icon.arrow-hovered{visibility:visible}p.sem-icone{margin-left:39px}.grow1{flex-grow:1}"]
            }] }
];
/** @nocollapse */
MenuItemComponent.ctorParameters = () => [
    { type: Router }
];
MenuItemComponent.propDecorators = {
    nome: [{ type: Input }],
    rota: [{ type: Input }],
    url: [{ type: Input }],
    nivel: [{ type: Input }],
    icone: [{ type: Input }],
    iconeGuia: [{ type: Input }],
    children: [{ type: Input }],
    item: [{ type: Input }],
    index: [{ type: Input }],
    funcionalidade: [{ type: Output }],
    funcionalidadeAbrirOutraAba: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuLateralService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.funcionalidadeAbrirOutraAba$ = new Subject();
    }
    /**
     * @param {?} url
     * @param {?} userId
     * @param {?} ambienteId
     * @return {?}
     */
    getMenuItems(url, userId, ambienteId) {
        return this.httpClient.get(`${url}/${userId}/${ambienteId}`);
    }
    /**
     * @param {?} item
     * @return {?}
     */
    cliqueFuncionalidadeAbrirOutraAba(item) {
        this.funcionalidadeAbrirOutraAba$.next(item);
    }
}
MenuLateralService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
MenuLateralService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ MenuLateralService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MenuLateralService_Factory() { return new MenuLateralService(ɵɵinject(HttpClient)); }, token: MenuLateralService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Componente de implementação do menu lateral
 */
class MenuLateralComponent {
    /**
     * @param {?} dialogRef
     * @param {?} itensMenu
     * @param {?} menuLateralService
     */
    constructor(dialogRef, itensMenu, menuLateralService) {
        this.dialogRef = dialogRef;
        this.itensMenu = itensMenu;
        this.menuLateralService = menuLateralService;
        this.funcionalidade = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * Emite o evento de clique do item de menu correspodende
     * @param {?} item
     * @return {?}
     */
    cliqueFuncionalidade(item) {
        this.funcionalidade.emit(item);
        this.fecharMenu();
    }
    /**
     * @param {?} item
     * @return {?}
     */
    cliqueFuncionalidadeAbrirOutraAba(item) {
        this.menuLateralService.cliqueFuncionalidadeAbrirOutraAba(item);
        this.fecharMenu();
    }
    /**
     * @return {?}
     */
    fecharMenu() {
        this.dialogRef.close();
    }
}
MenuLateralComponent.decorators = [
    { type: Component, args: [{
                selector: "gov-menu-lateral",
                template: "<div class=\"container opened\">\n    <div class=\"corpo-menu\">\n        <ul class=\"parent\" id=\"level-1\">\n            <li *ngFor=\"let levelOne of itensMenu\">\n                <gov-menu-item (funcionalidade)=\"cliqueFuncionalidade($event)\"\n                    (funcionalidadeAbrirOutraAba)=\"cliqueFuncionalidadeAbrirOutraAba($event)\" [url]=\"levelOne.url\"\n                    [rota]=\"levelOne.rota\" [nome]=\"levelOne.nome\" [nivel]=\"levelOne.nivel\" [icone]=\"levelOne.showIcon\"\n                    [iconeGuia]=\"levelOne.iconeGuia\" [children]=\"levelOne?.children\" [item]=\"levelOne\"></gov-menu-item>\n                <ul *ngIf=\"levelOne.children?.length\" class=\"child\" id=\"level-2\">\n                    <div class=\"divider\"></div>\n                    <div class=\"menu-level\">\n                        <p class=\"submenu-titulo\">{{levelOne.nome}}</p>\n                        <li *ngFor=\"let levelTwo of levelOne?.children\">\n                            <gov-menu-item (funcionalidade)=\"cliqueFuncionalidade($event)\"\n                                (funcionalidadeAbrirOutraAba)=\"cliqueFuncionalidadeAbrirOutraAba($event)\"\n                                [url]=\"levelTwo.url\" [rota]=\"levelTwo.rota\" [nome]=\"levelTwo.nome\"\n                                [nivel]=\"levelTwo.nivel\" [icone]=\"levelTwo.showIcon\" [iconeGuia]=\"levelTwo.iconeGuia\"\n                                [children]=\"levelTwo?.children\" [item]=\"levelTwo\">\n                            </gov-menu-item>\n                            <ul *ngIf=\"levelTwo.children?.length\" class=\"child\" id=\"level-3\">\n                                <div class=\"divider\"></div>\n                                <div class=\"menu-level\">\n                                    <p class=\"submenu-titulo\">{{levelTwo.nome}}</p>\n                                    <li *ngFor=\"let levelThree of levelTwo?.children\">\n                                        <gov-menu-item (funcionalidade)=\"cliqueFuncionalidade($event)\"\n                                            (funcionalidadeAbrirOutraAba)=\"cliqueFuncionalidadeAbrirOutraAba($event)\"\n                                            [url]=\"levelThree.url\" [rota]=\"levelThree.rota\" [nome]=\"levelThree.nome\"\n                                            [nivel]=\"levelThree.nivel\" [icone]=\"levelThree.showIcon\"\n                                            [iconeGuia]=\"levelThree.iconeGuia\" [children]=\"levelThree?.children\"\n                                            [item]=\"levelThree\"></gov-menu-item>\n                                        <ul *ngIf=\"levelThree.children?.length\" class=\"child\" id=\"level-4\">\n                                            <div class=\"divider\"></div>\n                                            <div class=\"menu-level\">\n                                                <p class=\"submenu-titulo\">{{levelThree.nome}}</p>\n                                                <li *ngFor=\"let levelFour of levelThree?.children\">\n                                                    <gov-menu-item (funcionalidade)=\"cliqueFuncionalidade($event)\"\n                                                        (funcionalidadeAbrirOutraAba)=\"cliqueFuncionalidadeAbrirOutraAba($event)\"\n                                                        [url]=\"levelThree.url\" [rota]=\"levelFour.rota\"\n                                                        [nome]=\"levelFour.nome\" [nivel]=\"levelFour.nivel\"\n                                                        [icone]=\"levelFour.showIcon\" [iconeGuia]=\"levelFour.iconeGuia\"\n                                                        [children]=\"levelFour?.children\" [item]=\"levelFour\">\n                                                    </gov-menu-item>\n                                                </li>\n                                            </div>\n                                        </ul>\n                                    </li>\n                                </div>\n                            </ul>\n                        </li>\n                    </div>\n                </ul>\n            </li>\n        </ul>\n    </div>\n</div>\n<div class=\"outside\" (mouseenter)=\"fecharMenu()\"></div>",
                styles: [":host{position:relative;height:100%;display:block}.container{display:none;overflow:hidden;position:absolute;margin-left:0;width:100%;height:100%}.container ul{height:100%}.container.opened{display:block}.corpo-menu{position:absolute;display:block;width:275px;height:100%;z-index:5}#level-1 li:hover::before{content:\" \";height:0;position:absolute;right:-1px;width:0;z-index:200}#level-1 li:hover #level-2,#level-2 li:hover #level-3,#level-3 li:hover #level-4{display:flex}#level-2{display:none;position:absolute;right:-242px;top:0;width:253px}#level-2 li:hover::before{content:\" \";height:0;position:absolute;right:11px;width:0;z-index:200}#level-3{display:none;position:absolute;right:-229px;top:0;width:253px}#level-3 li:hover::before{content:\" \";height:0;position:absolute;right:3px;width:0;z-index:200}#level-4{display:none;position:absolute;right:-237px;top:0;width:253px}#level-4 li:hover::before{display:none}.menu-level{width:100%}.outside{height:100%;width:calc(100% - 250px);position:absolute;z-index:1;left:250px}a{text-decoration:none;margin-top:20px;width:100%;display:block;height:100%}li{margin-top:10px;width:100%;list-style:none}.divider{width:3px;min-width:3px;height:100%;z-index:6}p.submenu-titulo{font-weight:700;padding:15px 27px 6px 50px;font-size:15px;line-height:20px}"]
            }] }
];
/** @nocollapse */
MenuLateralComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: MenuItem, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
    { type: MenuLateralService }
];
MenuLateralComponent.propDecorators = {
    funcionalidade: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuLateralModule {
}
MenuLateralModule.decorators = [
    { type: NgModule, args: [{
                declarations: [MenuLateralComponent, MenuItemComponent],
                imports: [
                    CommonModule,
                    MatIconModule,
                    RouterModule,
                ],
                exports: [
                    MenuLateralComponent
                ],
                entryComponents: [
                    MenuLateralComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ListagemGrpComponent {
    /**
     * @param {?} listagemGrpService
     */
    constructor(listagemGrpService) {
        this.listagemGrpService = listagemGrpService;
        this.listagemGrp = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        // Ordenação dos itens de menu por ordem alfabética.
        if (this.listagemGrp) {
            this.listagemGrp.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => a.titulo.localeCompare(b.titulo)));
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    capturaCliqueListagemGrp(event) {
        this.listagemGrpService.setCliqueMenuGrp(event);
    }
    /**
     * @return {?}
     */
    definirAlturaMenu() {
        this.totalItensListagemGrp = this.listagemGrp.length;
        if (this.totalItensListagemGrp <= 5) {
            this.listagemGrpheight = 112;
            return this.listagemGrpheight;
        }
        else if (this.totalItensListagemGrp <= 10) {
            this.listagemGrpheight = 182;
            return this.listagemGrpheight;
        }
        else if (this.totalItensListagemGrp <= 15) {
            this.listagemGrpheight = 252;
            return this.listagemGrpheight;
        }
        else {
            this.listagemGrpheight = 322;
            return this.listagemGrpheight;
        }
    }
}
ListagemGrpComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-listagem-grp',
                template: "<div class=\"listagem-grp\">\n  <div class=\"row\">\n    <div class=\"header\">\n      <h2>Meus produtos GOVBR <i class=\"assignment\"></i></h2>\n      <div class=\"separator\"></div>\n    </div>\n    <ul class=\"menu\" [style.height.px]=\"definirAlturaMenu()\">\n      <!-- Controle de limitacao dos itens do menu atraves do slice -->\n      <li *ngFor=\"let row of listagemGrp | slice:0:18\" [class.is-father]=\"row.submenu\">\n        <a [class.bg-blue]=\"row.submenu\">\n          <mat-icon>{{ row.icone }}</mat-icon>\n          <!-- Controle de limitacao dos caracteres do item do menu atraves do slice -->\n          {{ row.titulo | slice:0:30 }}\n        </a>\n        <ul *ngIf=\"row?.submenu?.length > 0\" class=\"submenu\">\n          <li *ngFor=\"let rowSubmenu of row.submenu | slice:0:7; let last = last\">\n            <a #selectItem [class.last-child]=\"last\" (click)=\"capturaCliqueListagemGrp(selectItem)\">\n              {{ rowSubmenu.titulo | slice:0:40 }}\n            </a>\n          </li>\n        </ul>\n      </li>\n    </ul>\n  </div>\n</div>\n",
                styles: ["@charset \"UTF-8\";*{box-sizing:border-box}.row:after{content:\"\";display:table;clear:both}.listagem-grp{display:block;position:absolute;width:calc(100% - 45px);left:20px}.header h2{padding:5px 0;font-family:\"Nunito Sans\";font-weight:400;text-align:left;text-decoration:none;color:#0395df}.header i.assignment{float:right;margin-top:10px;width:16px;height:16px;background-image:url(../../../assets/icons/assignment.svg);background-repeat:no-repeat}.header .separator{border-bottom:2px solid #0395df}.menu,.submenu{display:block;padding:0;position:absolute;width:100%}.menu{position:relative;padding-top:15px;background:#fff;border-bottom:1px solid #9fdfff}.menu li{float:left;margin:25px 0 20px;padding:0;width:20%;height:25px;list-style:none}.menu li a{display:block;float:none;padding:3px 0;font-family:\"Nunito Sans\";font-size:.875rem;text-align:left;text-decoration:none;color:#0395df;cursor:pointer}.menu li a mat-icon{font-size:1rem;vertical-align:middle;width:16px;height:20px}.is-father:hover .bg-blue{height:auto;color:#fff;background-color:#0395df;border:1px solid #0395df;border-radius:5px 5px 0 0;margin-left:-10px;padding-left:10px;margin-right:10px}.is-father .submenu{border:1px solid #0395df;border-radius:0 0 5px 5px}.is-father:hover .submenu{display:block}.submenu li{margin:0;padding:0;width:100%;height:auto;list-style:none}.submenu li a{padding:4px 10px 6px;height:auto;font-size:.813rem}.submenu li a:hover{background-color:#ecf2f8}.submenu{display:none;width:calc(20% - 0px);background-color:#fff;z-index:1;margin-left:-10px}.last-child:hover{border-radius:0 0 5px 5px}.menu:hover>li{opacity:.5}.menu>li:hover{opacity:1}"]
            }] }
];
/** @nocollapse */
ListagemGrpComponent.ctorParameters = () => [
    { type: MenuGrpService }
];
ListagemGrpComponent.propDecorators = {
    listagemGrp: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ListagemGrpModule {
}
ListagemGrpModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ListagemGrpComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    HttpClientModule,
                    RouterModule
                ],
                exports: [
                    ListagemGrpComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GovbrHomeModule {
}
GovbrHomeModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    MatButtonModule,
                    MatToolbarModule,
                    MatTooltipModule,
                    MatRadioModule,
                    MatCheckboxModule$1,
                    MatIconModule,
                    CommonModule,
                    MatFormFieldModule,
                    MatInputModule,
                    FormsModule,
                    ReactiveFormsModule,
                    CabecalhoModule,
                    MenuGrpModule,
                    MenuLateralModule,
                    RodapeModule,
                    PerfilUsuarioModule,
                    ListagemGrpModule,
                    MatSelectModule,
                    ProdutosMenuGrpModule,
                    ModalLgpdModule,
                ],
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class GovStepperComponent extends CdkStepper {
    /**
     * @param {?} dir
     * @param {?} changeDetectorRef
     * @param {?} cdr
     */
    constructor(dir, changeDetectorRef, cdr) {
        super(dir, changeDetectorRef);
        this.cdr = cdr;
        this.stepPercentage = 0;
        this.componentReady = false;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    onClick(index) {
        this.selectedIndex = index;
        this.setProgressBar();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.stepContainerNativeElement = ((/** @type {?} */ (this.stepContainer.nativeElement)));
        fromEvent(window, 'resize').subscribe((/**
         * @return {?}
         */
        () => {
            this.setProgressBar();
        }));
        this.steps.forEach((/**
         * @param {?} step
         * @return {?}
         */
        step => {
            if (!step.label) {
                throw new Error('Todos os steps devem possuir um label.');
            }
        }));
        this.cdr.detach();
        this.setProgressBar();
        this.componentReady = true;
        this.cdr.detectChanges();
        this.cdr.reattach();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    /**
     * @return {?}
     */
    setProgressBar() {
        /** @type {?} */
        const stepperProgressBarWidth = this.stepContainerNativeElement.offsetWidth;
        /** @type {?} */
        let progressWidth = 0;
        /** @type {?} */
        let i = 0;
        while (i <= this.selectedIndex) {
            progressWidth += this.stepContainerNativeElement
                .querySelector(`button[data-step-index="${this.selectedIndex}"]`).offsetWidth;
            i++;
        }
        /** @type {?} */
        const percentageStep = progressWidth / stepperProgressBarWidth * 100;
        this.stepPercentage = percentageStep;
        /** @type {?} */
        const progressBarBackground = this.stepContainerNativeElement
            .getElementsByClassName('mat-progress-bar-buffer mat-progress-bar-element');
        progressBarBackground[0].style.width = `calc(100% - ${progressWidth}px)`;
        progressBarBackground[0].style.left = `${progressWidth}px`;
    }
}
GovStepperComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-stepper',
                template: "<section #stepContainer class=\"container\" [ngClass]=\"{'not-ready': componentReady === false}\">\n    <div class=\"steps\">\n        <button class=\"step\" [attr.data-step-index]=\"i\" *ngFor=\"let step of steps; let i = index;\"\n            [ngClass]=\"{'active': selectedIndex === i}\" (click)=\"onClick(i)\"><span class=\"step-text\">{{ step.label ?\n                step.label : '' }}</span></button>\n    </div>\n    <mat-progress-bar class=\"step-indicator\" mode=\"determinate\" [value]=\"stepPercentage\"></mat-progress-bar>\n\n    <div [style.display]=\"selected ? 'block' : 'none'\">\n        <ng-container [ngTemplateOutlet]=\"selected.content\"></ng-container>\n    </div>\n</section>",
                providers: [{ provide: CdkStepper, useExisting: GovStepperComponent }],
                styles: [".not-ready{display:none}.step{border:none;border-top-left-radius:5px;border-top-right-radius:5px;padding:0 16px;display:inline-flex;width:auto;height:24px;font-style:normal;font-weight:400;font-size:14px;line-height:20px;align-items:center;justify-content:center;cursor:pointer}.step-indicator{width:100%;height:1px}"]
            }] }
];
/** @nocollapse */
GovStepperComponent.ctorParameters = () => [
    { type: Directionality },
    { type: ChangeDetectorRef },
    { type: ChangeDetectorRef }
];
GovStepperComponent.propDecorators = {
    stepContainer: [{ type: ViewChild, args: ['stepContainer', { static: false },] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepperModule {
}
StepperModule.decorators = [
    { type: NgModule, args: [{
                declarations: [GovStepperComponent],
                imports: [
                    CdkStepperModule,
                    CommonModule,
                    MatProgressBarModule
                ],
                exports: [
                    GovStepperComponent,
                    CdkStepperModule
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LoaderComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
LoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-loader',
                template: "<mat-spinner class=\"govbr-spinner\"></mat-spinner>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
LoaderComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line:eofline
class LoaderModule {
}
LoaderModule.decorators = [
    { type: NgModule, args: [{
                declarations: [LoaderComponent],
                imports: [
                    CommonModule,
                    MatProgressSpinnerModule
                ],
                exports: [
                    LoaderComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConfigLookup {
    /**
     * @param {?} titulo
     * @param {?} colunasTabela
     * @param {?} tituloColunas
     */
    constructor(titulo, colunasTabela, tituloColunas) {
        this.titulo = titulo;
        this.colunasTabela = colunasTabela;
        this.tituloColunas = tituloColunas;
        this.titulo = titulo;
        this.colunasTabela = colunasTabela;
        this.tituloColunas = tituloColunas;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LookupService {
    constructor() {
        this.subjectPaginacao = new Subject();
        this.subjectNovaPesquisa = new Subject();
        this.subjectDadoAtualizado = new Subject();
        this.subjectDadoSelecionado = new Subject();
        this.subjectDadosFiltrados = new Subject();
    }
    /**
     * @param {?} novaPesquisa
     * @return {?}
     */
    enviaNovaPesquisa(novaPesquisa) {
        this.subjectNovaPesquisa.next(novaPesquisa);
    }
    /**
     * @return {?}
     */
    pegaNovaPesquisa() {
        return this.subjectNovaPesquisa.asObservable();
    }
    /**
     * @param {?} atualizaDados
     * @return {?}
     */
    enviaAtualizaDados(atualizaDados) {
        this.subjectDadoAtualizado.next(atualizaDados);
    }
    /**
     * @return {?}
     */
    pegaAtualizaDados() {
        return this.subjectDadoAtualizado.asObservable();
    }
    /**
     * @param {?} dadoSelecionado
     * @return {?}
     */
    enviaDadoSelcionado(dadoSelecionado) {
        this.subjectDadoSelecionado.next(dadoSelecionado);
    }
    /**
     * @return {?}
     */
    pegaDadoSelecionado() {
        return this.subjectDadoSelecionado.asObservable();
    }
    /**
     * @param {?} pesquisa
     * @return {?}
     */
    pesquisaComPagincao(pesquisa) {
        this.subjectPaginacao.next(pesquisa);
    }
    /**
     * @return {?}
     */
    pegaNovaPaginacao() {
        return this.subjectPaginacao.asObservable();
    }
    /**
     * @param {?} dadosIniciais
     * @return {?}
     */
    enviaDadosFiltrados(dadosIniciais) {
        this.subjectDadosFiltrados.next(dadosIniciais);
    }
    /**
     * @return {?}
     */
    pegaDadosFiltrados() {
        return this.subjectDadosFiltrados.asObservable();
    }
}
LookupService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LookupService.ctorParameters = () => [];
/** @nocollapse */ LookupService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LookupService_Factory() { return new LookupService(); }, token: LookupService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LookupComponent {
    /**
     * @param {?} lookupService
     */
    constructor(lookupService) {
        this.lookupService = lookupService;
        this.novaPesquisa = new EventEmitter();
        this.paginacao = new EventEmitter();
        this.dadoSelecionado = new EventEmitter();
        this.sidenavToggle = new EventEmitter();
        this.dadosIniciais = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /**
         * evento que escuta quando uma nova paginação for disparada
         */
        this.lookupService.pegaNovaPaginacao().subscribe((/**
         * @param {?} novaPagincacao
         * @return {?}
         */
        novaPagincacao => {
            this.novaPesquisa.emit(novaPagincacao);
        }));
        /**
         * evento que escuta quando uma nova pesquisa no filtro for feita
         */
        this.lookupService.pegaNovaPesquisa()
            .subscribe((/**
         * @param {?} pesquisa
         * @return {?}
         */
        pesquisa => {
            this.novaPesquisa.emit(pesquisa);
        }));
        /**
         * evento que escuta quando o usuário selecionar um valor na tabela
         */
        this.lookupService.pegaDadoSelecionado()
            .subscribe((/**
         * @param {?} dado
         * @return {?}
         */
        dado => {
            this.dadoSelecionado.emit(dado);
        }));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.dadosTabela) {
            this.lookupService.enviaDadosFiltrados(changes.dadosTabela.currentValue);
        }
        if (changes.dadosFiltrados) {
            this.lookupService.enviaDadosFiltrados(changes.dadosFiltrados.currentValue);
        }
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    navOpen($event) {
        this.isOpen = !this.isOpen;
    }
}
LookupComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-lookup',
                template: "<govbr-lookup-drawer [openNav]=\"isOpen\" (open)=\"navOpen($event)\" [configLookup]=\"configLookup\" [dadoTabela]=\"dadosTabela\"></govbr-lookup-drawer>\n<govbr-lookup-header (open)=\"navOpen($event)\"></govbr-lookup-header>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
LookupComponent.ctorParameters = () => [
    { type: LookupService }
];
LookupComponent.propDecorators = {
    configLookup: [{ type: Input }],
    dadosTabela: [{ type: Input }],
    dadosFiltrados: [{ type: Input }],
    totalDadosTabela: [{ type: Input }],
    novaPesquisa: [{ type: Output }],
    paginacao: [{ type: Output }],
    dadoSelecionado: [{ type: Output }],
    sidenavToggle: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LookupHeaderComponent {
    constructor() {
        this.open = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    clickMenu() {
        this.open.emit(true);
    }
}
LookupHeaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-lookup-header',
                template: "<button mat-icon-button (click)=\"clickMenu()\">\n  <mat-icon>search</mat-icon>\n</button>",
                styles: ["button{position:relative;z-index:1;background:#fff;border:0;cursor:pointer}mat-icon{font-size:18px;color:#0395df}"]
            }] }
];
/** @nocollapse */
LookupHeaderComponent.ctorParameters = () => [];
LookupHeaderComponent.propDecorators = {
    open: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LookupDrawerComponent {
    /**
     * @param {?} lookupService
     */
    constructor(lookupService) {
        this.lookupService = lookupService;
        // MatPaginator Inputs
        this.length = 0;
        this.pageSize = 5;
        this.pageSizeOptions = [5, 10];
        // MatPaginator Output
        this.pageEvent = new PageEvent();
        this.displayedColumns = [];
        this.atualizaDados = new EventEmitter();
        this.filtroForm = new FormGroup({ filtro: new FormControl('') });
        this.textoFiltrado = '';
        this.open = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.dadosTabela();
        this.pegarValorInputFiltro();
        this.lookupService.pegaDadosFiltrados()
            .subscribe((/**
         * @param {?} tabelaAtualizada
         * @return {?}
         */
        tabelaAtualizada => this.dataSource = new MatTableDataSource(tabelaAtualizada)));
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.openNav) {
            this.sidenav.open();
        }
        else {
            this.sidenav.close();
        }
    }
    /**
     * @return {?}
     */
    dadosTabela() {
        this.tituloColuna = this.configLookup.tituloColunas;
        this.dataSource = new MatTableDataSource(this.dadoTabela);
        this.displayedColumns = this.configLookup.colunasTabela;
        this.length = this.dadoTabela.length;
    }
    /**
     * @return {?}
     */
    pegarValorInputFiltro() {
        this.filtroForm.valueChanges
            .subscribe((/**
         * @param {?} valor
         * @return {?}
         */
        valor => {
            const { filtro } = valor;
            this.textoFiltrado = filtro;
            if (!Object.keys(this.pageEvent).length) {
                this.pageEvent = { length: this.length, pageSize: this.pageSize, previousPageIndex: 0, pageIndex: 0 };
            }
            this.paginacao(this.pageEvent);
        }));
    }
    /**
     * @param {?} pageEvent
     * @return {?}
     */
    paginacao(pageEvent) {
        const { value } = this.filtroForm.controls.filtro;
        this.lookupService.pesquisaComPagincao({ filtro: value, paginacao: pageEvent });
    }
    /**
     * @param {?} dado
     * @return {?}
     */
    dadoSelecionadoTabela(dado) {
        this.lookupService.enviaDadoSelcionado(dado);
    }
    /**
     * @return {?}
     */
    clickMenu() {
        this.open.emit(false);
    }
}
LookupDrawerComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-lookup-drawer',
                template: "<mat-sidenav-container class='govbr-lookup-drawer-container' fullscreen>\n  <mat-sidenav #sidenav mode=\"over\" fixedInViewport=\"true\" position=\"end\">\n    <div class=\"cabecalho\">\n      <div class=\"titulo\">\n        <h3>{{ configLookup.titulo }}</h3>\n      </div>\n      <div class=\"btn-fechar\">\n        <button mat-button (click)=\"clickMenu()\">X</button>\n      </div>\n    </div>\n\n    <div class=\"conteudo\">\n\n      <form [formGroup]=\"filtroForm\">\n        <mat-form-field class=\"govbr-form-field\" appearance=\"outline\">\n          <mat-label>Filtrar</mat-label>\n          <input matInput placeholder=\"digite aqui o valor\" formControlName=\"filtro\" class=\"filtro\">\n        </mat-form-field>\n      </form>\n\n      <ng-container *ngIf=\"dataSource?.filteredData.length\">\n        <mat-table class=\"govbr-table table\" mat-table [dataSource]=\"dataSource\">\n          <ng-container *ngFor=\"let key of displayedColumns;  let i = index \">\n            <ng-container [matColumnDef]=\"key\">\n              <mat-header-cell *matHeaderCellDef> {{tituloColuna[i]}} </mat-header-cell>\n              <mat-cell *matCellDef=\"let element\" (click)=\"dadoSelecionadoTabela(element[key])\"\n                [innerHTML]=\"element[key] | highlightSearch: textoFiltrado\"></mat-cell>\n            </ng-container>\n          </ng-container>\n          <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\n          <mat-row *matRowDef=\"let row; columns: displayedColumns;\"></mat-row>\n        </mat-table>\n        <gov-paginator #paginator [length]=\"length\" [pageSize]=\"pageSize\" [pageSizeOptions]=\"pageSizeOptions\"\n         *ngIf=\"dataSource?.filteredData.length > 0\">\n        </gov-paginator>\n      </ng-container>\n      <ng-container *ngIf=\"!dataSource?.filteredData.length\">\n        <span class=\"sem-dados\"> Sem dados correspondentes ao filtro </span>\n      </ng-container>\n\n    </div>\n  </mat-sidenav>\n</mat-sidenav-container>\n",
                styles: [".mat-drawer-container[fullscreen]{left:auto}mat-sidenav{width:1000px}mat-sidenav div.cabecalho{display:flex;justify-content:space-between;padding:10px}mat-sidenav div.cabecalho .titulo h3{font-weight:100}mat-sidenav div.cabecalho .btn-fechar button{cursor:pointer;font-size:18px}mat-sidenav div.conteudo{padding:10px}"]
            }] }
];
/** @nocollapse */
LookupDrawerComponent.ctorParameters = () => [
    { type: LookupService }
];
LookupDrawerComponent.propDecorators = {
    sidenav: [{ type: ViewChild, args: ['sidenav', { static: true },] }],
    paginator: [{ type: ViewChild, args: ['paginator', { static: true },] }],
    openNav: [{ type: Input }],
    configLookup: [{ type: Input }],
    dadoTabela: [{ type: Input }],
    open: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LookupModule {
}
LookupModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    LookupComponent,
                    LookupHeaderComponent,
                    LookupDrawerComponent
                ],
                imports: [
                    PipesModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatFormFieldModule,
                    CommonModule,
                    MatIconModule,
                    MatToolbarModule,
                    MatTableModule$1,
                    MatInputModule,
                    PaginationModule,
                    MatSidenavModule
                ],
                providers: [LookupService],
                exports: [
                    LookupComponent,
                    LookupHeaderComponent,
                    LookupDrawerComponent
                ],
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Serviço que provê funcionalidades que auxiliam na funcionalidade de configurações de tabela
 */
class TableConfigService {
    constructor() {
        /**
         * Referência à todas as diretivas de configuração de tabela da aplicação
         */
        this.configDirectives = [];
        /**
         * Opções de tamanho de fontes disponíveis
         */
        this.displayModeOptions = ['compact', 'normal', 'confortable'];
    }
    /**
     * Salva uma referência para uma diretiva de configuração de tabela
     * @param {?} directive
     * @return {?}
     */
    registerDirective(directive) {
        /** @type {?} */
        const index = this.configDirectives.indexOf(directive);
        if (index === -1) {
            this.configDirectives.push(directive);
        }
    }
    /**
     * Indica se uma coluna de uma tabela está fixada
     * @param {?} tableId
     * @param {?} columnName
     * @return {?}
     */
    isPinnedColumn(tableId, columnName) {
        /** @type {?} */
        const directive = this.configDirectives.find((/**
         * @param {?} dir
         * @return {?}
         */
        dir => dir.tableId === tableId));
        if (directive && directive.pinnedColumns.indexOf(columnName) !== -1) {
            return true;
        }
        return false;
    }
    /**
     * Retorna o modo de exibição (tamanho de fonte e espaçamento) da tabela
     * @param {?} tableId
     * @return {?}
     */
    getViewModeClass(tableId) {
        /** @type {?} */
        const directive = this.configDirectives.find((/**
         * @param {?} dir
         * @return {?}
         */
        dir => dir.tableId === tableId));
        if (directive) {
            return directive.tableViewModeClass;
        }
        return { mode: 'normal' };
    }
    /**
     * Altera o modo de exibição (tamanho de fonte e espaçamento) da tabela
     * @param {?} tableConfigData
     * @param {?} renderer
     * @param {?} displayModeOption
     * @return {?}
     */
    changeDisplayMode(tableConfigData, renderer, displayModeOption) {
        this.displayModeOptions.filter((/**
         * @param {?} option
         * @return {?}
         */
        option => {
            return option !== displayModeOption;
        })).forEach((/**
         * @param {?} option
         * @return {?}
         */
        option => {
            renderer.removeClass(tableConfigData.tableElement, option);
        }));
        renderer.addClass(tableConfigData.tableElement, displayModeOption);
        tableConfigData.tableViewModeClass.mode = displayModeOption;
    }
}
TableConfigService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
TableConfigService.ctorParameters = () => [];
/** @nocollapse */ TableConfigService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TableConfigService_Factory() { return new TableConfigService(); }, token: TableConfigService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Painel com opções de configuração de visualizações de tabelas,
 * usado em conjunto com a diretiva `govTableConfig`
 */
class TableConfigDialogComponent {
    /**
     * @param {?} data
     * @param {?} dialogRef
     * @param {?} cdr
     * @param {?} renderer
     * @param {?} tableConfigService
     */
    constructor(data, dialogRef, cdr, renderer, tableConfigService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.cdr = cdr;
        this.renderer = renderer;
        this.tableConfigService = tableConfigService;
        /**
         * Estrutura que salva uma relação chave/nome de visualização de todas as colunas da tabela
         */
        this.originalTableColumnsData = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.originalTableColumnsData = this.data.originalColumns.map((/**
         * @param {?} column
         * @param {?} index
         * @return {?}
         */
        (column, index) => {
            return { dataName: column, displayName: this.data.originalColumnsNames[index] };
        }));
        this.cdr.detach();
        this.orderColumns();
        this.orderOriginalTableColumns();
        this.cdr.detectChanges();
        this.cdr.reattach();
    }
    /**
     * Altera os tamanhos da tela para melhor atender a visualização do usuário,
     * possui três tamanhos diferentes `compact`, `normal` e `confortable`
     * @param {?} displayModeOption
     * @return {?}
     */
    changeDisplayMode(displayModeOption) {
        this.tableConfigService.changeDisplayMode(this.data, this.renderer, displayModeOption);
    }
    /**
     * Altera o estado de visibilidade de uma coluna da tabela
     * @param {?} changeObject
     * @return {?}
     */
    onColumnVisibleChange(changeObject) {
        /** @type {?} */
        const tableColumn = this.originalTableColumnsData
            .find((/**
         * @param {?} column
         * @return {?}
         */
        column => column.displayName === changeObject.columnName));
        /** @type {?} */
        const columnChanged = this.data.tableColumns.find((/**
         * @param {?} column
         * @return {?}
         */
        column => column === tableColumn.dataName));
        /** @type {?} */
        const columnChangedDisplayName = this.data.tableColumnsNames.find((/**
         * @param {?} column
         * @return {?}
         */
        column => column === tableColumn.displayName));
        if (changeObject.visible && !columnChanged) {
            this.data.tableColumns.push(tableColumn.dataName);
            this.data.tableColumnsNames.push(tableColumn.displayName);
        }
        else if (!changeObject.visible && columnChanged) {
            this.data.tableColumns.splice(this.data.tableColumns.indexOf(columnChanged), 1);
            this.data.tableColumnsNames.splice(this.data.tableColumnsNames.indexOf(columnChangedDisplayName), 1);
        }
        this.orderColumns();
        if (!changeObject.visible) {
            this.onColumnPinnedChange(changeObject);
        }
    }
    /**
     * Define que uma coluna será fixa na tabela, é possível fixar até duas colunas na tabela,
     * caso uma terceira coluna seja marcada como fixa, a última coluna definida como fixa antes
     * dessa fica desafixada
     * @param {?} changeObject
     * @return {?}
     */
    onColumnPinnedChange(changeObject) {
        if (changeObject.visible && !this.isColumnPinned(changeObject.columnName)) {
            if (this.data.pinnedColumns.length === 2) {
                this.data.pinnedColumns.pop();
            }
            this.data.pinnedColumns.push(changeObject.columnName);
        }
        else {
            /** @type {?} */
            const index = this.data.pinnedColumns.indexOf(changeObject.columnName);
            if (index !== -1) {
                this.data.pinnedColumns.splice(index, 1);
            }
        }
        this.orderOriginalTableColumns();
    }
    /**
     * Indica se uma coluna está fixada
     * @param {?} columnName
     * @return {?}
     */
    isColumnPinned(columnName) {
        return this.data.pinnedColumns.includes(columnName);
    }
    /**
     * Indica se uma coluna está visível
     * @param {?} columnName
     * @return {?}
     */
    isColumnVisible(columnName) {
        return this.data.tableColumnsNames.includes(columnName);
    }
    /**
     * Reordena as colunas da tabela com base no movimento de drag n drop do usuário
     * @param {?} event
     * @return {?}
     */
    drop(event) {
        moveItemInArray(this.data.originalTableColumnsNames, event.previousIndex, event.currentIndex);
        this.orderColumns();
        this.orderOriginalTableColumns();
    }
    /**
     * Fecha o dialog de configurações de tabela
     * @return {?}
     */
    closeDialog() {
        this.dialogRef.close();
    }
    // TODO: implmentar lógica de salvar configurações com o apoio da
    // equipe do corporativo
    /**
     * Fecha o dialog de configurações de tabela e fecha o mesmo
     * @return {?}
     */
    saveAndCloseDialog() {
        this.dialogRef.close();
    }
    /**
     * Ordena as colunas da tabela
     * @private
     * @return {?}
     */
    orderColumns() {
        /** @type {?} */
        const tableColumns = [];
        /** @type {?} */
        const tableColumnsNames = [];
        this.data.originalTableColumnsNames.forEach((/**
         * @param {?} tableColumnName
         * @return {?}
         */
        tableColumnName => {
            /** @type {?} */
            const tableColumn = this.originalTableColumnsData
                .find((/**
             * @param {?} column
             * @return {?}
             */
            column => column.displayName === tableColumnName));
            /** @type {?} */
            const originalTableColumn = this.data.tableColumns.find((/**
             * @param {?} column
             * @return {?}
             */
            column => column === tableColumn.dataName));
            /** @type {?} */
            const originalTableColumnName = this.data.tableColumnsNames.find((/**
             * @param {?} column
             * @return {?}
             */
            column => column === tableColumn.displayName));
            if (originalTableColumn && originalTableColumnName) {
                tableColumns.push(originalTableColumn);
                tableColumnsNames.push(originalTableColumnName);
            }
        }));
        /** @type {?} */
        const orderedColumns = [];
        /** @type {?} */
        const orderedColumnsNames = [];
        tableColumnsNames.forEach((/**
         * @param {?} column
         * @param {?} index
         * @return {?}
         */
        (column, index) => {
            if (this.isColumnPinned(column)) {
                orderedColumns.push(tableColumns[index]);
                orderedColumnsNames.push(column);
            }
        }));
        orderedColumnsNames.forEach((/**
         * @param {?} column
         * @return {?}
         */
        (column) => {
            /** @type {?} */
            const sameColumnIndex = tableColumnsNames.indexOf(column);
            if (sameColumnIndex !== -1) {
                tableColumns.splice(sameColumnIndex, 1);
                tableColumnsNames.splice(sameColumnIndex, 1);
            }
        }));
        tableColumns.forEach((/**
         * @param {?} column
         * @return {?}
         */
        column => orderedColumns.push(column)));
        tableColumnsNames.forEach((/**
         * @param {?} column
         * @return {?}
         */
        column => orderedColumnsNames.push(column)));
        this.data.tableColumns.splice(0, this.data.tableColumns.length);
        this.data.tableColumnsNames.splice(0, this.data.tableColumnsNames.length);
        orderedColumns.forEach((/**
         * @param {?} column
         * @return {?}
         */
        column => this.data.tableColumns.push(column)));
        orderedColumnsNames.forEach((/**
         * @param {?} column
         * @return {?}
         */
        column => this.data.tableColumnsNames.push(column)));
    }
    /**
     * Ordena o array de colunas que é utilizado para renderizar a lista de configurações de coluna
     * @private
     * @return {?}
     */
    orderOriginalTableColumns() {
        this.orderColumns();
        /** @type {?} */
        const newOriginalTableColumnsNames = [...this.data.pinnedColumns];
        this.data.originalTableColumnsNames.filter((/**
         * @param {?} column
         * @return {?}
         */
        column => {
            return newOriginalTableColumnsNames.indexOf(column) === -1;
        })).forEach((/**
         * @param {?} column
         * @return {?}
         */
        column => {
            newOriginalTableColumnsNames.push(column);
        }));
        this.data.originalTableColumnsNames.splice(0, this.data.originalTableColumnsNames.length);
        newOriginalTableColumnsNames.forEach((/**
         * @param {?} column
         * @return {?}
         */
        column => this.data.originalTableColumnsNames.push(column)));
    }
}
TableConfigDialogComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-table-config-dialog',
                template: "<mat-toolbar>\n    <span>Configura\u00E7\u00F5es de tabela</span>\n    <mat-icon (click)=\"closeDialog()\">clear</mat-icon>\n</mat-toolbar>\n<mat-card class=\"config-dialog-container\">\n    <div govRowGrid class=\"table-columns-description-area\">\n        <div govColGrid cdkDropList xs=\"7\" class=\"table-config-columns-area\" (cdkDropListDropped)=\"drop($event)\">\n            <gov-table-config-column *ngFor=\"let column of data.originalTableColumnsNames\" cdkDrag\n                (visibleChange)=\"onColumnVisibleChange($event)\" (pinnedChange)=\"onColumnPinnedChange($event)\"\n                [pinned]=\"isColumnPinned(column)\" [columnName]=\"column\" [visible]=\"isColumnVisible(column)\">\n            </gov-table-config-column>\n        </div>\n        <div govColGrid xs=\"5\" class=\"table-config-description-area\">\n            <h3 class=\"table-config-title\">Sele\u00E7\u00E3o de colunas</h3>\n            <p class=\"table-config-description\">\n                Marque na lista ao lado as\n                colunas que gostaria de exibir\n                em seus resultados.\n            </p>\n            <h3 class=\"table-config-title\">Fixar colunas</h3>\n            <p class=\"table-config-description\">\n                Caso a quantidade de colunas\n                ultrapasse o espa\u00E7o dispon\u00EDvel,\n                uma barra de rolagem horizontal\n                aparecer\u00E1 abaixo dos resultados.\n                Contudo, h\u00E1 a possibilidade de fixar\n                at\u00E9 duas colunas e rolar apenas os\n                dados restantes. Para isso, use o pin\n                existente em cada linha selecionada.\n            </p>\n        </div>\n    </div>\n    <mat-divider></mat-divider>\n    <div govRowGrid class=\"config-font-size-container\">\n        <div govColGrid xs=\"12\" class=\"table-config-font-size\">\n            <h3>Modo de exibi\u00E7\u00E3o</h3>\n            <div govRowGrid class=\"table-config-font-size-actions\">\n                <mat-radio-group aria-label=\"Selecione um modo de exibi\u00E7\u00E3o\">\n                    <mat-radio-button class=\"govbr-radio-button\"\n                        [checked]=\"data.tableViewModeClass.mode === 'compact'\"\n                        (click)=\"changeDisplayMode('compact')\" value=\"compact\">Compacta</mat-radio-button>\n                    <mat-radio-button class=\"govbr-radio-button\"\n                        [checked]=\"data.tableViewModeClass.mode === 'normal'\"\n                        (click)=\"changeDisplayMode('normal')\" value=\"normal\">Normal</mat-radio-button>\n                    <mat-radio-button class=\"govbr-radio-button\"\n                        [checked]=\"data.tableViewModeClass.mode === 'confortable'\"\n                        (click)=\"changeDisplayMode('confortable')\" value=\"corfortable\">Confort\u00E1vel\n                    </mat-radio-button>\n                </mat-radio-group>\n                <div class=\"actions\">\n                    <!-- Implementar l\u00F3gica de configura\u00E7\u00F5es de usu\u00E1rio com equipe do Corporativo -->\n                    <button mat-raised-button class=\"govbr-button\" (click)=\"closeDialog()\">Cancelar</button>\n                    <button mat-raised-button mat-primary class=\"govbr-button\" (click)=\"saveAndCloseDialog()\">Salvar</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</mat-card>",
                styles: [".material-icons{font-family:\"Material Icons\"}mat-toolbar{display:flex;justify-content:space-between;height:43px}mat-toolbar mat-icon{cursor:pointer}.config-dialog-container{padding-top:19px}div.table-columns-description-area{display:flex}div.table-config-columns-area{width:79%;max-height:318px;overflow-y:scroll;padding-right:17px}div.table-config-description-area{width:50%;padding:0 0 0 30px}div.table-config-description-area p:nth-child(2){margin-bottom:14px}.table-config-title{font-size:17px}.table-config-description{font-size:13px}"]
            }] }
];
/** @nocollapse */
TableConfigDialogComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
    { type: MatDialogRef },
    { type: ChangeDetectorRef },
    { type: Renderer2 },
    { type: TableConfigService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Diretiva que deve ser associada à um elemento html para configurar opções de exibição de uma tabela,
 * que é identificada pelo seu atributo `id`
 */
class TableConfigDirective {
    /**
     * @param {?} dialog
     * @param {?} tableConfigService
     * @param {?} renderer
     */
    constructor(dialog, tableConfigService, renderer) {
        this.dialog = dialog;
        this.tableConfigService = tableConfigService;
        this.renderer = renderer;
        /**
         * tamanho da fonte da tabela
         */
        this.tableViewModeClass = { mode: 'normal' };
        /**
         * Colunas fixadas na tabela
         */
        this.pinnedColumns = [];
        /**
         * Cópia das colunas originais da tabela (nomes visíveis das colunas) usada
         * para reordenar a lista de colunas da tabela
         */
        this.originalTableColumnsNames = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.tableConfigService.registerDirective(this);
        this.originalTableColumnsNames = this.originalColumnsNames.slice();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        /** @type {?} */
        const table = document.getElementById(this.tableId);
        this.tableElement = table;
        this.configData = {
            tableElement: this.tableElement,
            tableColumns: this.tableColumns,
            tableColumnsNames: this.tableColumnsNames,
            originalColumns: this.originalColumns,
            originalColumnsNames: this.originalColumnsNames,
            originalTableColumnsNames: this.originalTableColumnsNames,
            pinnedColumns: this.pinnedColumns,
            tableViewModeClass: this.tableViewModeClass
        };
        this.tableConfigService.changeDisplayMode(this.configData, this.renderer, this.tableViewModeClass.mode);
    }
    /**
     * Abre o dialog de configuração de tabela
     * @return {?}
     */
    openDialog() {
        /** @type {?} */
        const dialogRef = this.dialog.open(TableConfigDialogComponent, {
            panelClass: 'gov-table-config',
            data: this.configData
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} result
         * @return {?}
         */
        (result) => {
            // TODO: implmentar lógica de salvar configurações
        }));
    }
    /**
     * (\@HostListener) Ouve o evento de click e chama o método para abrir o dialog de configuração de tabela
     * @param {?} $event
     * @return {?}
     */
    onClick($event) {
        $event.preventDefault();
        this.openDialog();
    }
}
TableConfigDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govTableConfig]',
            },] }
];
/** @nocollapse */
TableConfigDirective.ctorParameters = () => [
    { type: MatDialog },
    { type: TableConfigService },
    { type: Renderer2 }
];
TableConfigDirective.propDecorators = {
    tableId: [{ type: Input }],
    tableColumns: [{ type: Input }],
    tableColumnsNames: [{ type: Input }],
    originalColumns: [{ type: Input }],
    originalColumnsNames: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TableConfigColumnComponent {
    constructor() {
        /**
         * Nome visível da coluna da tabela (nome de exibição)
         */
        this.columnName = '';
        this.visible = true;
        this.pinned = true;
        this.visibleChange = new EventEmitter();
        this.pinnedChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    toggleVisible($event) {
        $event.preventDefault();
        this.visibleChange.emit({ columnName: this.columnName, visible: !this.visible });
    }
    /**
     * @return {?}
     */
    togglePinned() {
        this.pinnedChange.emit({ columnName: this.columnName, visible: this.visible });
    }
}
TableConfigColumnComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-table-config-column',
                template: "<div govRowGrid class=\"config-column-container\">\n    <mat-checkbox [checked]=\"visible\" (click)=\"toggleVisible($event)\" class=\"govbr-checkbox\"><span>{{columnName}}</span></mat-checkbox>\n    <mat-icon \n        class=\"default-icon-color pin\"\n        [ngClass]=\"{'not-pinned': !pinned}\"\n        (click)=\"togglePinned()\">push_pin\n    </mat-icon>\n    <mat-icon class=\"default-icon-color\">drag_handle</mat-icon>\n</div>",
                styles: [":host{display:block}.config-column-container{align-items:center;border-radius:5px;padding:0 12px 0 10.5px;height:30px;margin-bottom:6px;position:relative}.config-column-container mat-checkbox span{margin-left:8px;font-style:16px;font-size:12px}.config-column-container mat-icon{font-family:\"Material Icons\";position:absolute;text-align:center;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}.config-column-container mat-icon.pin{font-size:18px;cursor:pointer}.config-column-container mat-icon:nth-child(2){top:5px;left:calc(100% - 64px)}.config-column-container mat-icon:nth-child(3){left:calc(100% - 36px);cursor:move;top:3px}"]
            }] }
];
/** @nocollapse */
TableConfigColumnComponent.ctorParameters = () => [];
TableConfigColumnComponent.propDecorators = {
    columnName: [{ type: Input }],
    visible: [{ type: Input }],
    pinned: [{ type: Input }],
    visibleChange: [{ type: Output }],
    pinnedChange: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TablesModule {
}
TablesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [TableConfigDirective, TableConfigDialogComponent, TableConfigColumnComponent],
                imports: [
                    CommonModule,
                    DragDropModule,
                    GridModule,
                    FormsModule,
                    MatButtonModule,
                    MatCardModule,
                    MatCheckboxModule$1,
                    MatDialogModule$1,
                    MatDividerModule,
                    MatIconModule$1,
                    MatRadioModule,
                    MatToolbarModule$1,
                ],
                entryComponents: [TableConfigDialogComponent],
                exports: [TableConfigDirective, TableConfigDialogComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Módulo de multi-tenancy. Deve ser importado através do {\@link #forRoot}.
 * Ao utilizá-lo, o comportamento de multi-tenancy será configurado na aplicação a partir do {\@link TenantConfig} definido.
 * Além disso, o {\@link TenantService} será disponibilizado para ser utilizado na aplicação.
 *
 * @author Thiago Gesser
 */
class TenantModule {
    /**
     * @param {?} tenantModule
     */
    constructor(tenantModule) {
        if (tenantModule) {
            throw new Error('O TenantModule já foi carregado. Importe-o apenas uma vez no AppModule.');
        }
    }
    /**
     * Importa o módulo de multi-tenancy, configurando seus comportamentos e garantindo que seus serviços serão singletons.
     *
     * @param {?} config configuração de multi-tenancy da aplicação.
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: TenantModule,
            providers: [
                TenantService,
                { provide: TENANT_CONFIG, useValue: config },
            ]
        };
    }
}
TenantModule.decorators = [
    { type: NgModule }
];
/** @nocollapse */
TenantModule.ctorParameters = () => [
    { type: TenantModule, decorators: [{ type: Inject, args: [TenantModule,] }, { type: Optional }, { type: SkipSelf }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TelaMenuGrpComponent {
    /**
     * @param {?} telaMenuGrpService
     */
    constructor(telaMenuGrpService) {
        this.telaMenuGrpService = telaMenuGrpService;
        this.telaMenuGrp = [];
        this.cliqueItemMenuGrp = new EventEmitter();
        this.showMenu = false;
        this.inside = false;
        this.isBgBlue = [];
        this.areaAberta = false;
        this.dataMenu = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(tag);
        this.telaMenuGrp.map((/**
         * @param {?} menu
         * @return {?}
         */
        menu => {
            this.isBgBlue.push({ uid: menu.uid, hasBgBlue: false });
        }));
        this.telaMenuGrpService.cliqueHomeGrp.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => {
            if (event) {
                this.dataMenu = [];
                this.isBgBlue.forEach((/**
                 * @param {?} config
                 * @return {?}
                 */
                config => {
                    config.hasBgBlue = false;
                }));
            }
        }));
    }
    /**
     * @param {?} produto
     * @return {?}
     */
    emiteCliqueItemMenuGrp(produto) {
        this.cliqueItemMenuGrp.emit(produto);
    }
    /**
     * gera a config para que saber quando intejar a classe hasBgBlue
     * quando clicado no array isBgBlue
     * @param {?} event
     * @param {?} row
     * @return {?}
     */
    isShowSubMenu(event, row) {
        event.stopPropagation();
        this.isBgBlue = [];
        /** @type {?} */
        const dados = [];
        dados.push(row);
        this.dataMenu = dados.splice(0, 1);
        if (row.submenu) {
            /** @type {?} */
            const genBgBlueTrue = this.telaMenuGrp.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => row === item && item.submenu));
            genBgBlueTrue.map((/**
             * @param {?} config
             * @return {?}
             */
            config => this.isBgBlue.push({ uid: config.uid, hasBgBlue: true })));
        }
        if (row.submenu === undefined) {
            /** @type {?} */
            const genBgBlueNonSub = this.telaMenuGrp.filter((/**
             * @param {?} item
             * @return {?}
             */
            item => row === item));
            genBgBlueNonSub.map((/**
             * @param {?} config
             * @return {?}
             */
            config => this.isBgBlue.push({ uid: config.uid, hasBgBlue: false })));
        }
        /** @type {?} */
        const genBgBlueFalse = this.telaMenuGrp.filter((/**
         * @param {?} item
         * @return {?}
         */
        item => row !== item));
        genBgBlueFalse.map((/**
         * @param {?} config
         * @return {?}
         */
        config => this.isBgBlue.push({ uid: config.uid, hasBgBlue: false })));
        this.isBgBlue.sort((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        (a, b) => {
            return (a.uid - b.uid);
        }));
        this.areaAberta = true;
    }
}
TelaMenuGrpComponent.decorators = [
    { type: Component, args: [{
                // tslint:disable-next-line:component-selector
                selector: 'govbr-tela-menu-grp',
                template: "<div class=\"tela-menu-grp\">\n  <div class=\"row\">\n    <ul class=\"menu\">\n      <!-- Controle de limitacao dos itens do menu atraves do slice -->\n      <li *ngFor=\"let row of telaMenuGrp | slice:0:18; let indx = index\">\n        <a (mouseenter)=\"uidHover = row.uid\" (mouseleave)=\"uidHover = null\" (click)=\"isShowSubMenu($event, row)\"\n          [ngClass]=\"{'hasntProduct': !telaMenuGrp[indx]?.clientePossuiProduto,\n                          'hasProduct': telaMenuGrp[indx]?.clientePossuiProduto,\n                          'bg-blue': isBgBlue[indx].hasBgBlue && telaMenuGrp[indx]?.clientePossuiProduto}\">\n          <mat-icon *ngIf=\"row.icone !== null && row?.icone\">{{ row.icone }}</mat-icon>\n          <!-- Controle de limitacao dos caracteres do item do menu atraves do slice -->\n          <p>{{ row.titulo | slice:0:30 }}</p>\n        </a>\n        <span *ngIf=\"!telaMenuGrp[indx]?.clientePossuiProduto && uidHover === row.uid\">Conhe\u00E7a a solu\u00E7\u00E3o</span>\n      </li>\n    </ul>\n    \n      <div class=\"dados-menu-direita\">\n        <div class=\"wrapper\" *ngIf=\"dataMenu[0]?.submenu; else defaultTemplate\">\n          <div class=\"titulo-produto\">\n            <h5>{{dataMenu[0]?.submenu[0]?.titulo}}</h5>\n            <mat-icon>auto_stories</mat-icon>\n          </div>\n          <div class=\"corpo-texto-produto\">\n            <p>{{dataMenu[0]?.submenu[0]?.texto}}</p>\n  \n            <!-- <button mat-raised-button class=\"govbr-button\" type=\"button\">\n              {{dataMenu[0]?.submenu[0]?.textoBotao}}\n            </button> -->\n          </div>\n  \n          <div class=\"titulo-produto\">\n            <h5>Produtos de {{dataMenu[0]?.titulo}}</h5>\n            <mat-icon>{{dataMenu[0]?.icone}}</mat-icon>\n          </div>\n  \n          <div class=\"wrapper-produto\">\n            <div class=\"row-produto\">\n              <div [ngClass]=\"{'hasProduct': dataMenu[0].clientePossuiProduto}\" class=\"box-produto\" *ngFor=\"let p of dataMenu[0]?.submenu[0]?.produtos\">\n                <p>{{p.titulo}}</p>\n                <govbr-menu-grp-button\n                [corBotao]=\"p.corBotao\"\n                [textoBotao] = \"p.textoBotao\"\n                (cliqueStatusProduto)=\"emiteCliqueItemMenuGrp(p)\" \n                class=\"button-grp\">\n                </govbr-menu-grp-button>\n              </div>\n            </div>\n          </div>\n  \n        </div>\n        <ng-template #defaultTemplate>\n          <div class=\"wrapper\">\n            <div class=\"titulo-produto\">\n              <h5>Governan\u00E7a Brasil</h5>\n              <mat-icon>auto_stories</mat-icon>\n            </div>\n            <div class=\"corpo-texto-produto\">\n              <p>Fazer uma boa gest\u00E3o municipal \u00E9 o caminho para construir um pa\u00EDs melhor para todos viverem. A GOVBR, empresa com mais de 50 anos de mercado, conhece a realidade dos munic\u00EDpios e est\u00E1 sempre inovando para contribuir na gest\u00E3o p\u00FAblica. Acreditamos que a transforma\u00E7\u00E3o digital das cidades gera resultados positivos para todos os cidad\u00E3os e contribui para um Brasil melhor!</p>\n            </div>\n    \n            <div class=\"titulo-produto\">\n              \n            </div>\n    \n            <div class=\"wrapper-produto\">\n              <div class=\"video-border\">\n                <div class=\"video-wrapper\">\n                  <youtube-player \n                    videoId=\"1bg2dq9vmIg\" \n                    suggestedQuality=\"highres\" \n                    [height]=\"250\" \n                    [width]=\"380\" \n                    [startSeconds]=\"4\"\n                    [endSeconds]=\"8\">\n                  </youtube-player>\n                </div>\n              </div>\n            </div>\n    \n          </div>\n        </ng-template>\n\n      </div>\n    \n  </div>\n</div>",
                styles: ["@charset \"UTF-8\";:host{height:calc(100vh - 200px);display:block}*{box-sizing:border-box}.tela-menu-grp{width:95%;margin:auto;max-height:522px;border-radius:5px;border:none;height:100%}.tela-menu-grp .row{flex-wrap:nowrap;justify-content:space-evenly}.menu,.submenu{gap:16px;width:100%;height:100%;display:flex;flex-flow:row wrap;padding:57px 0 0 57px}.menu{max-width:50rem;padding-left:0}.menu li{display:flex;flex-direction:column;list-style:none;padding-bottom:47px}.menu li .hasntProduct{color:#aaabac}.menu li .hasntProduct mat-icon,.menu li .hasntProduct p{cursor:default;color:#aaabac}.menu li .hasntProduct:hover{opacity:1}.menu li a{width:104px;height:104px;display:flex;flex-flow:column;align-items:center;justify-content:center;text-align:center}.menu li a p{height:50px;font-size:.813rem;padding:0 .313rem;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.menu li span{width:104px;font-size:.75rem;margin-top:4px;color:#aaabac}.menu li .hasProduct{display:block;max-width:100%;overflow:hidden;cursor:pointer}.menu li:nth-child(6n) a{margin-right:0}.menu li:hover{padding-bottom:27px}.menu li a mat-icon{font-size:1.8rem;vertical-align:middle;width:26px;height:26px;margin-bottom:7px;margin-top:13px}.is-father:hover .bg-blue{height:auto;border-radius:5px 5px 0 0}.is-father .submenu{border-radius:0 0 5px 5px}.is-father:hover .submenu{display:block}.submenu li{margin:0;padding:0;width:100%;height:auto;list-style:none}.submenu li a{padding:4px 10px 6px;height:auto;font-size:.813rem}.submenu{display:none;width:calc(25% - 30px);z-index:1}.last-child:hover{border-radius:0 0 5px 5px}.dados-menu-direita{padding:0;width:430px;margin-top:50px;max-height:570px}.dados-menu-direita .wrapper{width:412px}.dados-menu-direita .titulo-produto{display:flex;align-items:center;justify-content:space-between;border-bottom:2px solid #0395df}.dados-menu-direita .titulo-produto h5{font-weight:600;font-size:16px}.dados-menu-direita .titulo-produto .mat-icon{font-size:16px;width:17px;height:14px}.dados-menu-direita .corpo-texto-produto{margin-top:16px;margin-bottom:40px}.dados-menu-direita .corpo-texto-produto p{font-weight:400;color:#707070;font-size:13px;line-height:18px}.dados-menu-direita .corpo-texto-produto button.govbr-button{background:#0395df;color:#fff;width:94px;height:30px;border:none;border-radius:4px;margin-top:22px;outline:0;cursor:pointer}.dados-menu-direita .wrapper-produto{margin-top:50px}.dados-menu-direita .wrapper-produto .video-border{position:relative;border:1px solid rgba(3,149,223,.4);height:250px;width:380px}.dados-menu-direita .wrapper-produto .video-border .video-wrapper{height:250px;width:380px;position:absolute;left:21px;top:-22px}.dados-menu-direita .row-produto{display:flex;flex-wrap:wrap;gap:25px;margin-bottom:25px}@media (max-width:1366px){.menu,.submenu{padding-top:50px}.dados-menu-direita{margin-top:50px;max-height:480px}}@media (min-height:920px){.dados-menu-direita{max-height:700px}}@media (max-height:677px){.dados-menu-direita{margin-top:50px;max-height:400px}}@media (max-height:420px){.dados-menu-direita{margin-top:50px;max-height:250px}}"]
            }] }
];
/** @nocollapse */
TelaMenuGrpComponent.ctorParameters = () => [
    { type: TelaMenuGrpService }
];
TelaMenuGrpComponent.propDecorators = {
    telaMenuGrp: [{ type: Input }],
    cliqueItemMenuGrp: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TelaMenuGrpModule {
}
TelaMenuGrpModule.decorators = [
    { type: NgModule, args: [{
                declarations: [TelaMenuGrpComponent],
                imports: [
                    CommonModule,
                    MatIconModule,
                    HttpClientModule,
                    RouterModule,
                    ProdutosMenuGrpModule,
                    MatDialogModule,
                    YouTubePlayerModule
                ],
                exports: [
                    TelaMenuGrpComponent
                ],
                entryComponents: [
                    TelaMenuGrpComponent
                ],
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Classe que representa um item de menu vindo do backend
 */
class ItemTelaMenuGrp {
    /**
     * @param {?} uid
     * @param {?} titulo
     * @param {?=} icone
     * @param {?=} url
     * @param {?=} submenu
     * @param {?=} statusProduto
     * @param {?=} clientePossuiProduto
     */
    constructor(uid, titulo, icone, url, submenu, statusProduto, clientePossuiProduto) {
        this.uid = uid;
        this.titulo = titulo;
        this.icone = icone;
        this.url = url;
        this.submenu = submenu;
        this.statusProduto = statusProduto;
        this.clientePossuiProduto = clientePossuiProduto;
    }
}
class SubmenuItemMenuGrp {
    /**
     * @param {?} uid
     * @param {?} titulo
     * @param {?=} icone
     * @param {?=} url
     * @param {?=} textoBotao
     * @param {?=} texto
     * @param {?=} produtos
     */
    constructor(uid, titulo, icone, url, textoBotao, texto, produtos) {
        this.uid = uid;
        this.titulo = titulo;
        this.icone = icone;
        this.url = url;
        this.textoBotao = textoBotao;
        this.texto = texto;
        this.produtos = produtos;
    }
}
class ProdutoMenuGrp {
    /**
     * @param {?} uid
     * @param {?} titulo
     * @param {?=} url
     * @param {?=} textoBotao
     * @param {?=} corBotao
     */
    constructor(uid, titulo, url, textoBotao, corBotao) {
        this.uid = uid;
        this.titulo = titulo;
        this.url = url;
        this.textoBotao = textoBotao;
        this.corBotao = corBotao;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LgpdText {
    /**
     * @param {?=} title
     * @param {?=} body
     */
    constructor(title, body) {
        this.title = title;
        this.body = body;
        this.title = title;
        this.body = body;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RodapePortalComponent {
    /**
     * @param {?} router
     */
    constructor(router) {
        this.router = router;
        this.ano = new Date().getFullYear();
        this.itens = Array();
        this.dadosDaPrefeitura = Array();
        this.redesSociais = false;
        this.exibeAjuda = false;
        this.exibeChat = false;
        this.dadosDoSistema = false;
        this.redesSociaisInsitituicao = Array();
        this.corBase = 200;
        this.urlAcesso = new EventEmitter();
        this.isShown = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.imgLogo = '../../../assets/icons/marcaGovBR-institucional.svg';
        this.changeTheme(this.corBase);
    }
    // Função para verificar se o link é externo.
    /**
     * @param {?} url
     * @param {?} externalLink
     * @return {?}
     */
    openLink(url, externalLink) {
        this.urlAcesso.emit(url);
    }
    /**
     * @return {?}
     */
    toggleShow() {
        this.isShown = !this.isShown;
    }
    /**
     * @param {?} tipo
     * @return {?}
     */
    abrirPagina(tipo) {
        /** @type {?} */
        let urlArray = window.location.href.split("/");
        /** @type {?} */
        let qtdmaximobarramento = 6;
        /** @type {?} */
        let link = "";
        for (let i = 0; i < qtdmaximobarramento; i++) {
            if (i == 0)
                link = urlArray[i];
            else
                link = link + "/" + urlArray[i];
        }
        switch (tipo) {
            case "usarportal":
                window.open(link + "/usarportal", '_blank');
                break;
            case "glossario":
                window.open(link + "/glossario", '_blank');
                break;
            case "perguntas":
                window.open(link + "/perguntas", '_blank');
                break;
            case "manual":
                window.open(link + "/manual", '_blank');
                break;
            case "termouso":
                window.open(link + "/termouso", '_blank');
                break;
            case "privacidade":
                window.open(link + "/privacidade", '_blank');
                break;
        }
    }
    // Função para mudar a cor base do tema da variavel css pelo valor do input do usuário
    /**
     * @param {?} corBase
     * @return {?}
     */
    changeTheme(corBase) {
        document.documentElement.style.setProperty('--hue', corBase);
    }
}
RodapePortalComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-rodape-portal',
                template: "<div class=\"rodape-container\">\n    <div *ngIf=\"dadosDaPrefeitura.length > 0\" class=\"rodape-itens\">\n        <div class=\"item\">\n            <p class=\"item-titulo mg-bottom-0\">{{nomePrefeitura}}</p>\n            <div *ngFor=\"let dado of dadosDaPrefeitura\">\n                <p>{{dado.nomeDaRua}}, {{dado.numeroDaRua}}, {{dado.bairro}}</p>\n                <p>Cep {{dado.cep}} | {{dado.cidade}} \u2013 {{dado.estado}}</p>\n                <p>Telefone: {{dado.telefone}}</p>\n                <p>Hor\u00E1rio de atendimento: {{dado.horarioDeAtendimento}}</p>\n            </div>\n            <div *ngIf=\"redesSociais\" class=\"redes-sociais\">\n                <p class=\"item-titulo\">Redes Sociais</p>\n                <div class=\"link-redes-sociais\" *ngFor=\"let redeSocialInstituicao of redesSociaisInsitituicao\">\n                  <a class=\"a-rs\" href=\"{{ redeSocialInstituicao.link }}\" target=\"_blank\" rel=\"noopener noreferrer\">\n                      <img src=\"assets/images/{{redeSocialInstituicao.nome}}.png\" alt=\"Link para {{redeSocialInstituicao.nome}}\" />\n                  </a>\n                </div>\n            </div>\n            <p class=\"item-titulo mg-bottom-0\">Respons\u00E1vel t\u00E9cnico</p>\n            <p>{{responsavelTecnico}} (ID funcional: {{idFuncional}})</p>\n        </div>\n        <div *ngIf=\"itens.length\" class=\"item acesso-rapido\">\n            <p class=\"item-titulo\">Acesso r\u00E1pido</p>\n            <a *ngFor=\"let item of itens\" class=\"itens-acesso-rapido\" (click)=\"openLink(item.url, item.externalLink)\">\n                {{item.titulo}}\n            </a>\n        </div>\n        <div *ngIf=\"dadosDoSistema\" class=\"item\">\n            <p class=\"item-titulo\">Dados do sistema</p>\n            <p class=\"numero\">{{numeroUsuariosOnline}}</p>\n            <p class=\"mg-bottom\">usu\u00E1rios online</p>\n            <p class=\"numero\"><a href=\"#\">{{numeroAcessoSistema}}</a></p>\n            <p class=\"mg-bottom\">acessos (<a href=\"#\">baixar dados</a>)</p>\n            <p class=\"numero\">{{versaoDoSistema}}</p>\n            <p class=\"mg-bottom\">vers\u00E3o do sistema</p>\n            <p class=\"numero\">{{ultimaAtualizacao}}</p>\n            <p class=\"mg-bottom\">\u00FAltima atualiza\u00E7\u00E3o</p>\n        </div>\n    </div>\n    <div class=\"rodape-formas\">\n        <div class=\"rodape-dados\">\n            <div class=\"rodape-texto\">\n                <mat-icon>copyright</mat-icon>\n                <p>{{ano}} - Copyright GOVERNAN\u00C7ABRASIL S/A</p>\n                <mat-icon class=\"expandir-menu\">more_horiz\n                </mat-icon>\n                <div class=\"links\">\n                    <a (click)=\"abrirPagina('termouso')\" target=\"_blank\">Termos de uso</a>\n                    <!-- <a (click)=\"abrirPagina('privacidade')\" target=\"_blank\">Privacidade</a> -->\n                    <a *ngIf=\"exibeAjuda\" (click)=\"toggleShow()\" >Ajuda</a>\n                    <div *ngIf=\"isShown\" >\n                      <ul class=\"menu-drop-rodape\">\n                          <li class=\"a1 first\"><a (click)=\"abrirPagina('manual')\" target=\"_blank\">Manual de ajuda</a></li>\n                          <li class=\"a2\"><a (click)=\"abrirPagina('perguntas')\" target=\"_blank\">Perguntas Frequentes</a></li>\n                          <li class=\"a3\"><a (click)=\"abrirPagina('usarportal')\" target=\"_blank\">Como Usar o Portal</a></li>\n                          <li class=\"a4\"><a (click)=\"abrirPagina('glossario')\" target=\"_blank\">Gloss&aacute;rio</a></li>\n                      </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <button mat-icon-button  *ngIf=\"exibeChat\" class=\"rodape-chat\">\n            <mat-icon id=\"icone-rodape\">chat</mat-icon>\n        </button>\n        <div class=\"rodape-logo\">\n            <img [src]=\"imgLogo\" alt=\"Logo GOVBR Institucional\">\n        </div>\n    </div>\n</div>\n",
                styles: ["a{text-decoration:none;cursor:pointer}.menu-drop-rodape{list-style:none;display:inline-block;margin:0;padding:0;position:absolute;top:-221px;background-color:#fff}.menu-drop-rodape li{border-bottom:1px solid #ccc;border-right:1px solid #ccc;border-left:1px solid #ccc;padding:16px 22px 16px 40px;display:block;background-repeat:no-repeat;background-size:20px;background-position:10px center}.menu-drop-rodape li a{color:#28aef2!important;text-decoration:none;font-size:verdana}.menu-drop-rodape li.first{border-top:1px solid #ccc}.menu-drop-rodape li.a1{background-image:url(https://upload.wikimedia.org/wikipedia/commons/7/7d/Simpleicons_Business_note.svg)}.menu-drop-rodape li.a2{background-image:url(https://upload.wikimedia.org/wikipedia/commons/2/29/Comment_alt_font_awesome.svg)}.menu-drop-rodape li.a3{background-image:url(https://upload.wikimedia.org/wikipedia/commons/0/0e/Feather-core-file-plus.svg)}.menu-drop-rodape li.a4{background-image:url(https://upload.wikimedia.org/wikipedia/commons/b/b3/Book_font_awesome.svg)}div.rodape-container{overflow:hidden;-webkit-overflow-scrolling:touch}div.rodape-container p{font-size:.75rem}div.rodape-container div.rodape-itens{padding-top:15px;padding-bottom:0}div.rodape-container div.rodape-itens div.item{width:100%;margin:15px 0 15px 12px}div.rodape-container div.rodape-itens div.item p.item-titulo{font-weight:600;line-height:1.12rem;margin-bottom:5px;font-size:.813rem}div.rodape-container div.rodape-itens div.item p.item-titulo.mg-bottom-0{margin-bottom:0}div.rodape-container div.rodape-itens div.item .numero{font-size:.875rem;font-weight:600}div.rodape-container div.rodape-itens div.item .redes-sociais{margin-left:0;margin-top:24px;margin-bottom:20px}div.rodape-container div.rodape-itens div.item .redes-sociais a.rede-social+a.rede-social{margin-left:16px}div.rodape-container div.rodape-itens div.item .redes-sociais .link-redes-sociais{display:contents}div.rodape-container div.rodape-itens div.item .itens-acesso-rapido{line-height:24px;font-size:.75rem;display:block}div.rodape-container div.rodape-itens div.item:nth-child(2){padding-top:15px;width:280px;padding-bottom:12px;margin-right:12px}div.rodape-container div.rodape-formas{height:39px;display:flex;align-items:center;position:relative}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto{display:flex;align-items:center;font-weight:400;margin-left:13px;justify-content:flex-start;width:258%}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto p{display:none}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto mat-icon{font-size:14px;width:14px;height:14px}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto .expandir-menu{margin-left:20px;margin-bottom:10px;font-size:24px;cursor:pointer}div.rodape-container div.rodape-formas div.rodape-logo{height:0;width:218px;top:-8px;right:0;position:absolute}div.rodape-container div.rodape-formas div.rodape-logo img{width:95px;height:47px;position:absolute;top:-8px;left:0}div.rodape-container div.rodape-formas .rodape-chat{position:absolute;width:67px;right:135px;top:0;transform:skew(134deg);z-index:1;height:39px;border:none}div.rodape-container div.rodape-formas .rodape-chat mat-icon{position:relative;top:4px;left:2px;font-size:20px;transform:skew(-134deg);cursor:pointer}div.rodape-container div.rodape-formas .sem-chat p{font-size:12px;min-width:24px;white-space:pre}div.rodape-container div.rodape-formas .sem-chat p a{text-decoration:none}div.rodape-container div.rodape-formas .links{z-index:100;display:none}.mg-bottom{margin-bottom:6px}@media screen and (min-width:768px){div.rodape-container div.rodape-itens{padding:0;display:flex}div.rodape-container div.rodape-itens div.item{margin-left:16px;width:30%}div.rodape-container div.rodape-itens div.item:nth-child(2){margin-left:0;margin-right:0;padding:0 16px;width:30%;border-bottom:none;border-top:none}div.rodape-container div.rodape-itens div.item:last-child{margin-right:10px}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto p{display:block;margin-left:7px;-ms-grid-row-align:auto;align-self:auto;font-size:10px;padding-top:2px;white-space:pre;flex:1}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto .expandir-menu{display:none}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto .links{display:block;display:flex;align-self:flex-end;z-index:100}div.rodape-container div.rodape-formas div.rodape-dados div.rodape-texto .links a{font-size:.75rem;font-weight:400;line-height:16px;margin-left:20px}}"]
            }] }
];
/** @nocollapse */
RodapePortalComponent.ctorParameters = () => [
    { type: Router }
];
RodapePortalComponent.propDecorators = {
    itens: [{ type: Input }],
    imgLogo: [{ type: Input }],
    dadosDaPrefeitura: [{ type: Input }],
    redesSociais: [{ type: Input }],
    exibeAjuda: [{ type: Input }],
    exibeChat: [{ type: Input }],
    dadosDoSistema: [{ type: Input }],
    nomePrefeitura: [{ type: Input }],
    responsavelTecnico: [{ type: Input }],
    idFuncional: [{ type: Input }],
    numeroUsuariosOnline: [{ type: Input }],
    numeroAcessoSistema: [{ type: Input }],
    versaoDoSistema: [{ type: Input }],
    ultimaAtualizacao: [{ type: Input }],
    redesSociaisInsitituicao: [{ type: Input }],
    corBase: [{ type: Input }],
    urlAcesso: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RodapePortalModule {
}
RodapePortalModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    RodapePortalComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatTooltipModule,
                    RouterModule
                ],
                exports: [
                    RodapePortalComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DadosPrefeitura {
    /**
     * @param {?} nomeDaRua
     * @param {?} numeroDaRua
     * @param {?} bairro
     * @param {?} cep
     * @param {?} cidade
     * @param {?} estado
     * @param {?} telefone
     * @param {?} horarioDeAtendimento
     */
    constructor(nomeDaRua, numeroDaRua, bairro, cep, cidade, estado, telefone, horarioDeAtendimento) {
        this.nomeDaRua = nomeDaRua;
        this.numeroDaRua = numeroDaRua;
        this.bairro = bairro;
        this.cep = cep;
        this.cidade = cidade;
        this.estado = estado;
        this.telefone = telefone;
        this.horarioDeAtendimento = horarioDeAtendimento;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DadosLinks {
    /**
     * @param {?} titulo
     * @param {?} externalLink
     * @param {?} url
     */
    constructor(titulo, externalLink, url) {
        this.titulo = titulo;
        this.externalLink = externalLink;
        this.url = url;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RichTextComponent {
    constructor() {
        this.richTextContent = '';
        this.loaded = false;
        this.readonly = false;
        this.onTextChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.config = {
            allowedContent: false,
            forcePasteAsPlainText: true,
            toolbarGroups: [
                { name: 'clipboard', groups: ['clipboard', 'undo'] },
                { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
                { name: 'links', groups: ['links'] },
                { name: 'insert', groups: ['insert'] },
                { name: 'tools', groups: ['tools'] },
                { name: 'document', groups: ['mode', 'document', 'doctools'] },
                '/',
                { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
                { name: 'styles', groups: ['styles'] },
                { name: 'others', groups: ['others'] },
                { name: 'about', groups: ['about'] },
                { name: 'colors', groups: ['colors'] },
                { name: 'forms', groups: ['forms'] }
            ],
            removeButtons: 'Save,NewPage,Preview,Print,Templates,' +
                'SelectAll,Find,Replace,Form,Checkbox,Radio,TextField,' +
                'Textarea,Select,Button,ImageButton,HiddenField,Flash,Smiley,' +
                'PageBreak,Iframe,ShowBlocks,CopyFormatting,Subscript,Superscript,' +
                'Underline,CreateDiv,Language,BidiRtl,BidiLtr',
            removePlugins: 'elementspath,save,magicline',
            extraPlugins: 'divarea,smiley,justify,indentblock,colordialog',
            colorButton_foreStyle: {
                element: 'font',
                attributes: { 'color': '#(color)' }
            },
            height: 188,
            removeDialogTabs: 'image:advanced;link:advanced',
            format_tags: 'p;h1;h2;h3;pre;div'
        };
    }
    /**
     * @return {?}
     */
    onChange() {
        this.onTextChange.emit(this.richTextContent);
    }
    /**
     * @return {?}
     */
    onEditorChange() {
        this.onTextChange.emit(this.richTextContent);
    }
}
RichTextComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-rich-text',
                template: "<div [hidden]=\"loaded\">\n    <mat-progress-spinner style=\"margin-left: 43%;\" mode=\"indeterminate\" strokeWidth=\"8\" color=\"primary\">\n    </mat-progress-spinner>\n</div>\n\n<span [hidden]=\"!loaded\">\n    <ckeditor debounce=\"500\" (ready)=\"loaded = true\" [(ngModel)]=\"richTextContent\" [config]=\"config\"\n        (editorChange)=\"onEditorChange()\" (change)=\"onChange()\" [readonly]=\"loaded ? readonly : false\"></ckeditor>\n</span>"
            }] }
];
/** @nocollapse */
RichTextComponent.ctorParameters = () => [];
RichTextComponent.propDecorators = {
    richTextContent: [{ type: Input }],
    loaded: [{ type: Input }],
    readonly: [{ type: Input }],
    onTextChange: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RichTextModule {
}
RichTextModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    RichTextComponent
                ],
                imports: [
                    FormsModule,
                    CommonModule,
                    ReactiveFormsModule,
                    CKEditorModule,
                    MatProgressSpinnerModule
                ],
                exports: [
                    RichTextComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ErroService {
    /**
     * @param {?} backService
     * @param {?} httpBackend
     * @param {?} router
     * @param {?} oauthService
     * @param {?} backendSrv
     * @param {?} tenantService
     */
    constructor(backService, httpBackend, router, oauthService, backendSrv, tenantService) {
        this.backService = backService;
        this.httpBackend = httpBackend;
        this.router = router;
        this.oauthService = oauthService;
        this.backendSrv = backendSrv;
        this.tenantService = tenantService;
    }
    /**
     * @return {?}
     */
    getTelefones() {
        return this.backService.setNomeEndpoint('pronim/rest/telefones-contatos')
            .get('');
    }
    /**
     * @return {?}
     */
    getAllTelefones() {
        /** @type {?} */
        let headers = new HttpHeaders();
        headers =
            headers
                .set('Authorization', '')
                .set('X-Tenant-Municipio', '')
                .set('X-Tenant-Entidade', '')
                .set('Pronim-Service', 'pronim/rest/telefones-contatos');
        /** @type {?} */
        const newHttpClient = new BackendCommService(new HttpClient(this.httpBackend), this.oauthService, this.backendSrv, this.tenantService);
        return newHttpClient.setNomeEndpoint('pronim/rest/telefones-contatos')
            .get('listarTodos', { headers });
    }
    /**
     * @param {?} erro
     * @param {?=} status
     * @return {?}
     */
    processaErro(erro, status) {
        console.log(erro);
        if (status && status === 422 /* Unprocessable Entity */) {
            return `As seguintes ocorrências foram verificadas durante a validação: ${erro}`;
        }
        return 'Não foi possível executar a ação, revise os dados e tente novamente.';
    }
    /**
     * @param {?} tipoErro
     * @param {?=} messageType
     * @return {?}
     */
    redirectToError(tipoErro, messageType) {
        if (tipoErro === 'PERSONALIZADO') {
            console.log(`redirectToError`);
            this.router.navigate(['/erro'], {
                queryParams: {
                    tipo: 'PERSONALIZADO',
                    msg: messageType
                }
            });
        }
        else {
            console.log(`ñ personalizado`);
            this.router.navigate(['/erro'], {
                queryParams: {
                    tipo: tipoErro,
                    msg: messageType
                }
            });
        }
    }
}
ErroService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ErroService.ctorParameters = () => [
    { type: BackendCommService, decorators: [{ type: Inject, args: [BackendCommService,] }] },
    { type: HttpBackend },
    { type: Router },
    { type: OAuthService, decorators: [{ type: Inject, args: [OAuthService,] }] },
    { type: String, decorators: [{ type: Inject, args: [GESTAO_SERVICOS_URI,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }, { type: Optional }] }
];
/** @nocollapse */ ErroService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ErroService_Factory() { return new ErroService(ɵɵinject(BackendCommService), ɵɵinject(HttpBackend), ɵɵinject(Router), ɵɵinject(OAuthService), ɵɵinject(GESTAO_SERVICOS_URI), ɵɵinject(TenantService, 8)); }, token: ErroService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const TipoErro = {
    DESCONHECIDO: 0,
    ACESSO_NEGADO_AUTENTICACAO: 1,
    ROTA_INVALIDA: 2,
    LICENCA_INVALIDA: 3,
    PERSONALIZADO: 4,
};
TipoErro[TipoErro.DESCONHECIDO] = 'DESCONHECIDO';
TipoErro[TipoErro.ACESSO_NEGADO_AUTENTICACAO] = 'ACESSO_NEGADO_AUTENTICACAO';
TipoErro[TipoErro.ROTA_INVALIDA] = 'ROTA_INVALIDA';
TipoErro[TipoErro.LICENCA_INVALIDA] = 'LICENCA_INVALIDA';
TipoErro[TipoErro.PERSONALIZADO] = 'PERSONALIZADO';
/** @type {?} */
const defaultPathKey = 'default-path';
/** @type {?} */
const PARAM_TIPO_ERRO = 'tipo';
class TelaErroComponent {
    /**
     * @param {?} route
     * @param {?} locationService
     * @param {?} authService
     * @param {?} tenantService
     * @param {?} erroService
     * @param {?} router
     */
    constructor(route, locationService, authService, tenantService, erroService, router) {
        this.route = route;
        this.locationService = locationService;
        this.authService = authService;
        this.tenantService = tenantService;
        this.erroService = erroService;
        this.router = router;
        this.allTelephones = [];
        this.ano = new Date().getFullYear();
        this.siglas = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.tenantCaminhoUrl = this.tenantService.getTenant().municipio;
        this.entidadeCaminhoUrl = this.tenantService.getTenant().entidade;
        this.defaultPathValue = this.getUrl();
        localStorage.setItem(defaultPathKey, this.defaultPathValue);
        this.tenantCorreto = this.authService.buscarTenantPorIdOauth();
        this.entidadeCorreta = localStorage.getItem('default-path');
        if (this.entidadeCorreta) {
            /** @type {?} */
            let urlTenente;
            urlTenente = this.entidadeCorreta.split('/');
            this.nomeProdutoCorreto = urlTenente[urlTenente.length - 3];
            this.nomeProdutoCaminhoUrl = this.parseUrl(this.nomeProdutoCorreto, urlTenente);
            this.entidadeCorreta = this.parseUrl(urlTenente[urlTenente.length - 1], urlTenente);
        }
        /** @type {?} */
        const routeSnapshot = this.route.snapshot;
        /** @type {?} */
        const tipoErroString = routeSnapshot.queryParams[PARAM_TIPO_ERRO] ||
            routeSnapshot.data[PARAM_TIPO_ERRO];
        this.msgPersonalizada = routeSnapshot.queryParams.msg;
        this.tipo = TipoErro[tipoErroString]
            ? TipoErro[tipoErroString]
            : TipoErro.DESCONHECIDO;
        this.mostrarTelefones();
    }
    /**
     * @return {?}
     */
    get error() {
        return TipoErro;
    }
    /**
     * @param {?} number
     * @return {?}
     */
    formatPhoneNumber(number) {
        /** @type {?} */
        const phoneNumber = number.split('');
        phoneNumber.splice(4, 0, '-');
        return phoneNumber.join('');
    }
    /**
     * @param {?} state
     * @return {?}
     */
    showStateName(state) {
        switch (state) {
            case 'AC':
                this.stateName = 'Acre';
                break;
            case 'AL':
                this.stateName = 'Alagoas';
                break;
            case 'AP':
                this.stateName = 'Amapá';
                break;
            case 'AM':
                this.stateName = 'Amazonas';
                break;
            case 'BA':
                this.stateName = 'Bahia';
                break;
            case 'CE':
                this.stateName = 'Ceará';
                break;
            case 'DF':
                this.stateName = 'Distrito Federal';
                break;
            case 'ES':
                this.stateName = 'Espírito Santo';
                break;
            case 'GO':
                this.stateName = 'Goiás';
                break;
            case 'MA':
                this.stateName = 'Maranhão';
                break;
            case 'MT':
                this.stateName = 'Mato Grosso';
                break;
            case 'MS':
                this.stateName = 'Mato Grosso do Sul';
                break;
            case 'MG':
                this.stateName = 'Minas Gerais';
                break;
            case 'PA':
                this.stateName = 'Pará';
                break;
            case 'PB':
                this.stateName = 'Paraíba';
                break;
            case 'PR':
                this.stateName = 'Paraná';
                break;
            case 'PE':
                this.stateName = 'Pernambuco';
                break;
            case 'PI':
                this.stateName = 'Piauí';
                break;
            case 'RJ':
                this.stateName = 'Rio de Janeiro';
                break;
            case 'RN':
                this.stateName = 'Rio Grande do Norte';
                break;
            case 'RS':
                this.stateName = 'Rio Grande do Sul';
                break;
            case 'RO':
                this.stateName = 'Rondônia';
                break;
            case 'RR':
                this.stateName = 'Roraima';
                break;
            case 'SC':
                this.stateName = 'Santa Catarina';
                break;
            case 'SP':
                this.stateName = 'São Paulo';
                break;
            case 'SE':
                this.stateName = 'Sergipe';
                break;
            case 'TO':
                this.stateName = 'Tocantins';
                break;
        }
    }
    /**
     * @param {?} phones
     * @param {?} state
     * @return {?}
     */
    getFormattedNumbersByState(phones, state) {
        return phones
            .filter((/**
         * @param {?} phone
         * @return {?}
         */
        phone => phone.siglaEstado === state.value))
            .map((/**
         * @param {?} tel
         * @return {?}
         */
        tel => `(${tel.ddd}) ${this.formatPhoneNumber(tel.numero)}`))
            .join(' / ');
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    detectSelectChange($event) {
        /** @type {?} */
        const formattedPhones = this.getFormattedNumbersByState(this.allTelephones, $event);
        this.showStateName($event.value);
        this.telephoneNumber = `Telefone(s): ${formattedPhones}`;
    }
    /**
     * @return {?}
     */
    hasDefaultPath() {
        return !!this.locationService.getDefaultPath();
    }
    /**
     * @return {?}
     */
    previousPage() {
        /** @type {?} */
        const routeBack = localStorage.getItem('last-valid-path');
        this.router.navigateByUrl(routeBack);
    }
    /**
     * @return {?}
     */
    logOut() {
        this.authService.logout();
    }
    /**
     * @private
     * @param {?} valor
     * @param {?} camposUrl
     * @return {?}
     */
    parseUrl(valor, camposUrl) {
        /** @type {?} */
        let urlCorreta;
        if (camposUrl.includes(valor)) {
            camposUrl.forEach((/**
             * @param {?} campo
             * @return {?}
             */
            campo => {
                urlCorreta = campo === valor ? valor : urlCorreta;
            }));
        }
        return urlCorreta;
    }
    /**
     * @return {?}
     */
    mostrarTelefones() {
        if (this.tenantCorreto !== this.tenantCaminhoUrl ||
            this.entidadeCaminhoUrl !== this.entidadeCorreta) {
            this.erroService.getAllTelefones().subscribe((/**
             * @param {?} dados
             * @return {?}
             */
            dados => {
                this.allTelephones = dados;
                this.arraySiglas(dados);
            }));
        }
        else {
            this.erroService.getTelefones().subscribe((/**
             * @param {?} dados
             * @return {?}
             */
            dados => {
                this.allTelephones = dados;
                this.arraySiglas(dados);
            }));
        }
    }
    /**
     * @param {?} telefones
     * @return {?}
     */
    arraySiglas(telefones) {
        telefones.forEach((/**
         * @param {?} teles
         * @return {?}
         */
        (teles) => {
            /** @type {?} */
            let sigla = teles.siglaEstado;
            if (this.siglas.includes(sigla) === false) {
                this.siglas.push(sigla);
            }
        }));
        this.siglas.sort();
    }
    /**
     * @return {?}
     */
    getUrl() {
        return `${this.locationService.getCurrentOrigin()}${this.tenantService.getBaseUri()}`;
    }
}
TelaErroComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-tela-erro',
                template: "<div class=\"container d-flex-column\">\n    <header class=\"d-flex login-header\">\n        <img class=\"logo-gov\" src=\"assets/icons/marca-GOVBR.svg\" alt=\"Logo GOVBR\">\n    </header>\n    <main class=\"main-content\">\n        <div class=\"error-screen\">\n            <img src=\"assets/icons/exclamacao.svg\" class=\"error-screen-exclamation\" alt=\"Exclama\u00E7\u00E3o\">\n            <div>\n                <h1 id=\"errorAlert\" class=\"error-screen-title\">Aten\u00E7\u00E3o</h1>\n                <ng-container [ngSwitch]=\"tipo\">\n                    <p class=\"error-screen-subtitle\" *ngSwitchCase=\"error.DESCONHECIDO\">Erro desconhecido</p>\n                    <p class=\"error-screen-subtitle\" *ngSwitchCase=\"error.ROTA_INVALIDA\">Rota inv\u00E1lida ou incorreta.\n                        Favor verificar o endere\u00E7o digitado.</p>\n                    <p class=\"error-screen-subtitle\" *ngSwitchCase=\"error.ACESSO_NEGADO_AUTENTICACAO\">Desculpe. Voc\u00EA n\u00E3o\n                        possui permiss\u00E3o para acessar esta p\u00E1gina.\n                        Favor verificar o endere\u00E7o digitado.</p>\n                    <p class=\"error-screen-subtitle\" *ngSwitchCase=\"error.LICENCA_INVALIDA\">Licen\u00E7a inv\u00E1lida.</p>\n                    <p class=\"error-screen-subtitle\" *ngSwitchCase=\"error.PERSONALIZADO\">{{msgPersonalizada}}</p>\n                </ng-container>\n                <p id=\"errorMessageDescription\" class=\"error-screen-help-text\">Por favor, entre em contato com nossa\n                    \u00E1rea de relacionamento\n                    para maiores informa\u00E7\u00F5es.</p>\n                <div class=\"gov-custom-select\">\n                    <mat-form-field appearance=\"outline\" class=\"mg-option\">\n                        <mat-label>Selecione sua localidade</mat-label>\n                        <mat-select disableOptionCentering (selectionChange)=\"detectSelectChange($event)\">\n                            <mat-option *ngFor=\"let sigla of siglas\" [value]=\"sigla\">\n                                {{sigla}}\n                            </mat-option>\n                        </mat-select>\n                    </mat-form-field>\n                </div>\n                <p class=\"error-screen-help-text nome-estado\">{{stateName}}</p>\n                <p class=\"error-screen-help-text\">{{telephoneNumber}}</p>\n                <button class=\"govbr-button error-screen-actions\" type=\"button\" (click)=\"previousPage()\">Voltar</button>\n                <button class=\"govbr-button error-screen-actions\" type=\"button\" (click)=\"logOut()\">Sair</button>\n            </div>\n        </div>\n    </main>\n</div>\n<footer class=\"footer\">\n    <div class=\"container footer-text\">\n        <span class=\"material-icons\">\n            copyright\n        </span>\n        <pre>   {{ano}} - Copyright GOVERNAN\u00C7ABRASIL S/A</pre>\n    </div>\n</footer>",
                styles: ["@charset \"UTF-8\";.d-flex-column{flex-direction:column}.d-flex-center{align-items:center;justify-content:center}.login-header{align-items:baseline;justify-content:flex-start;padding-bottom:24px;padding-top:24px}.container{max-width:920px}body>div.container{height:690px}body>div.container.no-scroll{height:auto}.logo-gov{width:148px;height:74px}.gov-custom-select{margin-top:20px}.main-content{display:flex;align-items:center;justify-content:center;height:auto}.error-screen{padding:30px;margin:118px auto;border-radius:5px;width:558px;height:auto;position:relative}.error-screen-exclamation{position:absolute;top:-64px;left:410px}.error-screen-title{font-weight:600;font-style:normal;font-size:24px}.error-screen-subtitle{font-weight:600;font-style:normal;font-size:18px;margin-top:24px;line-height:20px;max-width:346px}.error-screen-help-text{font-weight:400;font-style:normal;font-size:13px;margin-top:0;line-height:20px}.error-screen-help-text.nome-estado{margin-top:20px;font-weight:700}p.error-screen-help-text{margin-bottom:0}label.error-screen-help-text{margin-top:0}.error-screen-help-text:nth-child(4){margin-top:15px}.v-hidden{visibility:hidden}.error-screen-actions{width:150px;height:40px;border-radius:5px;transition:.3s;margin-top:30px;display:inline-block;font-style:normal;font-weight:400;font-size:14px;line-height:19px;cursor:pointer}.error-screen-actions:first-of-type{margin-right:20px}.error-screen-actions:disabled{cursor:default}.footer{display:flex;position:fixed;top:calc(100% - 47px);height:47px;width:100%}.footer div{display:flex}.footer-text{align-items:center;justify-content:flex-start}.footer-text *{font-weight:400;font-size:14px}.footer-text pre{font-size:10px;padding-top:3px;margin:0;font-family:\"Nunito Sans\",\"Helvetica Neue\",sans-serif}"]
            }] }
];
/** @nocollapse */
TelaErroComponent.ctorParameters = () => [
    { type: ActivatedRoute, decorators: [{ type: Inject, args: [ActivatedRoute,] }] },
    { type: LocationService, decorators: [{ type: Inject, args: [LocationService,] }] },
    { type: AuthService, decorators: [{ type: Inject, args: [AuthService,] }] },
    { type: TenantService, decorators: [{ type: Inject, args: [TenantService,] }, { type: Optional }] },
    { type: ErroService },
    { type: Router }
];
TelaErroComponent.propDecorators = {
    panelClass: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HistoricoRouterService {
    /**
     * @param {?} router
     */
    constructor(router) {
        this.router = router;
    }
    /**
     * @return {?}
     */
    getLastRouteValid() {
        this.router.events
            .pipe(filter((/**
         * @param {?} evt
         * @return {?}
         */
        evt => evt instanceof NavigationEnd)))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        (event) => {
            /** @type {?} */
            const childrens = this.router.config[0].children;
            /** @type {?} */
            const isValidPath = childrens.filter((/**
             * @param {?} child
             * @return {?}
             */
            child => `/${child.path}` === event.url));
            if (!event.url.includes('erro') && isValidPath.length) {
                this.setLocalStorage(`/${event.url}`);
            }
            else {
                this.setLocalStorage(`${event.url}`);
            }
        }));
    }
    /**
     * @param {?} path
     * @return {?}
     */
    setLocalStorage(path) {
        localStorage.setItem('last-valid-path', path);
    }
}
HistoricoRouterService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
HistoricoRouterService.ctorParameters = () => [
    { type: Router }
];
/** @nocollapse */ HistoricoRouterService.ngInjectableDef = ɵɵdefineInjectable({ factory: function HistoricoRouterService_Factory() { return new HistoricoRouterService(ɵɵinject(Router)); }, token: HistoricoRouterService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TelaErroModule {
}
TelaErroModule.decorators = [
    { type: NgModule, args: [{
                declarations: [TelaErroComponent],
                imports: [
                    CommonModule,
                    MatInputModule,
                    MatIconModule,
                    MatSelectModule
                ],
                exports: [TelaErroComponent],
                providers: [ErroService, HistoricoRouterService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DadosCabecalhoPortal {
    /**
     * @param {?} nomePrefeitura
     * @param {?} nomeProduto
     * @param {?} logoProduto
     * @param {?=} itens
     */
    constructor(nomePrefeitura, nomeProduto, logoProduto, itens) {
        this.nomePrefeitura = nomePrefeitura;
        this.nomeProduto = nomeProduto;
        this.logoProduto = logoProduto;
        this.itens = itens;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CabecalhoPortalComponent {
    constructor() {
        this.entered = false;
        this.corBase = 200;
        this.habilitaVlibras = false;
        this.urlMenu = new EventEmitter();
        this.link = new EventEmitter();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onResize(event) {
        this.widthPage = window.innerWidth;
        this.widthPageValue();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.changeTheme(this.corBase);
        this.widthPage = window.innerWidth;
        this.widthPageValue();
    }
    /**
     * Função para redirecionar, através do teclado, a navegação na página para o conteúdo, menu e busca.
     * @param {?} el
     * @return {?}
     */
    scroll(el) {
        el.scrollIntoView();
    }
    /**
     * Função para mudar a cor base do tema da variável CSS pelo valor do input do usuário.
     * @param {?} corBase
     * @return {?}
     */
    changeTheme(corBase) {
        document.documentElement.style.setProperty('--hue', corBase);
    }
    /**
     * @param {?} menuUrl
     * @return {?}
     */
    linkEvent(menuUrl) {
        this.urlMenu.emit(menuUrl);
    }
    /**
     * Hover para "scrollar" o mat-icon do search
     * @param {?} entered
     * @return {?}
     */
    onHoverVLibras(entered) {
        this.entered = entered;
        this.widthPageValue();
    }
    /**
     * Envia os valores dos margins para scroll do mat-icon do search
     * @return {?}
     */
    widthPageValue() {
        if (this.widthPage >= 769) {
            this.openedHover = `11.875rem`;
            this.closedHover = `5.625rem`;
        }
        else {
            this.openedHover = `5.625rem`;
            this.closedHover = `0rem`;
        }
    }
}
CabecalhoPortalComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-cabecalho-portal',
                template: "<div class=\"cabecalho-container\">\n  <div class=\"links\">\n    <div class=\"esquerda\">\n    <a (click)=\"linkEvent('scrollconteudo')\" tabindex=\"1\" accesskey=\"1\">\n        Ir para o conte\u00FAdo <span class=\"num-index\">1</span>\n    </a>\n    <a (click)=\"linkEvent('scrollmenu')\" tabindex=\"2\" accesskey=\"2\">\n        Ir para o menu <span class=\"num-index\">2</span>\n    </a>\n    <a (click)=\"scroll(busca)\" tabindex=\"3\" accesskey=\"3\">\n        Ir para a busca <span class=\"num-index\">3</span>\n    </a>\n    </div>\n    <div class=\"direita\">\n        <a (click)=\"linkEvent('acessibilidade')\">Acessibilidade</a>\n        <a (click)=\"linkEvent('altocontraste')\">Alto contraste</a>\n        <a (click)=\"linkEvent('mapa')\"> Mapa do site</a>\n    </div>\n</div>\n  <div class=\"principal\">\n    <div class=\"logo-produto\">\n      <a (click)=\"linkEvent('home')\">\n        <img src=\"{{ dadosCabecalhoPortal?.logoProduto }}\" style=\"width: 150px; height: 60px;\" alt=\"Logo Produto\" />\n      </a>\n    </div>\n    <div  class=\"itens-navegacao\">\n      <span #busca>\n        <mat-icon class=\"icone-search\">search</mat-icon>\n      </span>\n      <div *ngIf=\"habilitaVlibras\" class=\"vlibras-widget\" [style.width]=\"entered === true ? openedHover : closedHover\">\n        <gov-vlibras-widget\n        (mouseover)=\"onHoverVLibras(true)\"\n        (mouseout)=\"onHoverVLibras(false)\"></gov-vlibras-widget>\n      </div>\n      <button class=\"menu-hamburguer\">\n        <mat-icon [inline]=\"true\">menu</mat-icon>\n      </button>\n    </div>\n  </div>\n  <div class=\"nome-prefeitura\">\n    <div class=\"nomeprefeitura\">\n      <p>{{ dadosCabecalhoPortal?.nomePrefeitura}}</p>\n    </div>\n    <div class=\"linksBarra\">\n      <div *ngFor=\"let item of dadosCabecalhoPortal?.itens\">\n          <a (click)=\"linkEvent(item.url)\" target=\"_blank\">{{ item.nome }}</a>\n      </div>\n    </div>\n  </div>\n  <div class=\"nome-produto\">\n    <a (click)=\"linkEvent('home')\">\n      {{ dadosCabecalhoPortal?.nomeProduto }}\n    </a>\n  </div>\n</div>\n",
                styles: ["@media screen and (max-width:768px){div.cabecalho-container{display:flex;flex-direction:column;width:100%}div.cabecalho-container div.tab-index{display:none}div.cabecalho-container div.links{font-style:normal;font-weight:400;font-size:.68rem;line-height:15px;padding-left:12px;padding-right:12px}div.cabecalho-container div.links a{text-decoration:none;margin-top:6px;margin-bottom:4px}div.cabecalho-container div.links .esquerda{cursor:pointer;float:left}div.cabecalho-container div.links .direita{cursor:pointer;float:right}div.cabecalho-container div.linksBarra{font-style:normal;font-weight:400;font-size:.68rem;line-height:15px;padding-left:12px;padding-right:12px;justify-content:flex-end;width:90%;cursor:pointer}div.cabecalho-container div.linksBarra a{text-decoration:none;margin-top:6px;margin-bottom:4px}div.cabecalho-container div.principal{display:flex;align-items:center;padding:20px 12px 16px;justify-content:space-around}div.cabecalho-container div.principal div.logo-produto img{height:42px;max-width:150px}div.cabecalho-container div.principal div.logo-produto{flex:1}div.cabecalho-container div.principal div.itens-navegacao{display:flex;align-items:center;align-self:center;margin-right:.938rem}div.cabecalho-container div.principal div.itens-navegacao mat-icon{cursor:pointer;vertical-align:middle}div.cabecalho-container div.principal div.itens-navegacao span{margin-right:3.125rem}div.cabecalho-container div.principal div.itens-navegacao .vlibras-widget{width:5.625rem;transition:.5s}div.cabecalho-container div.principal div.itens-navegacao img{cursor:pointer;margin-left:10px}div.cabecalho-container div.principal div.itens-navegacao button.menu-hamburguer{border:none;width:24px;height:24px;cursor:pointer;margin-left:10px;justify-content:center;align-items:center}div.cabecalho-container div.principal div.itens-navegacao button.menu-hamburguer mat-icon{font-size:24px;margin-right:0;vertical-align:middle}div.cabecalho-container div.nomeprefeitura{left:0;right:0;height:30px;align-items:center}div.cabecalho-container div.nomeprefeitura p{font-family:Nunito Sans;font-style:normal;font-weight:700;font-size:12px;line-height:16px;padding-left:12px}div.cabecalho-container div.nomeprefeitura a{display:none}div.cabecalho-container div.nome-prefeitura{left:0;right:0;height:30px;display:flex;align-items:center}div.cabecalho-container div.nome-prefeitura p{font-family:Nunito Sans;font-style:normal;font-weight:700;font-size:12px;line-height:16px;padding-left:12px}div.cabecalho-container div.nome-prefeitura a{display:none}div.cabecalho-container div.nome-produto{margin-top:16px}div.cabecalho-container div.nome-produto a{text-decoration:none;font-family:Nunito Sans;font-style:normal;font-weight:700;font-size:22px;line-height:24px;padding-left:12px;text-transform:uppercase}}@media screen and (min-width:769px){div.cabecalho-container{display:flex;flex-direction:column;width:100%}div.cabecalho-container div.tab-index{display:flex;font-family:Nunito Sans;font-style:normal;font-weight:400;font-size:11px;line-height:15px;padding-left:0;margin-top:-16px}div.cabecalho-container div.tab-index a{text-decoration:none;margin:0 32px 0 0}div.cabecalho-container div.tab-index .num-index{width:12px;height:12px;position:absolute;border-radius:50%;margin-top:1px;margin-left:5px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Open Sans\",\"Helvetica Neue\",sans-serif;font-style:normal;font-weight:500;font-size:9px;line-height:11px;text-align:center}div.cabecalho-container div.links{font-style:normal;font-weight:400;font-size:.68rem;line-height:15px;padding-left:0;padding-right:0}div.cabecalho-container div.links a{text-decoration:none;margin:6px 16px 4px 4px}div.cabecalho-container div.links .esquerda{float:left}div.cabecalho-container div.links .direita{float:right}div.cabecalho-container div.linksBarra{display:flex;font-style:normal;font-weight:400;font-size:.68rem;line-height:15px;padding-left:0;padding-right:0;justify-content:flex-end;width:90%;cursor:pointer}div.cabecalho-container div.linksBarra a{text-decoration:none;margin:6px 16px 4px 4px}div.principal{display:flex;align-items:center;padding:4px 16px 16px;justify-content:space-around}div.principal div.logo-produto img{height:42px;max-width:200px}div.principal div.logo-produto{flex:1}div.principal div.itens-navegacao{display:block;align-items:center;-ms-grid-row-align:center;align-self:center;margin-top:18px;margin-right:0}div.principal div.itens-navegacao mat-icon{margin-left:10px}div.principal div.itens-navegacao .vlibras-widget{transition:.5s}div.principal div.itens-navegacao img{margin-left:10px}div.principal div.itens-navegacao button.menu-hamburguer,div.principal div.itens-navegacao button.menu-hamburguer mat-icon{display:none}div.nome-prefeitura{left:0;right:0;height:30px;display:flex;align-items:center}div.nome-prefeitura p{font-family:Nunito Sans;font-style:normal;font-weight:700;font-size:12px;line-height:16px;padding-left:16px}div.nome-prefeitura a{text-decoration:none;font-family:Nunito Sans;font-style:normal;font-weight:600;font-size:13px;line-height:18px;padding-right:16px}div.nome-produto{text-align:center;margin-top:-75px;margin-left:25%;max-width:50%}div.nome-produto a{text-decoration:none;font-family:Nunito Sans;font-style:normal;font-weight:700;font-size:22px;line-height:30px;padding-left:0}}"]
            }] }
];
/** @nocollapse */
CabecalhoPortalComponent.ctorParameters = () => [];
CabecalhoPortalComponent.propDecorators = {
    dadosCabecalhoPortal: [{ type: Input }],
    corBase: [{ type: Input }],
    habilitaVlibras: [{ type: Input }],
    urlMenu: [{ type: Output }],
    link: [{ type: Output }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VlibrasWidgetComponent {
    constructor() { }
}
VlibrasWidgetComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-vlibras-widget',
                template: "<div vw class=\"enabled\">\n    <div vw-access-button class=\"active\">\n    </div>\n    <div vw-plugin-wrapper>\n      <div class=\"vw-plugin-top-wrapper\"></div>\n    </div>\n</div>",
                styles: ["@media screen and (max-width:768px){div[vw]{top:35.5%;padding:0 1rem;right:47px}}@media screen and (min-width:769px){div[vw]{top:35.5%;padding:0 1rem;right:0}}"]
            }] }
];
/** @nocollapse */
VlibrasWidgetComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VlibrasWidgetModule {
}
VlibrasWidgetModule.decorators = [
    { type: NgModule, args: [{
                declarations: [VlibrasWidgetComponent],
                imports: [CommonModule],
                exports: [VlibrasWidgetComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CabecalhoPortalModule {
}
CabecalhoPortalModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    CabecalhoPortalComponent
                ],
                imports: [
                    CommonModule,
                    MatIconModule,
                    VlibrasWidgetModule,
                    RouterModule
                ],
                exports: [
                    CabecalhoPortalComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuSlideComponent {
    /**
     * @param {?} router
     * @param {?} renderer
     */
    constructor(router, renderer) {
        this.router = router;
        this.renderer = renderer;
        this.items = [];
        this.urlMenu = new EventEmitter();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onResize(event) {
        this.innerWidth = window.innerWidth;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.innerWidth = window.innerWidth;
    }
    /**
     * @return {?}
     */
    showText() {
        this.isReadMore = !this.isReadMore;
        /** @type {?} */
        let menus = (/** @type {?} */ (document.getElementsByClassName("hide")));
        for (let index = 0; index < menus.length; index++) {
            /** @type {?} */
            const element = menus[index];
            if (this.isReadMore)
                element.style.visibility = "visible";
            else
                element.style.visibility = "collapse";
        }
    }
    /**
     * @param {?} menuUrl
     * @return {?}
     */
    linkEvent(menuUrl) {
        this.urlMenu.emit(menuUrl);
    }
    /**
     * @param {?} submenuUrl
     * @return {?}
     */
    routerLinkEvent(submenuUrl) {
        this.router.navigate([submenuUrl]);
    }
    /**
     * @return {?}
     */
    isSectionMenuLarge() {
        if (this.sectionMenuLarge === null) {
            return true;
        }
        return this.sectionMenuLarge;
    }
}
MenuSlideComponent.decorators = [
    { type: Component, args: [{
                // tslint:disable-next-line:component-selector
                selector: 'gov-menu-slide',
                template: "<div class=\"menu-slide-container\" [ngClass]=\"{'alt-auto': abreFechaMenuMobile}\">\n  <div class=\"d-flex-row\" [ngClass]=\"{'limitTextHeight': isReadMore}\">\n    <div class=\"wrap-item\" [ngClass]=\"{'hide': (j > 8 && isSectionMenuLarge())}\" *ngFor=\"let item of items ; index as j\">\n      <div *ngIf=\"item.submenu.length > 0\" class=\"item-menu\">\n        <mat-icon>{{item.icone}}</mat-icon>\n        <!-- adicionar essa verificacao -->\n        <h3 *ngIf=\"item.submenu.length > 0\">{{item.titulo}}</h3>\n       <h3> <a (click)=\"linkEvent(item.url)\" *ngIf=\"item.submenu.length == 0\">{{item.titulo}}</a> </h3>\n        <!-- /adicionar essa verificacao -->\n      </div>\n  \n      <div class=\"item-submenu\">\n        <ul *ngFor=\"let submenu of item.submenu ; index as i\">\n          <li> <h3> <a (click)=\"linkEvent(submenu.url)\">{{submenu.titulo}}</a> </h3> </li>\n          <div *ngIf=\"item.submenu[i].submenu\" class=\"item-submenu1\">\n            <ul *ngFor=\"let submenu1 of item.submenu[i].submenu\">\n              <li> <h3> <a (click)=\"linkEvent(submenu1.url)\">{{submenu1.titulo}}</a> </h3> </li>\n            </ul>\n          </div>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <br />\n\n  <button class=\"govbr-button abre-fecha-menu\" *ngIf=\"botaoAbrirMais && items.length > 9\" type=\"button\" (click)=\"showText()\">\n    <span>{{ isReadMore ? 'Mostrar menos': 'Mostrar mais' }}</span>\n    <hr>\n    <mat-icon [ngClass]=\"{'rotate': isReadMore}\">arrow_forward_ios</mat-icon>\n  </button>\n\n\n  <!-- ========== MENU MOBILE/TABLET =========== -->\n  <mat-accordion class=\"govbr-accordion\" *ngIf=\"abreFechaMenuMobile\">\n\n    <mat-expansion-panel *ngFor=\"let nivel1 of items;\">\n      <mat-expansion-panel-header>\n        <mat-panel-title>\n          <mat-icon>{{nivel1.icone}}</mat-icon>\n          <p *ngIf=\"nivel1.submenu.length > 0\">{{nivel1.titulo}}</p>\n          <a (click)=\"linkEvent(nivel1.url)\" *ngIf=\"nivel1.submenu.length == 0\">{{nivel1.titulo}}</a>\n        </mat-panel-title>\n      </mat-expansion-panel-header>\n      <ul *ngFor=\"let nivel2 of nivel1.submenu ; index as i\">\n        <li><a (click)=\"linkEvent(nivel2.url)\" [ngClass]=\"{'link-bold': nivel2.submenu?.length > 0}\">{{nivel2.titulo}}</a></li>\n        <div *ngIf=\"nivel2.submenu?.length > 0\" class=\"item-nivel-3\">\n          <ul *ngFor=\"let nivel3 of nivel2.submenu\">\n            <li><a (click)=\"linkEvent(nivel3.url)\">{{nivel3.titulo}}</a></li>\n          </ul>\n        </div>\n      </ul>\n    </mat-expansion-panel>\n  </mat-accordion>\n</div>\n\n",
                styles: [".menu-slide-container{padding:0 5px 25px;max-width:1220px;margin:auto}.d-flex-row{display:flex;justify-content:center;flex-wrap:wrap;width:100%;margin:auto;height:110px}.wrap-item{margin:0 9px 20px;position:relative}.wrap-item:hover{z-index:2;margin-bottom:0}.wrap-item:hover .item-submenu,.wrap-item:hover .item-submenu1{display:block;border-top-left-radius:0}.wrap-item:hover .item-menu{height:123px;padding-bottom:15px;margin-bottom:0;border-bottom:none;border-bottom-right-radius:0;border-bottom-left-radius:0}.item-menu{text-decoration:none;display:flex;flex-direction:column;align-items:center;justify-content:center;border-radius:5px;height:110px;width:110px;min-width:110px;padding:0 10px;text-align:center;position:relative}.item-menu h3{font-family:\"Nunito Sans\";font-size:12px;margin-top:8px;font-weight:400}.item-submenu{text-decoration:none;position:absolute;display:none;z-index:-1;width:320px;top:120px;left:0;text-align:left;padding:12px;font-family:\"Nunito Sans\";font-size:12px;border-radius:5px}.item-submenu:hover{display:block;border-top-left-radius:0}.item-submenu ul{display:block;text-decoration:none;margin-bottom:15px}.item-submenu ul:last-child{margin-bottom:0}.item-submenu ul h3{font-family:\"Nunito Sans\";font-size:12px;font-weight:400}.item-submenu ul:hover .item-submenu1{display:block;text-decoration:none}.item-submenu1{display:none;text-decoration:none;z-index:-1;left:0;text-align:left;padding-top:15px;padding-left:50px;font-family:\"Nunito Sans\";font-size:12px;border-radius:5px}.item-submenu1:hover{display:block;border-top-left-radius:0;text-decoration:none}.item-submenu1 ul{display:block;text-decoration:none;margin-bottom:15px}.item-submenu1 ul:last-child{margin-bottom:0}.limitTextHeight{height:auto}.limitTextHeight .wrap-item:nth-child(n+5):nth-child(-n+12){opacity:1;max-height:123px}.hide{visibility:collapse}button.abre-fecha-menu{outline:0;background-color:transparent;border:none;cursor:pointer;font-size:12px;font-family:\"Nunito Sans\";width:100%;max-width:80rem;display:flex;justify-content:space-between;align-items:center;margin:0 auto}button.abre-fecha-menu span{width:100px;position:relative;top:-2px}button.abre-fecha-menu hr{width:100%}ul,ul li a{list-style-type:none;text-decoration:none}.govbr-accordion{display:none}@media screen and (min-width:1339px){.wrap-item:nth-child(18):hover .item-submenu,.wrap-item:nth-child(27):hover .item-submenu,.wrap-item:nth-child(36):hover .item-submenu,.wrap-item:nth-child(45):hover .item-submenu,.wrap-item:nth-child(54):hover .item-submenu,.wrap-item:nth-child(63):hover .item-submenu,.wrap-item:nth-child(72):hover .item-submenu,.wrap-item:nth-child(81):hover .item-submenu,.wrap-item:nth-child(9):hover .item-submenu,.wrap-item:nth-child(90) .wrap-item:last-child:hover .item-submenu{left:inherit;right:0;border-top-left-radius:5px}}@media screen and (min-width:1281px) and (max-width:1300px){.wrap-item:nth-child(n+9):nth-child(-n+12){opacity:0;max-height:0}}@media screen and (min-width:1063px) and (max-width:1280px){.wrap-item:nth-child(18):hover .item-submenu,.wrap-item:nth-child(27):hover .item-submenu,.wrap-item:nth-child(36):hover .item-submenu,.wrap-item:nth-child(45):hover .item-submenu,.wrap-item:nth-child(54):hover .item-submenu,.wrap-item:nth-child(63):hover .item-submenu,.wrap-item:nth-child(72):hover .item-submenu,.wrap-item:nth-child(81):hover .item-submenu,.wrap-item:nth-child(9):hover .item-submenu,.wrap-item:nth-child(90):hover .item-submenu{left:inherit;right:0;border-top-left-radius:5px}}@media screen and (min-width:933px) and (max-width:1062px){.wrap-item:nth-child(n+8):nth-child(-n+12){opacity:0;max-height:0}.wrap-item:last-child:hover .item-submenu,.wrap-item:nth-child(14):hover .item-submenu,.wrap-item:nth-child(21):hover .item-submenu,.wrap-item:nth-child(28):hover .item-submenu,.wrap-item:nth-child(35):hover .item-submenu,.wrap-item:nth-child(42):hover .item-submenu,.wrap-item:nth-child(49):hover .item-submenu,.wrap-item:nth-child(56):hover .item-submenu,.wrap-item:nth-child(63):hover .item-submenu,.wrap-item:nth-child(7):hover .item-submenu,.wrap-item:nth-child(70):hover .item-submenu,.wrap-item:nth-child(77):hover .item-submenu,.wrap-item:nth-child(84):hover .item-submenu,.wrap-item:nth-child(91):hover .item-submenu{left:inherit;right:0;border-top-left-radius:5px}}@media screen and (min-width:803px) and (max-width:932px){.wrap-item:nth-child(n+7):nth-child(-n+12){opacity:0;max-height:0}.wrap-item:nth-child(12):hover .item-submenu,.wrap-item:nth-child(18):hover .item-submenu,.wrap-item:nth-child(24):hover .item-submenu,.wrap-item:nth-child(30):hover .item-submenu,.wrap-item:nth-child(36):hover .item-submenu,.wrap-item:nth-child(42):hover .item-submenu,.wrap-item:nth-child(48):hover .item-submenu,.wrap-item:nth-child(54):hover .item-submenu,.wrap-item:nth-child(6):hover .item-submenu,.wrap-item:nth-child(60):hover .item-submenu,.wrap-item:nth-child(66):hover .item-submenu,.wrap-item:nth-child(72):hover .item-submenu,.wrap-item:nth-child(78):hover .item-submenu,.wrap-item:nth-child(84):hover .item-submenu,.wrap-item:nth-child(90):hover .item-submenu,.wrap-item:nth-child(96):hover .item-submenu{left:inherit;right:0;border-top-left-radius:5px}.limitTextHeight{height:auto}}@media screen and (min-width:803px) and (max-width:822px){.wrap-item:nth-child(11):hover .item-submenu{left:inherit;right:0;border-top-left-radius:5px}}@media screen and (min-width:769px) and (max-width:802px){.wrap-item:nth-child(n+6):nth-child(-n+12){opacity:0;max-height:0}.wrap-item:nth-child(10):hover .item-submenu,.wrap-item:nth-child(15):hover .item-submenu,.wrap-item:nth-child(20):hover .item-submenu,.wrap-item:nth-child(25):hover .item-submenu,.wrap-item:nth-child(30):hover .item-submenu,.wrap-item:nth-child(35):hover .item-submenu,.wrap-item:nth-child(40):hover .item-submenu,.wrap-item:nth-child(45):hover .item-submenu,.wrap-item:nth-child(5):hover .item-submenu,.wrap-item:nth-child(50):hover .item-submenu,.wrap-item:nth-child(55):hover .item-submenu,.wrap-item:nth-child(60):hover .item-submenu,.wrap-item:nth-child(65):hover .item-submenu,.wrap-item:nth-child(70):hover .item-submenu,.wrap-item:nth-child(75):hover .item-submenu,.wrap-item:nth-child(80):hover .item-submenu,.wrap-item:nth-child(85):hover .item-submenu,.wrap-item:nth-child(90):hover .item-submenu,.wrap-item:nth-child(95):hover .item-submenu{left:inherit;right:0;border-top-left-radius:5px}.limitTextHeight{height:auto}}@media screen and (max-width:768px){.menu-slide-container .d-flex-row,.wrap-item,button.abre-fecha-menu{display:none}.menu-slide-container{height:0}.menu-slide-container.alt-auto{height:auto}.govbr-accordion{display:block;position:relative;z-index:10}.govbr-accordion .mat-expansion-panel{border-radius:0}.govbr-accordion .mat-expansion-panel:not(.mat-expanded){height:40px}.govbr-accordion .mat-expansion-panel-spacing{margin:0}.govbr-accordion .mat-expansion-panel-header{padding:0 10px}.govbr-accordion .mat-expansion-panel-header.mat-expanded,.govbr-accordion .mat-expansion-panel-header:not(.mat-expanded){max-height:40px}.govbr-accordion .mat-expansion-panel-header-title{align-items:center}.govbr-accordion .mat-expansion-panel-header-title .mat-icon{margin-right:20px}.govbr-accordion .mat-expansion-panel-header-title a,.govbr-accordion .mat-expansion-panel-header-title p{font-size:14px}.govbr-accordion a{cursor:pointer}.govbr-accordion a.link-bold{font-weight:600}.govbr-accordion .item-nivel-3{padding-left:16px}}"]
            }] }
];
/** @nocollapse */
MenuSlideComponent.ctorParameters = () => [
    { type: Router },
    { type: Renderer2 }
];
MenuSlideComponent.propDecorators = {
    items: [{ type: Input }],
    isReadMore: [{ type: Input }],
    botaoAbrirMais: [{ type: Input }],
    sectionMenuLarge: [{ type: Input }],
    urlMenu: [{ type: Output }],
    abreFechaMenuMobile: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MenuSlideModule {
}
MenuSlideModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    MenuSlideComponent
                ],
                imports: [
                    CommonModule,
                    MatMenuModule,
                    RouterModule,
                    MatIconModule,
                    MatExpansionModule
                ],
                exports: [
                    MenuSlideComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const toastAnimations = {
    fadeToast: trigger("fadeAnimation", [
        state("default", style({ opacity: 1 })),
        transition("void => *", [
            style({ opacity: 0, transform: "translateY(800%)" }),
            animate("{{ fadeIn }}ms"),
        ]),
        transition("default => closing", animate("{{ fadeOut }}ms", style({ opacity: 0, transform: "translateY(800%)" }))),
    ]),
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastRef {
    /**
     * @param {?} overlay
     */
    constructor(overlay) {
        this.overlay = overlay;
    }
    /**
     * @return {?}
     */
    close() {
        this.overlay.dispose();
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastService {
    /**
     * @param {?} overlay
     * @param {?} parentInjector
     */
    constructor(overlay, parentInjector) {
        this.overlay = overlay;
        this.parentInjector = parentInjector;
        this.toastQueue = [];
        this.count = 0;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    show(data) {
        /** @type {?} */
        const positionStrategy = this.getPositionStrategy();
        /** @type {?} */
        const overlayRef = this.overlay.create({ positionStrategy });
        /** @type {?} */
        const toastRef = new ToastRef(overlayRef);
        /** @type {?} */
        const injector = this.getInjector(data, toastRef, this.parentInjector);
        /** @type {?} */
        const toastPortal = new ComponentPortal(ToastComponent, null, injector);
        overlayRef.attach(toastPortal);
        return toastRef;
    }
    /**
     * @return {?}
     */
    getPositionStrategy() {
        return this.overlay
            .position()
            .global()
            .right()
            .bottom();
    }
    /**
     * @param {?} data
     * @param {?} toastRef
     * @param {?} parentInjector
     * @return {?}
     */
    getInjector(data, toastRef, parentInjector) {
        /** @type {?} */
        const tokens = new WeakMap();
        tokens.set(ToastData, data);
        tokens.set(ToastRef, toastRef);
        return new PortalInjector(parentInjector, tokens);
    }
}
ToastService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
ToastService.ctorParameters = () => [
    { type: Overlay },
    { type: Injector }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastComponent {
    /**
     * @param {?} overlay
     * @param {?} parentInjector
     * @param {?} data
     * @param {?} ref
     * @param {?} toastConfig
     * @param {?} toastService
     */
    constructor(overlay, parentInjector, data, ref, toastConfig, toastService) {
        this.overlay = overlay;
        this.parentInjector = parentInjector;
        this.data = data;
        this.ref = ref;
        this.toastConfig = toastConfig;
        this.toastService = toastService;
        this.animationState = 'default';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.closeTime = this.toastConfig.animation.close;
        this.intervalId = setTimeout((/**
         * @return {?}
         */
        () => (this.animationState = 'closing')), this.closeTime);
        this.checkIcon();
        this.closeToastByQuantityOfCharacters();
        this.setButtonCloseTrueByDefault();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        clearTimeout(this.intervalId);
    }
    // funcao do botão de fechar da mensagem de toast
    /**
     * @return {?}
     */
    close() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.ref.close();
            clearTimeout(this.intervalId);
            if (this.toastService.toastQueue.length > 0) {
                this.pushQueuedToast();
            }
            else {
                this.toastService.count = 0;
                return true;
            }
        }), this.toastConfig.animation.fadeOut);
    }
    // funcao fechar toast pela quantidade de caracteres
    /**
     * @return {?}
     */
    closeToastByQuantityOfCharacters() {
        if (this.data.text.length <= 60) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.ref.close();
                clearTimeout(this.intervalId);
            }), 5000);
        }
        if (this.data.text.length <= 100) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.ref.close();
                clearTimeout(this.intervalId);
            }), 8000);
        }
        if (this.data.text.length > 100) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.ref.close();
                clearTimeout(this.intervalId);
            }), 12000);
        }
    }
    // funcao após o término completo da animação de fechar o toast e abrir um novo toast da fila
    /**
     * @param {?} event
     * @return {?}
     */
    onFadeFinished(event) {
        const { toState } = event;
        /** @type {?} */
        const isFadeOut = ((/** @type {?} */ (toState))) === 'closing';
        /** @type {?} */
        const itFinished = this.animationState === 'closing';
        if (isFadeOut && itFinished) {
            this.ref.close();
            if (this.toastService.toastQueue.length > 0) {
                this.pushQueuedToast();
            }
            else {
                this.toastService.count = 0;
                return true;
            }
        }
    }
    // funcao de abrir uma nova mensagem de toast que está na fila
    /**
     * @return {?}
     */
    pushQueuedToast() {
        /** @type {?} */
        const overlayRef = this.overlay.create();
        /** @type {?} */
        const toastRef = new ToastRef(overlayRef);
        /** @type {?} */
        const injector = this.toastService.getInjector(this.toastService.toastQueue[0], toastRef, this.parentInjector);
        /** @type {?} */
        const toastPortal = new ComponentPortal(ToastComponent, null, injector);
        overlayRef.attach(toastPortal);
        this.toastService.toastQueue.shift();
        this.toastService.count -= 1;
        return toastRef;
    }
    // funcao para exibir o botão de fechar como padrao do toast, caso o valor seja nulo
    /**
     * @return {?}
     */
    setButtonCloseTrueByDefault() {
        if (this.data.closeButton == null) {
            this.data.closeButton = true;
        }
    }
    // atribui o icone de acordo com o tipo do toast
    /**
     * @return {?}
     */
    checkIcon() {
        switch (this.data.type) {
            case 'success':
                this.icone = 'done';
                break;
            case 'danger':
                this.icone = 'block';
                break;
            case 'info':
                this.icone = 'info';
                break;
            case 'warning':
                this.icone = 'report_problem';
                break;
        }
        return this.icone;
    }
}
ToastComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-toast',
                template: "<div class=\"toast {{data.type}}\" [@fadeAnimation]=\"{value: animationState, params:\n        { fadeIn: toastConfig.animation.fadeIn, fadeOut: toastConfig.animation.fadeOut }}\"\n  (@fadeAnimation.done)=\"onFadeFinished($event)\">\n  <div class=\"container\">\n    <mat-icon>{{ icone }}</mat-icon>\n    <div class=\"conteudo\">\n      <p *ngIf=\"data.title\" class=\"titulo\">{{ data.title }}</p>\n      <p class=\"mensagem\">{{ data.text }}</p>\n    </div>\n  </div>\n  <div *ngIf=\"data.closeButton\" class=\"btn-fechar\" (click)=\"close()\">\n    <mat-icon id=\"{{data.type}}\">close</mat-icon>\n  </div>\n</div>\n",
                animations: [toastAnimations.fadeToast],
                styles: [".toast{display:flex;min-width:230px;max-width:380px;border-radius:4px}.toast .container{margin:16px 0}.toast .container mat-icon{margin:auto 16px}.toast .container .conteudo{display:-ms-grid;display:grid;align-items:center}.toast .container .conteudo .titulo{font-family:\"Nunito Sans\";font-size:20px;line-height:18px;font-weight:600;text-align:left;margin-bottom:16px}.toast .container .conteudo .mensagem{font-family:\"Nunito Sans\";font-size:14px;line-height:20px;font-weight:400;text-align:left;word-break:break-word}.toast .btn-fechar{display:flex;cursor:pointer;margin:8px;height:32px}.toast .btn-fechar #danger,.toast .btn-fechar #info,.toast .btn-fechar #success,.toast .btn-fechar #warning{display:flex;align-items:center;justify-content:center;padding:10px;opacity:50%;border-radius:4px;font-size:18px}"]
            }] }
];
/** @nocollapse */
ToastComponent.ctorParameters = () => [
    { type: Overlay },
    { type: Injector },
    { type: ToastData },
    { type: ToastRef },
    { type: undefined, decorators: [{ type: Inject, args: [TOAST_CONFIG_TOKEN,] }] },
    { type: ToastService }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ToastModule {
    /**
     * @param {?=} config
     * @return {?}
     */
    static forRoot(config = defaultToastConfig) {
        return {
            ngModule: ToastModule,
            providers: [
                {
                    provide: TOAST_CONFIG_TOKEN,
                    useValue: config,
                },
                ToastService,
            ],
        };
    }
}
ToastModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                    MatIconModule
                ],
                declarations: [ToastComponent],
                entryComponents: [ToastComponent],
                exports: [ToastComponent],
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelectEntidadeComponent {
    constructor() {
        this.entidades = [];
        this.botaoSair = new EventEmitter();
        this.emitirSelectedEntidade = new EventEmitter();
        this.hide = true;
        this.date = new Date().getFullYear();
        this.loginForm = new FormGroup({
            user: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required]),
            selectEntidade: new FormControl('', [Validators.required, Validators.nullValidator])
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.createForm();
        this.loginForm.patchValue({
            user: this.dadosLogin.usuario,
            password: this.dadosLogin.senha
        });
    }
    /**
     * @return {?}
     */
    createForm() {
        this.loginForm = new FormGroup({
            user: new FormControl('', [Validators.required, Validators.nullValidator]),
            password: new FormControl('', [Validators.required, Validators.nullValidator]),
            selectEntidade: new FormControl('', [Validators.required])
        });
    }
    /**
     * Método para detectar o valor do select ao clicar no botão IR / Enviar.
     * @param {?} event
     * @return {?}
     */
    onSelectedEntidade(event) {
        this.selectedEntidade = {
            titulo: event.value[0].titulo,
            uid: event.value[0].uid
        };
    }
    /**
     * @return {?}
     */
    salvarSelectedEntidade() {
        this.emitirSelectedEntidade.emit(this.selectedEntidade);
    }
    /**
     * Método para detectar o clique no botão de sair.
     * @return {?}
     */
    capturaCliqueBotaoSair() {
        this.botaoSair.emit(true);
    }
    /**
     * Define altura do select de acordo com a quantidade de itens.
     * @return {?}
     */
    definirAlturaSelect() {
        this.totalItensSelect = this.entidades.length;
        if (this.totalItensSelect === 1) {
            this.selectHeight = 40;
            return this.selectHeight;
        }
        else if (this.totalItensSelect === 2) {
            this.selectHeight = 80;
            return this.selectHeight;
        }
        else {
            this.selectHeight = 120;
        }
    }
}
SelectEntidadeComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-select-entidade',
                template: "<div class=\"container\">\n  <header class=\"header-page\">\n    <div class=\"header-itens\">\n      <img src=\"assets/icons/marca-GOVBR.svg\" alt=\"GOVBR\">\n      <div class=\"links\">\n        <a href=\"#\">Acesso a informa\u00E7\u00E3o</a>\n        <a href=\"#\">Alto contraste</a>\n      </div>\n    </div>\n  </header>\n  <main class=\"main-content\">\n    <div class=\"content\">\n      <h1>Ol\u00E1! Seja bem-vindo!</h1>\n      <p>\n        A GOVBR est\u00E1 ao seu lado para elevar a sua cidade a outro patamar.\n        <br />\n        <br />\n        Uma empresa que conhece as necessidades dos brasileiros porque est\u00E1\n        presente em todas as regi\u00F5es, e possui uma equipe especializada em\n        gest\u00E3o p\u00FAblica, sempre pr\u00F3xima de voc\u00EA.\n      </p>\n\n      <p class=\"info\">\n        <span class=\"titulo-info\">GOVBR</span>\n        <br />\n        Servi\u00E7os de tecnologia para a gest\u00E3o p\u00FAblica com governan\u00E7a.\n      </p>\n    </div>\n    <div class=\"form-content\">\n      <div class=\"form-title\">\n        <h1>Acesse sua conta GOVBR</h1>\n        <p>\n          Estamos ao seu lado para contribuir com cidades mais digitais e um\n          Brasil melhor.\n        </p>\n      </div>\n      <span class=\"botao-sair\">\n        <a (click)=\"capturaCliqueBotaoSair()\">[x] Sair</a>\n      </span>\n\n      <form class=\"form\" [formGroup]=\"loginForm\">\n        <div class=\"form-group\">\n          <mat-form-field appearance=\"outline\" class=\"govbr-form-field\">\n            <input\n              matInput\n              readonly\n              placeholder=\"Usu\u00E1rio\"\n              formControlName=\"user\"\n              required\n            />\n          </mat-form-field>\n          <mat-form-field appearance=\"outline\" class=\"govbr-form-field\">\n            <input\n              matInput\n              readonly\n              placeholder=\"Senha\"\n              [type]=\"hide ? 'password' : 'text'\"\n              formControlName=\"password\"\n              required\n            />\n            <button disabled mat-icon-button matSuffix (click)=\"hide = !hide\">\n              <mat-icon>{{ hide ? \"visibility\" : \"visibility_off\" }}</mat-icon>\n            </button>\n          </mat-form-field>\n        </div>\n        <div class=\"select-entidade\">\n          <mat-form-field class=\"govbr-form-field select\" appearance=\"outline\">\n            <mat-select\n              class=\"govbr-select select-entidade\"\n              formControlName=\"selectEntidade\"\n              disableOptionCentering\n              placeholder=\"Por favor, selecione a entidade\"\n              (selectionChange)=\"onSelectedEntidade($event)\"\n              panelClass=\"govbr-select select-entidade\"\n              required\n            >\n              \n                <mat-option\n                  *ngFor=\"let entidade of entidades; let isFirst = first\"\n                  [class.first-element]=\"isFirst\"\n                  [value]=\"entidade.submenu\"\n                >\n                  {{ entidade.submenu[0].titulo }}\n                </mat-option>\n              \n            </mat-select>\n          </mat-form-field>\n          <button\n            class=\"govbr-button\"\n            id=\"botao-ir\"\n            type=\"submit\"\n            (click)=\"salvarSelectedEntidade()\"\n            [disabled]=\"loginForm.invalid\"\n          >\n            IR\n          </button>\n        </div>\n      </form>\n    </div>\n  </main>\n  <footer class=\"footer-page\">\n    <mat-icon>copyright</mat-icon>\n    <p>{{date}} - Copyright GOVERNAN\u00C7ABRASIL S/A</p>\n  </footer>\n</div>\n",
                styles: ["div.container{display:flex;justify-content:center;align-items:center;flex-direction:column;height:100vh;margin:0;width:100%}div.container header.header-page{width:904px}div.container header.header-page div.header-itens{margin-top:23px;display:flex;align-items:center;justify-content:space-between}div.container header.header-page div.header-itens img{margin-bottom:35px;width:157px;height:76px}div.container header.header-page div.header-itens div.links{margin-top:30px}div.container header.header-page div.header-itens div.links a{text-decoration:none;font-size:.8rem;font-weight:400;line-height:19px}div.container header.header-page div.header-itens div.links a+a{margin-left:32px}div.container main.main-content{flex:1;display:flex;width:904px;justify-content:space-between}div.container main.main-content div.content{max-width:300px}div.container main.main-content div.form-content{max-width:320px}div.container main.main-content div.form-content form.form div.select-entidade{display:flex;align-items:center;justify-content:space-between}div.container main.main-content div.form-content form.form div.select-entidade #botao-ir{height:40px;width:40px;margin-top:10px;border-radius:4px;font-family:Nunito Sans;font-style:normal;font-weight:700;font-size:.8125rem;line-height:18px}div.container main.main-content div.form-content .botao-sair{display:flex;justify-content:flex-end;margin-bottom:4px}div.container main.main-content div.form-content .botao-sair a{height:16px;width:40px;cursor:pointer;text-decoration:none;font-family:Nunito Sans;font-style:normal;font-weight:400;font-size:12px;line-height:16px}div.container main.main-content div.content,div.container main.main-content div.form-title{text-align:initial;display:flex;flex-direction:column}div.container main.main-content div.content h1,div.container main.main-content div.form-title h1{font-size:1.4rem;font-weight:400;line-height:34px;margin-bottom:8px}div.container main.main-content div.content p,div.container main.main-content div.form-title p{font-size:.7rem;line-height:17px;font-weight:400}div.container main.main-content div.content p.info,div.container main.main-content div.form-title p.info{align-self:flex-end;font-size:.7rem;font-weight:400;line-height:16px;margin-top:68px}div.container main.main-content div.content p.info .titulo-info,div.container main.main-content div.form-title p.info .titulo-info{font-weight:700}div.container main.main-content div.content,div.container main.main-content div.form-content{margin-top:99px}div.container footer.footer-page{display:flex;align-items:center;width:100%;height:47px}div.container footer.footer-page p{margin-left:5px;font-size:.6rem;font-weight:400;line-height:13px}div.container footer.footer-page mat-icon.mat-icon{margin-left:1%;font-size:.8rem;width:14px;height:14px}.container-select-entidade{margin:5px 10px 0 0;height:120px;overflow-y:scroll}"]
            }] }
];
/** @nocollapse */
SelectEntidadeComponent.ctorParameters = () => [];
SelectEntidadeComponent.propDecorators = {
    dadosLogin: [{ type: Input }],
    entidades: [{ type: Input }],
    botaoSair: [{ type: Output }],
    emitirSelectedEntidade: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelectEntidadeModule {
}
SelectEntidadeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [SelectEntidadeComponent],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatFormFieldModule,
                    MatInputModule,
                    ReactiveFormsModule,
                    MatButtonModule,
                    MatCheckboxModule,
                    MatSelectModule,
                    FormsModule
                ],
                exports: [
                    SelectEntidadeComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CodeBlockComponent {
    constructor() {
        this.tabs = [];
        this.clicked = false;
        this.buttonMatIcon = 'keyboard_arrow_down';
    }
    /**
     * @return {?}
     */
    exibirCodigo() {
        this.clicked = !this.clicked;
        this.clicked ? this.buttonMatIcon = 'keyboard_arrow_up' : this.buttonMatIcon = 'keyboard_arrow_down';
    }
}
CodeBlockComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-code-block',
                template: "<div class=\"exibir-codigo\">\n  <h4 class=\"exibir-codigo-phrase\">Exibir c\u00F3digo fonte</h4>\n  <button mat-mini-fab class=\"button-arrow-drop-down\" (click)=\"exibirCodigo()\">\n    <mat-icon>{{ buttonMatIcon }}</mat-icon>\n  </button>\n</div>\n\n<div class=\"govbr-code\" *ngIf=\"clicked\">\n  <mat-tab-group class=\"govbr-tab-group\" mat-align-tabs=\"center\" dynamicHeight>\n    <mat-tab *ngFor=\"let tab of tabs\" [label]=\"tab.nome\">\n      <pre class=\"pre\">\n        <code [highlight]=\"tab.code\" [lineNumbers]=\"true\"></code>\n      </pre>\n    </mat-tab>\n  </mat-tab-group>\n</div>",
                styles: ["div.exibir-codigo{display:flex;margin-top:20px;margin-left:10px;justify-content:center}h4.exibir-codigo-phrase{width:143px;font-weight:unset}button.button-arrow-drop-down{display:flex;justify-content:center;align-items:center;height:24px;width:23px;box-shadow:none}div.govbr-code{display:flex;justify-content:center;margin-top:40px}pre{position:relative;width:800px;height:244px;display:block;overflow:scroll}code{position:absolute;top:0;left:0;width:100%;font-size:1em}"]
            }] }
];
/** @nocollapse */
CodeBlockComponent.ctorParameters = () => [];
CodeBlockComponent.propDecorators = {
    tabs: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
const ɵ0$1 = ({
    lineNumbers: true
});
class CodeBlockModule {
}
CodeBlockModule.decorators = [
    { type: NgModule, args: [{
                declarations: [CodeBlockComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    HighlightModule,
                    MatTabsModule,
                    MatIconModule$1,
                    MatButtonModule$1
                ],
                providers: [
                    {
                        provide: HIGHLIGHT_OPTIONS,
                        useValue: (/** @type {?} */ (ɵ0$1))
                    }
                ],
                exports: [
                    CodeBlockComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CodeSnippet {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IncomingMessageDTO {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewTableRegisterComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
ViewTableRegisterComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-view-table-register',
                template: "<div class=\"mais-detalhes\" govMovableArea>\n  <div class=\"area\" govMovable>\n    <div class=\"icone\">\n      <mat-icon aria-hidden=\"false\">drag_handle</mat-icon>\n    </div>\n    <div class=\"view-content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>",
                styles: [":host{position:fixed;top:calc(100vh - 310px);width:100%}:host div.mais-detalhes{position:relative;width:100%;height:300px;margin-top:10px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host div.mais-detalhes div.area{padding:10px 25px;height:100%;position:absolute;width:100%;top:100px}:host div.mais-detalhes div.area div.icone{cursor:pointer;text-align:center}:host div.mais-detalhes div.area div.view-content{overflow-y:scroll;max-height:250px}"]
            }] }
];
/** @nocollapse */
ViewTableRegisterComponent.ctorParameters = () => [];
ViewTableRegisterComponent.propDecorators = {
    tipoPessoa: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DraggableDirective {
    /**
     * @param {?} element
     */
    constructor(element) {
        this.element = element;
        this.draggable = true;
        // to trigger pointer-events polyfill
        this.touchAction = 'none';
        this.dragStart = new EventEmitter();
        this.dragMove = new EventEmitter();
        this.dragEnd = new EventEmitter();
        this.dragging = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onPointerDown(event) {
        this.dragging = true;
        this.dragStart.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onPointerMove(event) {
        if (!this.dragging) {
            return;
        }
        this.dragMove.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onPointerUp(event) {
        if (!this.dragging) {
            return;
        }
        this.dragging = false;
        this.dragEnd.emit(event);
    }
}
DraggableDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govDraggable]'
            },] }
];
/** @nocollapse */
DraggableDirective.ctorParameters = () => [
    { type: ElementRef }
];
DraggableDirective.propDecorators = {
    draggable: [{ type: HostBinding, args: ['class.draggable',] }],
    touchAction: [{ type: HostBinding, args: ['attr.touch-action',] }],
    dragStart: [{ type: Output }],
    dragMove: [{ type: Output }],
    dragEnd: [{ type: Output }],
    dragging: [{ type: HostBinding, args: ['class.dragging',] }],
    onPointerDown: [{ type: HostListener, args: ['pointerdown', ['$event'],] }],
    onPointerMove: [{ type: HostListener, args: ['document:pointermove', ['$event'],] }],
    onPointerUp: [{ type: HostListener, args: ['document:pointerup', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MovableDirective extends DraggableDirective {
    /**
     * @param {?} sanitizer
     * @param {?} element
     */
    constructor(sanitizer, element) {
        super(element);
        this.sanitizer = sanitizer;
        this.element = element;
        this.movable = true;
        this.position = { x: 0, y: 0 };
        this.reset = false;
    }
    /**
     * @return {?}
     */
    get transform() {
        return this.sanitizer.bypassSecurityTrustStyle(`translateX(${this.position.x}px) translateY(${this.position.y}px)`);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDragStart(event) {
        this.startPosition = {
            x: event.clientX - this.position.x,
            y: event.clientY - this.position.y
        };
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDragMove(event) {
        this.position.x = event.clientX - this.startPosition.x;
        this.position.y = event.clientY - this.startPosition.y;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onDragEnd(event) {
        if (this.reset) {
            this.position = { x: 0, y: 0 };
        }
    }
}
MovableDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govMovable]'
            },] }
];
/** @nocollapse */
MovableDirective.ctorParameters = () => [
    { type: DomSanitizer },
    { type: ElementRef }
];
MovableDirective.propDecorators = {
    transform: [{ type: HostBinding, args: ['style.transform',] }],
    movable: [{ type: HostBinding, args: ['class.movable',] }],
    reset: [{ type: Input, args: ['govMovableReset',] }],
    onDragStart: [{ type: HostListener, args: ['dragStart', ['$event'],] }],
    onDragMove: [{ type: HostListener, args: ['dragMove', ['$event'],] }],
    onDragEnd: [{ type: HostListener, args: ['dragEnd', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MovableAreaDirective {
    /**
     * @param {?} element
     */
    constructor(element) {
        this.element = element;
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.movables.changes.subscribe((/**
         * @return {?}
         */
        () => {
            this.subscriptions.forEach((/**
             * @param {?} s
             * @return {?}
             */
            s => s.unsubscribe()));
            this.movables.forEach((/**
             * @param {?} movable
             * @return {?}
             */
            movable => {
                this.subscriptions.push(movable.dragStart.subscribe((/**
                 * @return {?}
                 */
                () => this.measureBoundaries(movable))));
                this.subscriptions.push(movable.dragMove.subscribe((/**
                 * @return {?}
                 */
                () => this.maintainBoundaries(movable))));
            }));
        }));
        this.movables.notifyOnChanges();
    }
    /**
     * @private
     * @param {?} movable
     * @return {?}
     */
    measureBoundaries(movable) {
        /** @type {?} */
        const viewRect = this.element.nativeElement.getBoundingClientRect();
        /** @type {?} */
        const movableClientRect = movable.element.nativeElement.getBoundingClientRect();
        this.boundaries = {
            minX: viewRect.left - movableClientRect.left + movable.position.x,
            maxX: viewRect.right - movableClientRect.right + movable.position.x,
            minY: viewRect.top - movableClientRect.top + movable.position.y,
            // 310 (altura do componente) - 100 (top inicial do componente) - 50 (altura mínima)
            maxY: 160
        };
    }
    /**
     * @private
     * @param {?} movable
     * @return {?}
     */
    maintainBoundaries(movable) {
        movable.position.x = Math.max(this.boundaries.minX, movable.position.x);
        movable.position.x = Math.min(this.boundaries.maxX, movable.position.x);
        movable.position.y = Math.max(this.boundaries.minY, movable.position.y);
        movable.position.y = Math.min(this.boundaries.maxY, movable.position.y);
    }
}
MovableAreaDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govMovableArea]'
            },] }
];
/** @nocollapse */
MovableAreaDirective.ctorParameters = () => [
    { type: ElementRef }
];
MovableAreaDirective.propDecorators = {
    movables: [{ type: ContentChildren, args: [MovableDirective,] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DraggableHelperDirective {
    /**
     * @param {?} draggable
     * @param {?} templateRef
     * @param {?} viewContainerRef
     * @param {?} overlay
     */
    constructor(draggable, templateRef, viewContainerRef, overlay) {
        this.draggable = draggable;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
        this.overlay = overlay;
        this.positionStrategy = new GlobalPositionStrategy();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.draggable.dragStart.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => this.onDragStart(event)));
        this.draggable.dragMove.subscribe((/**
         * @param {?} event
         * @return {?}
         */
        event => this.onDragMove(event)));
        this.draggable.dragEnd.subscribe((/**
         * @return {?}
         */
        () => this.onDragEnd()));
        // create an overlay...
        this.overlayRef = this.overlay.create({
            positionStrategy: this.positionStrategy
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        // remove the overlay...
        this.overlayRef.dispose();
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    onDragStart(event) {
        // determine relative start position
        /** @type {?} */
        const clientRect = this.draggable.element.nativeElement.getBoundingClientRect();
        this.startPosition = {
            x: event.clientX - clientRect.left,
            y: event.clientY - clientRect.top
        };
    }
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    onDragMove(event) {
        if (!this.overlayRef.hasAttached()) {
            // render the helper in the overlay
            this.overlayRef.attach(new TemplatePortal(this.templateRef, this.viewContainerRef));
        }
        // position the helper...
        this.positionStrategy.left(`${event.clientX - this.startPosition.x}px`);
        this.positionStrategy.top(`${event.clientY - this.startPosition.y}px`);
        this.positionStrategy.apply();
    }
    /**
     * @private
     * @return {?}
     */
    onDragEnd() {
        // remove the helper from the overlay
        this.overlayRef.detach();
    }
}
DraggableHelperDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govDraggableHelper]',
                exportAs: 'govDraggableHelper'
            },] }
];
/** @nocollapse */
DraggableHelperDirective.ctorParameters = () => [
    { type: DraggableDirective },
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: Overlay }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DraggableModule {
}
DraggableModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    OverlayModule
                ],
                declarations: [DraggableDirective, MovableDirective, MovableAreaDirective, DraggableHelperDirective],
                exports: [DraggableDirective, MovableDirective, MovableAreaDirective, DraggableHelperDirective]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ViewTableRegisterModule {
}
ViewTableRegisterModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ViewTableRegisterComponent
                ],
                imports: [
                    CommonModule,
                    DraggableModule,
                    MatIconModule
                ],
                exports: [
                    ViewTableRegisterComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TituloFuncionalidadeComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
TituloFuncionalidadeComponent.decorators = [
    { type: Component, args: [{
                selector: 'gov-titulo-funcionalidade',
                template: "<div class=\"govbr-titulo\">\n    <h1 class=\"govbr-titulo-funcionalidade\">\n        <ng-content></ng-content>\n    </h1>\n    <mat-divider></mat-divider>\n</div>",
                styles: [":host{width:100%}:host .govbr-titulo{width:100%}:host .govbr-titulo .govbr-titulo-funcionalidade{font-style:normal;font-weight:400;font-size:24px;line-height:33px;color:#0395df;margin-top:0;margin-bottom:8px}:host .govbr-titulo .mat-divider{border-width:2px;background:#0395df}"]
            }] }
];
/** @nocollapse */
TituloFuncionalidadeComponent.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TipografiaModule {
}
TipografiaModule.decorators = [
    { type: NgModule, args: [{
                declarations: [TituloFuncionalidadeComponent],
                imports: [
                    CommonModule,
                    MatDividerModule$1
                ],
                exports: [TituloFuncionalidadeComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AvisosDialogComponent {
    /**
     * @param {?} dialogRef
     * @param {?} dialogData
     */
    constructor(dialogRef, dialogData) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.conteudoDialog = this.dialogData;
    }
    /**
     * @return {?}
     */
    fecharDialogCancelar() {
        this.dialogRef.close();
    }
    /**
     * @return {?}
     */
    fecharDialogConfirmar() {
        this.dialogRef.close('confirmar');
    }
}
AvisosDialogComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-avisos-dialog',
                template: "<div class=\"titulo-aviso\">\n    <p>{{conteudoDialog.titulo}}</p>\n    <mat-icon (click)=\"fecharDialogCancelar()\">close</mat-icon>\n</div>\n<div class=\"conteudo-aviso-container\">\n    <p class=\"conteudo-aviso\" *ngFor=\"let ctd of conteudoDialog.conteudo\">{{ctd}}</p>\n    <p class=\"conteudo-enfase\" *ngFor=\"let ctd of conteudoDialog.conteudoEnfase\">{{ctd}}</p>\n    <div class=\"acoes-dialog\">\n        <button mat-raised-button class=\"govbr-button\" *ngIf=\"conteudoDialog.rotuloCancelar\"\n            (click)=\"fecharDialogCancelar()\">{{conteudoDialog.rotuloCancelar}}</button>\n        <button mat-raised-button class=\"govbr-button\" color=\"primary\"\n            (click)=\"fecharDialogConfirmar()\">{{conteudoDialog.rotuloConfirmar}}</button>\n    </div>\n</div>",
                styles: [":host{min-width:343px;max-width:500px}:host .titulo-aviso{height:36px;display:flex;align-items:center;justify-content:space-between;padding-left:28px;padding-right:21px}:host .titulo-aviso p{width:calc(100% - 40px);font-style:normal;font-weight:400;font-size:16px;line-height:22px}:host .titulo-aviso .mat-icon{cursor:pointer}:host .conteudo-aviso-container{padding:28px}:host .conteudo-aviso-container .conteudo-aviso,:host .conteudo-aviso-container .conteudo-enfase{font-style:normal;font-weight:400;font-size:14px;line-height:16px;margin-bottom:16px}:host .conteudo-aviso-container .conteudo-enfase{font-weight:700}:host .conteudo-aviso-container .acoes-dialog .govbr-button{margin-bottom:0}"]
            }] }
];
/** @nocollapse */
AvisosDialogComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AvisosDialogModule {
}
AvisosDialogModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AvisosDialogComponent],
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatIconModule
                ],
                entryComponents: [AvisosDialogComponent],
                exports: [AvisosDialogComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Deve ser injetado diretamente na seção `providers`
 * do componente que chama esse serviço.
 */
class AvisosDialogService {
    /**
     * @param {?} dialog
     */
    constructor(dialog) {
        this.dialog = dialog;
        this.resultadoDialog$ = new Subject();
    }
    /**
     * @param {?} conteudoDialog
     * @return {?}
     */
    exibirDialogAviso(conteudoDialog) {
        /** @type {?} */
        const dialogRef = this.dialog.open(AvisosDialogComponent, { data: conteudoDialog, disableClose: true, panelClass: 'govbr-avisos', backdropClass: 'govbr-avisos-backdrop' });
        dialogRef.afterClosed()
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.resultadoDialog$.next(data);
        }));
    }
}
AvisosDialogService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AvisosDialogService.ctorParameters = () => [
    { type: MatDialog }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BotoesAcoesComponent {
    constructor() {
        this.itensExportacao = [];
        this.btnImprimir = new EventEmitter();
        this.btnAtualizar = new EventEmitter();
        this.btnConfigurar = new EventEmitter();
        this.btnExportar = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} event
     * @return {?}
     */
    imprimir(event) {
        this.btnImprimir.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    atualizar(event) {
        this.btnAtualizar.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    configurar(event) {
        this.btnConfigurar.emit(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    exportar(event) {
        this.btnExportar.emit(event);
    }
}
BotoesAcoesComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-botoes-acoes',
                template: "<div class=\"container-botoes\">\n    <button mat-raised-button class=\"govbr-button button-bg-white\" color=\"primary\" (click)=\"imprimir($event)\">\n        <mat-icon>print</mat-icon> Imprimir\n    </button>\n    <button mat-raised-button class=\"govbr-button button-bg-white\" color=\"primary\" (click)=\"atualizar($event)\">\n        <mat-icon>update</mat-icon> Atualizar\n    </button>\n    <button mat-raised-button class=\"govbr-button button-bg-white\" color=\"primary\" (click)=\"configurar($event)\">\n        <mat-icon>settings</mat-icon> Configurar\n    </button>\n    <button mat-raised-button [matMenuTriggerFor]=\"menu\" class=\"govbr-button button-bg-white\" color=\"primary\">\n        <mat-icon>save_alt</mat-icon> Exportar <mat-icon class=\"arrow-down\">arrow_drop_down</mat-icon>\n    </button>\n    <mat-menu #menu=\"matMenu\">\n        <button *ngFor=\"let item of itensExportacao\" mat-menu-item (click)=\"exportar($event)\">{{item}}</button>\n    </mat-menu>\n</div>",
                styles: [".container-botoes{padding:15px 0 5px;display:flex;align-items:center}.container-botoes mat-icon{font-size:18px;height:18px;margin-right:5px}.container-botoes mat-icon.arrow-down{margin-right:0}"]
            }] }
];
/** @nocollapse */
BotoesAcoesComponent.ctorParameters = () => [];
BotoesAcoesComponent.propDecorators = {
    itensExportacao: [{ type: Input }],
    btnImprimir: [{ type: Output }],
    btnAtualizar: [{ type: Output }],
    btnConfigurar: [{ type: Output }],
    btnExportar: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BotoesAcoesModule {
}
BotoesAcoesModule.decorators = [
    { type: NgModule, args: [{
                declarations: [BotoesAcoesComponent],
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatIconModule,
                    MatMenuModule,
                ],
                entryComponents: [BotoesAcoesComponent],
                exports: [BotoesAcoesComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogBackdropComponent {
    /**
     * @param {?} dialogRef
     * @param {?} dialogData
     */
    constructor(dialogRef, dialogData) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.itensMenuExportacao = [];
        this.dataSource = [];
        this.displayedColumns = new Subject();
        this.columnsToDisplay = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.conteudoDialogBackdrop = this.dialogData;
        this.carregaDadosTabela();
    }
    /**
     * @param {?} indice
     * @return {?}
     */
    clickTab(indice) {
        this.carregaDadosTabela(indice);
    }
    /**
     * @param {?=} indice
     * @return {?}
     */
    carregaDadosTabela(indice) {
        return __awaiter(this, void 0, void 0, /** @this {!DialogBackdropComponent} */ function* () {
            /** @type {?} */
            let dadosTabela = this.dialogData.conteudoTabs.map((/**
             * @param {?} data
             * @return {?}
             */
            data => data.dados)).filter((/**
             * @param {?} d
             * @return {?}
             */
            d => d !== undefined));
            this.dataSource = dadosTabela[0];
            /** @type {?} */
            let headers = yield dadosTabela[0].map((/**
             * @param {?} el
             * @return {?}
             */
            el => Object.keys(el)));
            this.displayedColumns.next(headers[0]);
            if (indice) { //seta os dados na tabela conforme o índice passado no click da tab superior
                this.dataSource = dadosTabela[indice];
                /** @type {?} */
                let headers = yield dadosTabela[indice].map((/**
                 * @param {?} el
                 * @return {?}
                 */
                el => Object.keys(el)));
                this.displayedColumns.next(headers[0]);
            }
        });
    }
    /**
     * @return {?}
     */
    fecharDialogCancelar() {
        this.dialogRef.close();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    imprimir(event) { console.log(event); }
    /**
     * @param {?} event
     * @return {?}
     */
    atualizar(event) { console.log(event); }
    /**
     * @param {?} event
     * @return {?}
     */
    configurar(event) { console.log(event); }
    /**
     * @param {?} event
     * @return {?}
     */
    exportar(event) { console.log(event); }
}
DialogBackdropComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-dialog-backdrop',
                template: "<div class=\"titulo-dialog-backdrop\">\n    <p>{{conteudoDialogBackdrop.titulo}}</p>\n    <mat-icon (click)=\"fecharDialogCancelar()\">close</mat-icon>\n</div>\n<div class=\"conteudo-dialog-backdrop\">\n    <div class=\"conteudo-tabs\">\n        <button class=\"govbr-custom-tabs\" *ngFor=\"let label of conteudoDialogBackdrop.conteudoTabs\" (click)=\"clickTab(label.indice)\">\n            {{label.nome}}\n        </button>\n    </div>\n    <div class=\"botoes-acoes\">\n        <govbr-botoes-acoes \n        [itensExportacao]=\"itensMenuExportacao\"\n        (btnImprimir)=\"imprimir($event)\"\n        (btnAtualizar)=\"atualizar($event)\"\n        (btnConfigurar)=\"configurar($event)\"\n        (btnExportar)=\"exportar($event)\">\n        </govbr-botoes-acoes>\n    </div>\n    <div class=\"conteudo-tabela\">\n        <table *ngIf=\"dataSource.length > 0\" mat-table [dataSource]=\"dataSource\"  class=\"govbr-table tabela\">\n            <ng-container [matColumnDef]=\"column\" *ngFor=\"let column of displayedColumns | async; let i = index\">\n              <th mat-header-cell *matHeaderCellDef [ngClass]=\"{ 'download-cell': column === 'Download'}\"> {{ column }} </th>\n              <td mat-cell *matCellDef=\"let row\" [ngClass]=\"{'align-right': row[column].toString().includes('$')}\" >\n                <ng-container *ngIf=\"column !== 'Download'; else downloadCell\">\n                  {{ row[column] }}\n                </ng-container>\n                <ng-template #downloadCell>\n                  <a class=\"align-center\" href=\"\" download>\n                    <mat-icon>file_download</mat-icon>\n                  </a>\n                </ng-template>\n              </td>\n            </ng-container>\n            \n            <tr  mat-header-row *matHeaderRowDef=\"displayedColumns | async\"  ></tr>\n            <tr  mat-row *matRowDef=\"let row; columns: displayedColumns | async;\" ></tr>\n        </table>\n    </div>\n    <div class=\"acoes-dialog\">\n        <button mat-raised-button class=\"govbr-button\" color=\"primary\"\n            (click)=\"fecharDialogCancelar()\">{{conteudoDialogBackdrop.rotuloFechar}}</button>\n    </div>\n</div>",
                styles: [":host{min-width:343px;max-width:500px}:host .titulo-dialog-backdrop{height:36px;display:flex;align-items:center;justify-content:space-between;padding-left:15px;padding-right:15px}:host .titulo-dialog-backdrop p{width:calc(100% - 40px);font-style:normal;font-weight:400;font-size:16px;line-height:22px}:host .titulo-dialog-backdrop .mat-icon{cursor:pointer}:host .conteudo-dialog-backdrop{padding:15px 15px 110px;overflow:scroll;height:100%}:host .conteudo-dialog-backdrop .govbr-custom-tabs{border-radius:4px 4px 0 0;padding:7px 10px;cursor:pointer}:host .conteudo-dialog-backdrop .acoes-dialog{position:absolute;bottom:0;left:0;width:100%;padding:15px 5px;display:flex;justify-content:flex-end}:host .conteudo-dialog-backdrop .acoes-dialog .govbr-button{margin-bottom:0}.align-right{text-align:right}.align-center{display:flex;justify-content:center;align-items:center;text-decoration:none}.align-center mat-icon{font-size:22px;color:#0395df}.download-cell{width:20px}.conteudo-tabela{overflow:auto}"]
            }] }
];
/** @nocollapse */
DialogBackdropComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DialogBackdropModule {
}
DialogBackdropModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DialogBackdropComponent],
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatIconModule,
                    MatTabsModule$1,
                    MatMenuModule,
                    GenericTableModule,
                    BotoesAcoesModule,
                    MatTableModule$1
                ],
                entryComponents: [DialogBackdropComponent],
                exports: [DialogBackdropComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Deve ser injetado diretamente na seção `providers`
 * do componente que chama esse serviço.
 */
class DialogBackdropService {
    /**
     * @param {?} dialog
     */
    constructor(dialog) {
        this.dialog = dialog;
        this.resultadoDialog$ = new Subject();
    }
    /**
     * @param {?} conteudoDialog
     * @return {?}
     */
    exibirDialogBackdrop(conteudoDialog) {
        /** @type {?} */
        const dialogRef = this.dialog.open(DialogBackdropComponent, {
            data: conteudoDialog,
            width: '80%',
            height: '640px',
            position: { top: '0', left: '0' },
            disableClose: true,
            panelClass: 'govbr-dialog-backdrop',
            backdropClass: 'govbr-dialog-backdrop'
        });
        dialogRef.afterClosed()
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            this.resultadoDialog$.next(data);
        }));
    }
}
DialogBackdropService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
DialogBackdropService.ctorParameters = () => [
    { type: MatDialog }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StatusProdutosGrp {
    /**
     * @param {?} titulo
     * @param {?} icone
     * @param {?=} uid
     */
    constructor(titulo, icone, uid) {
        this.titulo = titulo;
        this.icone = icone;
        this.uid = uid;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 *
 * ## DualListBoxComponent
 * #### Componente responsável por gerar um elemento select no formulario genérico
 *
 */
class DualListComponent {
    constructor() {
        this.tituloColunaEsquerda = 'Disponiveis';
        this.tituloColunaDireita = 'Selecionados';
        this.disponiveis = [];
        this.selecionados = [];
        this.onSelecionadosChange = new EventEmitter();
    }
    /**
     * @param {?} valor
     * @return {?}
     */
    setValue(valor) {
        if (valor && valor.length > 0) {
            /** @type {?} */
            const preSelecionados = valor;
            this.selecionados = this.entidades.filter((/**
             * @param {?} e
             * @return {?}
             */
            e => preSelecionados.find((/**
             * @param {?} ps
             * @return {?}
             */
            ps => ps.id === e.id))));
            // verificar se existe alguém da lista de entidades, que já está na lista de selecionados
            // se nao estiver, colocar na lista de disponíveis
            this.selecionados.forEach((/**
             * @param {?} s
             * @return {?}
             */
            s => {
                this.disponiveis = this.disponiveis.filter((/**
                 * @param {?} d
                 * @return {?}
                 */
                d => d.id !== s.id));
            }));
        }
        else {
            this.selecionados = [];
            this.disponiveis = this.entidades;
        }
        this.formControlSelecionados.setValue(this.selecionados);
        this.formControlDisponiveis.setValue(this.disponiveis);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.formControlDisponiveis = new FormControl('', []);
        this.formControlSelecionados = new FormControl('', []);
        this.formControlBuscaDisponiveis = new FormControl('', []);
        this.formControlBuscaSelecionados = new FormControl('', []);
        this.disponiveis = this.entidades;
        if (window.screen.width < 992) {
            this.iconHorizontal = false;
        }
        else {
            this.iconHorizontal = true;
        }
    }
    /**
     * @param {?} item
     * @return {?}
     */
    moverParaSelecionados(item) {
        this.disponiveis = this.disponiveis.filter((/**
         * @param {?} d
         * @return {?}
         */
        d => d.id !== item.id));
        this.selecionados.push(item);
        this.onSelecionadosChange.emit(this.selecionados);
        this.ordenaSelecionados();
    }
    /**
     * @param {?} item
     * @return {?}
     */
    moverParaDisponiveis(item) {
        this.selecionados = this.selecionados.filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.id !== item.id));
        this.disponiveis.push(item);
        this.onSelecionadosChange.emit(this.selecionados);
        this.ordenaDisponiveis();
    }
    /**
     * @return {?}
     */
    adicionaRegistrosSelecionados() {
        if (this.formControlDisponiveis.value) {
            this.formControlDisponiveis.value.forEach((/**
             * @param {?} id
             * @return {?}
             */
            (id) => {
                this.disponiveis.forEach((/**
                 * @param {?} d
                 * @param {?} i
                 * @return {?}
                 */
                (d, i) => {
                    if (d.id === id) {
                        this.selecionados.push(d);
                        this.disponiveis.splice(i, 1);
                    }
                }));
            }));
        }
        this.onSelecionadosChange.emit(this.selecionados);
        this.ordenaSelecionados();
    }
    /**
     * @return {?}
     */
    removeRegistrosSelecionados() {
        if (this.formControlSelecionados.value) {
            this.formControlSelecionados.value.forEach((/**
             * @param {?} id
             * @return {?}
             */
            (id) => {
                this.selecionados.forEach((/**
                 * @param {?} s
                 * @param {?} i
                 * @return {?}
                 */
                (s, i) => {
                    if (s.id === id) {
                        this.disponiveis.push(s);
                        this.selecionados.splice(i, 1);
                    }
                }));
            }));
        }
        this.onSelecionadosChange.emit(this.selecionados);
        this.ordenaDisponiveis();
    }
    /**
     * @return {?}
     */
    ordenaSelecionados() {
        this.selecionados.sort((/**
         * @param {?} d1
         * @param {?} d2
         * @return {?}
         */
        (d1, d2) => {
            if (d1.titulo > d2.titulo) {
                return 1;
            }
            else if (d1.titulo < d2.titulo) {
                return -1;
            }
            else {
                return 0;
            }
        }));
    }
    /**
     * @return {?}
     */
    ordenaDisponiveis() {
        this.disponiveis.sort((/**
         * @param {?} s1
         * @param {?} s2
         * @return {?}
         */
        (s1, s2) => {
            if (s1.titulo > s2.titulo) {
                return 1;
            }
            else if (s1.titulo < s2.titulo) {
                return -1;
            }
            else {
                return 0;
            }
        }));
    }
    /**
     * @param {?} item
     * @return {?}
     */
    buscaDisponiveis(item) {
        /** @type {?} */
        const n = item.titulo.toLowerCase().search(this.formControlBuscaDisponiveis.value.toLowerCase());
        if (n !== -1) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * @param {?} item
     * @return {?}
     */
    buscaSelecionados(item) {
        /** @type {?} */
        const n = item.titulo.toLowerCase().search(this.formControlBuscaSelecionados.value.toLowerCase());
        if (n !== -1) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onResize(event) {
        if (event.target.innerWidth < 992) {
            this.iconHorizontal = false;
        }
        else {
            this.iconHorizontal = true;
        }
    }
}
DualListComponent.decorators = [
    { type: Component, args: [{
                // tslint:disable-next-line:component-selector
                selector: 'govbr-dual-list',
                template: "<div govbrContainer [containerConfig]=\"['fluid']\" style=\"justify-content: center\">\n  <div govbrRow [rowConfig]=\"[]\" style=\"width: 100%;\">\n\n    <div govbrColumn [colConfig]=\"['5']\">\n      <div class=\"lista\">\n        <mat-form-field class=\"govbr-form-field search\" color=\"primary\">\n          <input type=\"text\" matInput placeholder=\"Dispon\u00EDveis\" [formControl]=\"formControlBuscaDisponiveis\">\n          <mat-icon matSuffix class=\"material-icons\">search</mat-icon>\n        </mat-form-field>\n        <div class=\"titulo\">{{ tituloColunaEsquerda }}</div>\n        <select class=\"form-control list-box list select\" #selectDisponiveis multiple\n          [formControl]=\"formControlDisponiveis\">\n          <option class=\"option\" *ngFor=\"let item of disponiveis\" id=\"{{item.titulo}}\" [hidden]=\"buscaDisponiveis(item)\"\n            [value]=\"item?.id\" (dblclick)=\"moverParaSelecionados(item)\">\n            {{item?.titulo}}\n          </option>\n        </select>\n      </div>\n    </div>\n\n    <div govbrColumn [colConfig]=\"['2']\" style=\"margin: auto;\">\n\n      <div govbrRow [rowConfig]=\"[]\" style=\"justify-content: center\">\n        <button mat-raised-button class=\"govbr-button add-button\" style=\"font-size: 14px;\"\n          (click)=\"adicionaRegistrosSelecionados()\">\n          Adicionar\n          <mat-icon *ngIf=\"iconHorizontal\" class=\"material-icons\">keyboard_double_arrow_right</mat-icon>\n          <mat-icon *ngIf=\"!iconHorizontal\" class=\"material-icons\">keyboard_double_arrow_down</mat-icon>\n        </button>\n      </div>\n\n      <div govbrRow [rowConfig]=\"[]\" style=\"justify-content: center\">\n        <button mat-raised-button class=\"govbr-button remove-button\" color=\"warn\" style=\"font-size: 14px;\"\n          (click)=\"removeRegistrosSelecionados()\">\n          <mat-icon *ngIf=\"iconHorizontal\" class=\"material-icons\">keyboard_double_arrow_left</mat-icon>\n          <mat-icon *ngIf=\"!iconHorizontal\" class=\"material-icons\">keyboard_double_arrow_up</mat-icon>\n          Remover\n        </button>\n      </div>\n\n    </div>\n\n    <div govbrColumn [colConfig]=\"['5']\">\n      <div class=\"lista\">\n        <mat-form-field class=\"govbr-form-field search\" color=\"primary\">\n          <input type=\"text\" matInput placeholder=\"Selecionados\" [formControl]=\"formControlBuscaSelecionados\">\n          <mat-icon matSuffix class=\"material-icons\">search</mat-icon>\n        </mat-form-field>\n        <div class=\"titulo\">{{ tituloColunaDireita }}</div>\n        <select class=\"form-control list-box list select\" multiple [formControl]=\"formControlSelecionados\">\n          <option class=\"option\" *ngFor=\"let item of selecionados\" [hidden]=\"buscaSelecionados(item)\" [value]=\"item?.id\"\n            (dblclick)=\"moverParaDisponiveis(item)\">\n            {{item?.titulo}}\n          </option>\n        </select>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: ["select{width:100%;font-size:14px;font-style:normal;margin-bottom:24px}.container-fluid{padding:0}.search{width:100%}.list{height:220px;border:none;overflow:auto}button .remove-button{width:105px;height:35px;text-align:center;margin:0;padding:0 10px 0 0}button .add-button{width:105px;margin:0 0 8px;text-align:center}.mat-icon,.material-icons{font-size:20px;line-height:1.2}.option{padding-top:20px;padding-bottom:13px;padding-left:16px}.titulo{padding-top:13px;padding-bottom:13px;padding-left:16px;width:100%}.center{text-align:center}.lista{width:100%;max-width:320px;margin:auto}@media only screen and (max-width:979px){.add-button,.remove-button{margin-top:0}.center{text-align:unset}div.right{text-align:right}}@media only screen and (min-width:980px) and (max-width:1279px){.center gov-grid-col{padding-left:0;padding-right:0}}"]
            }] }
];
/** @nocollapse */
DualListComponent.ctorParameters = () => [];
DualListComponent.propDecorators = {
    entidades: [{ type: Input }],
    tituloColunaEsquerda: [{ type: Input }],
    tituloColunaDireita: [{ type: Input }],
    onSelecionadosChange: [{ type: Output }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DualListModule {
}
DualListModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DualListComponent],
                imports: [
                    FormsModule,
                    CommonModule,
                    ReactiveFormsModule,
                    GridModule,
                    MatIconModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatButtonModule
                ],
                exports: [DualListComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CardsDirective {
    /**
     * @param {?} el
     * @param {?} renderer
     */
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, 'govbr-card');
        /** @type {?} */
        const tituloDiv = this.renderer.createElement('div');
        this.renderer.addClass(tituloDiv, 'titulo');
        /** @type {?} */
        const tituloTexto = this.renderer.createText(this.titulo);
        this.renderer.appendChild(tituloDiv, tituloTexto);
        this.renderer.appendChild(this.el.nativeElement, tituloDiv);
    }
}
CardsDirective.decorators = [
    { type: Directive, args: [{
                selector: '[govbrCard]'
            },] }
];
/** @nocollapse */
CardsDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
CardsDirective.propDecorators = {
    titulo: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CardsModule {
}
CardsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    CardsDirective
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    CardsDirective
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LogAnalyticsDirective {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     * @param {?} logAnalyticsService
     */
    constructor(renderer, elementRef, logAnalyticsService) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.logAnalyticsService = logAnalyticsService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /*
        * Método que "escuta" o evento passado como parâmetro e chama o serviço do logger do pronim analytics
        */
        if (!this.event) {
            this.event = 'click';
        }
        if (this.chaveAnalytics) {
            this.dispose = this.renderer.listen(this.elementRef.nativeElement, this.event, (/**
             * @param {?} e
             * @return {?}
             */
            e => {
                this.logarIntencao(this.acao, this.chaveAnalytics);
            }));
        }
    }
    /**
     * @param {?} acao
     * @param {?} chaveAnalytics
     * @return {?}
     */
    logarIntencao(acao, chaveAnalytics) {
        if (chaveAnalytics) {
            this.logAnalyticsService.SU_INF_0004(acao, chaveAnalytics);
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.dispose();
    }
}
LogAnalyticsDirective.decorators = [
    { type: Directive, args: [{
                selector: '[analyticsIntencao]'
            },] }
];
/** @nocollapse */
LogAnalyticsDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: LogAnalyticsService }
];
LogAnalyticsDirective.propDecorators = {
    acao: [{ type: Input }],
    chaveAnalytics: [{ type: Input }],
    event: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LogAnalyticsModule {
}
LogAnalyticsModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    LogAnalyticsDirective
                ],
                exports: [
                    LogAnalyticsDirective
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/* Componente Forms utilizado pela Comunicação Social */
/*
  geral - subType: number (input text somente numeros);
                   text (input text);
                   select (select com opções, multiple pode ser true ou false)
                   date (campo tipo data com data inicio e data final)
  checkbox - varias opções para escolher
*/
class FormsCsComponent {
    constructor() {
        this.eventoFormCs = new Subject();
        this.removeFieldChips = new Subject();
        this.getValorAnoSelecionado = new Subject();
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} event
     * @return {?}
     */
    getChangeInputvalue(event) {
        this.eventoFormCs.next(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    getChangeDoubleInputValue(event) {
        this.eventoFormCs.next(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    getChangeCheckboxValue(event) {
        this.eventoFormCs.next(event);
    }
    /**
     * @param {?} event
     * @return {?}
     */
    getChangeDoubleCheckboxValue(event) {
        console.log("evento" + event);
        this.eventoFormCs.next(event);
    }
}
FormsCsComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-forms-cs',
                template: "<div *ngFor=\"let field of fields\">\n    <div [ngSwitch]=\"field.type\">\n        <govbr-fields-geral-cs \n            *ngSwitchCase=\"'geral'\" \n            [field]=\"field\" \n            [form]=\"form\" \n            (changeInputValue)=\"getChangeInputvalue($event)\"  \n            [removeFieldChips]=\"removeFieldChips\"\n            [getValorAno]=\"getValorAnoSelecionado\">\n        </govbr-fields-geral-cs>\n        <govbr-checkbox-cs \n            *ngSwitchCase=\"'checkbox'\" \n            [field]=\"field\" \n            [form]=\"form\" \n            (changeCheckboxValue)=\"getChangeCheckboxValue($event)\">\n        </govbr-checkbox-cs>\n        <govbr-double-input-cs \n            *ngSwitchCase=\"'doubleInput'\" \n            [field]=\"field\" \n            [form]=\"form\" \n            (changeDoubleInputValue)=\"getChangeDoubleInputValue($event)\">\n        </govbr-double-input-cs>\n        <govbr-double-checkbox-cs \n            *ngSwitchCase=\"'doubleCheckbox'\" \n            [field]=\"field\" \n            [form]=\"form\" \n            (changeDoubleCheckboxValue)=\"getChangeDoubleCheckboxValue($event)\">\n        </govbr-double-checkbox-cs>\n    </div>\n</div>\n",
                styles: [""]
            }] }
];
/** @nocollapse */
FormsCsComponent.ctorParameters = () => [];
FormsCsComponent.propDecorators = {
    fields: [{ type: Input }],
    dadosEntradaAddFiltro: [{ type: Input }],
    form: [{ type: Input }],
    eventoFormCs: [{ type: Output }],
    removeFieldChips: [{ type: Input }],
    getValorAnoSelecionado: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CheckboxCsComponent {
    constructor() {
        this.field = {};
        this.itensPorLinha = 3;
        this.changeCheckboxValue = new Subject();
        this.selectedChecked = [];
        this.lista = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.itensPorLinha !== 2 && this.itensPorLinha !== 3) {
            this.itensPorLinha = 3;
        }
        this.buildDadosField();
    }
    /**
     * @return {?}
     */
    buildDadosField() {
        /** @type {?} */
        let contadorOp = 0;
        /** @type {?} */
        let auxiliarLista = [];
        if (this.field.name !== 'porteEmpresa') {
            auxiliarLista.push({ key: 'todos', label: 'Todos' });
            contadorOp = 1;
        }
        for (const op of this.field.options) {
            auxiliarLista.push(op);
            if (contadorOp === (this.itensPorLinha - 1)) { //deixa 2 ou 3 itens por array
                this.lista.push(auxiliarLista);
                auxiliarLista = [];
                contadorOp = 0;
            }
            else {
                contadorOp++;
            }
        }
        if (auxiliarLista.length !== 0) { //coloca a sobra do auxiliar na lista
            this.lista.push(auxiliarLista);
        }
    }
    /**
     * @return {?}
     */
    buildChips() {
        /** @type {?} */
        const objChips = [];
        if (this.selectedChecked.length > 0) {
            objChips.push({
                key: this.field.name,
                nome: this.field.label + ': ' + this.selectedChecked.join(', '),
                obrigatorio: false
            });
        }
        else {
            objChips.push({
                key: 'remove',
                nome: this.field.name,
                obrigatorio: false
            });
        }
        this.changeCheckboxValue.next(objChips);
    }
    /**
     * @param {?} nameChecked
     * @return {?}
     */
    checkListFull(nameChecked) {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        /** @type {?} */
        let retorno = true;
        Object.keys(values).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if ((values[key] === false || values[key] === null) && key !== nameChecked && key !== 'todos') {
                retorno = false;
            }
        }));
        return retorno;
    }
    /**
     * @return {?}
     */
    checkSelectAllField() {
        /** @type {?} */
        const oldValues = this.form.get(this.field.name).value;
        /** @type {?} */
        const newValues = {};
        Object.keys(oldValues).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            newValues[key] = true;
        }));
        this.form.get(this.field.name).setValue(newValues);
    }
    /**
     * @return {?}
     */
    uncheckSelectAllField() {
        /** @type {?} */
        const oldValues = this.form.get(this.field.name).value;
        /** @type {?} */
        const newValues = {};
        Object.keys(oldValues).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (key === 'todos') {
                newValues[key] = false;
            }
            else {
                newValues[key] = oldValues[key];
            }
        }));
        this.form.get(this.field.name).setValue(newValues);
    }
    /**
     * @param {?} event
     * @param {?} nameChecked
     * @param {?} value
     * @return {?}
     */
    checkedEvent(event, nameChecked, value) {
        this.verificaForm(nameChecked);
        if (event.checked) {
            this.selectedChecked.push(value);
            if (this.checkListFull(nameChecked)) {
                this.checkSelectAllField();
            }
        }
        else {
            /** @type {?} */
            const index = this.selectedChecked.indexOf(value);
            this.selectedChecked.splice(index, 1);
            this.uncheckSelectAllField();
        }
        this.buildChips();
    }
    /**
     * @param {?} nameChecked
     * @return {?}
     */
    verificaForm(nameChecked) {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        /** @type {?} */
        let zerarLista = true;
        Object.keys(values).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (values[key] !== null && key !== nameChecked) {
                zerarLista = false;
            }
        }));
        if (zerarLista) {
            this.selectedChecked = [];
        }
    }
    /**
     * @return {?}
     */
    getValueSelectAll() {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        /** @type {?} */
        let retorno = false;
        Object.keys(values).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (key === 'todos') {
                retorno = values[key];
            }
        }));
        return retorno;
    }
    /**
     * @return {?}
     */
    checkedAll() {
        this.selectedChecked = [];
        /** @type {?} */
        const oldValues = this.form.get(this.field.name).value;
        /** @type {?} */
        const newValues = {};
        if (this.getValueSelectAll()) {
            for (const op of this.field.options) {
                this.selectedChecked.push(op.label);
            }
            Object.keys(oldValues).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                newValues[key] = true;
            }));
        }
        else {
            Object.keys(oldValues).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                newValues[key] = false;
            }));
        }
        this.form.get(this.field.name).setValue(newValues);
        this.buildChips();
    }
}
CheckboxCsComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-checkbox-cs',
                template: "<div class=\"row\" [formGroup]=\"form\" *ngIf=\"field.show\">\n    <div class=\"col-3 coluna-titulo\">\n        <mat-label>{{field.label}}:</mat-label>\n    </div>\n    <div class=\"col-9\" [formGroupName]=\"field.name\">\n        <div class=\"row row-checkbox\" *ngFor=\"let options of lista\">\n            <div [ngClass]=\"itensPorLinha == 3 ? 'item-checkbox-3' : 'item-checkbox-2'\" *ngFor=\"let option of options\">\n                \n                \n                <mat-checkbox class=\"govbr-checkbox\"\n                    [formControlName]=\"option.key\"\n                    (change)=\"checkedAll()\"\n                    *ngIf=\"option.key == 'todos'\">\n                        {{option.label}}\n                </mat-checkbox>\n\n                \n                <mat-checkbox class=\"govbr-checkbox\"\n                    [formControlName]=\"option.key\"\n                    (change)=\"checkedEvent($event, option.key, option.label)\" \n                    *ngIf=\"option.key != 'todos'\">\n                        {{option.label}}\n                </mat-checkbox>\n\n\n            </div>\n        </div>\n    </div>\n</div>\n",
                styles: [".row{gap:16px}.item-checkbox-3{width:300px}.item-checkbox-2{width:450px}.coluna-titulo{margin-right:100px}.row-checkbox{margin-bottom:18px}"]
            }] }
];
/** @nocollapse */
CheckboxCsComponent.ctorParameters = () => [];
CheckboxCsComponent.propDecorators = {
    field: [{ type: Input }],
    itensPorLinha: [{ type: Input }],
    form: [{ type: Input }],
    changeCheckboxValue: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FieldsGeralCsComponent {
    /**
     * @param {?} datePipe
     */
    constructor(datePipe) {
        this.datePipe = datePipe;
        this.field = {};
        this.changeInputValue = new Subject();
        this.removeFieldChips = new Subject();
        this.getValorAno = new Subject();
        this.mesInicial = new Date().setMonth(0);
        this.diaMesInicial = new Date(this.mesInicial).setDate(1);
        this.mesFinal = new Date().setMonth(11);
        this.diaMesFinal = new Date(this.mesFinal).setDate(31);
        this.dataInicial = this.datePipe.transform(this.diaMesInicial, 'yyyy-MM-dd');
        this.dataFinal = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        this.anoCorrente = new Date().getFullYear();
        this.checkedAll = new BehaviorSubject(false);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.setValuesDatePeriod();
            this.setValuesMonths();
        }));
        this.valorAno();
        this.limpaCampos();
    }
    /**
     * @return {?}
     */
    valorAno() {
        /** @type {?} */
        const fieldDate = this.field.optionsFields.filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.subType === 'date'));
        this.getValorAno.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        (res) => {
            if (res) {
                if (fieldDate.length > 0) {
                    this.diaMesInicial = new Date(this.mesInicial).setDate(1);
                    /** @type {?} */
                    const dataI = new Date(this.diaMesInicial).setFullYear(res);
                    /** @type {?} */
                    const dataF = new Date(this.diaMesFinal).setFullYear(res);
                    if (this.anoCorrente === parseInt(res)) {
                        this.dataInicial = this.datePipe.transform(this.diaMesInicial, 'yyyy-MM-dd');
                        this.dataFinal = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
                        this.form.controls[fieldDate[0].name].get('dataInicial').patchValue(null);
                        this.form.controls[fieldDate[0].name].get('dataFinal').patchValue(null);
                        this.minDate = this.dataInicial;
                        this.maxDate = this.dataFinal;
                    }
                    else {
                        this.dataInicial = this.datePipe.transform(dataI, 'yyyy-MM-dd');
                        this.dataFinal = this.datePipe.transform(dataF, 'yyyy-MM-dd');
                        this.minDate = this.dataInicial;
                        this.maxDate = this.dataFinal;
                        this.form.controls[fieldDate[0].name].get('dataInicial').patchValue(null);
                        this.form.controls[fieldDate[0].name].get('dataFinal').patchValue(null);
                    }
                }
                this.mensagemValidacaoPeriodo = '';
            }
        }));
    }
    /**
     * @return {?}
     */
    setValuesDatePeriod() {
        /** @type {?} */
        const fieldDate = this.field.optionsFields.filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.subType === 'date'));
        /** @type {?} */
        const periodo = { dataInicial: '', dataFinal: '' };
        if (fieldDate.length > 0) {
            this.form.controls[fieldDate[0].name].get('dataInicial').valueChanges.subscribe((/**
             * @param {?} dataInicial
             * @return {?}
             */
            dataInicial => {
                periodo.dataInicial = this.datePipe.transform(dataInicial, 'yyyy-MM-dd');
                this.setDadosChipsDate(fieldDate[0].name, fieldDate[0].label, periodo);
            }));
            this.form.controls[fieldDate[0].name].get('dataFinal').valueChanges.subscribe((/**
             * @param {?} dataFinal
             * @return {?}
             */
            dataFinal => {
                periodo.dataFinal = this.datePipe.transform(dataFinal, 'yyyy-MM-dd');
                this.setDadosChipsDate(fieldDate[0].name, fieldDate[0].label, periodo);
            }));
        }
    }
    /**
     * @return {?}
     */
    setValuesMonths() {
        /** @type {?} */
        const fieldDate = this.field.optionsFields.filter((/**
         * @param {?} s
         * @return {?}
         */
        s => s.subType === 'months'));
        /** @type {?} */
        const periodo = { mesInicial: '', mesFinal: '' };
        if (fieldDate.length > 0) {
            this.form.controls[fieldDate[0].name].get('mesInicial').valueChanges.subscribe((/**
             * @param {?} mesInicial
             * @return {?}
             */
            mesInicial => {
                periodo.mesInicial = mesInicial;
                this.setDadosChipsMonths(fieldDate[0].name, fieldDate[0].label, periodo);
            }));
            this.form.controls[fieldDate[0].name].get('mesFinal').valueChanges.subscribe((/**
             * @param {?} mesFinal
             * @return {?}
             */
            mesFinal => {
                periodo.mesFinal = mesFinal;
                this.setDadosChipsMonths(fieldDate[0].name, fieldDate[0].label, periodo);
            }));
        }
    }
    /**
     * @param {?} event
     * @param {?} key
     * @return {?}
     */
    getIndexValue(event, key) {
        if (key === 'mesInicial') {
            this.mesInicialMovimento = parseInt(event.target.value.substring(0, 2));
        }
        if (key === 'mesFinal') {
            this.mesFinalMovimento = parseInt(event.target.value.substring(0, 2));
        }
        if (event && this.mesFinalMovimento < this.mesInicialMovimento) {
            this.mensagemValidacaoMeses = 'Mês final não pode ser menor que mês inicial';
        }
        else {
            this.mensagemValidacaoMeses = '';
        }
    }
    /**
     * @param {?} name
     * @param {?} label
     * @param {?} periodo
     * @return {?}
     */
    setDadosChipsDate(name, label, periodo) {
        if (periodo.dataFinal !== '' && periodo.dataInicial > periodo.dataFinal) {
            this.mensagemValidacaoPeriodo = 'Data inicial não pode ser maior que a data final';
        }
        else {
            this.mensagemValidacaoPeriodo = '';
            /** @type {?} */
            const objChips = [];
            /** @type {?} */
            const fieldDate = this.field.optionsFields.filter((/**
             * @param {?} s
             * @return {?}
             */
            s => s.subType === 'date'));
            if (fieldDate[0].show) {
                this.changeInputValue.next(objChips);
                if (periodo.dataInicial == null && periodo.dataFinal == null) {
                    objChips.push({
                        key: 'remove',
                        nome: name,
                        obrigatorio: false
                    });
                    this.changeInputValue.next(objChips);
                }
                else {
                    objChips.push({
                        key: name,
                        nome: `${label}: ${this.datePipe.transform(periodo.dataInicial, 'dd/MM/yyyy') || ''} - ${this.datePipe.transform(periodo.dataFinal, 'dd/MM/yyyy') || ''}`,
                        obrigatorio: false
                    });
                    this.changeInputValue.next(objChips);
                }
            }
        }
    }
    /**
     * @param {?} name
     * @param {?} label
     * @param {?} periodo
     * @return {?}
     */
    setDadosChipsMonths(name, label, periodo) {
        /** @type {?} */
        const objChips = [];
        if (periodo.mesInicial == null && periodo.mesFinal == null) {
            objChips.push({
                key: 'remove',
                nome: name,
                obrigatorio: false
            });
            this.changeInputValue.next(objChips);
        }
        else {
            objChips.push({
                key: name,
                nome: `${label}: ${periodo.mesInicial || ''} - ${periodo.mesFinal || ''}`,
                obrigatorio: false
            });
            this.changeInputValue.next(objChips);
        }
    }
    /**
     * @return {?}
     */
    limpaCampos() {
        this.removeFieldChips.subscribe((/**
         * @param {?} name
         * @return {?}
         */
        name => {
            this.form.get(name).reset();
            this.checkedAll.next(false);
        }));
    }
    /**
     * @param {?=} label
     * @param {?=} name
     * @return {?}
     */
    valueChange(label, name) {
        /** @type {?} */
        const objChips = [];
        if (this.form.get(name).value === '' || this.isArrayEmpty(this.form.get(name).value)) {
            objChips.push({
                key: 'remove',
                nome: name,
                obrigatorio: false
            });
            this.checkedAll.next(false);
        }
        else {
            objChips.push({
                key: name,
                nome: label + ': ' + this.form.get(name).value,
                obrigatorio: false
            });
        }
        this.changeInputValue.next(objChips);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    getEventCheckAll(data) {
        /** @type {?} */
        const objChips = [];
        if (data[0] === 'add') {
            objChips.push({
                key: data[1].name,
                nome: data[1].label + ': ' + this.form.get(data[1].name).value,
                obrigatorio: false
            });
        }
        else {
            objChips.push({
                key: 'remove',
                nome: data[1].name,
                obrigatorio: false
            });
            this.checkedAll.next(false);
        }
        this.changeInputValue.next(objChips);
    }
    /**
     * @template T
     * @param {?} arr
     * @return {?}
     */
    isArrayEmpty(arr) {
        return arr.length === 0;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    cpfcnpjmask(name) {
        /** @type {?} */
        let value = this.form.get(name).value;
        value = value.replace(/\D/g, ''); //Remove tudo o que não é dígito
        if (value.length > 11) {
            //CNPJ
            value = value.replace(/^(\d{2})(\d)/, "$1.$2"); //Coloca ponto entre o segundo e o terceiro dígitos
            value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3"); //Coloca ponto entre o quinto e o sexto dígitos
            value = value.replace(/\.(\d{3})(\d)/, ".$1/$2"); //Coloca uma barra entre o oitavo e o nono dígitos
            value = value.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca um hífen depois do bloco de quatro dígitos
        }
        else {
            //CPF
            value = value.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
            value = value.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
            value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
        }
        this.form.get(name).setValue(value);
    }
}
FieldsGeralCsComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-fields-geral-cs',
                template: "<div class=\"row\">\n    <div class=\"col-12 col-md-3\" *ngFor=\"let op of field.optionsFields\" [formGroup]=\"form\">\n\n        <!-- Input tipo text ou text area -->\n        <div class=\"col-field\" *ngIf=\"op.subType == 'text' && op.show\">\n            <mat-form-field class=\"govbr-form-field\" [ngClass]=\"{'field-small': op.size === 'small',\n                                        'field-medium': op.size === 'medium',\n                                        'field-large': op.size === 'large'}\" appearance=\"outline\">\n                <mat-label>\n                    {{op.label}}\n                </mat-label>\n                <input matInput *ngIf=\"!op.multiline\" type=\"text\" [id]=\"op.name\" [name]=\"op.name\"\n                    [placeholder]=\"op.label\" [formControlName]=\"op.name\" (change)=\"valueChange(op.label, op.name)\">\n                <textarea *ngIf=\"op.multiline\" [id]=\"op.name\" [formControlName]=\"op.name\" rows=\"9\" class=\"form-control\"\n                    [placeholder]=\"op.label\"></textarea>\n            </mat-form-field>\n        </div>\n\n        <!-- Input tipo text que so permite numeros -->\n        <div class=\"col-field\" *ngIf=\"op.subType == 'number' && op.show\">\n            <mat-form-field class=\"govbr-form-field\" [ngClass]=\"{'field-small': op.size === 'small',\n                                        'field-medium': op.size === 'medium',\n                                        'field-large': op.size === 'large'}\" appearance=\"outline\">\n                <mat-label>\n                    {{op.label}}\n                </mat-label>\n                <input matInput type=\"text\" [id]=\"op.name\" [name]=\"op.name\" [placeholder]=\"op.label\"\n                    (change)=\"valueChange(op.label, op.name)\" [formControlName]=\"op.name\"\n                    onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" />\n            </mat-form-field>\n        </div>\n\n        <!-- Select pode ser multiple ou n\u00E3o -->\n        <div class=\"col-field\" *ngIf=\"op.subType == 'select' && op.show\">\n            <mat-form-field class=\"govbr-form-field\" [ngClass]=\"{'field-small': op.size === 'small',\n                                        'field-medium': op.size === 'medium',\n                                        'field-large': op.size === 'large'}\" appearance=\"outline\">\n                <mat-label>\n                    {{op.label}}\n                </mat-label>\n\n                <select matNativeControl [id]=\"op.name\" class=\"govbr-select\" panelClass=\"govbr-select\"\n                    [formControlName]=\"op.name\" (change)=\"valueChange(op.label, op.name)\" *ngIf=\"!op.multiple\">\n                    <option *ngFor=\"let option of op.options\" [value]=\"option.key\">\n                        {{option.label}}\n                    </option>\n                </select>\n\n                <mat-select [id]=\"op.name\" class=\"govbr-select\" panelClass=\"govbr-select\" [formControlName]=\"op.name\"\n                    (selectionChange)=\"valueChange(op.label, op.name)\" *ngIf=\"op.multiple\" multiple>\n                    <govbr-select-check-all [(eventChecked)]=\"checkedAll\" (eventCheckAll)=\"getEventCheckAll($event)\" [model]=\"form.get(op.name)\" [values]=\"op\"></govbr-select-check-all>\n                    <mat-option *ngFor=\"let option of op.options\" [value]=\"option.key\" selected>\n                        {{option.label}}\n                    </mat-option>\n                </mat-select>\n\n            </mat-form-field>\n        </div>\n\n        <!-- Input tipo text que seleciona data in\u00EDcio e data final -->\n        <div class=\"col-field\" *ngIf=\"op.subType == 'date' && op.show\">\n            <ng-container [formGroupName]=\"op.name\">\n                <ng-container *ngFor=\"let opt of op.options\">\n                    <span> - </span>\n\n                    <mat-form-field class=\"govbr-form-field\"\n                        [ngClass]=\"{'mat-form-field-invalid': mensagemValidacaoPeriodo}\" appearance=\"outline\">\n                        <mat-label>{{opt.label}}</mat-label>\n                        <input matInput type=\"date\" [formControlName]=\"opt.key\" [min]=\"minDate\" [max]=\"maxDate\"\n                            class=\"form-control\" />\n                    </mat-form-field>\n                </ng-container>\n            </ng-container>\n            <mat-error *ngIf=\"mensagemValidacaoPeriodo\">\n                {{mensagemValidacaoPeriodo}}\n            </mat-error>\n        </div>\n\n        <!-- Input tipo select que seleciona m\u00EAs inicial e m\u00EAs final -->\n        <div class=\"col-field col-field-months\" *ngIf=\"op.subType == 'months' && op.show\">\n            <ng-container [formGroupName]=\"op.name\">\n                <ng-container *ngFor=\"let opt of op.options\">\n                    <span> - </span>\n\n                    <mat-form-field class=\"govbr-form-field\"\n                        [ngClass]=\"{'mat-form-field-invalid': mensagemValidacaoMeses}\" appearance=\"outline\">\n                        <mat-label>{{opt.label}}</mat-label>\n\n                        <select matNativeControl [id]=\"opt.key\" class=\"govbr-select\" panelClass=\"govbr-select\"\n                            [formControlName]=\"opt.key\" *ngIf=\"!op.multiple\" (change)=\"getIndexValue($event, opt.key)\">\n                            <option *ngFor=\"let mes of opt.values; let indice = index\" [ngValue]=\"mes\"> {{mes}}\n                            </option>\n                        </select>\n\n                    </mat-form-field>\n                </ng-container>\n            </ng-container>\n            <mat-error *ngIf=\"mensagemValidacaoMeses\">\n                {{mensagemValidacaoMeses}}\n            </mat-error>\n        </div>\n\n        <!-- Input tipo text com mascara de cpf e cnpj -->\n        <div class=\"col-field\" *ngIf=\"op.subType == 'textMask' && op.show\">\n            <mat-form-field class=\"govbr-form-field\" [ngClass]=\"{'field-small': op.size === 'small',\n                                        'field-medium': op.size === 'medium',\n                                        'field-large': op.size === 'large'}\" appearance=\"outline\">\n                <mat-label>\n                    {{op.label}}\n                </mat-label>\n\n                <input matInput onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"\n                    (keyup)=\"cpfcnpjmask(op.name)\" (change)=\"valueChange(op.label, op.name)\" type=\"text\"\n                    [formControlName]=\"op.name\" class=\"form-control\" maxlength=\"18\" />\n            </mat-form-field>\n        </div>\n\n    </div>\n</div>\n",
                styles: [".col-field{margin-right:15px;position:relative}.col-field.col-field-months{display:flex;align-items:center;gap:5px}.col-field mat-error{position:absolute;bottom:2px;font-size:11px}.col-field span:nth-child(1){display:none}.field-small{width:85px}.field-medium{width:150px}.field-large{width:200px}span{position:relative;top:-3px}"]
            }] }
];
/** @nocollapse */
FieldsGeralCsComponent.ctorParameters = () => [
    { type: DatePipe }
];
FieldsGeralCsComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    changeInputValue: [{ type: Output }],
    removeFieldChips: [{ type: Input }],
    getValorAno: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DoubleInputCsComponent {
    constructor() {
        this.field = {};
        this.changeDoubleInputValue = new Subject();
        this.ingresso = false;
        this.baixa = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    valueChange() {
        /** @type {?} */
        const objectForm = this.form.get(this.field.name).value;
        /** @type {?} */
        const objChips = [];
        if (this.checkDoubleFieldsIsEmpity(objectForm)) {
            objChips.push({
                key: 'remove',
                nome: this.field.name,
                obrigatorio: false
            });
        }
        else {
            if (this.checkDoubleFields(objectForm)) { //Se os dois campos estiverem preenchidos
                objChips.push({
                    key: this.field.name,
                    nome: this.field.label + ': ' +
                        this.field.options[0].label + ' ' + objectForm[this.field.options[0].key] + ' / ' +
                        this.field.options[1].label + ' ' + objectForm[this.field.options[1].key],
                    obrigatorio: false
                });
            }
            else if (this.checkFirstField(objectForm)) { //Se apenas o primeiro campo estiver preenchido
                objChips.push({
                    key: this.field.name,
                    nome: this.field.label + ': ' +
                        this.field.options[0].label + ' ' + objectForm[this.field.options[0].key],
                    obrigatorio: false
                });
            }
            else { //Se apenas o segundo campo estiver preenchido
                objChips.push({
                    key: this.field.name,
                    nome: this.field.label + ': ' +
                        this.field.options[1].label + ' ' + objectForm[this.field.options[1].key],
                    obrigatorio: false
                });
            }
        }
        this.changeDoubleInputValue.next(objChips);
    }
    //Verifica se os dois campos estão vazios
    /**
     * @param {?} objectForm
     * @return {?}
     */
    checkDoubleFieldsIsEmpity(objectForm) {
        if ((objectForm[this.field.options[0].key] === ''
            || objectForm[this.field.options[0].key] === null)
            && (objectForm[this.field.options[1].key] === ''
                || objectForm[this.field.options[1].key] === null)) {
            return true;
        }
        return false;
    }
    //Verifica se os dois campos não estão vazios
    /**
     * @param {?} objectForm
     * @return {?}
     */
    checkDoubleFields(objectForm) {
        if (objectForm[this.field.options[0].key] !== ''
            && objectForm[this.field.options[0].key] !== null
            && objectForm[this.field.options[1].key] !== ''
            && objectForm[this.field.options[1].key] !== null) {
            return true;
        }
        return false;
    }
    //Verifica se o primeiro campo não esta vazio
    /**
     * @param {?} objectForm
     * @return {?}
     */
    checkFirstField(objectForm) {
        if (objectForm[this.field.options[0].key] !== ''
            && objectForm[this.field.options[0].key] !== null) {
            return true;
        }
        return false;
    }
    /* --- Funções para o campo com dependência da tela de patrimonio --- */
    /**
     * @param {?} fieldsGroup
     * @return {?}
     */
    verificaInteracaoFieldsPatrimonio(fieldsGroup) {
        /** @type {?} */
        const tipoBem = fieldsGroup['tipoBem'];
        /** @type {?} */
        const situacao = fieldsGroup['situacao'];
        if (tipoBem === 'Patrimonial') {
            this.baixa = false;
            this.ingresso = false;
            if (situacao === 'Em Uso') {
                this.ingresso = true;
                this.baixa = false;
            }
            else if (situacao === 'Baixado') {
                this.baixa = true;
                this.ingresso = false;
            }
        }
        else {
            this.baixa = false;
            this.ingresso = false;
        }
        if (!this.ingresso) {
            fieldsGroup['tipoIngresso'] = '';
        }
        if (!this.baixa) {
            fieldsGroup['tipoBaixa'] = '';
        }
        this.form.get(this.field.name).setValue(fieldsGroup);
    }
    /**
     * @param {?} nameField
     * @return {?}
     */
    checkFieldDisable(nameField) {
        /** @type {?} */
        const fieldsGroup = this.form.get(this.field.name).value;
        /** @type {?} */
        const tipoBem = fieldsGroup['tipoBem'];
        /** @type {?} */
        const situacao = fieldsGroup['situacao'];
        if (nameField === 'tipoIngresso') {
            if (tipoBem !== 'Patrimonial' || situacao !== 'Em Uso') {
                this.ingresso = false;
                fieldsGroup[nameField] = '';
            }
        }
        else {
            if (tipoBem !== 'Patrimonial' || situacao !== 'Baixado') {
                this.ingresso = false;
                fieldsGroup[nameField] = '';
            }
        }
        this.form.get(this.field.name).setValue(fieldsGroup);
    }
    /**
     * @param {?} fieldsGroup
     * @return {?}
     */
    verificaCamposVaziosPatrimonio(fieldsGroup) {
        if ((fieldsGroup['tipoBem'] === '' || fieldsGroup['tipoBem'] === null) &&
            (fieldsGroup['situacao'] === '' || fieldsGroup['situacao'] === null) &&
            (fieldsGroup['tipoIngresso'] === '' || fieldsGroup['tipoIngresso'] === null) &&
            (fieldsGroup['tipoBaixa'] === '' || fieldsGroup['tipoIngresso'] === null)) {
            return true;
        }
        return false;
    }
    /**
     * @param {?} fieldsGroup
     * @return {?}
     */
    verificaCamposPreenchidosPatrimonio(fieldsGroup) {
        if ((fieldsGroup['tipoBem'] !== '' && fieldsGroup['tipoBem'] !== null) &&
            (fieldsGroup['situacao'] !== '' && fieldsGroup['situacao'] !== null) &&
            ((fieldsGroup['tipoIngresso'] !== '' && fieldsGroup['tipoIngresso'] !== null) ||
                (fieldsGroup['tipoBaixa'] !== '' && fieldsGroup['tipoBaixa'] !== null))) {
            return true;
        }
        return false;
    }
    /**
     * @param {?} fieldsGroup
     * @return {?}
     */
    verificaDoubleFirstFieldsPatrimonio(fieldsGroup) {
        if ((fieldsGroup['tipoBem'] !== '' && fieldsGroup['tipoBem'] !== null) &&
            (fieldsGroup['situacao'] !== '' && fieldsGroup['situacao'] !== null) &&
            (fieldsGroup['tipoIngresso'] === '' || fieldsGroup['tipoIngresso'] === null) &&
            (fieldsGroup['tipoBaixa'] === '' || fieldsGroup['tipoBaixa'] === null)) {
            return true;
        }
        return false;
    }
    /**
     * @param {?} fieldsGroup
     * @return {?}
     */
    buildChipsFildsPatrimonio(fieldsGroup) {
        /** @type {?} */
        const objChips = [];
        /** @type {?} */
        let text = '';
        if (this.verificaCamposVaziosPatrimonio(fieldsGroup)) {
            objChips.push({
                key: 'remove',
                nome: this.field.name,
                obrigatorio: false
            });
        }
        else {
            if (this.verificaCamposPreenchidosPatrimonio(fieldsGroup)) { //Se todos campos estiverem preenchidos
                if (fieldsGroup['tipoIngresso'] !== '' && fieldsGroup['tipoIngresso'] !== null) {
                    text = 'Tipo do Bem: ' + fieldsGroup['tipoBem'] + ' / ' + 'Situação: ' + fieldsGroup['situacao'] + ' / ' +
                        'Tipo de Ingresso: ' + fieldsGroup['tipoIngresso'];
                }
                else { //tipoBaixa
                    text = 'Tipo do Bem: ' + fieldsGroup['tipoBem'] + ' / ' + 'Situação: ' + fieldsGroup['situacao'] + ' / ' +
                        'Tipo de Baixa: ' + fieldsGroup['tipoBaixa'];
                }
            }
            else if (this.verificaDoubleFirstFieldsPatrimonio(fieldsGroup)) {
                text = 'Tipo do Bem: ' + fieldsGroup['tipoBem'] + ' / ' + 'Situação: ' + fieldsGroup['situacao'];
            }
            else {
                if (fieldsGroup['tipoBem'] !== '' && fieldsGroup['tipoBem'] !== null) {
                    text = 'Tipo do Bem: ' + fieldsGroup['tipoBem'];
                }
                else {
                    text = 'Situação: ' + fieldsGroup['situacao'];
                }
            }
            objChips.push({
                key: this.field.name,
                nome: text,
                obrigatorio: false
            });
        }
        this.changeDoubleInputValue.next(objChips);
    }
    /**
     * @return {?}
     */
    selectValueChangePatrimonio() {
        /** @type {?} */
        const fieldsGroup = this.form.get(this.field.name).value;
        this.verificaInteracaoFieldsPatrimonio(fieldsGroup);
        this.buildChipsFildsPatrimonio(fieldsGroup);
    }
}
DoubleInputCsComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-double-input-cs',
                template: "<div class=\"row\" [formGroup]=\"form\" *ngIf=\"field.show && (field.subType === null || field.subType === undefined)\">\n    <div class=\"col-3 coluna-titulo\">\n        {{field.label}}:\n    </div>\n    <div class=\"col-9\" [formGroupName]=\"field.name\">\n        <mat-form-field class=\"govbr-form-field double-input-field\" appearance=\"outline\" *ngFor=\"let op of field.options\">\n            <mat-label>\n                {{op.label}}\n            </mat-label>\n\n            <input matInput\n                type=\"text\"\n                [id]=\"op.key\"\n                [name]=\"op.key\"\n                [placeholder]=\"op.label\"\n                [formControlName]=\"op.key\"\n                (change)=\"valueChange()\"\n                maxlength=\"11\"\n                onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\"/>\n        </mat-form-field>\n    </div>\n</div>\n\n\n<!-- Aqui fica os campos com depend\u00EAncia -->\n<div class=\"row\" [formGroup]=\"form\" *ngIf=\"field.show && (field.subType !== null || field.subType !== undefined)\">\n\n    <!-- InputDependency Patrimonio -->\n    <div [formGroupName]=\"field.name\" *ngIf=\"field.subType === 'inputDependencyPatrimonio'\">\n        <div class=\"row\">\n            <div class=\"col-12 col-md-3 margin-select\">\n                <div class=\"col-field\">\n                    <mat-form-field class=\"govbr-form-field field-medium\" appearance=\"outline\">\n                        <mat-label>\n                            {{field.optionsFields[0].label}}\n                        </mat-label>\n        \n                        <mat-select [id]=\"field.optionsFields[0].name\" class=\"govbr-select\" panelClass=\"govbr-select\" [formControlName]=\"field.optionsFields[0].name\"\n                            (change)=\"selectValueChangePatrimonio()\">\n                            <mat-option *ngFor=\"let option of field.optionsFields[0].options\" [value]=\"option.label\">\n                                {{option.label}}\n                            </mat-option>\n                        </mat-select>\n                    </mat-form-field>\n                </div>\n            </div>\n\n            <div class=\"col-12 col-md-3 margin-select\">\n                <div class=\"col-field\">\n                    <mat-form-field class=\"govbr-form-field field-medium\" appearance=\"outline\">\n                        <mat-label>\n                            {{field.optionsFields[1].label}}\n                        </mat-label>\n        \n                        <mat-select [id]=\"field.optionsFields[1].name\" class=\"govbr-select\" panelClass=\"govbr-select\" [formControlName]=\"field.optionsFields[1].name\"\n                            (change)=\"selectValueChangePatrimonio()\">\n                            <mat-option *ngFor=\"let option of field.optionsFields[1].options\" [value]=\"option.label\">\n                                {{option.label}}\n                            </mat-option>\n                        </mat-select>\n                    </mat-form-field>\n                </div>\n            </div>\n\n            <div class=\"col-12 col-md-3 margin-select\" *ngIf=\"ingresso\">\n                <div class=\"col-field\">\n                    <mat-form-field class=\"govbr-form-field field-medium\" appearance=\"outline\">\n                        <mat-label>\n                            {{field.optionsFields[2].label}}\n                        </mat-label>\n        \n                        <mat-select [id]=\"field.optionsFields[2].name\" class=\"govbr-select\" panelClass=\"govbr-select\" [formControlName]=\"field.optionsFields[2].name\"\n                            (click)=\"checkFieldDisable('tipoIngresso')\" (change)=\"selectValueChangePatrimonio()\">\n                            <mat-option *ngFor=\"let option of field.optionsFields[2].options\" [value]=\"option.label\">\n                                {{option.label}}\n                            </mat-option>\n                        </mat-select>\n                    </mat-form-field>\n                </div>\n            </div>\n\n            <div class=\"col-12 col-md-3 margin-select\" *ngIf=\"baixa\">\n                <div class=\"col-field\">\n                    <mat-form-field class=\"govbr-form-field field-medium\" appearance=\"outline\">\n                        <mat-label>\n                            {{field.optionsFields[3].label}}\n                        </mat-label>\n        \n                        <mat-select [id]=\"field.optionsFields[3].name\" class=\"govbr-select\" panelClass=\"govbr-select\" [formControlName]=\"field.optionsFields[3].name\"\n                            (click)=\"checkFieldDisable('tipoBaixa')\" (change)=\"selectValueChangePatrimonio()\">\n                            <mat-option *ngFor=\"let option of field.optionsFields[3].options\" [value]=\"option.label\">\n                                {{option.label}}\n                            </mat-option>\n                        </mat-select>\n                    </mat-form-field>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>\n\n\n\n",
                styles: [".coluna-titulo{height:24px;margin:10px 100px 18px 0}.double-input-field{margin:10px 20px 18px 0;width:200px}.field-medium{width:200px}.margin-select{margin-right:20px}"]
            }] }
];
/** @nocollapse */
DoubleInputCsComponent.ctorParameters = () => [];
DoubleInputCsComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    changeDoubleInputValue: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DoubleCheckboxCsComponent {
    constructor() {
        this.field = {};
        this.changeDoubleCheckboxValue = new Subject();
        this.nameInput1 = {
            name: '',
            label: ''
        };
        this.nameInput2 = {
            name: '',
            label: ''
        };
        this.listaField1 = [];
        this.listaField2 = [];
        this.showSecondField = false;
        this.isDisable = false;
        this.itensPorLinha = 3;
        this.listaSelecionadosField1 = [];
        this.listaSelecionadosField2 = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.buildDadosListaField1();
        this.buildDadosListaField2();
        this.buildNameInput();
    }
    /**
     * @return {?}
     */
    buildDadosListaField1() {
        /** @type {?} */
        let contadorOp = 1;
        /** @type {?} */
        let auxiliarLista = [];
        auxiliarLista.push({ key: 'todos', label: 'Todos' });
        /** @type {?} */
        const field = this.field.optionsFields[0];
        for (const op of field.options) {
            auxiliarLista.push(op);
            if (contadorOp === (this.itensPorLinha - 1)) {
                this.listaField1.push(auxiliarLista);
                auxiliarLista = [];
                contadorOp = 0;
            }
            else {
                contadorOp++;
            }
        }
        if (auxiliarLista.length !== 0) {
            this.listaField1.push(auxiliarLista);
        }
    }
    /**
     * @return {?}
     */
    buildDadosListaField2() {
        /** @type {?} */
        let contadorOp = 1;
        /** @type {?} */
        let auxiliarLista = [];
        auxiliarLista.push({ key: 'todos', label: 'Todos' });
        /** @type {?} */
        const field = this.field.optionsFields[1];
        for (const op of field.options) {
            auxiliarLista.push(op);
            if (contadorOp === (this.itensPorLinha - 1)) {
                this.listaField2.push(auxiliarLista);
                auxiliarLista = [];
                contadorOp = 0;
            }
            else {
                contadorOp++;
            }
        }
        if (auxiliarLista.length !== 0) {
            this.listaField2.push(auxiliarLista);
        }
    }
    /**
     * @return {?}
     */
    buildNameInput() {
        this.nameInput1.name = this.field.optionsFields[0].name;
        this.nameInput1.label = this.field.optionsFields[0].label;
        this.nameInput2.name = this.field.optionsFields[1].name;
        this.nameInput2.label = this.field.optionsFields[1].label;
    }
    /**
     * @return {?}
     */
    buildChips() {
        /** @type {?} */
        const objChips = [];
        if (this.listaSelecionadosField1.length > 0 && this.listaSelecionadosField2.length === 0) {
            objChips.push({
                key: this.field.name,
                nome: this.field.optionsFields[0].label + ': ' + this.listaSelecionadosField1.join(', '),
                obrigatorio: false
            });
        }
        else if (this.listaSelecionadosField1.length > 0 && this.listaSelecionadosField2.length > 0) {
            /** @type {?} */
            let texto = this.field.optionsFields[0].label + ': ' + this.listaSelecionadosField1.join(', ');
            texto += '\n\n' + this.field.optionsFields[1].label + ': ' + this.listaSelecionadosField2.join(', ');
            objChips.push({
                key: this.field.name,
                nome: texto,
                obrigatorio: false
            });
        }
        else {
            objChips.push({
                key: 'remove',
                nome: this.field.name,
                obrigatorio: false
            });
        }
        this.changeDoubleCheckboxValue.next(objChips);
    }
    /**
     * @return {?}
     */
    checkField1NotEmpity() {
        /** @type {?} */
        let retorno = true;
        /** @type {?} */
        const name = this.field.optionsFields[0].name;
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        Object.keys(values[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (values[name][key] !== null && values[name][key] !== false) {
                retorno = false;
            }
        }));
        return retorno;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    setFalseAllField2(name) {
        this.listaSelecionadosField2 = [];
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        Object.keys(values[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            values[name][key] = false;
        }));
        this.form.get(this.field.name).setValue(values);
    }
    /**
     * @return {?}
     */
    getValueSelecionarTodosField1() {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        /** @type {?} */
        const name = this.field.optionsFields[0].name;
        /** @type {?} */
        let retorno = false;
        Object.keys(values[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (key === 'todos') {
                retorno = values[name][key];
            }
        }));
        return retorno;
    }
    /**
     * @return {?}
     */
    getValueSelecionarTodosField2() {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        /** @type {?} */
        const name = this.field.optionsFields[1].name;
        /** @type {?} */
        let retorno = false;
        Object.keys(values[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (key === 'todos') {
                retorno = values[name][key];
            }
        }));
        return retorno;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    checkedAllField1(name) {
        this.listaSelecionadosField1 = [];
        this.verificaFormField1('todos');
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        if (this.getValueSelecionarTodosField1()) {
            this.showSecondField = true;
            for (const op of this.field.optionsFields[0].options) {
                this.listaSelecionadosField1.push(op.label);
            }
            Object.keys(values[name]).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                values[name][key] = true;
            }));
        }
        else {
            Object.keys(values[name]).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                values[name][key] = false;
            }));
            Object.keys(values[this.nameInput2.name]).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                values[this.nameInput2.name][key] = false;
            }));
        }
        if (this.checkField1NotEmpity()) {
            this.setFalseAllField2(this.field.optionsFields[1].name);
            this.isDisable = true;
        }
        else {
            this.isDisable = false;
        }
        this.form.get(this.field.name).setValue(values);
        this.buildChips();
    }
    /**
     * @param {?} name
     * @return {?}
     */
    checkedAllField2(name) {
        if (this.checkField1NotEmpity()) {
            this.setFalseAllField2(name);
            this.isDisable = true;
            return;
        }
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        this.listaSelecionadosField2 = [];
        if (this.getValueSelecionarTodosField2()) {
            for (const op of this.field.optionsFields[1].options) {
                this.listaSelecionadosField2.push(op.label);
            }
            Object.keys(values[name]).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                values[name][key] = true;
            }));
        }
        else {
            Object.keys(values[name]).forEach((/**
             * @param {?} key
             * @return {?}
             */
            (key) => {
                values[name][key] = false;
            }));
        }
        this.form.get(this.field.name).setValue(values);
        this.buildChips();
    }
    /**
     * @param {?} name
     * @return {?}
     */
    checkListFull(name) {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        /** @type {?} */
        let retorno = true;
        Object.keys(values[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if ((values[name][key] === false || values[name][key] === null) && key !== 'todos') {
                retorno = false;
            }
        }));
        return retorno;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    checkSelectAllField(name) {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        Object.keys(values[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            values[name][key] = true;
        }));
        this.form.get(this.field.name).setValue(values);
    }
    /**
     * @param {?} name
     * @return {?}
     */
    uncheckSelectAllField(name) {
        /** @type {?} */
        const oldValues = this.form.get(this.field.name).value;
        /** @type {?} */
        const newValues = this.form.get(this.field.name).value;
        Object.keys(oldValues[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (key === 'todos') {
                newValues[name][key] = false;
            }
            else {
                newValues[name][key] = oldValues[name][key];
            }
        }));
        this.form.get(this.field.name).setValue(newValues);
    }
    /**
     * @param {?} nameChecked
     * @return {?}
     */
    verificaFormField1(nameChecked) {
        /** @type {?} */
        const values = this.form.get(this.field.name).value;
        /** @type {?} */
        const name = this.field.optionsFields[0].name;
        /** @type {?} */
        let zerarLista = true;
        Object.keys(values[name]).forEach((/**
         * @param {?} key
         * @return {?}
         */
        (key) => {
            if (values[name][key] !== null && key !== nameChecked) {
                zerarLista = false;
            }
        }));
        if (zerarLista) {
            this.listaSelecionadosField1 = [];
            this.listaSelecionadosField2 = [];
        }
    }
    /**
     * @param {?} event
     * @param {?} nameChecked
     * @param {?} label
     * @return {?}
     */
    checkedEventField1(event, nameChecked, label) {
        this.verificaFormField1(nameChecked);
        if (event.checked) {
            this.isDisable = false;
            this.showSecondField = true;
            this.listaSelecionadosField1.push(label);
            if (this.checkListFull(this.field.optionsFields[0].name)) {
                this.checkSelectAllField(this.field.optionsFields[0].name);
            }
        }
        else {
            /** @type {?} */
            const index = this.listaSelecionadosField1.indexOf(label);
            this.listaSelecionadosField1.splice(index, 1);
            if (this.listaSelecionadosField1.length === 0) {
                this.isDisable = true;
                this.setFalseAllField2(this.field.optionsFields[1].name);
            }
            this.uncheckSelectAllField(this.field.optionsFields[0].name);
        }
        this.buildChips();
    }
    /**
     * @param {?} event
     * @param {?} nameChecked
     * @param {?} label
     * @return {?}
     */
    checkedEventField2(event, nameChecked, label) {
        if (this.checkField1NotEmpity()) {
            this.setFalseAllField2(this.field.optionsFields[1].name);
            this.isDisable = true;
            return;
        }
        this.verificaFormField1(nameChecked);
        if (event.checked) {
            this.listaSelecionadosField2.push(label);
            if (this.checkListFull(this.field.optionsFields[1].name)) {
                this.checkSelectAllField(this.field.optionsFields[1].name);
            }
        }
        else {
            /** @type {?} */
            const index = this.listaSelecionadosField2.indexOf(label);
            this.listaSelecionadosField2.splice(index, 1);
            this.uncheckSelectAllField(this.field.optionsFields[1].name);
        }
        this.buildChips();
    }
}
DoubleCheckboxCsComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-double-checkbox-cs',
                template: "<div class=\"double-checkbox\" [formGroup]=\"form\" *ngIf=\"field.show\">\n    <div [formGroupName]=\"field.name\">\n\n        <div class=\"row\">\n            <div class=\"col-3 coluna-titulo\">\n                <mat-label>{{nameInput1.label}}:</mat-label>\n            </div>\n            <div class=\"col-9\" [formGroupName]=\"nameInput1.name\">\n\n                <div class=\"row row-double-checkbox\" *ngFor=\"let options of listaField1\">\n                    <div class=\"item-checkbox\" *ngFor=\"let option of options\">\n                            \n                        <mat-checkbox class=\"govbr-checkbox\"\n                            [formControlName]=\"option.key\"\n                            (change)=\"checkedAllField1(nameInput1.name)\"\n                            *ngIf=\"option.key == 'todos'\">\n                                {{option.label}}\n                        </mat-checkbox>\n                            \n                        <mat-checkbox class=\"govbr-checkbox\"\n                            [formControlName]=\"option.key\"\n                            (change)=\"checkedEventField1($event, option.key, option.label)\"\n                            *ngIf=\"option.key != 'todos'\">\n                                {{option.label}}\n                        </mat-checkbox>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"showSecondField\">\n            <mat-divider class=\"divider\"></mat-divider>\n            <div class=\"row\">\n                <div class=\"col-3 coluna-titulo\">\n                    <mat-label>{{nameInput2.label}}:</mat-label>\n                </div>\n                <div class=\"col-9\" [formGroupName]=\"nameInput2.name\">\n\n                    <div class=\"row row-double-checkbox\" *ngFor=\"let options of listaField2\">\n                        <div class=\"item-checkbox\" *ngFor=\"let option of options\">\n                                \n                            <mat-checkbox class=\"govbr-checkbox\"\n                                [formControlName]=\"option.key\"\n                                (change)=\"checkedAllField2(nameInput2.name)\"\n                                *ngIf=\"option.key == 'todos'\"\n                                [disabled]=\"isDisable\">\n                                    {{option.label}}\n                            </mat-checkbox>\n                                \n                            <mat-checkbox class=\"govbr-checkbox\"\n                                [formControlName]=\"option.key\"\n                                (change)=\"checkedEventField2($event, option.key, option.label)\" \n                                *ngIf=\"option.key != 'todos'\"\n                                [disabled]=\"isDisable\">\n                                    {{option.label}}\n                            </mat-checkbox>\n\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>",
                styles: [".row{gap:30px}.coluna-titulo{margin-right:100px;width:100px}.row-double-checkbox{margin-bottom:18px}.mat-divider{border-top-width:3px;margin-bottom:18px}.double-checkbox{margin-top:10px}"]
            }] }
];
/** @nocollapse */
DoubleCheckboxCsComponent.ctorParameters = () => [];
DoubleCheckboxCsComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    changeDoubleCheckboxValue: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SelectCheckAllComponent {
    constructor() {
        this.values = [];
        this.eventCheckAll = new Subject();
        this.isChecked = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.eventChecked.subscribe((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            this.isChecked = res;
        }));
    }
    /**
     * @return {?}
     */
    isIndeterminate() {
        return this.model.value && this.values.options.length && this.model.value.length
            && this.model.value.length < this.values.options.length;
    }
    /**
     * @param {?} change
     * @return {?}
     */
    toggleSelection(change) {
        if (change.checked) {
            /** @type {?} */
            const arrayKeys = [];
            this.values.options.map((/**
             * @param {?} data
             * @return {?}
             */
            data => {
                arrayKeys.push(data.key);
            }));
            this.model.setValue(arrayKeys);
            this.eventCheckAll.next(['add', this.values]);
            this.isChecked = true;
        }
        else {
            this.model.setValue([]);
            this.eventCheckAll.next(['remove', this.values]);
        }
    }
}
SelectCheckAllComponent.decorators = [
    { type: Component, args: [{
                selector: 'govbr-select-check-all',
                template: "<mat-checkbox class=\"govbr-checkbox mat-option\" [indeterminate]=\"isIndeterminate()\" [checked]=\"isChecked\" (click)=\"$event.stopPropagation()\"\n    (change)=\"toggleSelection($event)\">\n    Todos\n</mat-checkbox>",
                styles: [""]
            }] }
];
SelectCheckAllComponent.propDecorators = {
    model: [{ type: Input }],
    values: [{ type: Input }],
    eventCheckAll: [{ type: Output }],
    eventChecked: [{ type: Input }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FormsCsModule {
}
FormsCsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    FormsCsComponent,
                    CheckboxCsComponent,
                    FieldsGeralCsComponent,
                    DoubleInputCsComponent,
                    DoubleCheckboxCsComponent,
                    SelectCheckAllComponent
                ],
                imports: [
                    CommonModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatSelectModule,
                    MatDatepickerModule,
                    MatCheckboxModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDividerModule
                ],
                exports: [
                    FormsCsComponent,
                    CheckboxCsComponent,
                    FieldsGeralCsComponent,
                    MatFormFieldModule,
                    MatInputModule,
                    MatSelectModule,
                    MatDatepickerModule,
                    MatCheckboxModule,
                    FormsModule,
                    ReactiveFormsModule,
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                providers: [
                    DatePipe
                ]
            },] }
];

export { AMBIENTE_PRODUCAO, ANALYTICS_PRODUTO_FRAMEWORK, APP_SYS_NAME, AUTH_CONFIG_OBJ, AbreModalLgpdService, AbstractCommService, AlteracaoSenha, AlterarSenhaService, AsyncValidatorsConfig, AuthConfigService, AuthGuard, AuthGuardService, AuthModule, AuthService, AvisosDialogComponent, AvisosDialogModule, AvisosDialogService, BackendCommService, BotoesAcoesComponent, BotoesAcoesModule, CHATBOT_CONFIG, CabecalhoComponent, CabecalhoModule, CabecalhoPortalComponent, CabecalhoPortalModule, CardsDirective, CardsModule, Chat, ChatBotComponent, ChatBotDirective, ChatBotModule, ChatBotService, CodeBlockComponent, CodeBlockModule, CodeSnippet, ConfigLookup, ConteudoNotificacoesComponent, DadoRodape, DadosCabecalhoPortal, DadosLinks, DadosPrefeitura, DadosUsuarioService, DatepickerAdapter, DescritorCampo, Device, DeviceService, DeviceType, DialogBackdropComponent, DialogBackdropModule, DialogBackdropService, DialogLgpdComponent, DialogMensagemEccoComponent, DialogPesquisaComponent, DialogProdutosGrpComponent, DraggableDirective, DraggableHelperDirective, DraggableModule, DualListComponent, DualListModule, EllipsisPipe, EntidadeBase, EntidadeBuilderService, EntidadesMetadadosService, ErroService, ErrorService, EventoBotaoNovaSenhaService, FavoritosComponent, FavoritosModule, FilterComponent, FilterInputType, FilterLineComponent, FilterModule, FormBuilderService, FormsCsModule, GESTAO_SERVICOS_URI, GenericFormComponent, GenericFormRendererComponent, GenericFormsModule, GenericTableComponent, GenericTableModule, GovColDirective, GovRowDirective, GovStepperComponent, GovbrHomeModule, GridModule, HighlightSearchPipe, HistoricoRouterService, ISSUER_VALUE, IncomingMessageDTO, InputHiddenComponent, InputNumberComponent, InputNumberDirective, InputTextComponent, InputsModule, ItemFavoritos, ItemMenuGrp, ItemPerfilUsuario, ItemTelaMenuGrp, LIC, LICService, LIC_CODIGO_SISTEMA, LgpdText, ListagemGrpComponent, ListagemGrpModule, LoaderComponent, LoaderModule, LocationService, LogAnalyticsDirective, LogAnalyticsModule, LogAnalyticsService, LoginService, LookupComponent, LookupDrawerComponent, LookupHeaderComponent, LookupModule, LookupService, MOCK_TENANT, MensagensErroBase, MenuGrpComponent, MenuGrpModule, MenuGrpService, MenuItem, MenuLateralComponent, MenuLateralModule, MenuLateralService, MenuSlideComponent, MenuSlideModule, Message, MessageBuilder, MessageType, ModalLgpdComponent, ModalLgpdModule, MovableAreaDirective, MovableDirective, NavegacaoComponent, NotificacoesComponent, NotificacoesModule, NotificacoesService, Orientation, PARAMS_NOTIFICACAO, PARAM_TIPO_ERRO, PaginationModule, PaginatorComponent, PaginatorService, PerfilUsuarioComponent, PerfilUsuarioModule, Permissoes, PesquisaComponent, PesquisaModule, PesquisaService, PipesModule, Produto, ProdutoMenuGrp, ProdutosMenuGrpComponent, ProdutosMenuGrpModule, ROUTES_FOR_ROLES, RichTextComponent, RichTextModule, RodapeComponent, RodapeModule, RodapePortalComponent, RodapePortalModule, RoleInfo, SIGLA_SISTEMA, SelectComponent, SelectEntidadeComponent, SelectEntidadeModule, StatusProdutosGrp, StepperModule, SubmenuItemMenuGrp, TENANT_CONFIG, TENANT_ENTIDADE_PLACEHOLDER, TENANT_MUNICIPIO_PLACEHOLDER, TOAST_CONFIG_TOKEN, TableConfigColumnComponent, TableConfigDialogComponent, TableConfigDirective, TableConfigService, TablesModule, TelaErroComponent, TelaErroModule, TelaMenuGrpComponent, TelaMenuGrpModule, TelaMenuGrpService, Tenant, TenantMissingError, TenantModule, TenantService, TimeoutTokenHandlerService, TipoDado, TipoErro, TipografiaModule, TituloFuncionalidadeComponent, ToastComponent, ToastData, ToastModule, ToastService, UnauthorizedError, Unidade, Usuario$1 as Usuario, UsuarioSSO, UsuarioSsoService, ValidatorsConfig, ViewTableRegisterComponent, ViewTableRegisterModule, VlibrasWidgetComponent, VlibrasWidgetModule, authConfig, defaultToastConfig, onAppInitAuth, GovContainerDirective as ɵa, BotaoMenuGrpComponent as ɵb, DataMenuGrpModal as ɵc, MenuGrpButtonComponent as ɵd, DialogAlteracaoSenhaComponent as ɵe, PasswordToggleDirective as ɵf, NotificacoesDirective as ɵg, PaginatorCsComponent as ɵh, TimeoutService as ɵi, MenuItemComponent as ɵj, toastAnimations as ɵl, ToastRef as ɵm, FormsCsComponent as ɵp, CheckboxCsComponent as ɵq, FieldsGeralCsComponent as ɵr, DoubleInputCsComponent as ɵs, DoubleCheckboxCsComponent as ɵt, SelectCheckAllComponent as ɵu };
//# sourceMappingURL=govbr-lib.js.map
